import * as S from "react";
import Os, { forwardRef as o0, createElement as cc, useLayoutEffect as a0, useEffect as xo, useState as cn, useCallback as os } from "react";
import * as zc from "react-dom";
var ci = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {}, gs = { exports: {} }, fi = {};
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var fc;
function s0() {
  if (fc) return fi;
  fc = 1;
  var n = Os, i = Symbol.for("react.element"), r = Symbol.for("react.fragment"), a = Object.prototype.hasOwnProperty, s = n.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, l = { key: !0, ref: !0, __self: !0, __source: !0 };
  function f(m, g, p) {
    var w, x = {}, T = null, E = null;
    p !== void 0 && (T = "" + p), g.key !== void 0 && (T = "" + g.key), g.ref !== void 0 && (E = g.ref);
    for (w in g) a.call(g, w) && !l.hasOwnProperty(w) && (x[w] = g[w]);
    if (m && m.defaultProps) for (w in g = m.defaultProps, g) x[w] === void 0 && (x[w] = g[w]);
    return { $$typeof: i, type: m, key: T, ref: E, props: x, _owner: s.current };
  }
  return fi.Fragment = r, fi.jsx = f, fi.jsxs = f, fi;
}
var di = {};
/**
 * @license React
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var dc;
function u0() {
  return dc || (dc = 1, process.env.NODE_ENV !== "production" && function() {
    var n = Os, i = Symbol.for("react.element"), r = Symbol.for("react.portal"), a = Symbol.for("react.fragment"), s = Symbol.for("react.strict_mode"), l = Symbol.for("react.profiler"), f = Symbol.for("react.provider"), m = Symbol.for("react.context"), g = Symbol.for("react.forward_ref"), p = Symbol.for("react.suspense"), w = Symbol.for("react.suspense_list"), x = Symbol.for("react.memo"), T = Symbol.for("react.lazy"), E = Symbol.for("react.offscreen"), O = Symbol.iterator, k = "@@iterator";
    function L(y) {
      if (y === null || typeof y != "object")
        return null;
      var W = O && y[O] || y[k];
      return typeof W == "function" ? W : null;
    }
    var I = n.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function $(y) {
      {
        for (var W = arguments.length, G = new Array(W > 1 ? W - 1 : 0), ne = 1; ne < W; ne++)
          G[ne - 1] = arguments[ne];
        B("error", y, G);
      }
    }
    function B(y, W, G) {
      {
        var ne = I.ReactDebugCurrentFrame, Ee = ne.getStackAddendum();
        Ee !== "" && (W += "%s", G = G.concat([Ee]));
        var Ae = G.map(function(we) {
          return String(we);
        });
        Ae.unshift("Warning: " + W), Function.prototype.apply.call(console[y], console, Ae);
      }
    }
    var q = !1, Y = !1, Q = !1, j = !1, U = !1, se;
    se = Symbol.for("react.module.reference");
    function Ce(y) {
      return !!(typeof y == "string" || typeof y == "function" || y === a || y === l || U || y === s || y === p || y === w || j || y === E || q || Y || Q || typeof y == "object" && y !== null && (y.$$typeof === T || y.$$typeof === x || y.$$typeof === f || y.$$typeof === m || y.$$typeof === g || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      y.$$typeof === se || y.getModuleId !== void 0));
    }
    function fe(y, W, G) {
      var ne = y.displayName;
      if (ne)
        return ne;
      var Ee = W.displayName || W.name || "";
      return Ee !== "" ? G + "(" + Ee + ")" : G;
    }
    function de(y) {
      return y.displayName || "Context";
    }
    function re(y) {
      if (y == null)
        return null;
      if (typeof y.tag == "number" && $("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof y == "function")
        return y.displayName || y.name || null;
      if (typeof y == "string")
        return y;
      switch (y) {
        case a:
          return "Fragment";
        case r:
          return "Portal";
        case l:
          return "Profiler";
        case s:
          return "StrictMode";
        case p:
          return "Suspense";
        case w:
          return "SuspenseList";
      }
      if (typeof y == "object")
        switch (y.$$typeof) {
          case m:
            var W = y;
            return de(W) + ".Consumer";
          case f:
            var G = y;
            return de(G._context) + ".Provider";
          case g:
            return fe(y, y.render, "ForwardRef");
          case x:
            var ne = y.displayName || null;
            return ne !== null ? ne : re(y.type) || "Memo";
          case T: {
            var Ee = y, Ae = Ee._payload, we = Ee._init;
            try {
              return re(we(Ae));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var Te = Object.assign, me = 0, be, pe, F, Me, xe, Ie, yt;
    function Oe() {
    }
    Oe.__reactDisabledLog = !0;
    function Be() {
      {
        if (me === 0) {
          be = console.log, pe = console.info, F = console.warn, Me = console.error, xe = console.group, Ie = console.groupCollapsed, yt = console.groupEnd;
          var y = {
            configurable: !0,
            enumerable: !0,
            value: Oe,
            writable: !0
          };
          Object.defineProperties(console, {
            info: y,
            log: y,
            warn: y,
            error: y,
            group: y,
            groupCollapsed: y,
            groupEnd: y
          });
        }
        me++;
      }
    }
    function Se() {
      {
        if (me--, me === 0) {
          var y = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: Te({}, y, {
              value: be
            }),
            info: Te({}, y, {
              value: pe
            }),
            warn: Te({}, y, {
              value: F
            }),
            error: Te({}, y, {
              value: Me
            }),
            group: Te({}, y, {
              value: xe
            }),
            groupCollapsed: Te({}, y, {
              value: Ie
            }),
            groupEnd: Te({}, y, {
              value: yt
            })
          });
        }
        me < 0 && $("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var et = I.ReactCurrentDispatcher, ve;
    function Ye(y, W, G) {
      {
        if (ve === void 0)
          try {
            throw Error();
          } catch (Ee) {
            var ne = Ee.stack.trim().match(/\n( *(at )?)/);
            ve = ne && ne[1] || "";
          }
        return `
` + ve + y;
      }
    }
    var Ke = !1, ft;
    {
      var De = typeof WeakMap == "function" ? WeakMap : Map;
      ft = new De();
    }
    function st(y, W) {
      if (!y || Ke)
        return "";
      {
        var G = ft.get(y);
        if (G !== void 0)
          return G;
      }
      var ne;
      Ke = !0;
      var Ee = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var Ae;
      Ae = et.current, et.current = null, Be();
      try {
        if (W) {
          var we = function() {
            throw Error();
          };
          if (Object.defineProperty(we.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(we, []);
            } catch (nt) {
              ne = nt;
            }
            Reflect.construct(y, [], we);
          } else {
            try {
              we.call();
            } catch (nt) {
              ne = nt;
            }
            y.call(we.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (nt) {
            ne = nt;
          }
          y();
        }
      } catch (nt) {
        if (nt && ne && typeof nt.stack == "string") {
          for (var he = nt.stack.split(`
`), gt = ne.stack.split(`
`), Ge = he.length - 1, Ve = gt.length - 1; Ge >= 1 && Ve >= 0 && he[Ge] !== gt[Ve]; )
            Ve--;
          for (; Ge >= 1 && Ve >= 0; Ge--, Ve--)
            if (he[Ge] !== gt[Ve]) {
              if (Ge !== 1 || Ve !== 1)
                do
                  if (Ge--, Ve--, Ve < 0 || he[Ge] !== gt[Ve]) {
                    var Ot = `
` + he[Ge].replace(" at new ", " at ");
                    return y.displayName && Ot.includes("<anonymous>") && (Ot = Ot.replace("<anonymous>", y.displayName)), typeof y == "function" && ft.set(y, Ot), Ot;
                  }
                while (Ge >= 1 && Ve >= 0);
              break;
            }
        }
      } finally {
        Ke = !1, et.current = Ae, Se(), Error.prepareStackTrace = Ee;
      }
      var Jt = y ? y.displayName || y.name : "", pn = Jt ? Ye(Jt) : "";
      return typeof y == "function" && ft.set(y, pn), pn;
    }
    function Bt(y, W, G) {
      return st(y, !1);
    }
    function Qe(y) {
      var W = y.prototype;
      return !!(W && W.isReactComponent);
    }
    function dt(y, W, G) {
      if (y == null)
        return "";
      if (typeof y == "function")
        return st(y, Qe(y));
      if (typeof y == "string")
        return Ye(y);
      switch (y) {
        case p:
          return Ye("Suspense");
        case w:
          return Ye("SuspenseList");
      }
      if (typeof y == "object")
        switch (y.$$typeof) {
          case g:
            return Bt(y.render);
          case x:
            return dt(y.type, W, G);
          case T: {
            var ne = y, Ee = ne._payload, Ae = ne._init;
            try {
              return dt(Ae(Ee), W, G);
            } catch {
            }
          }
        }
      return "";
    }
    var Ct = Object.prototype.hasOwnProperty, ut = {}, gn = I.ReactDebugCurrentFrame;
    function kt(y) {
      if (y) {
        var W = y._owner, G = dt(y.type, y._source, W ? W.type : null);
        gn.setExtraStackFrame(G);
      } else
        gn.setExtraStackFrame(null);
    }
    function J(y, W, G, ne, Ee) {
      {
        var Ae = Function.call.bind(Ct);
        for (var we in y)
          if (Ae(y, we)) {
            var he = void 0;
            try {
              if (typeof y[we] != "function") {
                var gt = Error((ne || "React class") + ": " + G + " type `" + we + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof y[we] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw gt.name = "Invariant Violation", gt;
              }
              he = y[we](W, we, ne, G, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (Ge) {
              he = Ge;
            }
            he && !(he instanceof Error) && (kt(Ee), $("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", ne || "React class", G, we, typeof he), kt(null)), he instanceof Error && !(he.message in ut) && (ut[he.message] = !0, kt(Ee), $("Failed %s type: %s", G, he.message), kt(null));
          }
      }
    }
    var Re = Array.isArray;
    function Fe(y) {
      return Re(y);
    }
    function Qt(y) {
      {
        var W = typeof Symbol == "function" && Symbol.toStringTag, G = W && y[Symbol.toStringTag] || y.constructor.name || "Object";
        return G;
      }
    }
    function ht(y) {
      try {
        return tt(y), !1;
      } catch {
        return !0;
      }
    }
    function tt(y) {
      return "" + y;
    }
    function Tt(y) {
      if (ht(y))
        return $("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", Qt(y)), tt(y);
    }
    var Mt = I.ReactCurrentOwner, lt = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, Et, mn;
    function cr(y) {
      if (Ct.call(y, "ref")) {
        var W = Object.getOwnPropertyDescriptor(y, "ref").get;
        if (W && W.isReactWarning)
          return !1;
      }
      return y.ref !== void 0;
    }
    function $r(y) {
      if (Ct.call(y, "key")) {
        var W = Object.getOwnPropertyDescriptor(y, "key").get;
        if (W && W.isReactWarning)
          return !1;
      }
      return y.key !== void 0;
    }
    function Ur(y, W) {
      typeof y.ref == "string" && Mt.current;
    }
    function Hr(y, W) {
      {
        var G = function() {
          Et || (Et = !0, $("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", W));
        };
        G.isReactWarning = !0, Object.defineProperty(y, "key", {
          get: G,
          configurable: !0
        });
      }
    }
    function Br(y, W) {
      {
        var G = function() {
          mn || (mn = !0, $("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", W));
        };
        G.isReactWarning = !0, Object.defineProperty(y, "ref", {
          get: G,
          configurable: !0
        });
      }
    }
    var Yr = function(y, W, G, ne, Ee, Ae, we) {
      var he = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: i,
        // Built-in properties that belong on the element
        type: y,
        key: W,
        ref: G,
        props: we,
        // Record the component responsible for creating this element.
        _owner: Ae
      };
      return he._store = {}, Object.defineProperty(he._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(he, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: ne
      }), Object.defineProperty(he, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: Ee
      }), Object.freeze && (Object.freeze(he.props), Object.freeze(he)), he;
    };
    function jr(y, W, G, ne, Ee) {
      {
        var Ae, we = {}, he = null, gt = null;
        G !== void 0 && (Tt(G), he = "" + G), $r(W) && (Tt(W.key), he = "" + W.key), cr(W) && (gt = W.ref, Ur(W, Ee));
        for (Ae in W)
          Ct.call(W, Ae) && !lt.hasOwnProperty(Ae) && (we[Ae] = W[Ae]);
        if (y && y.defaultProps) {
          var Ge = y.defaultProps;
          for (Ae in Ge)
            we[Ae] === void 0 && (we[Ae] = Ge[Ae]);
        }
        if (he || gt) {
          var Ve = typeof y == "function" ? y.displayName || y.name || "Unknown" : y;
          he && Hr(we, Ve), gt && Br(we, Ve);
        }
        return Yr(y, he, gt, Ee, ne, Mt.current, we);
      }
    }
    var Gr = I.ReactCurrentOwner, Ei = I.ReactDebugCurrentFrame;
    function kn(y) {
      if (y) {
        var W = y._owner, G = dt(y.type, y._source, W ? W.type : null);
        Ei.setExtraStackFrame(G);
      } else
        Ei.setExtraStackFrame(null);
    }
    var fr;
    fr = !1;
    function dr(y) {
      return typeof y == "object" && y !== null && y.$$typeof === i;
    }
    function Oi() {
      {
        if (Gr.current) {
          var y = re(Gr.current.type);
          if (y)
            return `

Check the render method of \`` + y + "`.";
        }
        return "";
      }
    }
    function Uo(y) {
      return "";
    }
    var Pi = {};
    function Ho(y) {
      {
        var W = Oi();
        if (!W) {
          var G = typeof y == "string" ? y : y.displayName || y.name;
          G && (W = `

Check the top-level render call using <` + G + ">.");
        }
        return W;
      }
    }
    function qr(y, W) {
      {
        if (!y._store || y._store.validated || y.key != null)
          return;
        y._store.validated = !0;
        var G = Ho(W);
        if (Pi[G])
          return;
        Pi[G] = !0;
        var ne = "";
        y && y._owner && y._owner !== Gr.current && (ne = " It was passed a child from " + re(y._owner.type) + "."), kn(y), $('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', G, ne), kn(null);
      }
    }
    function Si(y, W) {
      {
        if (typeof y != "object")
          return;
        if (Fe(y))
          for (var G = 0; G < y.length; G++) {
            var ne = y[G];
            dr(ne) && qr(ne, W);
          }
        else if (dr(y))
          y._store && (y._store.validated = !0);
        else if (y) {
          var Ee = L(y);
          if (typeof Ee == "function" && Ee !== y.entries)
            for (var Ae = Ee.call(y), we; !(we = Ae.next()).done; )
              dr(we.value) && qr(we.value, W);
        }
      }
    }
    function Bo(y) {
      {
        var W = y.type;
        if (W == null || typeof W == "string")
          return;
        var G;
        if (typeof W == "function")
          G = W.propTypes;
        else if (typeof W == "object" && (W.$$typeof === g || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        W.$$typeof === x))
          G = W.propTypes;
        else
          return;
        if (G) {
          var ne = re(W);
          J(G, y.props, "prop", ne, y);
        } else if (W.PropTypes !== void 0 && !fr) {
          fr = !0;
          var Ee = re(W);
          $("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", Ee || "Unknown");
        }
        typeof W.getDefaultProps == "function" && !W.getDefaultProps.isReactClassApproved && $("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function Yo(y) {
      {
        for (var W = Object.keys(y.props), G = 0; G < W.length; G++) {
          var ne = W[G];
          if (ne !== "children" && ne !== "key") {
            kn(y), $("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", ne), kn(null);
            break;
          }
        }
        y.ref !== null && (kn(y), $("Invalid attribute `ref` supplied to `React.Fragment`."), kn(null));
      }
    }
    var hr = {};
    function Ri(y, W, G, ne, Ee, Ae) {
      {
        var we = Ce(y);
        if (!we) {
          var he = "";
          (y === void 0 || typeof y == "object" && y !== null && Object.keys(y).length === 0) && (he += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var gt = Uo();
          gt ? he += gt : he += Oi();
          var Ge;
          y === null ? Ge = "null" : Fe(y) ? Ge = "array" : y !== void 0 && y.$$typeof === i ? (Ge = "<" + (re(y.type) || "Unknown") + " />", he = " Did you accidentally export a JSX literal instead of a component?") : Ge = typeof y, $("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", Ge, he);
        }
        var Ve = jr(y, W, G, Ee, Ae);
        if (Ve == null)
          return Ve;
        if (we) {
          var Ot = W.children;
          if (Ot !== void 0)
            if (ne)
              if (Fe(Ot)) {
                for (var Jt = 0; Jt < Ot.length; Jt++)
                  Si(Ot[Jt], y);
                Object.freeze && Object.freeze(Ot);
              } else
                $("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              Si(Ot, y);
        }
        if (Ct.call(W, "key")) {
          var pn = re(y), nt = Object.keys(W).filter(function(Vo) {
            return Vo !== "key";
          }), Vr = nt.length > 0 ? "{key: someKey, " + nt.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!hr[pn + Vr]) {
            var zo = nt.length > 0 ? "{" + nt.join(": ..., ") + ": ...}" : "{}";
            $(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, Vr, pn, zo, pn), hr[pn + Vr] = !0;
          }
        }
        return y === a ? Yo(Ve) : Bo(Ve), Ve;
      }
    }
    function zr(y, W, G) {
      return Ri(y, W, G, !0);
    }
    function jo(y, W, G) {
      return Ri(y, W, G, !1);
    }
    var Go = jo, qo = zr;
    di.Fragment = a, di.jsx = Go, di.jsxs = qo;
  }()), di;
}
process.env.NODE_ENV === "production" ? gs.exports = s0() : gs.exports = u0();
var R = gs.exports, Co = { exports: {} };
/**
 * @license
 * Lodash <https://lodash.com/>
 * Copyright OpenJS Foundation and other contributors <https://openjsf.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */
Co.exports;
(function(n, i) {
  (function() {
    var r, a = "4.17.21", s = 200, l = "Unsupported core-js use. Try https://npms.io/search?q=ponyfill.", f = "Expected a function", m = "Invalid `variable` option passed into `_.template`", g = "__lodash_hash_undefined__", p = 500, w = "__lodash_placeholder__", x = 1, T = 2, E = 4, O = 1, k = 2, L = 1, I = 2, $ = 4, B = 8, q = 16, Y = 32, Q = 64, j = 128, U = 256, se = 512, Ce = 30, fe = "...", de = 800, re = 16, Te = 1, me = 2, be = 3, pe = 1 / 0, F = 9007199254740991, Me = 17976931348623157e292, xe = NaN, Ie = 4294967295, yt = Ie - 1, Oe = Ie >>> 1, Be = [
      ["ary", j],
      ["bind", L],
      ["bindKey", I],
      ["curry", B],
      ["curryRight", q],
      ["flip", se],
      ["partial", Y],
      ["partialRight", Q],
      ["rearg", U]
    ], Se = "[object Arguments]", et = "[object Array]", ve = "[object AsyncFunction]", Ye = "[object Boolean]", Ke = "[object Date]", ft = "[object DOMException]", De = "[object Error]", st = "[object Function]", Bt = "[object GeneratorFunction]", Qe = "[object Map]", dt = "[object Number]", Ct = "[object Null]", ut = "[object Object]", gn = "[object Promise]", kt = "[object Proxy]", J = "[object RegExp]", Re = "[object Set]", Fe = "[object String]", Qt = "[object Symbol]", ht = "[object Undefined]", tt = "[object WeakMap]", Tt = "[object WeakSet]", Mt = "[object ArrayBuffer]", lt = "[object DataView]", Et = "[object Float32Array]", mn = "[object Float64Array]", cr = "[object Int8Array]", $r = "[object Int16Array]", Ur = "[object Int32Array]", Hr = "[object Uint8Array]", Br = "[object Uint8ClampedArray]", Yr = "[object Uint16Array]", jr = "[object Uint32Array]", Gr = /\b__p \+= '';/g, Ei = /\b(__p \+=) '' \+/g, kn = /(__e\(.*?\)|\b__t\)) \+\n'';/g, fr = /&(?:amp|lt|gt|quot|#39);/g, dr = /[&<>"']/g, Oi = RegExp(fr.source), Uo = RegExp(dr.source), Pi = /<%-([\s\S]+?)%>/g, Ho = /<%([\s\S]+?)%>/g, qr = /<%=([\s\S]+?)%>/g, Si = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, Bo = /^\w*$/, Yo = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, hr = /[\\^$.*+?()[\]{}|]/g, Ri = RegExp(hr.source), zr = /^\s+/, jo = /\s/, Go = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/, qo = /\{\n\/\* \[wrapped with (.+)\] \*/, y = /,? & /, W = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g, G = /[()=,{}\[\]\/\s]/, ne = /\\(\\)?/g, Ee = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g, Ae = /\w*$/, we = /^[-+]0x[0-9a-f]+$/i, he = /^0b[01]+$/i, gt = /^\[object .+?Constructor\]$/, Ge = /^0o[0-7]+$/i, Ve = /^(?:0|[1-9]\d*)$/, Ot = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g, Jt = /($^)/, pn = /['\n\r\u2028\u2029\\]/g, nt = "\\ud800-\\udfff", Vr = "\\u0300-\\u036f", zo = "\\ufe20-\\ufe2f", Vo = "\\u20d0-\\u20ff", $s = Vr + zo + Vo, Us = "\\u2700-\\u27bf", Hs = "a-z\\xdf-\\xf6\\xf8-\\xff", td = "\\xac\\xb1\\xd7\\xf7", nd = "\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf", rd = "\\u2000-\\u206f", id = " \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000", Bs = "A-Z\\xc0-\\xd6\\xd8-\\xde", Ys = "\\ufe0e\\ufe0f", js = td + nd + rd + id, Xo = "['’]", od = "[" + nt + "]", Gs = "[" + js + "]", Ai = "[" + $s + "]", qs = "\\d+", ad = "[" + Us + "]", zs = "[" + Hs + "]", Vs = "[^" + nt + js + qs + Us + Hs + Bs + "]", Ko = "\\ud83c[\\udffb-\\udfff]", sd = "(?:" + Ai + "|" + Ko + ")", Xs = "[^" + nt + "]", Qo = "(?:\\ud83c[\\udde6-\\uddff]){2}", Jo = "[\\ud800-\\udbff][\\udc00-\\udfff]", gr = "[" + Bs + "]", Ks = "\\u200d", Qs = "(?:" + zs + "|" + Vs + ")", ud = "(?:" + gr + "|" + Vs + ")", Js = "(?:" + Xo + "(?:d|ll|m|re|s|t|ve))?", Zs = "(?:" + Xo + "(?:D|LL|M|RE|S|T|VE))?", eu = sd + "?", tu = "[" + Ys + "]?", ld = "(?:" + Ks + "(?:" + [Xs, Qo, Jo].join("|") + ")" + tu + eu + ")*", cd = "\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])", fd = "\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])", nu = tu + eu + ld, dd = "(?:" + [ad, Qo, Jo].join("|") + ")" + nu, hd = "(?:" + [Xs + Ai + "?", Ai, Qo, Jo, od].join("|") + ")", gd = RegExp(Xo, "g"), md = RegExp(Ai, "g"), Zo = RegExp(Ko + "(?=" + Ko + ")|" + hd + nu, "g"), pd = RegExp([
      gr + "?" + zs + "+" + Js + "(?=" + [Gs, gr, "$"].join("|") + ")",
      ud + "+" + Zs + "(?=" + [Gs, gr + Qs, "$"].join("|") + ")",
      gr + "?" + Qs + "+" + Js,
      gr + "+" + Zs,
      fd,
      cd,
      qs,
      dd
    ].join("|"), "g"), vd = RegExp("[" + Ks + nt + $s + Ys + "]"), wd = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/, yd = [
      "Array",
      "Buffer",
      "DataView",
      "Date",
      "Error",
      "Float32Array",
      "Float64Array",
      "Function",
      "Int8Array",
      "Int16Array",
      "Int32Array",
      "Map",
      "Math",
      "Object",
      "Promise",
      "RegExp",
      "Set",
      "String",
      "Symbol",
      "TypeError",
      "Uint8Array",
      "Uint8ClampedArray",
      "Uint16Array",
      "Uint32Array",
      "WeakMap",
      "_",
      "clearTimeout",
      "isFinite",
      "parseInt",
      "setTimeout"
    ], bd = -1, He = {};
    He[Et] = He[mn] = He[cr] = He[$r] = He[Ur] = He[Hr] = He[Br] = He[Yr] = He[jr] = !0, He[Se] = He[et] = He[Mt] = He[Ye] = He[lt] = He[Ke] = He[De] = He[st] = He[Qe] = He[dt] = He[ut] = He[J] = He[Re] = He[Fe] = He[tt] = !1;
    var Ue = {};
    Ue[Se] = Ue[et] = Ue[Mt] = Ue[lt] = Ue[Ye] = Ue[Ke] = Ue[Et] = Ue[mn] = Ue[cr] = Ue[$r] = Ue[Ur] = Ue[Qe] = Ue[dt] = Ue[ut] = Ue[J] = Ue[Re] = Ue[Fe] = Ue[Qt] = Ue[Hr] = Ue[Br] = Ue[Yr] = Ue[jr] = !0, Ue[De] = Ue[st] = Ue[tt] = !1;
    var xd = {
      // Latin-1 Supplement block.
      À: "A",
      Á: "A",
      Â: "A",
      Ã: "A",
      Ä: "A",
      Å: "A",
      à: "a",
      á: "a",
      â: "a",
      ã: "a",
      ä: "a",
      å: "a",
      Ç: "C",
      ç: "c",
      Ð: "D",
      ð: "d",
      È: "E",
      É: "E",
      Ê: "E",
      Ë: "E",
      è: "e",
      é: "e",
      ê: "e",
      ë: "e",
      Ì: "I",
      Í: "I",
      Î: "I",
      Ï: "I",
      ì: "i",
      í: "i",
      î: "i",
      ï: "i",
      Ñ: "N",
      ñ: "n",
      Ò: "O",
      Ó: "O",
      Ô: "O",
      Õ: "O",
      Ö: "O",
      Ø: "O",
      ò: "o",
      ó: "o",
      ô: "o",
      õ: "o",
      ö: "o",
      ø: "o",
      Ù: "U",
      Ú: "U",
      Û: "U",
      Ü: "U",
      ù: "u",
      ú: "u",
      û: "u",
      ü: "u",
      Ý: "Y",
      ý: "y",
      ÿ: "y",
      Æ: "Ae",
      æ: "ae",
      Þ: "Th",
      þ: "th",
      ß: "ss",
      // Latin Extended-A block.
      Ā: "A",
      Ă: "A",
      Ą: "A",
      ā: "a",
      ă: "a",
      ą: "a",
      Ć: "C",
      Ĉ: "C",
      Ċ: "C",
      Č: "C",
      ć: "c",
      ĉ: "c",
      ċ: "c",
      č: "c",
      Ď: "D",
      Đ: "D",
      ď: "d",
      đ: "d",
      Ē: "E",
      Ĕ: "E",
      Ė: "E",
      Ę: "E",
      Ě: "E",
      ē: "e",
      ĕ: "e",
      ė: "e",
      ę: "e",
      ě: "e",
      Ĝ: "G",
      Ğ: "G",
      Ġ: "G",
      Ģ: "G",
      ĝ: "g",
      ğ: "g",
      ġ: "g",
      ģ: "g",
      Ĥ: "H",
      Ħ: "H",
      ĥ: "h",
      ħ: "h",
      Ĩ: "I",
      Ī: "I",
      Ĭ: "I",
      Į: "I",
      İ: "I",
      ĩ: "i",
      ī: "i",
      ĭ: "i",
      į: "i",
      ı: "i",
      Ĵ: "J",
      ĵ: "j",
      Ķ: "K",
      ķ: "k",
      ĸ: "k",
      Ĺ: "L",
      Ļ: "L",
      Ľ: "L",
      Ŀ: "L",
      Ł: "L",
      ĺ: "l",
      ļ: "l",
      ľ: "l",
      ŀ: "l",
      ł: "l",
      Ń: "N",
      Ņ: "N",
      Ň: "N",
      Ŋ: "N",
      ń: "n",
      ņ: "n",
      ň: "n",
      ŋ: "n",
      Ō: "O",
      Ŏ: "O",
      Ő: "O",
      ō: "o",
      ŏ: "o",
      ő: "o",
      Ŕ: "R",
      Ŗ: "R",
      Ř: "R",
      ŕ: "r",
      ŗ: "r",
      ř: "r",
      Ś: "S",
      Ŝ: "S",
      Ş: "S",
      Š: "S",
      ś: "s",
      ŝ: "s",
      ş: "s",
      š: "s",
      Ţ: "T",
      Ť: "T",
      Ŧ: "T",
      ţ: "t",
      ť: "t",
      ŧ: "t",
      Ũ: "U",
      Ū: "U",
      Ŭ: "U",
      Ů: "U",
      Ű: "U",
      Ų: "U",
      ũ: "u",
      ū: "u",
      ŭ: "u",
      ů: "u",
      ű: "u",
      ų: "u",
      Ŵ: "W",
      ŵ: "w",
      Ŷ: "Y",
      ŷ: "y",
      Ÿ: "Y",
      Ź: "Z",
      Ż: "Z",
      Ž: "Z",
      ź: "z",
      ż: "z",
      ž: "z",
      Ĳ: "IJ",
      ĳ: "ij",
      Œ: "Oe",
      œ: "oe",
      ŉ: "'n",
      ſ: "s"
    }, _d = {
      "&": "&amp;",
      "<": "&lt;",
      ">": "&gt;",
      '"': "&quot;",
      "'": "&#39;"
    }, Cd = {
      "&amp;": "&",
      "&lt;": "<",
      "&gt;": ">",
      "&quot;": '"',
      "&#39;": "'"
    }, Td = {
      "\\": "\\",
      "'": "'",
      "\n": "n",
      "\r": "r",
      "\u2028": "u2028",
      "\u2029": "u2029"
    }, Ed = parseFloat, Od = parseInt, ru = typeof ci == "object" && ci && ci.Object === Object && ci, Pd = typeof self == "object" && self && self.Object === Object && self, mt = ru || Pd || Function("return this")(), ea = i && !i.nodeType && i, zn = ea && !0 && n && !n.nodeType && n, iu = zn && zn.exports === ea, ta = iu && ru.process, Yt = function() {
      try {
        var _ = zn && zn.require && zn.require("util").types;
        return _ || ta && ta.binding && ta.binding("util");
      } catch {
      }
    }(), ou = Yt && Yt.isArrayBuffer, au = Yt && Yt.isDate, su = Yt && Yt.isMap, uu = Yt && Yt.isRegExp, lu = Yt && Yt.isSet, cu = Yt && Yt.isTypedArray;
    function Dt(_, A, P) {
      switch (P.length) {
        case 0:
          return _.call(A);
        case 1:
          return _.call(A, P[0]);
        case 2:
          return _.call(A, P[0], P[1]);
        case 3:
          return _.call(A, P[0], P[1], P[2]);
      }
      return _.apply(A, P);
    }
    function Sd(_, A, P, z) {
      for (var ie = -1, Pe = _ == null ? 0 : _.length; ++ie < Pe; ) {
        var rt = _[ie];
        A(z, rt, P(rt), _);
      }
      return z;
    }
    function jt(_, A) {
      for (var P = -1, z = _ == null ? 0 : _.length; ++P < z && A(_[P], P, _) !== !1; )
        ;
      return _;
    }
    function Rd(_, A) {
      for (var P = _ == null ? 0 : _.length; P-- && A(_[P], P, _) !== !1; )
        ;
      return _;
    }
    function fu(_, A) {
      for (var P = -1, z = _ == null ? 0 : _.length; ++P < z; )
        if (!A(_[P], P, _))
          return !1;
      return !0;
    }
    function Mn(_, A) {
      for (var P = -1, z = _ == null ? 0 : _.length, ie = 0, Pe = []; ++P < z; ) {
        var rt = _[P];
        A(rt, P, _) && (Pe[ie++] = rt);
      }
      return Pe;
    }
    function ki(_, A) {
      var P = _ == null ? 0 : _.length;
      return !!P && mr(_, A, 0) > -1;
    }
    function na(_, A, P) {
      for (var z = -1, ie = _ == null ? 0 : _.length; ++z < ie; )
        if (P(A, _[z]))
          return !0;
      return !1;
    }
    function je(_, A) {
      for (var P = -1, z = _ == null ? 0 : _.length, ie = Array(z); ++P < z; )
        ie[P] = A(_[P], P, _);
      return ie;
    }
    function Dn(_, A) {
      for (var P = -1, z = A.length, ie = _.length; ++P < z; )
        _[ie + P] = A[P];
      return _;
    }
    function ra(_, A, P, z) {
      var ie = -1, Pe = _ == null ? 0 : _.length;
      for (z && Pe && (P = _[++ie]); ++ie < Pe; )
        P = A(P, _[ie], ie, _);
      return P;
    }
    function Ad(_, A, P, z) {
      var ie = _ == null ? 0 : _.length;
      for (z && ie && (P = _[--ie]); ie--; )
        P = A(P, _[ie], ie, _);
      return P;
    }
    function ia(_, A) {
      for (var P = -1, z = _ == null ? 0 : _.length; ++P < z; )
        if (A(_[P], P, _))
          return !0;
      return !1;
    }
    var kd = oa("length");
    function Md(_) {
      return _.split("");
    }
    function Dd(_) {
      return _.match(W) || [];
    }
    function du(_, A, P) {
      var z;
      return P(_, function(ie, Pe, rt) {
        if (A(ie, Pe, rt))
          return z = Pe, !1;
      }), z;
    }
    function Mi(_, A, P, z) {
      for (var ie = _.length, Pe = P + (z ? 1 : -1); z ? Pe-- : ++Pe < ie; )
        if (A(_[Pe], Pe, _))
          return Pe;
      return -1;
    }
    function mr(_, A, P) {
      return A === A ? Gd(_, A, P) : Mi(_, hu, P);
    }
    function Ld(_, A, P, z) {
      for (var ie = P - 1, Pe = _.length; ++ie < Pe; )
        if (z(_[ie], A))
          return ie;
      return -1;
    }
    function hu(_) {
      return _ !== _;
    }
    function gu(_, A) {
      var P = _ == null ? 0 : _.length;
      return P ? sa(_, A) / P : xe;
    }
    function oa(_) {
      return function(A) {
        return A == null ? r : A[_];
      };
    }
    function aa(_) {
      return function(A) {
        return _ == null ? r : _[A];
      };
    }
    function mu(_, A, P, z, ie) {
      return ie(_, function(Pe, rt, $e) {
        P = z ? (z = !1, Pe) : A(P, Pe, rt, $e);
      }), P;
    }
    function Nd(_, A) {
      var P = _.length;
      for (_.sort(A); P--; )
        _[P] = _[P].value;
      return _;
    }
    function sa(_, A) {
      for (var P, z = -1, ie = _.length; ++z < ie; ) {
        var Pe = A(_[z]);
        Pe !== r && (P = P === r ? Pe : P + Pe);
      }
      return P;
    }
    function ua(_, A) {
      for (var P = -1, z = Array(_); ++P < _; )
        z[P] = A(P);
      return z;
    }
    function Wd(_, A) {
      return je(A, function(P) {
        return [P, _[P]];
      });
    }
    function pu(_) {
      return _ && _.slice(0, bu(_) + 1).replace(zr, "");
    }
    function Lt(_) {
      return function(A) {
        return _(A);
      };
    }
    function la(_, A) {
      return je(A, function(P) {
        return _[P];
      });
    }
    function Xr(_, A) {
      return _.has(A);
    }
    function vu(_, A) {
      for (var P = -1, z = _.length; ++P < z && mr(A, _[P], 0) > -1; )
        ;
      return P;
    }
    function wu(_, A) {
      for (var P = _.length; P-- && mr(A, _[P], 0) > -1; )
        ;
      return P;
    }
    function Id(_, A) {
      for (var P = _.length, z = 0; P--; )
        _[P] === A && ++z;
      return z;
    }
    var Fd = aa(xd), $d = aa(_d);
    function Ud(_) {
      return "\\" + Td[_];
    }
    function Hd(_, A) {
      return _ == null ? r : _[A];
    }
    function pr(_) {
      return vd.test(_);
    }
    function Bd(_) {
      return wd.test(_);
    }
    function Yd(_) {
      for (var A, P = []; !(A = _.next()).done; )
        P.push(A.value);
      return P;
    }
    function ca(_) {
      var A = -1, P = Array(_.size);
      return _.forEach(function(z, ie) {
        P[++A] = [ie, z];
      }), P;
    }
    function yu(_, A) {
      return function(P) {
        return _(A(P));
      };
    }
    function Ln(_, A) {
      for (var P = -1, z = _.length, ie = 0, Pe = []; ++P < z; ) {
        var rt = _[P];
        (rt === A || rt === w) && (_[P] = w, Pe[ie++] = P);
      }
      return Pe;
    }
    function Di(_) {
      var A = -1, P = Array(_.size);
      return _.forEach(function(z) {
        P[++A] = z;
      }), P;
    }
    function jd(_) {
      var A = -1, P = Array(_.size);
      return _.forEach(function(z) {
        P[++A] = [z, z];
      }), P;
    }
    function Gd(_, A, P) {
      for (var z = P - 1, ie = _.length; ++z < ie; )
        if (_[z] === A)
          return z;
      return -1;
    }
    function qd(_, A, P) {
      for (var z = P + 1; z--; )
        if (_[z] === A)
          return z;
      return z;
    }
    function vr(_) {
      return pr(_) ? Vd(_) : kd(_);
    }
    function Zt(_) {
      return pr(_) ? Xd(_) : Md(_);
    }
    function bu(_) {
      for (var A = _.length; A-- && jo.test(_.charAt(A)); )
        ;
      return A;
    }
    var zd = aa(Cd);
    function Vd(_) {
      for (var A = Zo.lastIndex = 0; Zo.test(_); )
        ++A;
      return A;
    }
    function Xd(_) {
      return _.match(Zo) || [];
    }
    function Kd(_) {
      return _.match(pd) || [];
    }
    var Qd = function _(A) {
      A = A == null ? mt : wr.defaults(mt.Object(), A, wr.pick(mt, yd));
      var P = A.Array, z = A.Date, ie = A.Error, Pe = A.Function, rt = A.Math, $e = A.Object, fa = A.RegExp, Jd = A.String, Gt = A.TypeError, Li = P.prototype, Zd = Pe.prototype, yr = $e.prototype, Ni = A["__core-js_shared__"], Wi = Zd.toString, Le = yr.hasOwnProperty, eh = 0, xu = function() {
        var e = /[^.]+$/.exec(Ni && Ni.keys && Ni.keys.IE_PROTO || "");
        return e ? "Symbol(src)_1." + e : "";
      }(), Ii = yr.toString, th = Wi.call($e), nh = mt._, rh = fa(
        "^" + Wi.call(Le).replace(hr, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
      ), Fi = iu ? A.Buffer : r, Nn = A.Symbol, $i = A.Uint8Array, _u = Fi ? Fi.allocUnsafe : r, Ui = yu($e.getPrototypeOf, $e), Cu = $e.create, Tu = yr.propertyIsEnumerable, Hi = Li.splice, Eu = Nn ? Nn.isConcatSpreadable : r, Kr = Nn ? Nn.iterator : r, Vn = Nn ? Nn.toStringTag : r, Bi = function() {
        try {
          var e = Zn($e, "defineProperty");
          return e({}, "", {}), e;
        } catch {
        }
      }(), ih = A.clearTimeout !== mt.clearTimeout && A.clearTimeout, oh = z && z.now !== mt.Date.now && z.now, ah = A.setTimeout !== mt.setTimeout && A.setTimeout, Yi = rt.ceil, ji = rt.floor, da = $e.getOwnPropertySymbols, sh = Fi ? Fi.isBuffer : r, Ou = A.isFinite, uh = Li.join, lh = yu($e.keys, $e), it = rt.max, vt = rt.min, ch = z.now, fh = A.parseInt, Pu = rt.random, dh = Li.reverse, ha = Zn(A, "DataView"), Qr = Zn(A, "Map"), ga = Zn(A, "Promise"), br = Zn(A, "Set"), Jr = Zn(A, "WeakMap"), Zr = Zn($e, "create"), Gi = Jr && new Jr(), xr = {}, hh = er(ha), gh = er(Qr), mh = er(ga), ph = er(br), vh = er(Jr), qi = Nn ? Nn.prototype : r, ei = qi ? qi.valueOf : r, Su = qi ? qi.toString : r;
      function d(e) {
        if (Xe(e) && !oe(e) && !(e instanceof ye)) {
          if (e instanceof qt)
            return e;
          if (Le.call(e, "__wrapped__"))
            return Rl(e);
        }
        return new qt(e);
      }
      var _r = /* @__PURE__ */ function() {
        function e() {
        }
        return function(t) {
          if (!qe(t))
            return {};
          if (Cu)
            return Cu(t);
          e.prototype = t;
          var o = new e();
          return e.prototype = r, o;
        };
      }();
      function zi() {
      }
      function qt(e, t) {
        this.__wrapped__ = e, this.__actions__ = [], this.__chain__ = !!t, this.__index__ = 0, this.__values__ = r;
      }
      d.templateSettings = {
        /**
         * Used to detect `data` property values to be HTML-escaped.
         *
         * @memberOf _.templateSettings
         * @type {RegExp}
         */
        escape: Pi,
        /**
         * Used to detect code to be evaluated.
         *
         * @memberOf _.templateSettings
         * @type {RegExp}
         */
        evaluate: Ho,
        /**
         * Used to detect `data` property values to inject.
         *
         * @memberOf _.templateSettings
         * @type {RegExp}
         */
        interpolate: qr,
        /**
         * Used to reference the data object in the template text.
         *
         * @memberOf _.templateSettings
         * @type {string}
         */
        variable: "",
        /**
         * Used to import variables into the compiled template.
         *
         * @memberOf _.templateSettings
         * @type {Object}
         */
        imports: {
          /**
           * A reference to the `lodash` function.
           *
           * @memberOf _.templateSettings.imports
           * @type {Function}
           */
          _: d
        }
      }, d.prototype = zi.prototype, d.prototype.constructor = d, qt.prototype = _r(zi.prototype), qt.prototype.constructor = qt;
      function ye(e) {
        this.__wrapped__ = e, this.__actions__ = [], this.__dir__ = 1, this.__filtered__ = !1, this.__iteratees__ = [], this.__takeCount__ = Ie, this.__views__ = [];
      }
      function wh() {
        var e = new ye(this.__wrapped__);
        return e.__actions__ = Pt(this.__actions__), e.__dir__ = this.__dir__, e.__filtered__ = this.__filtered__, e.__iteratees__ = Pt(this.__iteratees__), e.__takeCount__ = this.__takeCount__, e.__views__ = Pt(this.__views__), e;
      }
      function yh() {
        if (this.__filtered__) {
          var e = new ye(this);
          e.__dir__ = -1, e.__filtered__ = !0;
        } else
          e = this.clone(), e.__dir__ *= -1;
        return e;
      }
      function bh() {
        var e = this.__wrapped__.value(), t = this.__dir__, o = oe(e), u = t < 0, c = o ? e.length : 0, h = Mg(0, c, this.__views__), v = h.start, b = h.end, C = b - v, M = u ? b : v - 1, D = this.__iteratees__, N = D.length, H = 0, K = vt(C, this.__takeCount__);
        if (!o || !u && c == C && K == C)
          return Ju(e, this.__actions__);
        var ee = [];
        e:
          for (; C-- && H < K; ) {
            M += t;
            for (var ue = -1, te = e[M]; ++ue < N; ) {
              var ge = D[ue], _e = ge.iteratee, It = ge.type, _t = _e(te);
              if (It == me)
                te = _t;
              else if (!_t) {
                if (It == Te)
                  continue e;
                break e;
              }
            }
            ee[H++] = te;
          }
        return ee;
      }
      ye.prototype = _r(zi.prototype), ye.prototype.constructor = ye;
      function Xn(e) {
        var t = -1, o = e == null ? 0 : e.length;
        for (this.clear(); ++t < o; ) {
          var u = e[t];
          this.set(u[0], u[1]);
        }
      }
      function xh() {
        this.__data__ = Zr ? Zr(null) : {}, this.size = 0;
      }
      function _h(e) {
        var t = this.has(e) && delete this.__data__[e];
        return this.size -= t ? 1 : 0, t;
      }
      function Ch(e) {
        var t = this.__data__;
        if (Zr) {
          var o = t[e];
          return o === g ? r : o;
        }
        return Le.call(t, e) ? t[e] : r;
      }
      function Th(e) {
        var t = this.__data__;
        return Zr ? t[e] !== r : Le.call(t, e);
      }
      function Eh(e, t) {
        var o = this.__data__;
        return this.size += this.has(e) ? 0 : 1, o[e] = Zr && t === r ? g : t, this;
      }
      Xn.prototype.clear = xh, Xn.prototype.delete = _h, Xn.prototype.get = Ch, Xn.prototype.has = Th, Xn.prototype.set = Eh;
      function vn(e) {
        var t = -1, o = e == null ? 0 : e.length;
        for (this.clear(); ++t < o; ) {
          var u = e[t];
          this.set(u[0], u[1]);
        }
      }
      function Oh() {
        this.__data__ = [], this.size = 0;
      }
      function Ph(e) {
        var t = this.__data__, o = Vi(t, e);
        if (o < 0)
          return !1;
        var u = t.length - 1;
        return o == u ? t.pop() : Hi.call(t, o, 1), --this.size, !0;
      }
      function Sh(e) {
        var t = this.__data__, o = Vi(t, e);
        return o < 0 ? r : t[o][1];
      }
      function Rh(e) {
        return Vi(this.__data__, e) > -1;
      }
      function Ah(e, t) {
        var o = this.__data__, u = Vi(o, e);
        return u < 0 ? (++this.size, o.push([e, t])) : o[u][1] = t, this;
      }
      vn.prototype.clear = Oh, vn.prototype.delete = Ph, vn.prototype.get = Sh, vn.prototype.has = Rh, vn.prototype.set = Ah;
      function wn(e) {
        var t = -1, o = e == null ? 0 : e.length;
        for (this.clear(); ++t < o; ) {
          var u = e[t];
          this.set(u[0], u[1]);
        }
      }
      function kh() {
        this.size = 0, this.__data__ = {
          hash: new Xn(),
          map: new (Qr || vn)(),
          string: new Xn()
        };
      }
      function Mh(e) {
        var t = ao(this, e).delete(e);
        return this.size -= t ? 1 : 0, t;
      }
      function Dh(e) {
        return ao(this, e).get(e);
      }
      function Lh(e) {
        return ao(this, e).has(e);
      }
      function Nh(e, t) {
        var o = ao(this, e), u = o.size;
        return o.set(e, t), this.size += o.size == u ? 0 : 1, this;
      }
      wn.prototype.clear = kh, wn.prototype.delete = Mh, wn.prototype.get = Dh, wn.prototype.has = Lh, wn.prototype.set = Nh;
      function Kn(e) {
        var t = -1, o = e == null ? 0 : e.length;
        for (this.__data__ = new wn(); ++t < o; )
          this.add(e[t]);
      }
      function Wh(e) {
        return this.__data__.set(e, g), this;
      }
      function Ih(e) {
        return this.__data__.has(e);
      }
      Kn.prototype.add = Kn.prototype.push = Wh, Kn.prototype.has = Ih;
      function en(e) {
        var t = this.__data__ = new vn(e);
        this.size = t.size;
      }
      function Fh() {
        this.__data__ = new vn(), this.size = 0;
      }
      function $h(e) {
        var t = this.__data__, o = t.delete(e);
        return this.size = t.size, o;
      }
      function Uh(e) {
        return this.__data__.get(e);
      }
      function Hh(e) {
        return this.__data__.has(e);
      }
      function Bh(e, t) {
        var o = this.__data__;
        if (o instanceof vn) {
          var u = o.__data__;
          if (!Qr || u.length < s - 1)
            return u.push([e, t]), this.size = ++o.size, this;
          o = this.__data__ = new wn(u);
        }
        return o.set(e, t), this.size = o.size, this;
      }
      en.prototype.clear = Fh, en.prototype.delete = $h, en.prototype.get = Uh, en.prototype.has = Hh, en.prototype.set = Bh;
      function Ru(e, t) {
        var o = oe(e), u = !o && tr(e), c = !o && !u && Un(e), h = !o && !u && !c && Or(e), v = o || u || c || h, b = v ? ua(e.length, Jd) : [], C = b.length;
        for (var M in e)
          (t || Le.call(e, M)) && !(v && // Safari 9 has enumerable `arguments.length` in strict mode.
          (M == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
          c && (M == "offset" || M == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
          h && (M == "buffer" || M == "byteLength" || M == "byteOffset") || // Skip index properties.
          _n(M, C))) && b.push(M);
        return b;
      }
      function Au(e) {
        var t = e.length;
        return t ? e[Ea(0, t - 1)] : r;
      }
      function Yh(e, t) {
        return so(Pt(e), Qn(t, 0, e.length));
      }
      function jh(e) {
        return so(Pt(e));
      }
      function ma(e, t, o) {
        (o !== r && !tn(e[t], o) || o === r && !(t in e)) && yn(e, t, o);
      }
      function ti(e, t, o) {
        var u = e[t];
        (!(Le.call(e, t) && tn(u, o)) || o === r && !(t in e)) && yn(e, t, o);
      }
      function Vi(e, t) {
        for (var o = e.length; o--; )
          if (tn(e[o][0], t))
            return o;
        return -1;
      }
      function Gh(e, t, o, u) {
        return Wn(e, function(c, h, v) {
          t(u, c, o(c), v);
        }), u;
      }
      function ku(e, t) {
        return e && un(t, ct(t), e);
      }
      function qh(e, t) {
        return e && un(t, Rt(t), e);
      }
      function yn(e, t, o) {
        t == "__proto__" && Bi ? Bi(e, t, {
          configurable: !0,
          enumerable: !0,
          value: o,
          writable: !0
        }) : e[t] = o;
      }
      function pa(e, t) {
        for (var o = -1, u = t.length, c = P(u), h = e == null; ++o < u; )
          c[o] = h ? r : Ka(e, t[o]);
        return c;
      }
      function Qn(e, t, o) {
        return e === e && (o !== r && (e = e <= o ? e : o), t !== r && (e = e >= t ? e : t)), e;
      }
      function zt(e, t, o, u, c, h) {
        var v, b = t & x, C = t & T, M = t & E;
        if (o && (v = c ? o(e, u, c, h) : o(e)), v !== r)
          return v;
        if (!qe(e))
          return e;
        var D = oe(e);
        if (D) {
          if (v = Lg(e), !b)
            return Pt(e, v);
        } else {
          var N = wt(e), H = N == st || N == Bt;
          if (Un(e))
            return tl(e, b);
          if (N == ut || N == Se || H && !c) {
            if (v = C || H ? {} : bl(e), !b)
              return C ? Cg(e, qh(v, e)) : _g(e, ku(v, e));
          } else {
            if (!Ue[N])
              return c ? e : {};
            v = Ng(e, N, b);
          }
        }
        h || (h = new en());
        var K = h.get(e);
        if (K)
          return K;
        h.set(e, v), Xl(e) ? e.forEach(function(te) {
          v.add(zt(te, t, o, te, e, h));
        }) : zl(e) && e.forEach(function(te, ge) {
          v.set(ge, zt(te, t, o, ge, e, h));
        });
        var ee = M ? C ? Wa : Na : C ? Rt : ct, ue = D ? r : ee(e);
        return jt(ue || e, function(te, ge) {
          ue && (ge = te, te = e[ge]), ti(v, ge, zt(te, t, o, ge, e, h));
        }), v;
      }
      function zh(e) {
        var t = ct(e);
        return function(o) {
          return Mu(o, e, t);
        };
      }
      function Mu(e, t, o) {
        var u = o.length;
        if (e == null)
          return !u;
        for (e = $e(e); u--; ) {
          var c = o[u], h = t[c], v = e[c];
          if (v === r && !(c in e) || !h(v))
            return !1;
        }
        return !0;
      }
      function Du(e, t, o) {
        if (typeof e != "function")
          throw new Gt(f);
        return ui(function() {
          e.apply(r, o);
        }, t);
      }
      function ni(e, t, o, u) {
        var c = -1, h = ki, v = !0, b = e.length, C = [], M = t.length;
        if (!b)
          return C;
        o && (t = je(t, Lt(o))), u ? (h = na, v = !1) : t.length >= s && (h = Xr, v = !1, t = new Kn(t));
        e:
          for (; ++c < b; ) {
            var D = e[c], N = o == null ? D : o(D);
            if (D = u || D !== 0 ? D : 0, v && N === N) {
              for (var H = M; H--; )
                if (t[H] === N)
                  continue e;
              C.push(D);
            } else h(t, N, u) || C.push(D);
          }
        return C;
      }
      var Wn = al(sn), Lu = al(wa, !0);
      function Vh(e, t) {
        var o = !0;
        return Wn(e, function(u, c, h) {
          return o = !!t(u, c, h), o;
        }), o;
      }
      function Xi(e, t, o) {
        for (var u = -1, c = e.length; ++u < c; ) {
          var h = e[u], v = t(h);
          if (v != null && (b === r ? v === v && !Wt(v) : o(v, b)))
            var b = v, C = h;
        }
        return C;
      }
      function Xh(e, t, o, u) {
        var c = e.length;
        for (o = ae(o), o < 0 && (o = -o > c ? 0 : c + o), u = u === r || u > c ? c : ae(u), u < 0 && (u += c), u = o > u ? 0 : Ql(u); o < u; )
          e[o++] = t;
        return e;
      }
      function Nu(e, t) {
        var o = [];
        return Wn(e, function(u, c, h) {
          t(u, c, h) && o.push(u);
        }), o;
      }
      function pt(e, t, o, u, c) {
        var h = -1, v = e.length;
        for (o || (o = Ig), c || (c = []); ++h < v; ) {
          var b = e[h];
          t > 0 && o(b) ? t > 1 ? pt(b, t - 1, o, u, c) : Dn(c, b) : u || (c[c.length] = b);
        }
        return c;
      }
      var va = sl(), Wu = sl(!0);
      function sn(e, t) {
        return e && va(e, t, ct);
      }
      function wa(e, t) {
        return e && Wu(e, t, ct);
      }
      function Ki(e, t) {
        return Mn(t, function(o) {
          return Cn(e[o]);
        });
      }
      function Jn(e, t) {
        t = Fn(t, e);
        for (var o = 0, u = t.length; e != null && o < u; )
          e = e[ln(t[o++])];
        return o && o == u ? e : r;
      }
      function Iu(e, t, o) {
        var u = t(e);
        return oe(e) ? u : Dn(u, o(e));
      }
      function bt(e) {
        return e == null ? e === r ? ht : Ct : Vn && Vn in $e(e) ? kg(e) : jg(e);
      }
      function ya(e, t) {
        return e > t;
      }
      function Kh(e, t) {
        return e != null && Le.call(e, t);
      }
      function Qh(e, t) {
        return e != null && t in $e(e);
      }
      function Jh(e, t, o) {
        return e >= vt(t, o) && e < it(t, o);
      }
      function ba(e, t, o) {
        for (var u = o ? na : ki, c = e[0].length, h = e.length, v = h, b = P(h), C = 1 / 0, M = []; v--; ) {
          var D = e[v];
          v && t && (D = je(D, Lt(t))), C = vt(D.length, C), b[v] = !o && (t || c >= 120 && D.length >= 120) ? new Kn(v && D) : r;
        }
        D = e[0];
        var N = -1, H = b[0];
        e:
          for (; ++N < c && M.length < C; ) {
            var K = D[N], ee = t ? t(K) : K;
            if (K = o || K !== 0 ? K : 0, !(H ? Xr(H, ee) : u(M, ee, o))) {
              for (v = h; --v; ) {
                var ue = b[v];
                if (!(ue ? Xr(ue, ee) : u(e[v], ee, o)))
                  continue e;
              }
              H && H.push(ee), M.push(K);
            }
          }
        return M;
      }
      function Zh(e, t, o, u) {
        return sn(e, function(c, h, v) {
          t(u, o(c), h, v);
        }), u;
      }
      function ri(e, t, o) {
        t = Fn(t, e), e = Tl(e, t);
        var u = e == null ? e : e[ln(Xt(t))];
        return u == null ? r : Dt(u, e, o);
      }
      function Fu(e) {
        return Xe(e) && bt(e) == Se;
      }
      function eg(e) {
        return Xe(e) && bt(e) == Mt;
      }
      function tg(e) {
        return Xe(e) && bt(e) == Ke;
      }
      function ii(e, t, o, u, c) {
        return e === t ? !0 : e == null || t == null || !Xe(e) && !Xe(t) ? e !== e && t !== t : ng(e, t, o, u, ii, c);
      }
      function ng(e, t, o, u, c, h) {
        var v = oe(e), b = oe(t), C = v ? et : wt(e), M = b ? et : wt(t);
        C = C == Se ? ut : C, M = M == Se ? ut : M;
        var D = C == ut, N = M == ut, H = C == M;
        if (H && Un(e)) {
          if (!Un(t))
            return !1;
          v = !0, D = !1;
        }
        if (H && !D)
          return h || (h = new en()), v || Or(e) ? vl(e, t, o, u, c, h) : Rg(e, t, C, o, u, c, h);
        if (!(o & O)) {
          var K = D && Le.call(e, "__wrapped__"), ee = N && Le.call(t, "__wrapped__");
          if (K || ee) {
            var ue = K ? e.value() : e, te = ee ? t.value() : t;
            return h || (h = new en()), c(ue, te, o, u, h);
          }
        }
        return H ? (h || (h = new en()), Ag(e, t, o, u, c, h)) : !1;
      }
      function rg(e) {
        return Xe(e) && wt(e) == Qe;
      }
      function xa(e, t, o, u) {
        var c = o.length, h = c, v = !u;
        if (e == null)
          return !h;
        for (e = $e(e); c--; ) {
          var b = o[c];
          if (v && b[2] ? b[1] !== e[b[0]] : !(b[0] in e))
            return !1;
        }
        for (; ++c < h; ) {
          b = o[c];
          var C = b[0], M = e[C], D = b[1];
          if (v && b[2]) {
            if (M === r && !(C in e))
              return !1;
          } else {
            var N = new en();
            if (u)
              var H = u(M, D, C, e, t, N);
            if (!(H === r ? ii(D, M, O | k, u, N) : H))
              return !1;
          }
        }
        return !0;
      }
      function $u(e) {
        if (!qe(e) || $g(e))
          return !1;
        var t = Cn(e) ? rh : gt;
        return t.test(er(e));
      }
      function ig(e) {
        return Xe(e) && bt(e) == J;
      }
      function og(e) {
        return Xe(e) && wt(e) == Re;
      }
      function ag(e) {
        return Xe(e) && go(e.length) && !!He[bt(e)];
      }
      function Uu(e) {
        return typeof e == "function" ? e : e == null ? At : typeof e == "object" ? oe(e) ? Yu(e[0], e[1]) : Bu(e) : uc(e);
      }
      function _a(e) {
        if (!si(e))
          return lh(e);
        var t = [];
        for (var o in $e(e))
          Le.call(e, o) && o != "constructor" && t.push(o);
        return t;
      }
      function sg(e) {
        if (!qe(e))
          return Yg(e);
        var t = si(e), o = [];
        for (var u in e)
          u == "constructor" && (t || !Le.call(e, u)) || o.push(u);
        return o;
      }
      function Ca(e, t) {
        return e < t;
      }
      function Hu(e, t) {
        var o = -1, u = St(e) ? P(e.length) : [];
        return Wn(e, function(c, h, v) {
          u[++o] = t(c, h, v);
        }), u;
      }
      function Bu(e) {
        var t = Fa(e);
        return t.length == 1 && t[0][2] ? _l(t[0][0], t[0][1]) : function(o) {
          return o === e || xa(o, e, t);
        };
      }
      function Yu(e, t) {
        return Ua(e) && xl(t) ? _l(ln(e), t) : function(o) {
          var u = Ka(o, e);
          return u === r && u === t ? Qa(o, e) : ii(t, u, O | k);
        };
      }
      function Qi(e, t, o, u, c) {
        e !== t && va(t, function(h, v) {
          if (c || (c = new en()), qe(h))
            ug(e, t, v, o, Qi, u, c);
          else {
            var b = u ? u(Ba(e, v), h, v + "", e, t, c) : r;
            b === r && (b = h), ma(e, v, b);
          }
        }, Rt);
      }
      function ug(e, t, o, u, c, h, v) {
        var b = Ba(e, o), C = Ba(t, o), M = v.get(C);
        if (M) {
          ma(e, o, M);
          return;
        }
        var D = h ? h(b, C, o + "", e, t, v) : r, N = D === r;
        if (N) {
          var H = oe(C), K = !H && Un(C), ee = !H && !K && Or(C);
          D = C, H || K || ee ? oe(b) ? D = b : Je(b) ? D = Pt(b) : K ? (N = !1, D = tl(C, !0)) : ee ? (N = !1, D = nl(C, !0)) : D = [] : li(C) || tr(C) ? (D = b, tr(b) ? D = Jl(b) : (!qe(b) || Cn(b)) && (D = bl(C))) : N = !1;
        }
        N && (v.set(C, D), c(D, C, u, h, v), v.delete(C)), ma(e, o, D);
      }
      function ju(e, t) {
        var o = e.length;
        if (o)
          return t += t < 0 ? o : 0, _n(t, o) ? e[t] : r;
      }
      function Gu(e, t, o) {
        t.length ? t = je(t, function(h) {
          return oe(h) ? function(v) {
            return Jn(v, h.length === 1 ? h[0] : h);
          } : h;
        }) : t = [At];
        var u = -1;
        t = je(t, Lt(Z()));
        var c = Hu(e, function(h, v, b) {
          var C = je(t, function(M) {
            return M(h);
          });
          return { criteria: C, index: ++u, value: h };
        });
        return Nd(c, function(h, v) {
          return xg(h, v, o);
        });
      }
      function lg(e, t) {
        return qu(e, t, function(o, u) {
          return Qa(e, u);
        });
      }
      function qu(e, t, o) {
        for (var u = -1, c = t.length, h = {}; ++u < c; ) {
          var v = t[u], b = Jn(e, v);
          o(b, v) && oi(h, Fn(v, e), b);
        }
        return h;
      }
      function cg(e) {
        return function(t) {
          return Jn(t, e);
        };
      }
      function Ta(e, t, o, u) {
        var c = u ? Ld : mr, h = -1, v = t.length, b = e;
        for (e === t && (t = Pt(t)), o && (b = je(e, Lt(o))); ++h < v; )
          for (var C = 0, M = t[h], D = o ? o(M) : M; (C = c(b, D, C, u)) > -1; )
            b !== e && Hi.call(b, C, 1), Hi.call(e, C, 1);
        return e;
      }
      function zu(e, t) {
        for (var o = e ? t.length : 0, u = o - 1; o--; ) {
          var c = t[o];
          if (o == u || c !== h) {
            var h = c;
            _n(c) ? Hi.call(e, c, 1) : Sa(e, c);
          }
        }
        return e;
      }
      function Ea(e, t) {
        return e + ji(Pu() * (t - e + 1));
      }
      function fg(e, t, o, u) {
        for (var c = -1, h = it(Yi((t - e) / (o || 1)), 0), v = P(h); h--; )
          v[u ? h : ++c] = e, e += o;
        return v;
      }
      function Oa(e, t) {
        var o = "";
        if (!e || t < 1 || t > F)
          return o;
        do
          t % 2 && (o += e), t = ji(t / 2), t && (e += e);
        while (t);
        return o;
      }
      function le(e, t) {
        return Ya(Cl(e, t, At), e + "");
      }
      function dg(e) {
        return Au(Pr(e));
      }
      function hg(e, t) {
        var o = Pr(e);
        return so(o, Qn(t, 0, o.length));
      }
      function oi(e, t, o, u) {
        if (!qe(e))
          return e;
        t = Fn(t, e);
        for (var c = -1, h = t.length, v = h - 1, b = e; b != null && ++c < h; ) {
          var C = ln(t[c]), M = o;
          if (C === "__proto__" || C === "constructor" || C === "prototype")
            return e;
          if (c != v) {
            var D = b[C];
            M = u ? u(D, C, b) : r, M === r && (M = qe(D) ? D : _n(t[c + 1]) ? [] : {});
          }
          ti(b, C, M), b = b[C];
        }
        return e;
      }
      var Vu = Gi ? function(e, t) {
        return Gi.set(e, t), e;
      } : At, gg = Bi ? function(e, t) {
        return Bi(e, "toString", {
          configurable: !0,
          enumerable: !1,
          value: Za(t),
          writable: !0
        });
      } : At;
      function mg(e) {
        return so(Pr(e));
      }
      function Vt(e, t, o) {
        var u = -1, c = e.length;
        t < 0 && (t = -t > c ? 0 : c + t), o = o > c ? c : o, o < 0 && (o += c), c = t > o ? 0 : o - t >>> 0, t >>>= 0;
        for (var h = P(c); ++u < c; )
          h[u] = e[u + t];
        return h;
      }
      function pg(e, t) {
        var o;
        return Wn(e, function(u, c, h) {
          return o = t(u, c, h), !o;
        }), !!o;
      }
      function Ji(e, t, o) {
        var u = 0, c = e == null ? u : e.length;
        if (typeof t == "number" && t === t && c <= Oe) {
          for (; u < c; ) {
            var h = u + c >>> 1, v = e[h];
            v !== null && !Wt(v) && (o ? v <= t : v < t) ? u = h + 1 : c = h;
          }
          return c;
        }
        return Pa(e, t, At, o);
      }
      function Pa(e, t, o, u) {
        var c = 0, h = e == null ? 0 : e.length;
        if (h === 0)
          return 0;
        t = o(t);
        for (var v = t !== t, b = t === null, C = Wt(t), M = t === r; c < h; ) {
          var D = ji((c + h) / 2), N = o(e[D]), H = N !== r, K = N === null, ee = N === N, ue = Wt(N);
          if (v)
            var te = u || ee;
          else M ? te = ee && (u || H) : b ? te = ee && H && (u || !K) : C ? te = ee && H && !K && (u || !ue) : K || ue ? te = !1 : te = u ? N <= t : N < t;
          te ? c = D + 1 : h = D;
        }
        return vt(h, yt);
      }
      function Xu(e, t) {
        for (var o = -1, u = e.length, c = 0, h = []; ++o < u; ) {
          var v = e[o], b = t ? t(v) : v;
          if (!o || !tn(b, C)) {
            var C = b;
            h[c++] = v === 0 ? 0 : v;
          }
        }
        return h;
      }
      function Ku(e) {
        return typeof e == "number" ? e : Wt(e) ? xe : +e;
      }
      function Nt(e) {
        if (typeof e == "string")
          return e;
        if (oe(e))
          return je(e, Nt) + "";
        if (Wt(e))
          return Su ? Su.call(e) : "";
        var t = e + "";
        return t == "0" && 1 / e == -1 / 0 ? "-0" : t;
      }
      function In(e, t, o) {
        var u = -1, c = ki, h = e.length, v = !0, b = [], C = b;
        if (o)
          v = !1, c = na;
        else if (h >= s) {
          var M = t ? null : Pg(e);
          if (M)
            return Di(M);
          v = !1, c = Xr, C = new Kn();
        } else
          C = t ? [] : b;
        e:
          for (; ++u < h; ) {
            var D = e[u], N = t ? t(D) : D;
            if (D = o || D !== 0 ? D : 0, v && N === N) {
              for (var H = C.length; H--; )
                if (C[H] === N)
                  continue e;
              t && C.push(N), b.push(D);
            } else c(C, N, o) || (C !== b && C.push(N), b.push(D));
          }
        return b;
      }
      function Sa(e, t) {
        return t = Fn(t, e), e = Tl(e, t), e == null || delete e[ln(Xt(t))];
      }
      function Qu(e, t, o, u) {
        return oi(e, t, o(Jn(e, t)), u);
      }
      function Zi(e, t, o, u) {
        for (var c = e.length, h = u ? c : -1; (u ? h-- : ++h < c) && t(e[h], h, e); )
          ;
        return o ? Vt(e, u ? 0 : h, u ? h + 1 : c) : Vt(e, u ? h + 1 : 0, u ? c : h);
      }
      function Ju(e, t) {
        var o = e;
        return o instanceof ye && (o = o.value()), ra(t, function(u, c) {
          return c.func.apply(c.thisArg, Dn([u], c.args));
        }, o);
      }
      function Ra(e, t, o) {
        var u = e.length;
        if (u < 2)
          return u ? In(e[0]) : [];
        for (var c = -1, h = P(u); ++c < u; )
          for (var v = e[c], b = -1; ++b < u; )
            b != c && (h[c] = ni(h[c] || v, e[b], t, o));
        return In(pt(h, 1), t, o);
      }
      function Zu(e, t, o) {
        for (var u = -1, c = e.length, h = t.length, v = {}; ++u < c; ) {
          var b = u < h ? t[u] : r;
          o(v, e[u], b);
        }
        return v;
      }
      function Aa(e) {
        return Je(e) ? e : [];
      }
      function ka(e) {
        return typeof e == "function" ? e : At;
      }
      function Fn(e, t) {
        return oe(e) ? e : Ua(e, t) ? [e] : Sl(ke(e));
      }
      var vg = le;
      function $n(e, t, o) {
        var u = e.length;
        return o = o === r ? u : o, !t && o >= u ? e : Vt(e, t, o);
      }
      var el = ih || function(e) {
        return mt.clearTimeout(e);
      };
      function tl(e, t) {
        if (t)
          return e.slice();
        var o = e.length, u = _u ? _u(o) : new e.constructor(o);
        return e.copy(u), u;
      }
      function Ma(e) {
        var t = new e.constructor(e.byteLength);
        return new $i(t).set(new $i(e)), t;
      }
      function wg(e, t) {
        var o = t ? Ma(e.buffer) : e.buffer;
        return new e.constructor(o, e.byteOffset, e.byteLength);
      }
      function yg(e) {
        var t = new e.constructor(e.source, Ae.exec(e));
        return t.lastIndex = e.lastIndex, t;
      }
      function bg(e) {
        return ei ? $e(ei.call(e)) : {};
      }
      function nl(e, t) {
        var o = t ? Ma(e.buffer) : e.buffer;
        return new e.constructor(o, e.byteOffset, e.length);
      }
      function rl(e, t) {
        if (e !== t) {
          var o = e !== r, u = e === null, c = e === e, h = Wt(e), v = t !== r, b = t === null, C = t === t, M = Wt(t);
          if (!b && !M && !h && e > t || h && v && C && !b && !M || u && v && C || !o && C || !c)
            return 1;
          if (!u && !h && !M && e < t || M && o && c && !u && !h || b && o && c || !v && c || !C)
            return -1;
        }
        return 0;
      }
      function xg(e, t, o) {
        for (var u = -1, c = e.criteria, h = t.criteria, v = c.length, b = o.length; ++u < v; ) {
          var C = rl(c[u], h[u]);
          if (C) {
            if (u >= b)
              return C;
            var M = o[u];
            return C * (M == "desc" ? -1 : 1);
          }
        }
        return e.index - t.index;
      }
      function il(e, t, o, u) {
        for (var c = -1, h = e.length, v = o.length, b = -1, C = t.length, M = it(h - v, 0), D = P(C + M), N = !u; ++b < C; )
          D[b] = t[b];
        for (; ++c < v; )
          (N || c < h) && (D[o[c]] = e[c]);
        for (; M--; )
          D[b++] = e[c++];
        return D;
      }
      function ol(e, t, o, u) {
        for (var c = -1, h = e.length, v = -1, b = o.length, C = -1, M = t.length, D = it(h - b, 0), N = P(D + M), H = !u; ++c < D; )
          N[c] = e[c];
        for (var K = c; ++C < M; )
          N[K + C] = t[C];
        for (; ++v < b; )
          (H || c < h) && (N[K + o[v]] = e[c++]);
        return N;
      }
      function Pt(e, t) {
        var o = -1, u = e.length;
        for (t || (t = P(u)); ++o < u; )
          t[o] = e[o];
        return t;
      }
      function un(e, t, o, u) {
        var c = !o;
        o || (o = {});
        for (var h = -1, v = t.length; ++h < v; ) {
          var b = t[h], C = u ? u(o[b], e[b], b, o, e) : r;
          C === r && (C = e[b]), c ? yn(o, b, C) : ti(o, b, C);
        }
        return o;
      }
      function _g(e, t) {
        return un(e, $a(e), t);
      }
      function Cg(e, t) {
        return un(e, wl(e), t);
      }
      function eo(e, t) {
        return function(o, u) {
          var c = oe(o) ? Sd : Gh, h = t ? t() : {};
          return c(o, e, Z(u, 2), h);
        };
      }
      function Cr(e) {
        return le(function(t, o) {
          var u = -1, c = o.length, h = c > 1 ? o[c - 1] : r, v = c > 2 ? o[2] : r;
          for (h = e.length > 3 && typeof h == "function" ? (c--, h) : r, v && xt(o[0], o[1], v) && (h = c < 3 ? r : h, c = 1), t = $e(t); ++u < c; ) {
            var b = o[u];
            b && e(t, b, u, h);
          }
          return t;
        });
      }
      function al(e, t) {
        return function(o, u) {
          if (o == null)
            return o;
          if (!St(o))
            return e(o, u);
          for (var c = o.length, h = t ? c : -1, v = $e(o); (t ? h-- : ++h < c) && u(v[h], h, v) !== !1; )
            ;
          return o;
        };
      }
      function sl(e) {
        return function(t, o, u) {
          for (var c = -1, h = $e(t), v = u(t), b = v.length; b--; ) {
            var C = v[e ? b : ++c];
            if (o(h[C], C, h) === !1)
              break;
          }
          return t;
        };
      }
      function Tg(e, t, o) {
        var u = t & L, c = ai(e);
        function h() {
          var v = this && this !== mt && this instanceof h ? c : e;
          return v.apply(u ? o : this, arguments);
        }
        return h;
      }
      function ul(e) {
        return function(t) {
          t = ke(t);
          var o = pr(t) ? Zt(t) : r, u = o ? o[0] : t.charAt(0), c = o ? $n(o, 1).join("") : t.slice(1);
          return u[e]() + c;
        };
      }
      function Tr(e) {
        return function(t) {
          return ra(ac(oc(t).replace(gd, "")), e, "");
        };
      }
      function ai(e) {
        return function() {
          var t = arguments;
          switch (t.length) {
            case 0:
              return new e();
            case 1:
              return new e(t[0]);
            case 2:
              return new e(t[0], t[1]);
            case 3:
              return new e(t[0], t[1], t[2]);
            case 4:
              return new e(t[0], t[1], t[2], t[3]);
            case 5:
              return new e(t[0], t[1], t[2], t[3], t[4]);
            case 6:
              return new e(t[0], t[1], t[2], t[3], t[4], t[5]);
            case 7:
              return new e(t[0], t[1], t[2], t[3], t[4], t[5], t[6]);
          }
          var o = _r(e.prototype), u = e.apply(o, t);
          return qe(u) ? u : o;
        };
      }
      function Eg(e, t, o) {
        var u = ai(e);
        function c() {
          for (var h = arguments.length, v = P(h), b = h, C = Er(c); b--; )
            v[b] = arguments[b];
          var M = h < 3 && v[0] !== C && v[h - 1] !== C ? [] : Ln(v, C);
          if (h -= M.length, h < o)
            return hl(
              e,
              t,
              to,
              c.placeholder,
              r,
              v,
              M,
              r,
              r,
              o - h
            );
          var D = this && this !== mt && this instanceof c ? u : e;
          return Dt(D, this, v);
        }
        return c;
      }
      function ll(e) {
        return function(t, o, u) {
          var c = $e(t);
          if (!St(t)) {
            var h = Z(o, 3);
            t = ct(t), o = function(b) {
              return h(c[b], b, c);
            };
          }
          var v = e(t, o, u);
          return v > -1 ? c[h ? t[v] : v] : r;
        };
      }
      function cl(e) {
        return xn(function(t) {
          var o = t.length, u = o, c = qt.prototype.thru;
          for (e && t.reverse(); u--; ) {
            var h = t[u];
            if (typeof h != "function")
              throw new Gt(f);
            if (c && !v && oo(h) == "wrapper")
              var v = new qt([], !0);
          }
          for (u = v ? u : o; ++u < o; ) {
            h = t[u];
            var b = oo(h), C = b == "wrapper" ? Ia(h) : r;
            C && Ha(C[0]) && C[1] == (j | B | Y | U) && !C[4].length && C[9] == 1 ? v = v[oo(C[0])].apply(v, C[3]) : v = h.length == 1 && Ha(h) ? v[b]() : v.thru(h);
          }
          return function() {
            var M = arguments, D = M[0];
            if (v && M.length == 1 && oe(D))
              return v.plant(D).value();
            for (var N = 0, H = o ? t[N].apply(this, M) : D; ++N < o; )
              H = t[N].call(this, H);
            return H;
          };
        });
      }
      function to(e, t, o, u, c, h, v, b, C, M) {
        var D = t & j, N = t & L, H = t & I, K = t & (B | q), ee = t & se, ue = H ? r : ai(e);
        function te() {
          for (var ge = arguments.length, _e = P(ge), It = ge; It--; )
            _e[It] = arguments[It];
          if (K)
            var _t = Er(te), Ft = Id(_e, _t);
          if (u && (_e = il(_e, u, c, K)), h && (_e = ol(_e, h, v, K)), ge -= Ft, K && ge < M) {
            var Ze = Ln(_e, _t);
            return hl(
              e,
              t,
              to,
              te.placeholder,
              o,
              _e,
              Ze,
              b,
              C,
              M - ge
            );
          }
          var nn = N ? o : this, En = H ? nn[e] : e;
          return ge = _e.length, b ? _e = Gg(_e, b) : ee && ge > 1 && _e.reverse(), D && C < ge && (_e.length = C), this && this !== mt && this instanceof te && (En = ue || ai(En)), En.apply(nn, _e);
        }
        return te;
      }
      function fl(e, t) {
        return function(o, u) {
          return Zh(o, e, t(u), {});
        };
      }
      function no(e, t) {
        return function(o, u) {
          var c;
          if (o === r && u === r)
            return t;
          if (o !== r && (c = o), u !== r) {
            if (c === r)
              return u;
            typeof o == "string" || typeof u == "string" ? (o = Nt(o), u = Nt(u)) : (o = Ku(o), u = Ku(u)), c = e(o, u);
          }
          return c;
        };
      }
      function Da(e) {
        return xn(function(t) {
          return t = je(t, Lt(Z())), le(function(o) {
            var u = this;
            return e(t, function(c) {
              return Dt(c, u, o);
            });
          });
        });
      }
      function ro(e, t) {
        t = t === r ? " " : Nt(t);
        var o = t.length;
        if (o < 2)
          return o ? Oa(t, e) : t;
        var u = Oa(t, Yi(e / vr(t)));
        return pr(t) ? $n(Zt(u), 0, e).join("") : u.slice(0, e);
      }
      function Og(e, t, o, u) {
        var c = t & L, h = ai(e);
        function v() {
          for (var b = -1, C = arguments.length, M = -1, D = u.length, N = P(D + C), H = this && this !== mt && this instanceof v ? h : e; ++M < D; )
            N[M] = u[M];
          for (; C--; )
            N[M++] = arguments[++b];
          return Dt(H, c ? o : this, N);
        }
        return v;
      }
      function dl(e) {
        return function(t, o, u) {
          return u && typeof u != "number" && xt(t, o, u) && (o = u = r), t = Tn(t), o === r ? (o = t, t = 0) : o = Tn(o), u = u === r ? t < o ? 1 : -1 : Tn(u), fg(t, o, u, e);
        };
      }
      function io(e) {
        return function(t, o) {
          return typeof t == "string" && typeof o == "string" || (t = Kt(t), o = Kt(o)), e(t, o);
        };
      }
      function hl(e, t, o, u, c, h, v, b, C, M) {
        var D = t & B, N = D ? v : r, H = D ? r : v, K = D ? h : r, ee = D ? r : h;
        t |= D ? Y : Q, t &= ~(D ? Q : Y), t & $ || (t &= -4);
        var ue = [
          e,
          t,
          c,
          K,
          N,
          ee,
          H,
          b,
          C,
          M
        ], te = o.apply(r, ue);
        return Ha(e) && El(te, ue), te.placeholder = u, Ol(te, e, t);
      }
      function La(e) {
        var t = rt[e];
        return function(o, u) {
          if (o = Kt(o), u = u == null ? 0 : vt(ae(u), 292), u && Ou(o)) {
            var c = (ke(o) + "e").split("e"), h = t(c[0] + "e" + (+c[1] + u));
            return c = (ke(h) + "e").split("e"), +(c[0] + "e" + (+c[1] - u));
          }
          return t(o);
        };
      }
      var Pg = br && 1 / Di(new br([, -0]))[1] == pe ? function(e) {
        return new br(e);
      } : ns;
      function gl(e) {
        return function(t) {
          var o = wt(t);
          return o == Qe ? ca(t) : o == Re ? jd(t) : Wd(t, e(t));
        };
      }
      function bn(e, t, o, u, c, h, v, b) {
        var C = t & I;
        if (!C && typeof e != "function")
          throw new Gt(f);
        var M = u ? u.length : 0;
        if (M || (t &= -97, u = c = r), v = v === r ? v : it(ae(v), 0), b = b === r ? b : ae(b), M -= c ? c.length : 0, t & Q) {
          var D = u, N = c;
          u = c = r;
        }
        var H = C ? r : Ia(e), K = [
          e,
          t,
          o,
          u,
          c,
          D,
          N,
          h,
          v,
          b
        ];
        if (H && Bg(K, H), e = K[0], t = K[1], o = K[2], u = K[3], c = K[4], b = K[9] = K[9] === r ? C ? 0 : e.length : it(K[9] - M, 0), !b && t & (B | q) && (t &= -25), !t || t == L)
          var ee = Tg(e, t, o);
        else t == B || t == q ? ee = Eg(e, t, b) : (t == Y || t == (L | Y)) && !c.length ? ee = Og(e, t, o, u) : ee = to.apply(r, K);
        var ue = H ? Vu : El;
        return Ol(ue(ee, K), e, t);
      }
      function ml(e, t, o, u) {
        return e === r || tn(e, yr[o]) && !Le.call(u, o) ? t : e;
      }
      function pl(e, t, o, u, c, h) {
        return qe(e) && qe(t) && (h.set(t, e), Qi(e, t, r, pl, h), h.delete(t)), e;
      }
      function Sg(e) {
        return li(e) ? r : e;
      }
      function vl(e, t, o, u, c, h) {
        var v = o & O, b = e.length, C = t.length;
        if (b != C && !(v && C > b))
          return !1;
        var M = h.get(e), D = h.get(t);
        if (M && D)
          return M == t && D == e;
        var N = -1, H = !0, K = o & k ? new Kn() : r;
        for (h.set(e, t), h.set(t, e); ++N < b; ) {
          var ee = e[N], ue = t[N];
          if (u)
            var te = v ? u(ue, ee, N, t, e, h) : u(ee, ue, N, e, t, h);
          if (te !== r) {
            if (te)
              continue;
            H = !1;
            break;
          }
          if (K) {
            if (!ia(t, function(ge, _e) {
              if (!Xr(K, _e) && (ee === ge || c(ee, ge, o, u, h)))
                return K.push(_e);
            })) {
              H = !1;
              break;
            }
          } else if (!(ee === ue || c(ee, ue, o, u, h))) {
            H = !1;
            break;
          }
        }
        return h.delete(e), h.delete(t), H;
      }
      function Rg(e, t, o, u, c, h, v) {
        switch (o) {
          case lt:
            if (e.byteLength != t.byteLength || e.byteOffset != t.byteOffset)
              return !1;
            e = e.buffer, t = t.buffer;
          case Mt:
            return !(e.byteLength != t.byteLength || !h(new $i(e), new $i(t)));
          case Ye:
          case Ke:
          case dt:
            return tn(+e, +t);
          case De:
            return e.name == t.name && e.message == t.message;
          case J:
          case Fe:
            return e == t + "";
          case Qe:
            var b = ca;
          case Re:
            var C = u & O;
            if (b || (b = Di), e.size != t.size && !C)
              return !1;
            var M = v.get(e);
            if (M)
              return M == t;
            u |= k, v.set(e, t);
            var D = vl(b(e), b(t), u, c, h, v);
            return v.delete(e), D;
          case Qt:
            if (ei)
              return ei.call(e) == ei.call(t);
        }
        return !1;
      }
      function Ag(e, t, o, u, c, h) {
        var v = o & O, b = Na(e), C = b.length, M = Na(t), D = M.length;
        if (C != D && !v)
          return !1;
        for (var N = C; N--; ) {
          var H = b[N];
          if (!(v ? H in t : Le.call(t, H)))
            return !1;
        }
        var K = h.get(e), ee = h.get(t);
        if (K && ee)
          return K == t && ee == e;
        var ue = !0;
        h.set(e, t), h.set(t, e);
        for (var te = v; ++N < C; ) {
          H = b[N];
          var ge = e[H], _e = t[H];
          if (u)
            var It = v ? u(_e, ge, H, t, e, h) : u(ge, _e, H, e, t, h);
          if (!(It === r ? ge === _e || c(ge, _e, o, u, h) : It)) {
            ue = !1;
            break;
          }
          te || (te = H == "constructor");
        }
        if (ue && !te) {
          var _t = e.constructor, Ft = t.constructor;
          _t != Ft && "constructor" in e && "constructor" in t && !(typeof _t == "function" && _t instanceof _t && typeof Ft == "function" && Ft instanceof Ft) && (ue = !1);
        }
        return h.delete(e), h.delete(t), ue;
      }
      function xn(e) {
        return Ya(Cl(e, r, Ml), e + "");
      }
      function Na(e) {
        return Iu(e, ct, $a);
      }
      function Wa(e) {
        return Iu(e, Rt, wl);
      }
      var Ia = Gi ? function(e) {
        return Gi.get(e);
      } : ns;
      function oo(e) {
        for (var t = e.name + "", o = xr[t], u = Le.call(xr, t) ? o.length : 0; u--; ) {
          var c = o[u], h = c.func;
          if (h == null || h == e)
            return c.name;
        }
        return t;
      }
      function Er(e) {
        var t = Le.call(d, "placeholder") ? d : e;
        return t.placeholder;
      }
      function Z() {
        var e = d.iteratee || es;
        return e = e === es ? Uu : e, arguments.length ? e(arguments[0], arguments[1]) : e;
      }
      function ao(e, t) {
        var o = e.__data__;
        return Fg(t) ? o[typeof t == "string" ? "string" : "hash"] : o.map;
      }
      function Fa(e) {
        for (var t = ct(e), o = t.length; o--; ) {
          var u = t[o], c = e[u];
          t[o] = [u, c, xl(c)];
        }
        return t;
      }
      function Zn(e, t) {
        var o = Hd(e, t);
        return $u(o) ? o : r;
      }
      function kg(e) {
        var t = Le.call(e, Vn), o = e[Vn];
        try {
          e[Vn] = r;
          var u = !0;
        } catch {
        }
        var c = Ii.call(e);
        return u && (t ? e[Vn] = o : delete e[Vn]), c;
      }
      var $a = da ? function(e) {
        return e == null ? [] : (e = $e(e), Mn(da(e), function(t) {
          return Tu.call(e, t);
        }));
      } : rs, wl = da ? function(e) {
        for (var t = []; e; )
          Dn(t, $a(e)), e = Ui(e);
        return t;
      } : rs, wt = bt;
      (ha && wt(new ha(new ArrayBuffer(1))) != lt || Qr && wt(new Qr()) != Qe || ga && wt(ga.resolve()) != gn || br && wt(new br()) != Re || Jr && wt(new Jr()) != tt) && (wt = function(e) {
        var t = bt(e), o = t == ut ? e.constructor : r, u = o ? er(o) : "";
        if (u)
          switch (u) {
            case hh:
              return lt;
            case gh:
              return Qe;
            case mh:
              return gn;
            case ph:
              return Re;
            case vh:
              return tt;
          }
        return t;
      });
      function Mg(e, t, o) {
        for (var u = -1, c = o.length; ++u < c; ) {
          var h = o[u], v = h.size;
          switch (h.type) {
            case "drop":
              e += v;
              break;
            case "dropRight":
              t -= v;
              break;
            case "take":
              t = vt(t, e + v);
              break;
            case "takeRight":
              e = it(e, t - v);
              break;
          }
        }
        return { start: e, end: t };
      }
      function Dg(e) {
        var t = e.match(qo);
        return t ? t[1].split(y) : [];
      }
      function yl(e, t, o) {
        t = Fn(t, e);
        for (var u = -1, c = t.length, h = !1; ++u < c; ) {
          var v = ln(t[u]);
          if (!(h = e != null && o(e, v)))
            break;
          e = e[v];
        }
        return h || ++u != c ? h : (c = e == null ? 0 : e.length, !!c && go(c) && _n(v, c) && (oe(e) || tr(e)));
      }
      function Lg(e) {
        var t = e.length, o = new e.constructor(t);
        return t && typeof e[0] == "string" && Le.call(e, "index") && (o.index = e.index, o.input = e.input), o;
      }
      function bl(e) {
        return typeof e.constructor == "function" && !si(e) ? _r(Ui(e)) : {};
      }
      function Ng(e, t, o) {
        var u = e.constructor;
        switch (t) {
          case Mt:
            return Ma(e);
          case Ye:
          case Ke:
            return new u(+e);
          case lt:
            return wg(e, o);
          case Et:
          case mn:
          case cr:
          case $r:
          case Ur:
          case Hr:
          case Br:
          case Yr:
          case jr:
            return nl(e, o);
          case Qe:
            return new u();
          case dt:
          case Fe:
            return new u(e);
          case J:
            return yg(e);
          case Re:
            return new u();
          case Qt:
            return bg(e);
        }
      }
      function Wg(e, t) {
        var o = t.length;
        if (!o)
          return e;
        var u = o - 1;
        return t[u] = (o > 1 ? "& " : "") + t[u], t = t.join(o > 2 ? ", " : " "), e.replace(Go, `{
/* [wrapped with ` + t + `] */
`);
      }
      function Ig(e) {
        return oe(e) || tr(e) || !!(Eu && e && e[Eu]);
      }
      function _n(e, t) {
        var o = typeof e;
        return t = t ?? F, !!t && (o == "number" || o != "symbol" && Ve.test(e)) && e > -1 && e % 1 == 0 && e < t;
      }
      function xt(e, t, o) {
        if (!qe(o))
          return !1;
        var u = typeof t;
        return (u == "number" ? St(o) && _n(t, o.length) : u == "string" && t in o) ? tn(o[t], e) : !1;
      }
      function Ua(e, t) {
        if (oe(e))
          return !1;
        var o = typeof e;
        return o == "number" || o == "symbol" || o == "boolean" || e == null || Wt(e) ? !0 : Bo.test(e) || !Si.test(e) || t != null && e in $e(t);
      }
      function Fg(e) {
        var t = typeof e;
        return t == "string" || t == "number" || t == "symbol" || t == "boolean" ? e !== "__proto__" : e === null;
      }
      function Ha(e) {
        var t = oo(e), o = d[t];
        if (typeof o != "function" || !(t in ye.prototype))
          return !1;
        if (e === o)
          return !0;
        var u = Ia(o);
        return !!u && e === u[0];
      }
      function $g(e) {
        return !!xu && xu in e;
      }
      var Ug = Ni ? Cn : is;
      function si(e) {
        var t = e && e.constructor, o = typeof t == "function" && t.prototype || yr;
        return e === o;
      }
      function xl(e) {
        return e === e && !qe(e);
      }
      function _l(e, t) {
        return function(o) {
          return o == null ? !1 : o[e] === t && (t !== r || e in $e(o));
        };
      }
      function Hg(e) {
        var t = fo(e, function(u) {
          return o.size === p && o.clear(), u;
        }), o = t.cache;
        return t;
      }
      function Bg(e, t) {
        var o = e[1], u = t[1], c = o | u, h = c < (L | I | j), v = u == j && o == B || u == j && o == U && e[7].length <= t[8] || u == (j | U) && t[7].length <= t[8] && o == B;
        if (!(h || v))
          return e;
        u & L && (e[2] = t[2], c |= o & L ? 0 : $);
        var b = t[3];
        if (b) {
          var C = e[3];
          e[3] = C ? il(C, b, t[4]) : b, e[4] = C ? Ln(e[3], w) : t[4];
        }
        return b = t[5], b && (C = e[5], e[5] = C ? ol(C, b, t[6]) : b, e[6] = C ? Ln(e[5], w) : t[6]), b = t[7], b && (e[7] = b), u & j && (e[8] = e[8] == null ? t[8] : vt(e[8], t[8])), e[9] == null && (e[9] = t[9]), e[0] = t[0], e[1] = c, e;
      }
      function Yg(e) {
        var t = [];
        if (e != null)
          for (var o in $e(e))
            t.push(o);
        return t;
      }
      function jg(e) {
        return Ii.call(e);
      }
      function Cl(e, t, o) {
        return t = it(t === r ? e.length - 1 : t, 0), function() {
          for (var u = arguments, c = -1, h = it(u.length - t, 0), v = P(h); ++c < h; )
            v[c] = u[t + c];
          c = -1;
          for (var b = P(t + 1); ++c < t; )
            b[c] = u[c];
          return b[t] = o(v), Dt(e, this, b);
        };
      }
      function Tl(e, t) {
        return t.length < 2 ? e : Jn(e, Vt(t, 0, -1));
      }
      function Gg(e, t) {
        for (var o = e.length, u = vt(t.length, o), c = Pt(e); u--; ) {
          var h = t[u];
          e[u] = _n(h, o) ? c[h] : r;
        }
        return e;
      }
      function Ba(e, t) {
        if (!(t === "constructor" && typeof e[t] == "function") && t != "__proto__")
          return e[t];
      }
      var El = Pl(Vu), ui = ah || function(e, t) {
        return mt.setTimeout(e, t);
      }, Ya = Pl(gg);
      function Ol(e, t, o) {
        var u = t + "";
        return Ya(e, Wg(u, qg(Dg(u), o)));
      }
      function Pl(e) {
        var t = 0, o = 0;
        return function() {
          var u = ch(), c = re - (u - o);
          if (o = u, c > 0) {
            if (++t >= de)
              return arguments[0];
          } else
            t = 0;
          return e.apply(r, arguments);
        };
      }
      function so(e, t) {
        var o = -1, u = e.length, c = u - 1;
        for (t = t === r ? u : t; ++o < t; ) {
          var h = Ea(o, c), v = e[h];
          e[h] = e[o], e[o] = v;
        }
        return e.length = t, e;
      }
      var Sl = Hg(function(e) {
        var t = [];
        return e.charCodeAt(0) === 46 && t.push(""), e.replace(Yo, function(o, u, c, h) {
          t.push(c ? h.replace(ne, "$1") : u || o);
        }), t;
      });
      function ln(e) {
        if (typeof e == "string" || Wt(e))
          return e;
        var t = e + "";
        return t == "0" && 1 / e == -1 / 0 ? "-0" : t;
      }
      function er(e) {
        if (e != null) {
          try {
            return Wi.call(e);
          } catch {
          }
          try {
            return e + "";
          } catch {
          }
        }
        return "";
      }
      function qg(e, t) {
        return jt(Be, function(o) {
          var u = "_." + o[0];
          t & o[1] && !ki(e, u) && e.push(u);
        }), e.sort();
      }
      function Rl(e) {
        if (e instanceof ye)
          return e.clone();
        var t = new qt(e.__wrapped__, e.__chain__);
        return t.__actions__ = Pt(e.__actions__), t.__index__ = e.__index__, t.__values__ = e.__values__, t;
      }
      function zg(e, t, o) {
        (o ? xt(e, t, o) : t === r) ? t = 1 : t = it(ae(t), 0);
        var u = e == null ? 0 : e.length;
        if (!u || t < 1)
          return [];
        for (var c = 0, h = 0, v = P(Yi(u / t)); c < u; )
          v[h++] = Vt(e, c, c += t);
        return v;
      }
      function Vg(e) {
        for (var t = -1, o = e == null ? 0 : e.length, u = 0, c = []; ++t < o; ) {
          var h = e[t];
          h && (c[u++] = h);
        }
        return c;
      }
      function Xg() {
        var e = arguments.length;
        if (!e)
          return [];
        for (var t = P(e - 1), o = arguments[0], u = e; u--; )
          t[u - 1] = arguments[u];
        return Dn(oe(o) ? Pt(o) : [o], pt(t, 1));
      }
      var Kg = le(function(e, t) {
        return Je(e) ? ni(e, pt(t, 1, Je, !0)) : [];
      }), Qg = le(function(e, t) {
        var o = Xt(t);
        return Je(o) && (o = r), Je(e) ? ni(e, pt(t, 1, Je, !0), Z(o, 2)) : [];
      }), Jg = le(function(e, t) {
        var o = Xt(t);
        return Je(o) && (o = r), Je(e) ? ni(e, pt(t, 1, Je, !0), r, o) : [];
      });
      function Zg(e, t, o) {
        var u = e == null ? 0 : e.length;
        return u ? (t = o || t === r ? 1 : ae(t), Vt(e, t < 0 ? 0 : t, u)) : [];
      }
      function em(e, t, o) {
        var u = e == null ? 0 : e.length;
        return u ? (t = o || t === r ? 1 : ae(t), t = u - t, Vt(e, 0, t < 0 ? 0 : t)) : [];
      }
      function tm(e, t) {
        return e && e.length ? Zi(e, Z(t, 3), !0, !0) : [];
      }
      function nm(e, t) {
        return e && e.length ? Zi(e, Z(t, 3), !0) : [];
      }
      function rm(e, t, o, u) {
        var c = e == null ? 0 : e.length;
        return c ? (o && typeof o != "number" && xt(e, t, o) && (o = 0, u = c), Xh(e, t, o, u)) : [];
      }
      function Al(e, t, o) {
        var u = e == null ? 0 : e.length;
        if (!u)
          return -1;
        var c = o == null ? 0 : ae(o);
        return c < 0 && (c = it(u + c, 0)), Mi(e, Z(t, 3), c);
      }
      function kl(e, t, o) {
        var u = e == null ? 0 : e.length;
        if (!u)
          return -1;
        var c = u - 1;
        return o !== r && (c = ae(o), c = o < 0 ? it(u + c, 0) : vt(c, u - 1)), Mi(e, Z(t, 3), c, !0);
      }
      function Ml(e) {
        var t = e == null ? 0 : e.length;
        return t ? pt(e, 1) : [];
      }
      function im(e) {
        var t = e == null ? 0 : e.length;
        return t ? pt(e, pe) : [];
      }
      function om(e, t) {
        var o = e == null ? 0 : e.length;
        return o ? (t = t === r ? 1 : ae(t), pt(e, t)) : [];
      }
      function am(e) {
        for (var t = -1, o = e == null ? 0 : e.length, u = {}; ++t < o; ) {
          var c = e[t];
          u[c[0]] = c[1];
        }
        return u;
      }
      function Dl(e) {
        return e && e.length ? e[0] : r;
      }
      function sm(e, t, o) {
        var u = e == null ? 0 : e.length;
        if (!u)
          return -1;
        var c = o == null ? 0 : ae(o);
        return c < 0 && (c = it(u + c, 0)), mr(e, t, c);
      }
      function um(e) {
        var t = e == null ? 0 : e.length;
        return t ? Vt(e, 0, -1) : [];
      }
      var lm = le(function(e) {
        var t = je(e, Aa);
        return t.length && t[0] === e[0] ? ba(t) : [];
      }), cm = le(function(e) {
        var t = Xt(e), o = je(e, Aa);
        return t === Xt(o) ? t = r : o.pop(), o.length && o[0] === e[0] ? ba(o, Z(t, 2)) : [];
      }), fm = le(function(e) {
        var t = Xt(e), o = je(e, Aa);
        return t = typeof t == "function" ? t : r, t && o.pop(), o.length && o[0] === e[0] ? ba(o, r, t) : [];
      });
      function dm(e, t) {
        return e == null ? "" : uh.call(e, t);
      }
      function Xt(e) {
        var t = e == null ? 0 : e.length;
        return t ? e[t - 1] : r;
      }
      function hm(e, t, o) {
        var u = e == null ? 0 : e.length;
        if (!u)
          return -1;
        var c = u;
        return o !== r && (c = ae(o), c = c < 0 ? it(u + c, 0) : vt(c, u - 1)), t === t ? qd(e, t, c) : Mi(e, hu, c, !0);
      }
      function gm(e, t) {
        return e && e.length ? ju(e, ae(t)) : r;
      }
      var mm = le(Ll);
      function Ll(e, t) {
        return e && e.length && t && t.length ? Ta(e, t) : e;
      }
      function pm(e, t, o) {
        return e && e.length && t && t.length ? Ta(e, t, Z(o, 2)) : e;
      }
      function vm(e, t, o) {
        return e && e.length && t && t.length ? Ta(e, t, r, o) : e;
      }
      var wm = xn(function(e, t) {
        var o = e == null ? 0 : e.length, u = pa(e, t);
        return zu(e, je(t, function(c) {
          return _n(c, o) ? +c : c;
        }).sort(rl)), u;
      });
      function ym(e, t) {
        var o = [];
        if (!(e && e.length))
          return o;
        var u = -1, c = [], h = e.length;
        for (t = Z(t, 3); ++u < h; ) {
          var v = e[u];
          t(v, u, e) && (o.push(v), c.push(u));
        }
        return zu(e, c), o;
      }
      function ja(e) {
        return e == null ? e : dh.call(e);
      }
      function bm(e, t, o) {
        var u = e == null ? 0 : e.length;
        return u ? (o && typeof o != "number" && xt(e, t, o) ? (t = 0, o = u) : (t = t == null ? 0 : ae(t), o = o === r ? u : ae(o)), Vt(e, t, o)) : [];
      }
      function xm(e, t) {
        return Ji(e, t);
      }
      function _m(e, t, o) {
        return Pa(e, t, Z(o, 2));
      }
      function Cm(e, t) {
        var o = e == null ? 0 : e.length;
        if (o) {
          var u = Ji(e, t);
          if (u < o && tn(e[u], t))
            return u;
        }
        return -1;
      }
      function Tm(e, t) {
        return Ji(e, t, !0);
      }
      function Em(e, t, o) {
        return Pa(e, t, Z(o, 2), !0);
      }
      function Om(e, t) {
        var o = e == null ? 0 : e.length;
        if (o) {
          var u = Ji(e, t, !0) - 1;
          if (tn(e[u], t))
            return u;
        }
        return -1;
      }
      function Pm(e) {
        return e && e.length ? Xu(e) : [];
      }
      function Sm(e, t) {
        return e && e.length ? Xu(e, Z(t, 2)) : [];
      }
      function Rm(e) {
        var t = e == null ? 0 : e.length;
        return t ? Vt(e, 1, t) : [];
      }
      function Am(e, t, o) {
        return e && e.length ? (t = o || t === r ? 1 : ae(t), Vt(e, 0, t < 0 ? 0 : t)) : [];
      }
      function km(e, t, o) {
        var u = e == null ? 0 : e.length;
        return u ? (t = o || t === r ? 1 : ae(t), t = u - t, Vt(e, t < 0 ? 0 : t, u)) : [];
      }
      function Mm(e, t) {
        return e && e.length ? Zi(e, Z(t, 3), !1, !0) : [];
      }
      function Dm(e, t) {
        return e && e.length ? Zi(e, Z(t, 3)) : [];
      }
      var Lm = le(function(e) {
        return In(pt(e, 1, Je, !0));
      }), Nm = le(function(e) {
        var t = Xt(e);
        return Je(t) && (t = r), In(pt(e, 1, Je, !0), Z(t, 2));
      }), Wm = le(function(e) {
        var t = Xt(e);
        return t = typeof t == "function" ? t : r, In(pt(e, 1, Je, !0), r, t);
      });
      function Im(e) {
        return e && e.length ? In(e) : [];
      }
      function Fm(e, t) {
        return e && e.length ? In(e, Z(t, 2)) : [];
      }
      function $m(e, t) {
        return t = typeof t == "function" ? t : r, e && e.length ? In(e, r, t) : [];
      }
      function Ga(e) {
        if (!(e && e.length))
          return [];
        var t = 0;
        return e = Mn(e, function(o) {
          if (Je(o))
            return t = it(o.length, t), !0;
        }), ua(t, function(o) {
          return je(e, oa(o));
        });
      }
      function Nl(e, t) {
        if (!(e && e.length))
          return [];
        var o = Ga(e);
        return t == null ? o : je(o, function(u) {
          return Dt(t, r, u);
        });
      }
      var Um = le(function(e, t) {
        return Je(e) ? ni(e, t) : [];
      }), Hm = le(function(e) {
        return Ra(Mn(e, Je));
      }), Bm = le(function(e) {
        var t = Xt(e);
        return Je(t) && (t = r), Ra(Mn(e, Je), Z(t, 2));
      }), Ym = le(function(e) {
        var t = Xt(e);
        return t = typeof t == "function" ? t : r, Ra(Mn(e, Je), r, t);
      }), jm = le(Ga);
      function Gm(e, t) {
        return Zu(e || [], t || [], ti);
      }
      function qm(e, t) {
        return Zu(e || [], t || [], oi);
      }
      var zm = le(function(e) {
        var t = e.length, o = t > 1 ? e[t - 1] : r;
        return o = typeof o == "function" ? (e.pop(), o) : r, Nl(e, o);
      });
      function Wl(e) {
        var t = d(e);
        return t.__chain__ = !0, t;
      }
      function Vm(e, t) {
        return t(e), e;
      }
      function uo(e, t) {
        return t(e);
      }
      var Xm = xn(function(e) {
        var t = e.length, o = t ? e[0] : 0, u = this.__wrapped__, c = function(h) {
          return pa(h, e);
        };
        return t > 1 || this.__actions__.length || !(u instanceof ye) || !_n(o) ? this.thru(c) : (u = u.slice(o, +o + (t ? 1 : 0)), u.__actions__.push({
          func: uo,
          args: [c],
          thisArg: r
        }), new qt(u, this.__chain__).thru(function(h) {
          return t && !h.length && h.push(r), h;
        }));
      });
      function Km() {
        return Wl(this);
      }
      function Qm() {
        return new qt(this.value(), this.__chain__);
      }
      function Jm() {
        this.__values__ === r && (this.__values__ = Kl(this.value()));
        var e = this.__index__ >= this.__values__.length, t = e ? r : this.__values__[this.__index__++];
        return { done: e, value: t };
      }
      function Zm() {
        return this;
      }
      function ep(e) {
        for (var t, o = this; o instanceof zi; ) {
          var u = Rl(o);
          u.__index__ = 0, u.__values__ = r, t ? c.__wrapped__ = u : t = u;
          var c = u;
          o = o.__wrapped__;
        }
        return c.__wrapped__ = e, t;
      }
      function tp() {
        var e = this.__wrapped__;
        if (e instanceof ye) {
          var t = e;
          return this.__actions__.length && (t = new ye(this)), t = t.reverse(), t.__actions__.push({
            func: uo,
            args: [ja],
            thisArg: r
          }), new qt(t, this.__chain__);
        }
        return this.thru(ja);
      }
      function np() {
        return Ju(this.__wrapped__, this.__actions__);
      }
      var rp = eo(function(e, t, o) {
        Le.call(e, o) ? ++e[o] : yn(e, o, 1);
      });
      function ip(e, t, o) {
        var u = oe(e) ? fu : Vh;
        return o && xt(e, t, o) && (t = r), u(e, Z(t, 3));
      }
      function op(e, t) {
        var o = oe(e) ? Mn : Nu;
        return o(e, Z(t, 3));
      }
      var ap = ll(Al), sp = ll(kl);
      function up(e, t) {
        return pt(lo(e, t), 1);
      }
      function lp(e, t) {
        return pt(lo(e, t), pe);
      }
      function cp(e, t, o) {
        return o = o === r ? 1 : ae(o), pt(lo(e, t), o);
      }
      function Il(e, t) {
        var o = oe(e) ? jt : Wn;
        return o(e, Z(t, 3));
      }
      function Fl(e, t) {
        var o = oe(e) ? Rd : Lu;
        return o(e, Z(t, 3));
      }
      var fp = eo(function(e, t, o) {
        Le.call(e, o) ? e[o].push(t) : yn(e, o, [t]);
      });
      function dp(e, t, o, u) {
        e = St(e) ? e : Pr(e), o = o && !u ? ae(o) : 0;
        var c = e.length;
        return o < 0 && (o = it(c + o, 0)), mo(e) ? o <= c && e.indexOf(t, o) > -1 : !!c && mr(e, t, o) > -1;
      }
      var hp = le(function(e, t, o) {
        var u = -1, c = typeof t == "function", h = St(e) ? P(e.length) : [];
        return Wn(e, function(v) {
          h[++u] = c ? Dt(t, v, o) : ri(v, t, o);
        }), h;
      }), gp = eo(function(e, t, o) {
        yn(e, o, t);
      });
      function lo(e, t) {
        var o = oe(e) ? je : Hu;
        return o(e, Z(t, 3));
      }
      function mp(e, t, o, u) {
        return e == null ? [] : (oe(t) || (t = t == null ? [] : [t]), o = u ? r : o, oe(o) || (o = o == null ? [] : [o]), Gu(e, t, o));
      }
      var pp = eo(function(e, t, o) {
        e[o ? 0 : 1].push(t);
      }, function() {
        return [[], []];
      });
      function vp(e, t, o) {
        var u = oe(e) ? ra : mu, c = arguments.length < 3;
        return u(e, Z(t, 4), o, c, Wn);
      }
      function wp(e, t, o) {
        var u = oe(e) ? Ad : mu, c = arguments.length < 3;
        return u(e, Z(t, 4), o, c, Lu);
      }
      function yp(e, t) {
        var o = oe(e) ? Mn : Nu;
        return o(e, ho(Z(t, 3)));
      }
      function bp(e) {
        var t = oe(e) ? Au : dg;
        return t(e);
      }
      function xp(e, t, o) {
        (o ? xt(e, t, o) : t === r) ? t = 1 : t = ae(t);
        var u = oe(e) ? Yh : hg;
        return u(e, t);
      }
      function _p(e) {
        var t = oe(e) ? jh : mg;
        return t(e);
      }
      function Cp(e) {
        if (e == null)
          return 0;
        if (St(e))
          return mo(e) ? vr(e) : e.length;
        var t = wt(e);
        return t == Qe || t == Re ? e.size : _a(e).length;
      }
      function Tp(e, t, o) {
        var u = oe(e) ? ia : pg;
        return o && xt(e, t, o) && (t = r), u(e, Z(t, 3));
      }
      var Ep = le(function(e, t) {
        if (e == null)
          return [];
        var o = t.length;
        return o > 1 && xt(e, t[0], t[1]) ? t = [] : o > 2 && xt(t[0], t[1], t[2]) && (t = [t[0]]), Gu(e, pt(t, 1), []);
      }), co = oh || function() {
        return mt.Date.now();
      };
      function Op(e, t) {
        if (typeof t != "function")
          throw new Gt(f);
        return e = ae(e), function() {
          if (--e < 1)
            return t.apply(this, arguments);
        };
      }
      function $l(e, t, o) {
        return t = o ? r : t, t = e && t == null ? e.length : t, bn(e, j, r, r, r, r, t);
      }
      function Ul(e, t) {
        var o;
        if (typeof t != "function")
          throw new Gt(f);
        return e = ae(e), function() {
          return --e > 0 && (o = t.apply(this, arguments)), e <= 1 && (t = r), o;
        };
      }
      var qa = le(function(e, t, o) {
        var u = L;
        if (o.length) {
          var c = Ln(o, Er(qa));
          u |= Y;
        }
        return bn(e, u, t, o, c);
      }), Hl = le(function(e, t, o) {
        var u = L | I;
        if (o.length) {
          var c = Ln(o, Er(Hl));
          u |= Y;
        }
        return bn(t, u, e, o, c);
      });
      function Bl(e, t, o) {
        t = o ? r : t;
        var u = bn(e, B, r, r, r, r, r, t);
        return u.placeholder = Bl.placeholder, u;
      }
      function Yl(e, t, o) {
        t = o ? r : t;
        var u = bn(e, q, r, r, r, r, r, t);
        return u.placeholder = Yl.placeholder, u;
      }
      function jl(e, t, o) {
        var u, c, h, v, b, C, M = 0, D = !1, N = !1, H = !0;
        if (typeof e != "function")
          throw new Gt(f);
        t = Kt(t) || 0, qe(o) && (D = !!o.leading, N = "maxWait" in o, h = N ? it(Kt(o.maxWait) || 0, t) : h, H = "trailing" in o ? !!o.trailing : H);
        function K(Ze) {
          var nn = u, En = c;
          return u = c = r, M = Ze, v = e.apply(En, nn), v;
        }
        function ee(Ze) {
          return M = Ze, b = ui(ge, t), D ? K(Ze) : v;
        }
        function ue(Ze) {
          var nn = Ze - C, En = Ze - M, lc = t - nn;
          return N ? vt(lc, h - En) : lc;
        }
        function te(Ze) {
          var nn = Ze - C, En = Ze - M;
          return C === r || nn >= t || nn < 0 || N && En >= h;
        }
        function ge() {
          var Ze = co();
          if (te(Ze))
            return _e(Ze);
          b = ui(ge, ue(Ze));
        }
        function _e(Ze) {
          return b = r, H && u ? K(Ze) : (u = c = r, v);
        }
        function It() {
          b !== r && el(b), M = 0, u = C = c = b = r;
        }
        function _t() {
          return b === r ? v : _e(co());
        }
        function Ft() {
          var Ze = co(), nn = te(Ze);
          if (u = arguments, c = this, C = Ze, nn) {
            if (b === r)
              return ee(C);
            if (N)
              return el(b), b = ui(ge, t), K(C);
          }
          return b === r && (b = ui(ge, t)), v;
        }
        return Ft.cancel = It, Ft.flush = _t, Ft;
      }
      var Pp = le(function(e, t) {
        return Du(e, 1, t);
      }), Sp = le(function(e, t, o) {
        return Du(e, Kt(t) || 0, o);
      });
      function Rp(e) {
        return bn(e, se);
      }
      function fo(e, t) {
        if (typeof e != "function" || t != null && typeof t != "function")
          throw new Gt(f);
        var o = function() {
          var u = arguments, c = t ? t.apply(this, u) : u[0], h = o.cache;
          if (h.has(c))
            return h.get(c);
          var v = e.apply(this, u);
          return o.cache = h.set(c, v) || h, v;
        };
        return o.cache = new (fo.Cache || wn)(), o;
      }
      fo.Cache = wn;
      function ho(e) {
        if (typeof e != "function")
          throw new Gt(f);
        return function() {
          var t = arguments;
          switch (t.length) {
            case 0:
              return !e.call(this);
            case 1:
              return !e.call(this, t[0]);
            case 2:
              return !e.call(this, t[0], t[1]);
            case 3:
              return !e.call(this, t[0], t[1], t[2]);
          }
          return !e.apply(this, t);
        };
      }
      function Ap(e) {
        return Ul(2, e);
      }
      var kp = vg(function(e, t) {
        t = t.length == 1 && oe(t[0]) ? je(t[0], Lt(Z())) : je(pt(t, 1), Lt(Z()));
        var o = t.length;
        return le(function(u) {
          for (var c = -1, h = vt(u.length, o); ++c < h; )
            u[c] = t[c].call(this, u[c]);
          return Dt(e, this, u);
        });
      }), za = le(function(e, t) {
        var o = Ln(t, Er(za));
        return bn(e, Y, r, t, o);
      }), Gl = le(function(e, t) {
        var o = Ln(t, Er(Gl));
        return bn(e, Q, r, t, o);
      }), Mp = xn(function(e, t) {
        return bn(e, U, r, r, r, t);
      });
      function Dp(e, t) {
        if (typeof e != "function")
          throw new Gt(f);
        return t = t === r ? t : ae(t), le(e, t);
      }
      function Lp(e, t) {
        if (typeof e != "function")
          throw new Gt(f);
        return t = t == null ? 0 : it(ae(t), 0), le(function(o) {
          var u = o[t], c = $n(o, 0, t);
          return u && Dn(c, u), Dt(e, this, c);
        });
      }
      function Np(e, t, o) {
        var u = !0, c = !0;
        if (typeof e != "function")
          throw new Gt(f);
        return qe(o) && (u = "leading" in o ? !!o.leading : u, c = "trailing" in o ? !!o.trailing : c), jl(e, t, {
          leading: u,
          maxWait: t,
          trailing: c
        });
      }
      function Wp(e) {
        return $l(e, 1);
      }
      function Ip(e, t) {
        return za(ka(t), e);
      }
      function Fp() {
        if (!arguments.length)
          return [];
        var e = arguments[0];
        return oe(e) ? e : [e];
      }
      function $p(e) {
        return zt(e, E);
      }
      function Up(e, t) {
        return t = typeof t == "function" ? t : r, zt(e, E, t);
      }
      function Hp(e) {
        return zt(e, x | E);
      }
      function Bp(e, t) {
        return t = typeof t == "function" ? t : r, zt(e, x | E, t);
      }
      function Yp(e, t) {
        return t == null || Mu(e, t, ct(t));
      }
      function tn(e, t) {
        return e === t || e !== e && t !== t;
      }
      var jp = io(ya), Gp = io(function(e, t) {
        return e >= t;
      }), tr = Fu(/* @__PURE__ */ function() {
        return arguments;
      }()) ? Fu : function(e) {
        return Xe(e) && Le.call(e, "callee") && !Tu.call(e, "callee");
      }, oe = P.isArray, qp = ou ? Lt(ou) : eg;
      function St(e) {
        return e != null && go(e.length) && !Cn(e);
      }
      function Je(e) {
        return Xe(e) && St(e);
      }
      function zp(e) {
        return e === !0 || e === !1 || Xe(e) && bt(e) == Ye;
      }
      var Un = sh || is, Vp = au ? Lt(au) : tg;
      function Xp(e) {
        return Xe(e) && e.nodeType === 1 && !li(e);
      }
      function Kp(e) {
        if (e == null)
          return !0;
        if (St(e) && (oe(e) || typeof e == "string" || typeof e.splice == "function" || Un(e) || Or(e) || tr(e)))
          return !e.length;
        var t = wt(e);
        if (t == Qe || t == Re)
          return !e.size;
        if (si(e))
          return !_a(e).length;
        for (var o in e)
          if (Le.call(e, o))
            return !1;
        return !0;
      }
      function Qp(e, t) {
        return ii(e, t);
      }
      function Jp(e, t, o) {
        o = typeof o == "function" ? o : r;
        var u = o ? o(e, t) : r;
        return u === r ? ii(e, t, r, o) : !!u;
      }
      function Va(e) {
        if (!Xe(e))
          return !1;
        var t = bt(e);
        return t == De || t == ft || typeof e.message == "string" && typeof e.name == "string" && !li(e);
      }
      function Zp(e) {
        return typeof e == "number" && Ou(e);
      }
      function Cn(e) {
        if (!qe(e))
          return !1;
        var t = bt(e);
        return t == st || t == Bt || t == ve || t == kt;
      }
      function ql(e) {
        return typeof e == "number" && e == ae(e);
      }
      function go(e) {
        return typeof e == "number" && e > -1 && e % 1 == 0 && e <= F;
      }
      function qe(e) {
        var t = typeof e;
        return e != null && (t == "object" || t == "function");
      }
      function Xe(e) {
        return e != null && typeof e == "object";
      }
      var zl = su ? Lt(su) : rg;
      function ev(e, t) {
        return e === t || xa(e, t, Fa(t));
      }
      function tv(e, t, o) {
        return o = typeof o == "function" ? o : r, xa(e, t, Fa(t), o);
      }
      function nv(e) {
        return Vl(e) && e != +e;
      }
      function rv(e) {
        if (Ug(e))
          throw new ie(l);
        return $u(e);
      }
      function iv(e) {
        return e === null;
      }
      function ov(e) {
        return e == null;
      }
      function Vl(e) {
        return typeof e == "number" || Xe(e) && bt(e) == dt;
      }
      function li(e) {
        if (!Xe(e) || bt(e) != ut)
          return !1;
        var t = Ui(e);
        if (t === null)
          return !0;
        var o = Le.call(t, "constructor") && t.constructor;
        return typeof o == "function" && o instanceof o && Wi.call(o) == th;
      }
      var Xa = uu ? Lt(uu) : ig;
      function av(e) {
        return ql(e) && e >= -9007199254740991 && e <= F;
      }
      var Xl = lu ? Lt(lu) : og;
      function mo(e) {
        return typeof e == "string" || !oe(e) && Xe(e) && bt(e) == Fe;
      }
      function Wt(e) {
        return typeof e == "symbol" || Xe(e) && bt(e) == Qt;
      }
      var Or = cu ? Lt(cu) : ag;
      function sv(e) {
        return e === r;
      }
      function uv(e) {
        return Xe(e) && wt(e) == tt;
      }
      function lv(e) {
        return Xe(e) && bt(e) == Tt;
      }
      var cv = io(Ca), fv = io(function(e, t) {
        return e <= t;
      });
      function Kl(e) {
        if (!e)
          return [];
        if (St(e))
          return mo(e) ? Zt(e) : Pt(e);
        if (Kr && e[Kr])
          return Yd(e[Kr]());
        var t = wt(e), o = t == Qe ? ca : t == Re ? Di : Pr;
        return o(e);
      }
      function Tn(e) {
        if (!e)
          return e === 0 ? e : 0;
        if (e = Kt(e), e === pe || e === -1 / 0) {
          var t = e < 0 ? -1 : 1;
          return t * Me;
        }
        return e === e ? e : 0;
      }
      function ae(e) {
        var t = Tn(e), o = t % 1;
        return t === t ? o ? t - o : t : 0;
      }
      function Ql(e) {
        return e ? Qn(ae(e), 0, Ie) : 0;
      }
      function Kt(e) {
        if (typeof e == "number")
          return e;
        if (Wt(e))
          return xe;
        if (qe(e)) {
          var t = typeof e.valueOf == "function" ? e.valueOf() : e;
          e = qe(t) ? t + "" : t;
        }
        if (typeof e != "string")
          return e === 0 ? e : +e;
        e = pu(e);
        var o = he.test(e);
        return o || Ge.test(e) ? Od(e.slice(2), o ? 2 : 8) : we.test(e) ? xe : +e;
      }
      function Jl(e) {
        return un(e, Rt(e));
      }
      function dv(e) {
        return e ? Qn(ae(e), -9007199254740991, F) : e === 0 ? e : 0;
      }
      function ke(e) {
        return e == null ? "" : Nt(e);
      }
      var hv = Cr(function(e, t) {
        if (si(t) || St(t)) {
          un(t, ct(t), e);
          return;
        }
        for (var o in t)
          Le.call(t, o) && ti(e, o, t[o]);
      }), Zl = Cr(function(e, t) {
        un(t, Rt(t), e);
      }), po = Cr(function(e, t, o, u) {
        un(t, Rt(t), e, u);
      }), gv = Cr(function(e, t, o, u) {
        un(t, ct(t), e, u);
      }), mv = xn(pa);
      function pv(e, t) {
        var o = _r(e);
        return t == null ? o : ku(o, t);
      }
      var vv = le(function(e, t) {
        e = $e(e);
        var o = -1, u = t.length, c = u > 2 ? t[2] : r;
        for (c && xt(t[0], t[1], c) && (u = 1); ++o < u; )
          for (var h = t[o], v = Rt(h), b = -1, C = v.length; ++b < C; ) {
            var M = v[b], D = e[M];
            (D === r || tn(D, yr[M]) && !Le.call(e, M)) && (e[M] = h[M]);
          }
        return e;
      }), wv = le(function(e) {
        return e.push(r, pl), Dt(ec, r, e);
      });
      function yv(e, t) {
        return du(e, Z(t, 3), sn);
      }
      function bv(e, t) {
        return du(e, Z(t, 3), wa);
      }
      function xv(e, t) {
        return e == null ? e : va(e, Z(t, 3), Rt);
      }
      function _v(e, t) {
        return e == null ? e : Wu(e, Z(t, 3), Rt);
      }
      function Cv(e, t) {
        return e && sn(e, Z(t, 3));
      }
      function Tv(e, t) {
        return e && wa(e, Z(t, 3));
      }
      function Ev(e) {
        return e == null ? [] : Ki(e, ct(e));
      }
      function Ov(e) {
        return e == null ? [] : Ki(e, Rt(e));
      }
      function Ka(e, t, o) {
        var u = e == null ? r : Jn(e, t);
        return u === r ? o : u;
      }
      function Pv(e, t) {
        return e != null && yl(e, t, Kh);
      }
      function Qa(e, t) {
        return e != null && yl(e, t, Qh);
      }
      var Sv = fl(function(e, t, o) {
        t != null && typeof t.toString != "function" && (t = Ii.call(t)), e[t] = o;
      }, Za(At)), Rv = fl(function(e, t, o) {
        t != null && typeof t.toString != "function" && (t = Ii.call(t)), Le.call(e, t) ? e[t].push(o) : e[t] = [o];
      }, Z), Av = le(ri);
      function ct(e) {
        return St(e) ? Ru(e) : _a(e);
      }
      function Rt(e) {
        return St(e) ? Ru(e, !0) : sg(e);
      }
      function kv(e, t) {
        var o = {};
        return t = Z(t, 3), sn(e, function(u, c, h) {
          yn(o, t(u, c, h), u);
        }), o;
      }
      function Mv(e, t) {
        var o = {};
        return t = Z(t, 3), sn(e, function(u, c, h) {
          yn(o, c, t(u, c, h));
        }), o;
      }
      var Dv = Cr(function(e, t, o) {
        Qi(e, t, o);
      }), ec = Cr(function(e, t, o, u) {
        Qi(e, t, o, u);
      }), Lv = xn(function(e, t) {
        var o = {};
        if (e == null)
          return o;
        var u = !1;
        t = je(t, function(h) {
          return h = Fn(h, e), u || (u = h.length > 1), h;
        }), un(e, Wa(e), o), u && (o = zt(o, x | T | E, Sg));
        for (var c = t.length; c--; )
          Sa(o, t[c]);
        return o;
      });
      function Nv(e, t) {
        return tc(e, ho(Z(t)));
      }
      var Wv = xn(function(e, t) {
        return e == null ? {} : lg(e, t);
      });
      function tc(e, t) {
        if (e == null)
          return {};
        var o = je(Wa(e), function(u) {
          return [u];
        });
        return t = Z(t), qu(e, o, function(u, c) {
          return t(u, c[0]);
        });
      }
      function Iv(e, t, o) {
        t = Fn(t, e);
        var u = -1, c = t.length;
        for (c || (c = 1, e = r); ++u < c; ) {
          var h = e == null ? r : e[ln(t[u])];
          h === r && (u = c, h = o), e = Cn(h) ? h.call(e) : h;
        }
        return e;
      }
      function Fv(e, t, o) {
        return e == null ? e : oi(e, t, o);
      }
      function $v(e, t, o, u) {
        return u = typeof u == "function" ? u : r, e == null ? e : oi(e, t, o, u);
      }
      var nc = gl(ct), rc = gl(Rt);
      function Uv(e, t, o) {
        var u = oe(e), c = u || Un(e) || Or(e);
        if (t = Z(t, 4), o == null) {
          var h = e && e.constructor;
          c ? o = u ? new h() : [] : qe(e) ? o = Cn(h) ? _r(Ui(e)) : {} : o = {};
        }
        return (c ? jt : sn)(e, function(v, b, C) {
          return t(o, v, b, C);
        }), o;
      }
      function Hv(e, t) {
        return e == null ? !0 : Sa(e, t);
      }
      function Bv(e, t, o) {
        return e == null ? e : Qu(e, t, ka(o));
      }
      function Yv(e, t, o, u) {
        return u = typeof u == "function" ? u : r, e == null ? e : Qu(e, t, ka(o), u);
      }
      function Pr(e) {
        return e == null ? [] : la(e, ct(e));
      }
      function jv(e) {
        return e == null ? [] : la(e, Rt(e));
      }
      function Gv(e, t, o) {
        return o === r && (o = t, t = r), o !== r && (o = Kt(o), o = o === o ? o : 0), t !== r && (t = Kt(t), t = t === t ? t : 0), Qn(Kt(e), t, o);
      }
      function qv(e, t, o) {
        return t = Tn(t), o === r ? (o = t, t = 0) : o = Tn(o), e = Kt(e), Jh(e, t, o);
      }
      function zv(e, t, o) {
        if (o && typeof o != "boolean" && xt(e, t, o) && (t = o = r), o === r && (typeof t == "boolean" ? (o = t, t = r) : typeof e == "boolean" && (o = e, e = r)), e === r && t === r ? (e = 0, t = 1) : (e = Tn(e), t === r ? (t = e, e = 0) : t = Tn(t)), e > t) {
          var u = e;
          e = t, t = u;
        }
        if (o || e % 1 || t % 1) {
          var c = Pu();
          return vt(e + c * (t - e + Ed("1e-" + ((c + "").length - 1))), t);
        }
        return Ea(e, t);
      }
      var Vv = Tr(function(e, t, o) {
        return t = t.toLowerCase(), e + (o ? ic(t) : t);
      });
      function ic(e) {
        return Ja(ke(e).toLowerCase());
      }
      function oc(e) {
        return e = ke(e), e && e.replace(Ot, Fd).replace(md, "");
      }
      function Xv(e, t, o) {
        e = ke(e), t = Nt(t);
        var u = e.length;
        o = o === r ? u : Qn(ae(o), 0, u);
        var c = o;
        return o -= t.length, o >= 0 && e.slice(o, c) == t;
      }
      function Kv(e) {
        return e = ke(e), e && Uo.test(e) ? e.replace(dr, $d) : e;
      }
      function Qv(e) {
        return e = ke(e), e && Ri.test(e) ? e.replace(hr, "\\$&") : e;
      }
      var Jv = Tr(function(e, t, o) {
        return e + (o ? "-" : "") + t.toLowerCase();
      }), Zv = Tr(function(e, t, o) {
        return e + (o ? " " : "") + t.toLowerCase();
      }), ew = ul("toLowerCase");
      function tw(e, t, o) {
        e = ke(e), t = ae(t);
        var u = t ? vr(e) : 0;
        if (!t || u >= t)
          return e;
        var c = (t - u) / 2;
        return ro(ji(c), o) + e + ro(Yi(c), o);
      }
      function nw(e, t, o) {
        e = ke(e), t = ae(t);
        var u = t ? vr(e) : 0;
        return t && u < t ? e + ro(t - u, o) : e;
      }
      function rw(e, t, o) {
        e = ke(e), t = ae(t);
        var u = t ? vr(e) : 0;
        return t && u < t ? ro(t - u, o) + e : e;
      }
      function iw(e, t, o) {
        return o || t == null ? t = 0 : t && (t = +t), fh(ke(e).replace(zr, ""), t || 0);
      }
      function ow(e, t, o) {
        return (o ? xt(e, t, o) : t === r) ? t = 1 : t = ae(t), Oa(ke(e), t);
      }
      function aw() {
        var e = arguments, t = ke(e[0]);
        return e.length < 3 ? t : t.replace(e[1], e[2]);
      }
      var sw = Tr(function(e, t, o) {
        return e + (o ? "_" : "") + t.toLowerCase();
      });
      function uw(e, t, o) {
        return o && typeof o != "number" && xt(e, t, o) && (t = o = r), o = o === r ? Ie : o >>> 0, o ? (e = ke(e), e && (typeof t == "string" || t != null && !Xa(t)) && (t = Nt(t), !t && pr(e)) ? $n(Zt(e), 0, o) : e.split(t, o)) : [];
      }
      var lw = Tr(function(e, t, o) {
        return e + (o ? " " : "") + Ja(t);
      });
      function cw(e, t, o) {
        return e = ke(e), o = o == null ? 0 : Qn(ae(o), 0, e.length), t = Nt(t), e.slice(o, o + t.length) == t;
      }
      function fw(e, t, o) {
        var u = d.templateSettings;
        o && xt(e, t, o) && (t = r), e = ke(e), t = po({}, t, u, ml);
        var c = po({}, t.imports, u.imports, ml), h = ct(c), v = la(c, h), b, C, M = 0, D = t.interpolate || Jt, N = "__p += '", H = fa(
          (t.escape || Jt).source + "|" + D.source + "|" + (D === qr ? Ee : Jt).source + "|" + (t.evaluate || Jt).source + "|$",
          "g"
        ), K = "//# sourceURL=" + (Le.call(t, "sourceURL") ? (t.sourceURL + "").replace(/\s/g, " ") : "lodash.templateSources[" + ++bd + "]") + `
`;
        e.replace(H, function(te, ge, _e, It, _t, Ft) {
          return _e || (_e = It), N += e.slice(M, Ft).replace(pn, Ud), ge && (b = !0, N += `' +
__e(` + ge + `) +
'`), _t && (C = !0, N += `';
` + _t + `;
__p += '`), _e && (N += `' +
((__t = (` + _e + `)) == null ? '' : __t) +
'`), M = Ft + te.length, te;
        }), N += `';
`;
        var ee = Le.call(t, "variable") && t.variable;
        if (!ee)
          N = `with (obj) {
` + N + `
}
`;
        else if (G.test(ee))
          throw new ie(m);
        N = (C ? N.replace(Gr, "") : N).replace(Ei, "$1").replace(kn, "$1;"), N = "function(" + (ee || "obj") + `) {
` + (ee ? "" : `obj || (obj = {});
`) + "var __t, __p = ''" + (b ? ", __e = _.escape" : "") + (C ? `, __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
` : `;
`) + N + `return __p
}`;
        var ue = sc(function() {
          return Pe(h, K + "return " + N).apply(r, v);
        });
        if (ue.source = N, Va(ue))
          throw ue;
        return ue;
      }
      function dw(e) {
        return ke(e).toLowerCase();
      }
      function hw(e) {
        return ke(e).toUpperCase();
      }
      function gw(e, t, o) {
        if (e = ke(e), e && (o || t === r))
          return pu(e);
        if (!e || !(t = Nt(t)))
          return e;
        var u = Zt(e), c = Zt(t), h = vu(u, c), v = wu(u, c) + 1;
        return $n(u, h, v).join("");
      }
      function mw(e, t, o) {
        if (e = ke(e), e && (o || t === r))
          return e.slice(0, bu(e) + 1);
        if (!e || !(t = Nt(t)))
          return e;
        var u = Zt(e), c = wu(u, Zt(t)) + 1;
        return $n(u, 0, c).join("");
      }
      function pw(e, t, o) {
        if (e = ke(e), e && (o || t === r))
          return e.replace(zr, "");
        if (!e || !(t = Nt(t)))
          return e;
        var u = Zt(e), c = vu(u, Zt(t));
        return $n(u, c).join("");
      }
      function vw(e, t) {
        var o = Ce, u = fe;
        if (qe(t)) {
          var c = "separator" in t ? t.separator : c;
          o = "length" in t ? ae(t.length) : o, u = "omission" in t ? Nt(t.omission) : u;
        }
        e = ke(e);
        var h = e.length;
        if (pr(e)) {
          var v = Zt(e);
          h = v.length;
        }
        if (o >= h)
          return e;
        var b = o - vr(u);
        if (b < 1)
          return u;
        var C = v ? $n(v, 0, b).join("") : e.slice(0, b);
        if (c === r)
          return C + u;
        if (v && (b += C.length - b), Xa(c)) {
          if (e.slice(b).search(c)) {
            var M, D = C;
            for (c.global || (c = fa(c.source, ke(Ae.exec(c)) + "g")), c.lastIndex = 0; M = c.exec(D); )
              var N = M.index;
            C = C.slice(0, N === r ? b : N);
          }
        } else if (e.indexOf(Nt(c), b) != b) {
          var H = C.lastIndexOf(c);
          H > -1 && (C = C.slice(0, H));
        }
        return C + u;
      }
      function ww(e) {
        return e = ke(e), e && Oi.test(e) ? e.replace(fr, zd) : e;
      }
      var yw = Tr(function(e, t, o) {
        return e + (o ? " " : "") + t.toUpperCase();
      }), Ja = ul("toUpperCase");
      function ac(e, t, o) {
        return e = ke(e), t = o ? r : t, t === r ? Bd(e) ? Kd(e) : Dd(e) : e.match(t) || [];
      }
      var sc = le(function(e, t) {
        try {
          return Dt(e, r, t);
        } catch (o) {
          return Va(o) ? o : new ie(o);
        }
      }), bw = xn(function(e, t) {
        return jt(t, function(o) {
          o = ln(o), yn(e, o, qa(e[o], e));
        }), e;
      });
      function xw(e) {
        var t = e == null ? 0 : e.length, o = Z();
        return e = t ? je(e, function(u) {
          if (typeof u[1] != "function")
            throw new Gt(f);
          return [o(u[0]), u[1]];
        }) : [], le(function(u) {
          for (var c = -1; ++c < t; ) {
            var h = e[c];
            if (Dt(h[0], this, u))
              return Dt(h[1], this, u);
          }
        });
      }
      function _w(e) {
        return zh(zt(e, x));
      }
      function Za(e) {
        return function() {
          return e;
        };
      }
      function Cw(e, t) {
        return e == null || e !== e ? t : e;
      }
      var Tw = cl(), Ew = cl(!0);
      function At(e) {
        return e;
      }
      function es(e) {
        return Uu(typeof e == "function" ? e : zt(e, x));
      }
      function Ow(e) {
        return Bu(zt(e, x));
      }
      function Pw(e, t) {
        return Yu(e, zt(t, x));
      }
      var Sw = le(function(e, t) {
        return function(o) {
          return ri(o, e, t);
        };
      }), Rw = le(function(e, t) {
        return function(o) {
          return ri(e, o, t);
        };
      });
      function ts(e, t, o) {
        var u = ct(t), c = Ki(t, u);
        o == null && !(qe(t) && (c.length || !u.length)) && (o = t, t = e, e = this, c = Ki(t, ct(t)));
        var h = !(qe(o) && "chain" in o) || !!o.chain, v = Cn(e);
        return jt(c, function(b) {
          var C = t[b];
          e[b] = C, v && (e.prototype[b] = function() {
            var M = this.__chain__;
            if (h || M) {
              var D = e(this.__wrapped__), N = D.__actions__ = Pt(this.__actions__);
              return N.push({ func: C, args: arguments, thisArg: e }), D.__chain__ = M, D;
            }
            return C.apply(e, Dn([this.value()], arguments));
          });
        }), e;
      }
      function Aw() {
        return mt._ === this && (mt._ = nh), this;
      }
      function ns() {
      }
      function kw(e) {
        return e = ae(e), le(function(t) {
          return ju(t, e);
        });
      }
      var Mw = Da(je), Dw = Da(fu), Lw = Da(ia);
      function uc(e) {
        return Ua(e) ? oa(ln(e)) : cg(e);
      }
      function Nw(e) {
        return function(t) {
          return e == null ? r : Jn(e, t);
        };
      }
      var Ww = dl(), Iw = dl(!0);
      function rs() {
        return [];
      }
      function is() {
        return !1;
      }
      function Fw() {
        return {};
      }
      function $w() {
        return "";
      }
      function Uw() {
        return !0;
      }
      function Hw(e, t) {
        if (e = ae(e), e < 1 || e > F)
          return [];
        var o = Ie, u = vt(e, Ie);
        t = Z(t), e -= Ie;
        for (var c = ua(u, t); ++o < e; )
          t(o);
        return c;
      }
      function Bw(e) {
        return oe(e) ? je(e, ln) : Wt(e) ? [e] : Pt(Sl(ke(e)));
      }
      function Yw(e) {
        var t = ++eh;
        return ke(e) + t;
      }
      var jw = no(function(e, t) {
        return e + t;
      }, 0), Gw = La("ceil"), qw = no(function(e, t) {
        return e / t;
      }, 1), zw = La("floor");
      function Vw(e) {
        return e && e.length ? Xi(e, At, ya) : r;
      }
      function Xw(e, t) {
        return e && e.length ? Xi(e, Z(t, 2), ya) : r;
      }
      function Kw(e) {
        return gu(e, At);
      }
      function Qw(e, t) {
        return gu(e, Z(t, 2));
      }
      function Jw(e) {
        return e && e.length ? Xi(e, At, Ca) : r;
      }
      function Zw(e, t) {
        return e && e.length ? Xi(e, Z(t, 2), Ca) : r;
      }
      var e0 = no(function(e, t) {
        return e * t;
      }, 1), t0 = La("round"), n0 = no(function(e, t) {
        return e - t;
      }, 0);
      function r0(e) {
        return e && e.length ? sa(e, At) : 0;
      }
      function i0(e, t) {
        return e && e.length ? sa(e, Z(t, 2)) : 0;
      }
      return d.after = Op, d.ary = $l, d.assign = hv, d.assignIn = Zl, d.assignInWith = po, d.assignWith = gv, d.at = mv, d.before = Ul, d.bind = qa, d.bindAll = bw, d.bindKey = Hl, d.castArray = Fp, d.chain = Wl, d.chunk = zg, d.compact = Vg, d.concat = Xg, d.cond = xw, d.conforms = _w, d.constant = Za, d.countBy = rp, d.create = pv, d.curry = Bl, d.curryRight = Yl, d.debounce = jl, d.defaults = vv, d.defaultsDeep = wv, d.defer = Pp, d.delay = Sp, d.difference = Kg, d.differenceBy = Qg, d.differenceWith = Jg, d.drop = Zg, d.dropRight = em, d.dropRightWhile = tm, d.dropWhile = nm, d.fill = rm, d.filter = op, d.flatMap = up, d.flatMapDeep = lp, d.flatMapDepth = cp, d.flatten = Ml, d.flattenDeep = im, d.flattenDepth = om, d.flip = Rp, d.flow = Tw, d.flowRight = Ew, d.fromPairs = am, d.functions = Ev, d.functionsIn = Ov, d.groupBy = fp, d.initial = um, d.intersection = lm, d.intersectionBy = cm, d.intersectionWith = fm, d.invert = Sv, d.invertBy = Rv, d.invokeMap = hp, d.iteratee = es, d.keyBy = gp, d.keys = ct, d.keysIn = Rt, d.map = lo, d.mapKeys = kv, d.mapValues = Mv, d.matches = Ow, d.matchesProperty = Pw, d.memoize = fo, d.merge = Dv, d.mergeWith = ec, d.method = Sw, d.methodOf = Rw, d.mixin = ts, d.negate = ho, d.nthArg = kw, d.omit = Lv, d.omitBy = Nv, d.once = Ap, d.orderBy = mp, d.over = Mw, d.overArgs = kp, d.overEvery = Dw, d.overSome = Lw, d.partial = za, d.partialRight = Gl, d.partition = pp, d.pick = Wv, d.pickBy = tc, d.property = uc, d.propertyOf = Nw, d.pull = mm, d.pullAll = Ll, d.pullAllBy = pm, d.pullAllWith = vm, d.pullAt = wm, d.range = Ww, d.rangeRight = Iw, d.rearg = Mp, d.reject = yp, d.remove = ym, d.rest = Dp, d.reverse = ja, d.sampleSize = xp, d.set = Fv, d.setWith = $v, d.shuffle = _p, d.slice = bm, d.sortBy = Ep, d.sortedUniq = Pm, d.sortedUniqBy = Sm, d.split = uw, d.spread = Lp, d.tail = Rm, d.take = Am, d.takeRight = km, d.takeRightWhile = Mm, d.takeWhile = Dm, d.tap = Vm, d.throttle = Np, d.thru = uo, d.toArray = Kl, d.toPairs = nc, d.toPairsIn = rc, d.toPath = Bw, d.toPlainObject = Jl, d.transform = Uv, d.unary = Wp, d.union = Lm, d.unionBy = Nm, d.unionWith = Wm, d.uniq = Im, d.uniqBy = Fm, d.uniqWith = $m, d.unset = Hv, d.unzip = Ga, d.unzipWith = Nl, d.update = Bv, d.updateWith = Yv, d.values = Pr, d.valuesIn = jv, d.without = Um, d.words = ac, d.wrap = Ip, d.xor = Hm, d.xorBy = Bm, d.xorWith = Ym, d.zip = jm, d.zipObject = Gm, d.zipObjectDeep = qm, d.zipWith = zm, d.entries = nc, d.entriesIn = rc, d.extend = Zl, d.extendWith = po, ts(d, d), d.add = jw, d.attempt = sc, d.camelCase = Vv, d.capitalize = ic, d.ceil = Gw, d.clamp = Gv, d.clone = $p, d.cloneDeep = Hp, d.cloneDeepWith = Bp, d.cloneWith = Up, d.conformsTo = Yp, d.deburr = oc, d.defaultTo = Cw, d.divide = qw, d.endsWith = Xv, d.eq = tn, d.escape = Kv, d.escapeRegExp = Qv, d.every = ip, d.find = ap, d.findIndex = Al, d.findKey = yv, d.findLast = sp, d.findLastIndex = kl, d.findLastKey = bv, d.floor = zw, d.forEach = Il, d.forEachRight = Fl, d.forIn = xv, d.forInRight = _v, d.forOwn = Cv, d.forOwnRight = Tv, d.get = Ka, d.gt = jp, d.gte = Gp, d.has = Pv, d.hasIn = Qa, d.head = Dl, d.identity = At, d.includes = dp, d.indexOf = sm, d.inRange = qv, d.invoke = Av, d.isArguments = tr, d.isArray = oe, d.isArrayBuffer = qp, d.isArrayLike = St, d.isArrayLikeObject = Je, d.isBoolean = zp, d.isBuffer = Un, d.isDate = Vp, d.isElement = Xp, d.isEmpty = Kp, d.isEqual = Qp, d.isEqualWith = Jp, d.isError = Va, d.isFinite = Zp, d.isFunction = Cn, d.isInteger = ql, d.isLength = go, d.isMap = zl, d.isMatch = ev, d.isMatchWith = tv, d.isNaN = nv, d.isNative = rv, d.isNil = ov, d.isNull = iv, d.isNumber = Vl, d.isObject = qe, d.isObjectLike = Xe, d.isPlainObject = li, d.isRegExp = Xa, d.isSafeInteger = av, d.isSet = Xl, d.isString = mo, d.isSymbol = Wt, d.isTypedArray = Or, d.isUndefined = sv, d.isWeakMap = uv, d.isWeakSet = lv, d.join = dm, d.kebabCase = Jv, d.last = Xt, d.lastIndexOf = hm, d.lowerCase = Zv, d.lowerFirst = ew, d.lt = cv, d.lte = fv, d.max = Vw, d.maxBy = Xw, d.mean = Kw, d.meanBy = Qw, d.min = Jw, d.minBy = Zw, d.stubArray = rs, d.stubFalse = is, d.stubObject = Fw, d.stubString = $w, d.stubTrue = Uw, d.multiply = e0, d.nth = gm, d.noConflict = Aw, d.noop = ns, d.now = co, d.pad = tw, d.padEnd = nw, d.padStart = rw, d.parseInt = iw, d.random = zv, d.reduce = vp, d.reduceRight = wp, d.repeat = ow, d.replace = aw, d.result = Iv, d.round = t0, d.runInContext = _, d.sample = bp, d.size = Cp, d.snakeCase = sw, d.some = Tp, d.sortedIndex = xm, d.sortedIndexBy = _m, d.sortedIndexOf = Cm, d.sortedLastIndex = Tm, d.sortedLastIndexBy = Em, d.sortedLastIndexOf = Om, d.startCase = lw, d.startsWith = cw, d.subtract = n0, d.sum = r0, d.sumBy = i0, d.template = fw, d.times = Hw, d.toFinite = Tn, d.toInteger = ae, d.toLength = Ql, d.toLower = dw, d.toNumber = Kt, d.toSafeInteger = dv, d.toString = ke, d.toUpper = hw, d.trim = gw, d.trimEnd = mw, d.trimStart = pw, d.truncate = vw, d.unescape = ww, d.uniqueId = Yw, d.upperCase = yw, d.upperFirst = Ja, d.each = Il, d.eachRight = Fl, d.first = Dl, ts(d, function() {
        var e = {};
        return sn(d, function(t, o) {
          Le.call(d.prototype, o) || (e[o] = t);
        }), e;
      }(), { chain: !1 }), d.VERSION = a, jt(["bind", "bindKey", "curry", "curryRight", "partial", "partialRight"], function(e) {
        d[e].placeholder = d;
      }), jt(["drop", "take"], function(e, t) {
        ye.prototype[e] = function(o) {
          o = o === r ? 1 : it(ae(o), 0);
          var u = this.__filtered__ && !t ? new ye(this) : this.clone();
          return u.__filtered__ ? u.__takeCount__ = vt(o, u.__takeCount__) : u.__views__.push({
            size: vt(o, Ie),
            type: e + (u.__dir__ < 0 ? "Right" : "")
          }), u;
        }, ye.prototype[e + "Right"] = function(o) {
          return this.reverse()[e](o).reverse();
        };
      }), jt(["filter", "map", "takeWhile"], function(e, t) {
        var o = t + 1, u = o == Te || o == be;
        ye.prototype[e] = function(c) {
          var h = this.clone();
          return h.__iteratees__.push({
            iteratee: Z(c, 3),
            type: o
          }), h.__filtered__ = h.__filtered__ || u, h;
        };
      }), jt(["head", "last"], function(e, t) {
        var o = "take" + (t ? "Right" : "");
        ye.prototype[e] = function() {
          return this[o](1).value()[0];
        };
      }), jt(["initial", "tail"], function(e, t) {
        var o = "drop" + (t ? "" : "Right");
        ye.prototype[e] = function() {
          return this.__filtered__ ? new ye(this) : this[o](1);
        };
      }), ye.prototype.compact = function() {
        return this.filter(At);
      }, ye.prototype.find = function(e) {
        return this.filter(e).head();
      }, ye.prototype.findLast = function(e) {
        return this.reverse().find(e);
      }, ye.prototype.invokeMap = le(function(e, t) {
        return typeof e == "function" ? new ye(this) : this.map(function(o) {
          return ri(o, e, t);
        });
      }), ye.prototype.reject = function(e) {
        return this.filter(ho(Z(e)));
      }, ye.prototype.slice = function(e, t) {
        e = ae(e);
        var o = this;
        return o.__filtered__ && (e > 0 || t < 0) ? new ye(o) : (e < 0 ? o = o.takeRight(-e) : e && (o = o.drop(e)), t !== r && (t = ae(t), o = t < 0 ? o.dropRight(-t) : o.take(t - e)), o);
      }, ye.prototype.takeRightWhile = function(e) {
        return this.reverse().takeWhile(e).reverse();
      }, ye.prototype.toArray = function() {
        return this.take(Ie);
      }, sn(ye.prototype, function(e, t) {
        var o = /^(?:filter|find|map|reject)|While$/.test(t), u = /^(?:head|last)$/.test(t), c = d[u ? "take" + (t == "last" ? "Right" : "") : t], h = u || /^find/.test(t);
        c && (d.prototype[t] = function() {
          var v = this.__wrapped__, b = u ? [1] : arguments, C = v instanceof ye, M = b[0], D = C || oe(v), N = function(ge) {
            var _e = c.apply(d, Dn([ge], b));
            return u && H ? _e[0] : _e;
          };
          D && o && typeof M == "function" && M.length != 1 && (C = D = !1);
          var H = this.__chain__, K = !!this.__actions__.length, ee = h && !H, ue = C && !K;
          if (!h && D) {
            v = ue ? v : new ye(this);
            var te = e.apply(v, b);
            return te.__actions__.push({ func: uo, args: [N], thisArg: r }), new qt(te, H);
          }
          return ee && ue ? e.apply(this, b) : (te = this.thru(N), ee ? u ? te.value()[0] : te.value() : te);
        });
      }), jt(["pop", "push", "shift", "sort", "splice", "unshift"], function(e) {
        var t = Li[e], o = /^(?:push|sort|unshift)$/.test(e) ? "tap" : "thru", u = /^(?:pop|shift)$/.test(e);
        d.prototype[e] = function() {
          var c = arguments;
          if (u && !this.__chain__) {
            var h = this.value();
            return t.apply(oe(h) ? h : [], c);
          }
          return this[o](function(v) {
            return t.apply(oe(v) ? v : [], c);
          });
        };
      }), sn(ye.prototype, function(e, t) {
        var o = d[t];
        if (o) {
          var u = o.name + "";
          Le.call(xr, u) || (xr[u] = []), xr[u].push({ name: t, func: o });
        }
      }), xr[to(r, I).name] = [{
        name: "wrapper",
        func: r
      }], ye.prototype.clone = wh, ye.prototype.reverse = yh, ye.prototype.value = bh, d.prototype.at = Xm, d.prototype.chain = Km, d.prototype.commit = Qm, d.prototype.next = Jm, d.prototype.plant = ep, d.prototype.reverse = tp, d.prototype.toJSON = d.prototype.valueOf = d.prototype.value = np, d.prototype.first = d.prototype.head, Kr && (d.prototype[Kr] = Zm), d;
    }, wr = Qd();
    zn ? ((zn.exports = wr)._ = wr, ea._ = wr) : mt._ = wr;
  }).call(ci);
})(Co, Co.exports);
var as = Co.exports;
function To(n) {
  "@babel/helpers - typeof";
  return To = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(i) {
    return typeof i;
  } : function(i) {
    return i && typeof Symbol == "function" && i.constructor === Symbol && i !== Symbol.prototype ? "symbol" : typeof i;
  }, To(n);
}
function Ht(n) {
  if (n === null || n === !0 || n === !1)
    return NaN;
  var i = Number(n);
  return isNaN(i) ? i : i < 0 ? Math.ceil(i) : Math.floor(i);
}
function ze(n, i) {
  if (i.length < n)
    throw new TypeError(n + " argument" + (n > 1 ? "s" : "") + " required, but only " + i.length + " present");
}
function at(n) {
  ze(1, arguments);
  var i = Object.prototype.toString.call(n);
  return n instanceof Date || To(n) === "object" && i === "[object Date]" ? new Date(n.getTime()) : typeof n == "number" || i === "[object Number]" ? new Date(n) : ((typeof n == "string" || i === "[object String]") && typeof console < "u" && (console.warn("Starting with v2.0.0-beta.1 date-fns doesn't accept strings as date arguments. Please use `parseISO` to parse strings. See: https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#string-arguments"), console.warn(new Error().stack)), /* @__PURE__ */ new Date(NaN));
}
function Vc(n, i) {
  ze(2, arguments);
  var r = at(n), a = Ht(i);
  return isNaN(a) ? /* @__PURE__ */ new Date(NaN) : (a && r.setDate(r.getDate() + a), r);
}
function l0(n, i) {
  ze(2, arguments);
  var r = at(n), a = Ht(i);
  if (isNaN(a))
    return /* @__PURE__ */ new Date(NaN);
  if (!a)
    return r;
  var s = r.getDate(), l = new Date(r.getTime());
  l.setMonth(r.getMonth() + a + 1, 0);
  var f = l.getDate();
  return s >= f ? l : (r.setFullYear(l.getFullYear(), l.getMonth(), s), r);
}
function c0(n, i) {
  ze(2, arguments);
  var r = at(n).getTime(), a = Ht(i);
  return new Date(r + a);
}
var f0 = {};
function _i() {
  return f0;
}
function hc(n, i) {
  var r, a, s, l, f, m;
  ze(1, arguments);
  var g = _i(), p = Ht((r = (a = (s = (l = void 0) !== null && l !== void 0 ? l : void 0) !== null && s !== void 0 ? s : g.weekStartsOn) !== null && a !== void 0 ? a : (f = g.locale) === null || f === void 0 || (m = f.options) === null || m === void 0 ? void 0 : m.weekStartsOn) !== null && r !== void 0 ? r : 0);
  if (!(p >= 0 && p <= 6))
    throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
  var w = at(n), x = w.getDay(), T = (x < p ? 7 : 0) + x - p;
  return w.setDate(w.getDate() - T), w.setHours(0, 0, 0, 0), w;
}
function d0(n) {
  var i = new Date(Date.UTC(n.getFullYear(), n.getMonth(), n.getDate(), n.getHours(), n.getMinutes(), n.getSeconds(), n.getMilliseconds()));
  return i.setUTCFullYear(n.getFullYear()), n.getTime() - i.getTime();
}
function h0(n, i) {
  ze(2, arguments);
  var r = Ht(i), a = r * 7;
  return Vc(n, a);
}
function g0(n, i) {
  ze(2, arguments);
  var r = Ht(i);
  return l0(n, r * 12);
}
function m0(n) {
  return ze(1, arguments), n instanceof Date || To(n) === "object" && Object.prototype.toString.call(n) === "[object Date]";
}
function p0(n) {
  if (ze(1, arguments), !m0(n) && typeof n != "number")
    return !1;
  var i = at(n);
  return !isNaN(Number(i));
}
function v0(n, i) {
  var r;
  ze(1, arguments);
  var a = n || {}, s = at(a.start), l = at(a.end), f = l.getTime();
  if (!(s.getTime() <= f))
    throw new RangeError("Invalid interval");
  var m = [], g = s;
  g.setHours(0, 0, 0, 0);
  var p = Number((r = void 0) !== null && r !== void 0 ? r : 1);
  if (p < 1 || isNaN(p)) throw new RangeError("`options.step` must be a number greater than 1");
  for (; g.getTime() <= f; )
    m.push(at(g)), g.setDate(g.getDate() + p), g.setHours(0, 0, 0, 0);
  return m;
}
function w0(n, i) {
  ze(1, arguments);
  var r = n || {}, a = at(r.start), s = at(r.end), l = s.getTime();
  if (!(a.getTime() <= l))
    throw new RangeError("Invalid interval");
  var f = hc(a, i), m = hc(s, i);
  f.setHours(15), m.setHours(15), l = m.getTime();
  for (var g = [], p = f; p.getTime() <= l; )
    p.setHours(0), g.push(at(p)), p = h0(p, 1), p.setHours(15);
  return g;
}
function y0(n, i) {
  ze(2, arguments);
  var r = Ht(i);
  return c0(n, -r);
}
var b0 = 864e5;
function x0(n) {
  ze(1, arguments);
  var i = at(n), r = i.getTime();
  i.setUTCMonth(0, 1), i.setUTCHours(0, 0, 0, 0);
  var a = i.getTime(), s = r - a;
  return Math.floor(s / b0) + 1;
}
function Eo(n) {
  ze(1, arguments);
  var i = 1, r = at(n), a = r.getUTCDay(), s = (a < i ? 7 : 0) + a - i;
  return r.setUTCDate(r.getUTCDate() - s), r.setUTCHours(0, 0, 0, 0), r;
}
function Xc(n) {
  ze(1, arguments);
  var i = at(n), r = i.getUTCFullYear(), a = /* @__PURE__ */ new Date(0);
  a.setUTCFullYear(r + 1, 0, 4), a.setUTCHours(0, 0, 0, 0);
  var s = Eo(a), l = /* @__PURE__ */ new Date(0);
  l.setUTCFullYear(r, 0, 4), l.setUTCHours(0, 0, 0, 0);
  var f = Eo(l);
  return i.getTime() >= s.getTime() ? r + 1 : i.getTime() >= f.getTime() ? r : r - 1;
}
function _0(n) {
  ze(1, arguments);
  var i = Xc(n), r = /* @__PURE__ */ new Date(0);
  r.setUTCFullYear(i, 0, 4), r.setUTCHours(0, 0, 0, 0);
  var a = Eo(r);
  return a;
}
var C0 = 6048e5;
function T0(n) {
  ze(1, arguments);
  var i = at(n), r = Eo(i).getTime() - _0(i).getTime();
  return Math.round(r / C0) + 1;
}
function Oo(n, i) {
  var r, a, s, l, f, m, g, p;
  ze(1, arguments);
  var w = _i(), x = Ht((r = (a = (s = (l = i == null ? void 0 : i.weekStartsOn) !== null && l !== void 0 ? l : i == null || (f = i.locale) === null || f === void 0 || (m = f.options) === null || m === void 0 ? void 0 : m.weekStartsOn) !== null && s !== void 0 ? s : w.weekStartsOn) !== null && a !== void 0 ? a : (g = w.locale) === null || g === void 0 || (p = g.options) === null || p === void 0 ? void 0 : p.weekStartsOn) !== null && r !== void 0 ? r : 0);
  if (!(x >= 0 && x <= 6))
    throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
  var T = at(n), E = T.getUTCDay(), O = (E < x ? 7 : 0) + E - x;
  return T.setUTCDate(T.getUTCDate() - O), T.setUTCHours(0, 0, 0, 0), T;
}
function Kc(n, i) {
  var r, a, s, l, f, m, g, p;
  ze(1, arguments);
  var w = at(n), x = w.getUTCFullYear(), T = _i(), E = Ht((r = (a = (s = (l = i == null ? void 0 : i.firstWeekContainsDate) !== null && l !== void 0 ? l : i == null || (f = i.locale) === null || f === void 0 || (m = f.options) === null || m === void 0 ? void 0 : m.firstWeekContainsDate) !== null && s !== void 0 ? s : T.firstWeekContainsDate) !== null && a !== void 0 ? a : (g = T.locale) === null || g === void 0 || (p = g.options) === null || p === void 0 ? void 0 : p.firstWeekContainsDate) !== null && r !== void 0 ? r : 1);
  if (!(E >= 1 && E <= 7))
    throw new RangeError("firstWeekContainsDate must be between 1 and 7 inclusively");
  var O = /* @__PURE__ */ new Date(0);
  O.setUTCFullYear(x + 1, 0, E), O.setUTCHours(0, 0, 0, 0);
  var k = Oo(O, i), L = /* @__PURE__ */ new Date(0);
  L.setUTCFullYear(x, 0, E), L.setUTCHours(0, 0, 0, 0);
  var I = Oo(L, i);
  return w.getTime() >= k.getTime() ? x + 1 : w.getTime() >= I.getTime() ? x : x - 1;
}
function E0(n, i) {
  var r, a, s, l, f, m, g, p;
  ze(1, arguments);
  var w = _i(), x = Ht((r = (a = (s = (l = i == null ? void 0 : i.firstWeekContainsDate) !== null && l !== void 0 ? l : i == null || (f = i.locale) === null || f === void 0 || (m = f.options) === null || m === void 0 ? void 0 : m.firstWeekContainsDate) !== null && s !== void 0 ? s : w.firstWeekContainsDate) !== null && a !== void 0 ? a : (g = w.locale) === null || g === void 0 || (p = g.options) === null || p === void 0 ? void 0 : p.firstWeekContainsDate) !== null && r !== void 0 ? r : 1), T = Kc(n, i), E = /* @__PURE__ */ new Date(0);
  E.setUTCFullYear(T, 0, x), E.setUTCHours(0, 0, 0, 0);
  var O = Oo(E, i);
  return O;
}
var O0 = 6048e5;
function P0(n, i) {
  ze(1, arguments);
  var r = at(n), a = Oo(r, i).getTime() - E0(r, i).getTime();
  return Math.round(a / O0) + 1;
}
function Ne(n, i) {
  for (var r = n < 0 ? "-" : "", a = Math.abs(n).toString(); a.length < i; )
    a = "0" + a;
  return r + a;
}
var Hn = {
  // Year
  y: function(i, r) {
    var a = i.getUTCFullYear(), s = a > 0 ? a : 1 - a;
    return Ne(r === "yy" ? s % 100 : s, r.length);
  },
  // Month
  M: function(i, r) {
    var a = i.getUTCMonth();
    return r === "M" ? String(a + 1) : Ne(a + 1, 2);
  },
  // Day of the month
  d: function(i, r) {
    return Ne(i.getUTCDate(), r.length);
  },
  // AM or PM
  a: function(i, r) {
    var a = i.getUTCHours() / 12 >= 1 ? "pm" : "am";
    switch (r) {
      case "a":
      case "aa":
        return a.toUpperCase();
      case "aaa":
        return a;
      case "aaaaa":
        return a[0];
      case "aaaa":
      default:
        return a === "am" ? "a.m." : "p.m.";
    }
  },
  // Hour [1-12]
  h: function(i, r) {
    return Ne(i.getUTCHours() % 12 || 12, r.length);
  },
  // Hour [0-23]
  H: function(i, r) {
    return Ne(i.getUTCHours(), r.length);
  },
  // Minute
  m: function(i, r) {
    return Ne(i.getUTCMinutes(), r.length);
  },
  // Second
  s: function(i, r) {
    return Ne(i.getUTCSeconds(), r.length);
  },
  // Fraction of second
  S: function(i, r) {
    var a = r.length, s = i.getUTCMilliseconds(), l = Math.floor(s * Math.pow(10, a - 3));
    return Ne(l, r.length);
  }
}, Sr = {
  midnight: "midnight",
  noon: "noon",
  morning: "morning",
  afternoon: "afternoon",
  evening: "evening",
  night: "night"
}, S0 = {
  // Era
  G: function(i, r, a) {
    var s = i.getUTCFullYear() > 0 ? 1 : 0;
    switch (r) {
      case "G":
      case "GG":
      case "GGG":
        return a.era(s, {
          width: "abbreviated"
        });
      case "GGGGG":
        return a.era(s, {
          width: "narrow"
        });
      case "GGGG":
      default:
        return a.era(s, {
          width: "wide"
        });
    }
  },
  // Year
  y: function(i, r, a) {
    if (r === "yo") {
      var s = i.getUTCFullYear(), l = s > 0 ? s : 1 - s;
      return a.ordinalNumber(l, {
        unit: "year"
      });
    }
    return Hn.y(i, r);
  },
  // Local week-numbering year
  Y: function(i, r, a, s) {
    var l = Kc(i, s), f = l > 0 ? l : 1 - l;
    if (r === "YY") {
      var m = f % 100;
      return Ne(m, 2);
    }
    return r === "Yo" ? a.ordinalNumber(f, {
      unit: "year"
    }) : Ne(f, r.length);
  },
  // ISO week-numbering year
  R: function(i, r) {
    var a = Xc(i);
    return Ne(a, r.length);
  },
  // Extended year. This is a single number designating the year of this calendar system.
  // The main difference between `y` and `u` localizers are B.C. years:
  // | Year | `y` | `u` |
  // |------|-----|-----|
  // | AC 1 |   1 |   1 |
  // | BC 1 |   1 |   0 |
  // | BC 2 |   2 |  -1 |
  // Also `yy` always returns the last two digits of a year,
  // while `uu` pads single digit years to 2 characters and returns other years unchanged.
  u: function(i, r) {
    var a = i.getUTCFullYear();
    return Ne(a, r.length);
  },
  // Quarter
  Q: function(i, r, a) {
    var s = Math.ceil((i.getUTCMonth() + 1) / 3);
    switch (r) {
      case "Q":
        return String(s);
      case "QQ":
        return Ne(s, 2);
      case "Qo":
        return a.ordinalNumber(s, {
          unit: "quarter"
        });
      case "QQQ":
        return a.quarter(s, {
          width: "abbreviated",
          context: "formatting"
        });
      case "QQQQQ":
        return a.quarter(s, {
          width: "narrow",
          context: "formatting"
        });
      case "QQQQ":
      default:
        return a.quarter(s, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone quarter
  q: function(i, r, a) {
    var s = Math.ceil((i.getUTCMonth() + 1) / 3);
    switch (r) {
      case "q":
        return String(s);
      case "qq":
        return Ne(s, 2);
      case "qo":
        return a.ordinalNumber(s, {
          unit: "quarter"
        });
      case "qqq":
        return a.quarter(s, {
          width: "abbreviated",
          context: "standalone"
        });
      case "qqqqq":
        return a.quarter(s, {
          width: "narrow",
          context: "standalone"
        });
      case "qqqq":
      default:
        return a.quarter(s, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // Month
  M: function(i, r, a) {
    var s = i.getUTCMonth();
    switch (r) {
      case "M":
      case "MM":
        return Hn.M(i, r);
      case "Mo":
        return a.ordinalNumber(s + 1, {
          unit: "month"
        });
      case "MMM":
        return a.month(s, {
          width: "abbreviated",
          context: "formatting"
        });
      case "MMMMM":
        return a.month(s, {
          width: "narrow",
          context: "formatting"
        });
      case "MMMM":
      default:
        return a.month(s, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone month
  L: function(i, r, a) {
    var s = i.getUTCMonth();
    switch (r) {
      case "L":
        return String(s + 1);
      case "LL":
        return Ne(s + 1, 2);
      case "Lo":
        return a.ordinalNumber(s + 1, {
          unit: "month"
        });
      case "LLL":
        return a.month(s, {
          width: "abbreviated",
          context: "standalone"
        });
      case "LLLLL":
        return a.month(s, {
          width: "narrow",
          context: "standalone"
        });
      case "LLLL":
      default:
        return a.month(s, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // Local week of year
  w: function(i, r, a, s) {
    var l = P0(i, s);
    return r === "wo" ? a.ordinalNumber(l, {
      unit: "week"
    }) : Ne(l, r.length);
  },
  // ISO week of year
  I: function(i, r, a) {
    var s = T0(i);
    return r === "Io" ? a.ordinalNumber(s, {
      unit: "week"
    }) : Ne(s, r.length);
  },
  // Day of the month
  d: function(i, r, a) {
    return r === "do" ? a.ordinalNumber(i.getUTCDate(), {
      unit: "date"
    }) : Hn.d(i, r);
  },
  // Day of year
  D: function(i, r, a) {
    var s = x0(i);
    return r === "Do" ? a.ordinalNumber(s, {
      unit: "dayOfYear"
    }) : Ne(s, r.length);
  },
  // Day of week
  E: function(i, r, a) {
    var s = i.getUTCDay();
    switch (r) {
      case "E":
      case "EE":
      case "EEE":
        return a.day(s, {
          width: "abbreviated",
          context: "formatting"
        });
      case "EEEEE":
        return a.day(s, {
          width: "narrow",
          context: "formatting"
        });
      case "EEEEEE":
        return a.day(s, {
          width: "short",
          context: "formatting"
        });
      case "EEEE":
      default:
        return a.day(s, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Local day of week
  e: function(i, r, a, s) {
    var l = i.getUTCDay(), f = (l - s.weekStartsOn + 8) % 7 || 7;
    switch (r) {
      case "e":
        return String(f);
      case "ee":
        return Ne(f, 2);
      case "eo":
        return a.ordinalNumber(f, {
          unit: "day"
        });
      case "eee":
        return a.day(l, {
          width: "abbreviated",
          context: "formatting"
        });
      case "eeeee":
        return a.day(l, {
          width: "narrow",
          context: "formatting"
        });
      case "eeeeee":
        return a.day(l, {
          width: "short",
          context: "formatting"
        });
      case "eeee":
      default:
        return a.day(l, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone local day of week
  c: function(i, r, a, s) {
    var l = i.getUTCDay(), f = (l - s.weekStartsOn + 8) % 7 || 7;
    switch (r) {
      case "c":
        return String(f);
      case "cc":
        return Ne(f, r.length);
      case "co":
        return a.ordinalNumber(f, {
          unit: "day"
        });
      case "ccc":
        return a.day(l, {
          width: "abbreviated",
          context: "standalone"
        });
      case "ccccc":
        return a.day(l, {
          width: "narrow",
          context: "standalone"
        });
      case "cccccc":
        return a.day(l, {
          width: "short",
          context: "standalone"
        });
      case "cccc":
      default:
        return a.day(l, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // ISO day of week
  i: function(i, r, a) {
    var s = i.getUTCDay(), l = s === 0 ? 7 : s;
    switch (r) {
      case "i":
        return String(l);
      case "ii":
        return Ne(l, r.length);
      case "io":
        return a.ordinalNumber(l, {
          unit: "day"
        });
      case "iii":
        return a.day(s, {
          width: "abbreviated",
          context: "formatting"
        });
      case "iiiii":
        return a.day(s, {
          width: "narrow",
          context: "formatting"
        });
      case "iiiiii":
        return a.day(s, {
          width: "short",
          context: "formatting"
        });
      case "iiii":
      default:
        return a.day(s, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // AM or PM
  a: function(i, r, a) {
    var s = i.getUTCHours(), l = s / 12 >= 1 ? "pm" : "am";
    switch (r) {
      case "a":
      case "aa":
        return a.dayPeriod(l, {
          width: "abbreviated",
          context: "formatting"
        });
      case "aaa":
        return a.dayPeriod(l, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "aaaaa":
        return a.dayPeriod(l, {
          width: "narrow",
          context: "formatting"
        });
      case "aaaa":
      default:
        return a.dayPeriod(l, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // AM, PM, midnight, noon
  b: function(i, r, a) {
    var s = i.getUTCHours(), l;
    switch (s === 12 ? l = Sr.noon : s === 0 ? l = Sr.midnight : l = s / 12 >= 1 ? "pm" : "am", r) {
      case "b":
      case "bb":
        return a.dayPeriod(l, {
          width: "abbreviated",
          context: "formatting"
        });
      case "bbb":
        return a.dayPeriod(l, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "bbbbb":
        return a.dayPeriod(l, {
          width: "narrow",
          context: "formatting"
        });
      case "bbbb":
      default:
        return a.dayPeriod(l, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // in the morning, in the afternoon, in the evening, at night
  B: function(i, r, a) {
    var s = i.getUTCHours(), l;
    switch (s >= 17 ? l = Sr.evening : s >= 12 ? l = Sr.afternoon : s >= 4 ? l = Sr.morning : l = Sr.night, r) {
      case "B":
      case "BB":
      case "BBB":
        return a.dayPeriod(l, {
          width: "abbreviated",
          context: "formatting"
        });
      case "BBBBB":
        return a.dayPeriod(l, {
          width: "narrow",
          context: "formatting"
        });
      case "BBBB":
      default:
        return a.dayPeriod(l, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Hour [1-12]
  h: function(i, r, a) {
    if (r === "ho") {
      var s = i.getUTCHours() % 12;
      return s === 0 && (s = 12), a.ordinalNumber(s, {
        unit: "hour"
      });
    }
    return Hn.h(i, r);
  },
  // Hour [0-23]
  H: function(i, r, a) {
    return r === "Ho" ? a.ordinalNumber(i.getUTCHours(), {
      unit: "hour"
    }) : Hn.H(i, r);
  },
  // Hour [0-11]
  K: function(i, r, a) {
    var s = i.getUTCHours() % 12;
    return r === "Ko" ? a.ordinalNumber(s, {
      unit: "hour"
    }) : Ne(s, r.length);
  },
  // Hour [1-24]
  k: function(i, r, a) {
    var s = i.getUTCHours();
    return s === 0 && (s = 24), r === "ko" ? a.ordinalNumber(s, {
      unit: "hour"
    }) : Ne(s, r.length);
  },
  // Minute
  m: function(i, r, a) {
    return r === "mo" ? a.ordinalNumber(i.getUTCMinutes(), {
      unit: "minute"
    }) : Hn.m(i, r);
  },
  // Second
  s: function(i, r, a) {
    return r === "so" ? a.ordinalNumber(i.getUTCSeconds(), {
      unit: "second"
    }) : Hn.s(i, r);
  },
  // Fraction of second
  S: function(i, r) {
    return Hn.S(i, r);
  },
  // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
  X: function(i, r, a, s) {
    var l = s._originalDate || i, f = l.getTimezoneOffset();
    if (f === 0)
      return "Z";
    switch (r) {
      case "X":
        return mc(f);
      case "XXXX":
      case "XX":
        return rr(f);
      case "XXXXX":
      case "XXX":
      default:
        return rr(f, ":");
    }
  },
  // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
  x: function(i, r, a, s) {
    var l = s._originalDate || i, f = l.getTimezoneOffset();
    switch (r) {
      case "x":
        return mc(f);
      case "xxxx":
      case "xx":
        return rr(f);
      case "xxxxx":
      case "xxx":
      default:
        return rr(f, ":");
    }
  },
  // Timezone (GMT)
  O: function(i, r, a, s) {
    var l = s._originalDate || i, f = l.getTimezoneOffset();
    switch (r) {
      case "O":
      case "OO":
      case "OOO":
        return "GMT" + gc(f, ":");
      case "OOOO":
      default:
        return "GMT" + rr(f, ":");
    }
  },
  // Timezone (specific non-location)
  z: function(i, r, a, s) {
    var l = s._originalDate || i, f = l.getTimezoneOffset();
    switch (r) {
      case "z":
      case "zz":
      case "zzz":
        return "GMT" + gc(f, ":");
      case "zzzz":
      default:
        return "GMT" + rr(f, ":");
    }
  },
  // Seconds timestamp
  t: function(i, r, a, s) {
    var l = s._originalDate || i, f = Math.floor(l.getTime() / 1e3);
    return Ne(f, r.length);
  },
  // Milliseconds timestamp
  T: function(i, r, a, s) {
    var l = s._originalDate || i, f = l.getTime();
    return Ne(f, r.length);
  }
};
function gc(n, i) {
  var r = n > 0 ? "-" : "+", a = Math.abs(n), s = Math.floor(a / 60), l = a % 60;
  if (l === 0)
    return r + String(s);
  var f = i;
  return r + String(s) + f + Ne(l, 2);
}
function mc(n, i) {
  if (n % 60 === 0) {
    var r = n > 0 ? "-" : "+";
    return r + Ne(Math.abs(n) / 60, 2);
  }
  return rr(n, i);
}
function rr(n, i) {
  var r = i || "", a = n > 0 ? "-" : "+", s = Math.abs(n), l = Ne(Math.floor(s / 60), 2), f = Ne(s % 60, 2);
  return a + l + r + f;
}
var pc = function(i, r) {
  switch (i) {
    case "P":
      return r.date({
        width: "short"
      });
    case "PP":
      return r.date({
        width: "medium"
      });
    case "PPP":
      return r.date({
        width: "long"
      });
    case "PPPP":
    default:
      return r.date({
        width: "full"
      });
  }
}, Qc = function(i, r) {
  switch (i) {
    case "p":
      return r.time({
        width: "short"
      });
    case "pp":
      return r.time({
        width: "medium"
      });
    case "ppp":
      return r.time({
        width: "long"
      });
    case "pppp":
    default:
      return r.time({
        width: "full"
      });
  }
}, R0 = function(i, r) {
  var a = i.match(/(P+)(p+)?/) || [], s = a[1], l = a[2];
  if (!l)
    return pc(i, r);
  var f;
  switch (s) {
    case "P":
      f = r.dateTime({
        width: "short"
      });
      break;
    case "PP":
      f = r.dateTime({
        width: "medium"
      });
      break;
    case "PPP":
      f = r.dateTime({
        width: "long"
      });
      break;
    case "PPPP":
    default:
      f = r.dateTime({
        width: "full"
      });
      break;
  }
  return f.replace("{{date}}", pc(s, r)).replace("{{time}}", Qc(l, r));
}, A0 = {
  p: Qc,
  P: R0
}, k0 = ["D", "DD"], M0 = ["YY", "YYYY"];
function D0(n) {
  return k0.indexOf(n) !== -1;
}
function L0(n) {
  return M0.indexOf(n) !== -1;
}
function vc(n, i, r) {
  if (n === "YYYY")
    throw new RangeError("Use `yyyy` instead of `YYYY` (in `".concat(i, "`) for formatting years to the input `").concat(r, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
  if (n === "YY")
    throw new RangeError("Use `yy` instead of `YY` (in `".concat(i, "`) for formatting years to the input `").concat(r, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
  if (n === "D")
    throw new RangeError("Use `d` instead of `D` (in `".concat(i, "`) for formatting days of the month to the input `").concat(r, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
  if (n === "DD")
    throw new RangeError("Use `dd` instead of `DD` (in `".concat(i, "`) for formatting days of the month to the input `").concat(r, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
}
var N0 = {
  lessThanXSeconds: {
    one: "less than a second",
    other: "less than {{count}} seconds"
  },
  xSeconds: {
    one: "1 second",
    other: "{{count}} seconds"
  },
  halfAMinute: "half a minute",
  lessThanXMinutes: {
    one: "less than a minute",
    other: "less than {{count}} minutes"
  },
  xMinutes: {
    one: "1 minute",
    other: "{{count}} minutes"
  },
  aboutXHours: {
    one: "about 1 hour",
    other: "about {{count}} hours"
  },
  xHours: {
    one: "1 hour",
    other: "{{count}} hours"
  },
  xDays: {
    one: "1 day",
    other: "{{count}} days"
  },
  aboutXWeeks: {
    one: "about 1 week",
    other: "about {{count}} weeks"
  },
  xWeeks: {
    one: "1 week",
    other: "{{count}} weeks"
  },
  aboutXMonths: {
    one: "about 1 month",
    other: "about {{count}} months"
  },
  xMonths: {
    one: "1 month",
    other: "{{count}} months"
  },
  aboutXYears: {
    one: "about 1 year",
    other: "about {{count}} years"
  },
  xYears: {
    one: "1 year",
    other: "{{count}} years"
  },
  overXYears: {
    one: "over 1 year",
    other: "over {{count}} years"
  },
  almostXYears: {
    one: "almost 1 year",
    other: "almost {{count}} years"
  }
}, W0 = function(i, r, a) {
  var s, l = N0[i];
  return typeof l == "string" ? s = l : r === 1 ? s = l.one : s = l.other.replace("{{count}}", r.toString()), a != null && a.addSuffix ? a.comparison && a.comparison > 0 ? "in " + s : s + " ago" : s;
};
function ss(n) {
  return function() {
    var i = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, r = i.width ? String(i.width) : n.defaultWidth, a = n.formats[r] || n.formats[n.defaultWidth];
    return a;
  };
}
var I0 = {
  full: "EEEE, MMMM do, y",
  long: "MMMM do, y",
  medium: "MMM d, y",
  short: "MM/dd/yyyy"
}, F0 = {
  full: "h:mm:ss a zzzz",
  long: "h:mm:ss a z",
  medium: "h:mm:ss a",
  short: "h:mm a"
}, $0 = {
  full: "{{date}} 'at' {{time}}",
  long: "{{date}} 'at' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, U0 = {
  date: ss({
    formats: I0,
    defaultWidth: "full"
  }),
  time: ss({
    formats: F0,
    defaultWidth: "full"
  }),
  dateTime: ss({
    formats: $0,
    defaultWidth: "full"
  })
}, H0 = {
  lastWeek: "'last' eeee 'at' p",
  yesterday: "'yesterday at' p",
  today: "'today at' p",
  tomorrow: "'tomorrow at' p",
  nextWeek: "eeee 'at' p",
  other: "P"
}, B0 = function(i, r, a, s) {
  return H0[i];
};
function hi(n) {
  return function(i, r) {
    var a = r != null && r.context ? String(r.context) : "standalone", s;
    if (a === "formatting" && n.formattingValues) {
      var l = n.defaultFormattingWidth || n.defaultWidth, f = r != null && r.width ? String(r.width) : l;
      s = n.formattingValues[f] || n.formattingValues[l];
    } else {
      var m = n.defaultWidth, g = r != null && r.width ? String(r.width) : n.defaultWidth;
      s = n.values[g] || n.values[m];
    }
    var p = n.argumentCallback ? n.argumentCallback(i) : i;
    return s[p];
  };
}
var Y0 = {
  narrow: ["B", "A"],
  abbreviated: ["BC", "AD"],
  wide: ["Before Christ", "Anno Domini"]
}, j0 = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["Q1", "Q2", "Q3", "Q4"],
  wide: ["1st quarter", "2nd quarter", "3rd quarter", "4th quarter"]
}, G0 = {
  narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
  abbreviated: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
  wide: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"]
}, q0 = {
  narrow: ["S", "M", "T", "W", "T", "F", "S"],
  short: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"],
  abbreviated: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
  wide: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"]
}, z0 = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  }
}, V0 = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  }
}, X0 = function(i, r) {
  var a = Number(i), s = a % 100;
  if (s > 20 || s < 10)
    switch (s % 10) {
      case 1:
        return a + "st";
      case 2:
        return a + "nd";
      case 3:
        return a + "rd";
    }
  return a + "th";
}, K0 = {
  ordinalNumber: X0,
  era: hi({
    values: Y0,
    defaultWidth: "wide"
  }),
  quarter: hi({
    values: j0,
    defaultWidth: "wide",
    argumentCallback: function(i) {
      return i - 1;
    }
  }),
  month: hi({
    values: G0,
    defaultWidth: "wide"
  }),
  day: hi({
    values: q0,
    defaultWidth: "wide"
  }),
  dayPeriod: hi({
    values: z0,
    defaultWidth: "wide",
    formattingValues: V0,
    defaultFormattingWidth: "wide"
  })
};
function gi(n) {
  return function(i) {
    var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, a = r.width, s = a && n.matchPatterns[a] || n.matchPatterns[n.defaultMatchWidth], l = i.match(s);
    if (!l)
      return null;
    var f = l[0], m = a && n.parsePatterns[a] || n.parsePatterns[n.defaultParseWidth], g = Array.isArray(m) ? J0(m, function(x) {
      return x.test(f);
    }) : Q0(m, function(x) {
      return x.test(f);
    }), p;
    p = n.valueCallback ? n.valueCallback(g) : g, p = r.valueCallback ? r.valueCallback(p) : p;
    var w = i.slice(f.length);
    return {
      value: p,
      rest: w
    };
  };
}
function Q0(n, i) {
  for (var r in n)
    if (n.hasOwnProperty(r) && i(n[r]))
      return r;
}
function J0(n, i) {
  for (var r = 0; r < n.length; r++)
    if (i(n[r]))
      return r;
}
function Z0(n) {
  return function(i) {
    var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, a = i.match(n.matchPattern);
    if (!a) return null;
    var s = a[0], l = i.match(n.parsePattern);
    if (!l) return null;
    var f = n.valueCallback ? n.valueCallback(l[0]) : l[0];
    f = r.valueCallback ? r.valueCallback(f) : f;
    var m = i.slice(s.length);
    return {
      value: f,
      rest: m
    };
  };
}
var ey = /^(\d+)(th|st|nd|rd)?/i, ty = /\d+/i, ny = {
  narrow: /^(b|a)/i,
  abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
  wide: /^(before christ|before common era|anno domini|common era)/i
}, ry = {
  any: [/^b/i, /^(a|c)/i]
}, iy = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234](th|st|nd|rd)? quarter/i
}, oy = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, ay = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
  wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
}, sy = {
  narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
  any: [/^ja/i, /^f/i, /^mar/i, /^ap/i, /^may/i, /^jun/i, /^jul/i, /^au/i, /^s/i, /^o/i, /^n/i, /^d/i]
}, uy = {
  narrow: /^[smtwf]/i,
  short: /^(su|mo|tu|we|th|fr|sa)/i,
  abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
  wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
}, ly = {
  narrow: [/^s/i, /^m/i, /^t/i, /^w/i, /^t/i, /^f/i, /^s/i],
  any: [/^su/i, /^m/i, /^tu/i, /^w/i, /^th/i, /^f/i, /^sa/i]
}, cy = {
  narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
  any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
}, fy = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^mi/i,
    noon: /^no/i,
    morning: /morning/i,
    afternoon: /afternoon/i,
    evening: /evening/i,
    night: /night/i
  }
}, dy = {
  ordinalNumber: Z0({
    matchPattern: ey,
    parsePattern: ty,
    valueCallback: function(i) {
      return parseInt(i, 10);
    }
  }),
  era: gi({
    matchPatterns: ny,
    defaultMatchWidth: "wide",
    parsePatterns: ry,
    defaultParseWidth: "any"
  }),
  quarter: gi({
    matchPatterns: iy,
    defaultMatchWidth: "wide",
    parsePatterns: oy,
    defaultParseWidth: "any",
    valueCallback: function(i) {
      return i + 1;
    }
  }),
  month: gi({
    matchPatterns: ay,
    defaultMatchWidth: "wide",
    parsePatterns: sy,
    defaultParseWidth: "any"
  }),
  day: gi({
    matchPatterns: uy,
    defaultMatchWidth: "wide",
    parsePatterns: ly,
    defaultParseWidth: "any"
  }),
  dayPeriod: gi({
    matchPatterns: cy,
    defaultMatchWidth: "any",
    parsePatterns: fy,
    defaultParseWidth: "any"
  })
}, hy = {
  code: "en-US",
  formatDistance: W0,
  formatLong: U0,
  formatRelative: B0,
  localize: K0,
  match: dy,
  options: {
    weekStartsOn: 0,
    firstWeekContainsDate: 1
  }
}, gy = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g, my = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g, py = /^'([^]*?)'?$/, vy = /''/g, wy = /[a-zA-Z]/;
function Mr(n, i, r) {
  var a, s, l, f, m, g, p, w, x, T, E, O, k, L;
  ze(2, arguments);
  var I = String(i), $ = _i(), B = (a = (s = void 0) !== null && s !== void 0 ? s : $.locale) !== null && a !== void 0 ? a : hy, q = Ht((l = (f = (m = (g = void 0) !== null && g !== void 0 ? g : void 0) !== null && m !== void 0 ? m : $.firstWeekContainsDate) !== null && f !== void 0 ? f : (p = $.locale) === null || p === void 0 || (w = p.options) === null || w === void 0 ? void 0 : w.firstWeekContainsDate) !== null && l !== void 0 ? l : 1);
  if (!(q >= 1 && q <= 7))
    throw new RangeError("firstWeekContainsDate must be between 1 and 7 inclusively");
  var Y = Ht((x = (T = (E = (O = void 0) !== null && O !== void 0 ? O : void 0) !== null && E !== void 0 ? E : $.weekStartsOn) !== null && T !== void 0 ? T : (k = $.locale) === null || k === void 0 || (L = k.options) === null || L === void 0 ? void 0 : L.weekStartsOn) !== null && x !== void 0 ? x : 0);
  if (!(Y >= 0 && Y <= 6))
    throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
  if (!B.localize)
    throw new RangeError("locale must contain localize property");
  if (!B.formatLong)
    throw new RangeError("locale must contain formatLong property");
  var Q = at(n);
  if (!p0(Q))
    throw new RangeError("Invalid time value");
  var j = d0(Q), U = y0(Q, j), se = {
    firstWeekContainsDate: q,
    weekStartsOn: Y,
    locale: B,
    _originalDate: Q
  }, Ce = I.match(my).map(function(fe) {
    var de = fe[0];
    if (de === "p" || de === "P") {
      var re = A0[de];
      return re(fe, B.formatLong);
    }
    return fe;
  }).join("").match(gy).map(function(fe) {
    if (fe === "''")
      return "'";
    var de = fe[0];
    if (de === "'")
      return yy(fe);
    var re = S0[de];
    if (re)
      return L0(fe) && vc(fe, i, String(n)), D0(fe) && vc(fe, i, String(n)), re(U, fe, B.localize, se);
    if (de.match(wy))
      throw new RangeError("Format string contains an unescaped latin alphabet character `" + de + "`");
    return fe;
  }).join("");
  return Ce;
}
function yy(n) {
  var i = n.match(py);
  return i ? i[1].replace(vy, "'") : n;
}
function by(n, i) {
  ze(2, arguments);
  var r = Ht(i);
  return g0(n, -r);
}
/**
 * @license lucide-react v0.344.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
var xy = {
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
};
/**
 * @license lucide-react v0.344.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const _y = (n) => n.replace(/([a-z0-9])([A-Z])/g, "$1-$2").toLowerCase().trim(), Ci = (n, i) => {
  const r = o0(
    ({
      color: a = "currentColor",
      size: s = 24,
      strokeWidth: l = 2,
      absoluteStrokeWidth: f,
      className: m = "",
      children: g,
      ...p
    }, w) => cc(
      "svg",
      {
        ref: w,
        ...xy,
        width: s,
        height: s,
        stroke: a,
        strokeWidth: f ? Number(l) * 24 / Number(s) : l,
        className: ["lucide", `lucide-${_y(n)}`, m].join(" "),
        ...p
      },
      [
        ...i.map(([x, T]) => cc(x, T)),
        ...Array.isArray(g) ? g : [g]
      ]
    )
  );
  return r.displayName = `${n}`, r;
};
/**
 * @license lucide-react v0.344.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const wc = Ci("Calendar", [
  ["path", { d: "M8 2v4", key: "1cmpym" }],
  ["path", { d: "M16 2v4", key: "4m81vk" }],
  ["rect", { width: "18", height: "18", x: "3", y: "4", rx: "2", key: "1hopcy" }],
  ["path", { d: "M3 10h18", key: "8toen8" }]
]);
/**
 * @license lucide-react v0.344.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Cy = Ci("GitBranch", [
  ["line", { x1: "6", x2: "6", y1: "3", y2: "15", key: "17qcm7" }],
  ["circle", { cx: "18", cy: "6", r: "3", key: "1h7g24" }],
  ["circle", { cx: "6", cy: "18", r: "3", key: "fqmcym" }],
  ["path", { d: "M18 9a9 9 0 0 1-9 9", key: "n2h4wq" }]
]);
/**
 * @license lucide-react v0.344.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Ty = Ci("GitCommitHorizontal", [
  ["circle", { cx: "12", cy: "12", r: "3", key: "1v7zrd" }],
  ["line", { x1: "3", x2: "9", y1: "12", y2: "12", key: "1dyftd" }],
  ["line", { x1: "15", x2: "21", y1: "12", y2: "12", key: "oup4p8" }]
]);
/**
 * @license lucide-react v0.344.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Ey = Ci("GitMerge", [
  ["circle", { cx: "18", cy: "18", r: "3", key: "1xkwt0" }],
  ["circle", { cx: "6", cy: "6", r: "3", key: "1lh9wr" }],
  ["path", { d: "M6 21V9a9 9 0 0 0 9 9", key: "7kw0sc" }]
]);
/**
 * @license lucide-react v0.344.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Oy = Ci("GitPullRequest", [
  ["circle", { cx: "18", cy: "18", r: "3", key: "1xkwt0" }],
  ["circle", { cx: "6", cy: "6", r: "3", key: "1lh9wr" }],
  ["path", { d: "M13 6h3a2 2 0 0 1 2 2v7", key: "1yeb86" }],
  ["line", { x1: "6", x2: "6", y1: "9", y2: "21", key: "rroup" }]
]);
function Jc(n) {
  var i, r, a = "";
  if (typeof n == "string" || typeof n == "number") a += n;
  else if (typeof n == "object") if (Array.isArray(n)) {
    var s = n.length;
    for (i = 0; i < s; i++) n[i] && (r = Jc(n[i])) && (a && (a += " "), a += r);
  } else for (r in n) n[r] && (a && (a += " "), a += r);
  return a;
}
function Zc() {
  for (var n, i, r = 0, a = "", s = arguments.length; r < s; r++) (n = arguments[r]) && (i = Jc(n)) && (a && (a += " "), a += i);
  return a;
}
const Ps = "-", Py = (n) => {
  const i = Ry(n), {
    conflictingClassGroups: r,
    conflictingClassGroupModifiers: a
  } = n;
  return {
    getClassGroupId: (f) => {
      const m = f.split(Ps);
      return m[0] === "" && m.length !== 1 && m.shift(), ef(m, i) || Sy(f);
    },
    getConflictingClassGroupIds: (f, m) => {
      const g = r[f] || [];
      return m && a[f] ? [...g, ...a[f]] : g;
    }
  };
}, ef = (n, i) => {
  var f;
  if (n.length === 0)
    return i.classGroupId;
  const r = n[0], a = i.nextPart.get(r), s = a ? ef(n.slice(1), a) : void 0;
  if (s)
    return s;
  if (i.validators.length === 0)
    return;
  const l = n.join(Ps);
  return (f = i.validators.find(({
    validator: m
  }) => m(l))) == null ? void 0 : f.classGroupId;
}, yc = /^\[(.+)\]$/, Sy = (n) => {
  if (yc.test(n)) {
    const i = yc.exec(n)[1], r = i == null ? void 0 : i.substring(0, i.indexOf(":"));
    if (r)
      return "arbitrary.." + r;
  }
}, Ry = (n) => {
  const {
    theme: i,
    classGroups: r
  } = n, a = {
    nextPart: /* @__PURE__ */ new Map(),
    validators: []
  };
  for (const s in r)
    ms(r[s], a, s, i);
  return a;
}, ms = (n, i, r, a) => {
  n.forEach((s) => {
    if (typeof s == "string") {
      const l = s === "" ? i : bc(i, s);
      l.classGroupId = r;
      return;
    }
    if (typeof s == "function") {
      if (Ay(s)) {
        ms(s(a), i, r, a);
        return;
      }
      i.validators.push({
        validator: s,
        classGroupId: r
      });
      return;
    }
    Object.entries(s).forEach(([l, f]) => {
      ms(f, bc(i, l), r, a);
    });
  });
}, bc = (n, i) => {
  let r = n;
  return i.split(Ps).forEach((a) => {
    r.nextPart.has(a) || r.nextPart.set(a, {
      nextPart: /* @__PURE__ */ new Map(),
      validators: []
    }), r = r.nextPart.get(a);
  }), r;
}, Ay = (n) => n.isThemeGetter, ky = (n) => {
  if (n < 1)
    return {
      get: () => {
      },
      set: () => {
      }
    };
  let i = 0, r = /* @__PURE__ */ new Map(), a = /* @__PURE__ */ new Map();
  const s = (l, f) => {
    r.set(l, f), i++, i > n && (i = 0, a = r, r = /* @__PURE__ */ new Map());
  };
  return {
    get(l) {
      let f = r.get(l);
      if (f !== void 0)
        return f;
      if ((f = a.get(l)) !== void 0)
        return s(l, f), f;
    },
    set(l, f) {
      r.has(l) ? r.set(l, f) : s(l, f);
    }
  };
}, ps = "!", vs = ":", My = vs.length, Dy = (n) => {
  const {
    prefix: i,
    experimentalParseClassName: r
  } = n;
  let a = (s) => {
    const l = [];
    let f = 0, m = 0, g = 0, p;
    for (let O = 0; O < s.length; O++) {
      let k = s[O];
      if (f === 0 && m === 0) {
        if (k === vs) {
          l.push(s.slice(g, O)), g = O + My;
          continue;
        }
        if (k === "/") {
          p = O;
          continue;
        }
      }
      k === "[" ? f++ : k === "]" ? f-- : k === "(" ? m++ : k === ")" && m--;
    }
    const w = l.length === 0 ? s : s.substring(g), x = Ly(w), T = x !== w, E = p && p > g ? p - g : void 0;
    return {
      modifiers: l,
      hasImportantModifier: T,
      baseClassName: x,
      maybePostfixModifierPosition: E
    };
  };
  if (i) {
    const s = i + vs, l = a;
    a = (f) => f.startsWith(s) ? l(f.substring(s.length)) : {
      isExternal: !0,
      modifiers: [],
      hasImportantModifier: !1,
      baseClassName: f,
      maybePostfixModifierPosition: void 0
    };
  }
  if (r) {
    const s = a;
    a = (l) => r({
      className: l,
      parseClassName: s
    });
  }
  return a;
}, Ly = (n) => n.endsWith(ps) ? n.substring(0, n.length - 1) : n.startsWith(ps) ? n.substring(1) : n, Ny = (n) => {
  const i = Object.fromEntries(n.orderSensitiveModifiers.map((a) => [a, !0]));
  return (a) => {
    if (a.length <= 1)
      return a;
    const s = [];
    let l = [];
    return a.forEach((f) => {
      f[0] === "[" || i[f] ? (s.push(...l.sort(), f), l = []) : l.push(f);
    }), s.push(...l.sort()), s;
  };
}, Wy = (n) => ({
  cache: ky(n.cacheSize),
  parseClassName: Dy(n),
  sortModifiers: Ny(n),
  ...Py(n)
}), Iy = /\s+/, Fy = (n, i) => {
  const {
    parseClassName: r,
    getClassGroupId: a,
    getConflictingClassGroupIds: s,
    sortModifiers: l
  } = i, f = [], m = n.trim().split(Iy);
  let g = "";
  for (let p = m.length - 1; p >= 0; p -= 1) {
    const w = m[p], {
      isExternal: x,
      modifiers: T,
      hasImportantModifier: E,
      baseClassName: O,
      maybePostfixModifierPosition: k
    } = r(w);
    if (x) {
      g = w + (g.length > 0 ? " " + g : g);
      continue;
    }
    let L = !!k, I = a(L ? O.substring(0, k) : O);
    if (!I) {
      if (!L) {
        g = w + (g.length > 0 ? " " + g : g);
        continue;
      }
      if (I = a(O), !I) {
        g = w + (g.length > 0 ? " " + g : g);
        continue;
      }
      L = !1;
    }
    const $ = l(T).join(":"), B = E ? $ + ps : $, q = B + I;
    if (f.includes(q))
      continue;
    f.push(q);
    const Y = s(I, L);
    for (let Q = 0; Q < Y.length; ++Q) {
      const j = Y[Q];
      f.push(B + j);
    }
    g = w + (g.length > 0 ? " " + g : g);
  }
  return g;
};
function $y() {
  let n = 0, i, r, a = "";
  for (; n < arguments.length; )
    (i = arguments[n++]) && (r = tf(i)) && (a && (a += " "), a += r);
  return a;
}
const tf = (n) => {
  if (typeof n == "string")
    return n;
  let i, r = "";
  for (let a = 0; a < n.length; a++)
    n[a] && (i = tf(n[a])) && (r && (r += " "), r += i);
  return r;
};
function Uy(n, ...i) {
  let r, a, s, l = f;
  function f(g) {
    const p = i.reduce((w, x) => x(w), n());
    return r = Wy(p), a = r.cache.get, s = r.cache.set, l = m, m(g);
  }
  function m(g) {
    const p = a(g);
    if (p)
      return p;
    const w = Fy(g, r);
    return s(g, w), w;
  }
  return function() {
    return l($y.apply(null, arguments));
  };
}
const ot = (n) => {
  const i = (r) => r[n] || [];
  return i.isThemeGetter = !0, i;
}, nf = /^\[(?:(\w[\w-]*):)?(.+)\]$/i, rf = /^\((?:(\w[\w-]*):)?(.+)\)$/i, Hy = /^\d+\/\d+$/, By = /^(\d+(\.\d+)?)?(xs|sm|md|lg|xl)$/, Yy = /\d+(%|px|r?em|[sdl]?v([hwib]|min|max)|pt|pc|in|cm|mm|cap|ch|ex|r?lh|cq(w|h|i|b|min|max))|\b(calc|min|max|clamp)\(.+\)|^0$/, jy = /^(rgba?|hsla?|hwb|(ok)?(lab|lch))\(.+\)$/, Gy = /^(inset_)?-?((\d+)?\.?(\d+)[a-z]+|0)_-?((\d+)?\.?(\d+)[a-z]+|0)/, qy = /^(url|image|image-set|cross-fade|element|(repeating-)?(linear|radial|conic)-gradient)\(.+\)$/, Rr = (n) => Hy.test(n), ce = (n) => !!n && !Number.isNaN(Number(n)), Bn = (n) => !!n && Number.isInteger(Number(n)), us = (n) => n.endsWith("%") && ce(n.slice(0, -1)), On = (n) => By.test(n), zy = () => !0, Vy = (n) => (
  // `colorFunctionRegex` check is necessary because color functions can have percentages in them which which would be incorrectly classified as lengths.
  // For example, `hsl(0 0% 0%)` would be classified as a length without this check.
  // I could also use lookbehind assertion in `lengthUnitRegex` but that isn't supported widely enough.
  Yy.test(n) && !jy.test(n)
), of = () => !1, Xy = (n) => Gy.test(n), Ky = (n) => qy.test(n), Qy = (n) => !V(n) && !X(n), Jy = (n) => Nr(n, uf, of), V = (n) => nf.test(n), nr = (n) => Nr(n, lf, Vy), ls = (n) => Nr(n, rb, ce), xc = (n) => Nr(n, af, of), Zy = (n) => Nr(n, sf, Ky), vo = (n) => Nr(n, cf, Xy), X = (n) => rf.test(n), mi = (n) => Wr(n, lf), eb = (n) => Wr(n, ib), _c = (n) => Wr(n, af), tb = (n) => Wr(n, uf), nb = (n) => Wr(n, sf), wo = (n) => Wr(n, cf, !0), Nr = (n, i, r) => {
  const a = nf.exec(n);
  return a ? a[1] ? i(a[1]) : r(a[2]) : !1;
}, Wr = (n, i, r = !1) => {
  const a = rf.exec(n);
  return a ? a[1] ? i(a[1]) : r : !1;
}, af = (n) => n === "position" || n === "percentage", sf = (n) => n === "image" || n === "url", uf = (n) => n === "length" || n === "size" || n === "bg-size", lf = (n) => n === "length", rb = (n) => n === "number", ib = (n) => n === "family-name", cf = (n) => n === "shadow", ob = () => {
  const n = ot("color"), i = ot("font"), r = ot("text"), a = ot("font-weight"), s = ot("tracking"), l = ot("leading"), f = ot("breakpoint"), m = ot("container"), g = ot("spacing"), p = ot("radius"), w = ot("shadow"), x = ot("inset-shadow"), T = ot("text-shadow"), E = ot("drop-shadow"), O = ot("blur"), k = ot("perspective"), L = ot("aspect"), I = ot("ease"), $ = ot("animate"), B = () => ["auto", "avoid", "all", "avoid-page", "page", "left", "right", "column"], q = () => [
    "center",
    "top",
    "bottom",
    "left",
    "right",
    "top-left",
    // Deprecated since Tailwind CSS v4.1.0, see https://github.com/tailwindlabs/tailwindcss/pull/17378
    "left-top",
    "top-right",
    // Deprecated since Tailwind CSS v4.1.0, see https://github.com/tailwindlabs/tailwindcss/pull/17378
    "right-top",
    "bottom-right",
    // Deprecated since Tailwind CSS v4.1.0, see https://github.com/tailwindlabs/tailwindcss/pull/17378
    "right-bottom",
    "bottom-left",
    // Deprecated since Tailwind CSS v4.1.0, see https://github.com/tailwindlabs/tailwindcss/pull/17378
    "left-bottom"
  ], Y = () => [...q(), X, V], Q = () => ["auto", "hidden", "clip", "visible", "scroll"], j = () => ["auto", "contain", "none"], U = () => [X, V, g], se = () => [Rr, "full", "auto", ...U()], Ce = () => [Bn, "none", "subgrid", X, V], fe = () => ["auto", {
    span: ["full", Bn, X, V]
  }, Bn, X, V], de = () => [Bn, "auto", X, V], re = () => ["auto", "min", "max", "fr", X, V], Te = () => ["start", "end", "center", "between", "around", "evenly", "stretch", "baseline", "center-safe", "end-safe"], me = () => ["start", "end", "center", "stretch", "center-safe", "end-safe"], be = () => ["auto", ...U()], pe = () => [Rr, "auto", "full", "dvw", "dvh", "lvw", "lvh", "svw", "svh", "min", "max", "fit", ...U()], F = () => [n, X, V], Me = () => [...q(), _c, xc, {
    position: [X, V]
  }], xe = () => ["no-repeat", {
    repeat: ["", "x", "y", "space", "round"]
  }], Ie = () => ["auto", "cover", "contain", tb, Jy, {
    size: [X, V]
  }], yt = () => [us, mi, nr], Oe = () => [
    // Deprecated since Tailwind CSS v4.0.0
    "",
    "none",
    "full",
    p,
    X,
    V
  ], Be = () => ["", ce, mi, nr], Se = () => ["solid", "dashed", "dotted", "double"], et = () => ["normal", "multiply", "screen", "overlay", "darken", "lighten", "color-dodge", "color-burn", "hard-light", "soft-light", "difference", "exclusion", "hue", "saturation", "color", "luminosity"], ve = () => [ce, us, _c, xc], Ye = () => [
    // Deprecated since Tailwind CSS v4.0.0
    "",
    "none",
    O,
    X,
    V
  ], Ke = () => ["none", ce, X, V], ft = () => ["none", ce, X, V], De = () => [ce, X, V], st = () => [Rr, "full", ...U()];
  return {
    cacheSize: 500,
    theme: {
      animate: ["spin", "ping", "pulse", "bounce"],
      aspect: ["video"],
      blur: [On],
      breakpoint: [On],
      color: [zy],
      container: [On],
      "drop-shadow": [On],
      ease: ["in", "out", "in-out"],
      font: [Qy],
      "font-weight": ["thin", "extralight", "light", "normal", "medium", "semibold", "bold", "extrabold", "black"],
      "inset-shadow": [On],
      leading: ["none", "tight", "snug", "normal", "relaxed", "loose"],
      perspective: ["dramatic", "near", "normal", "midrange", "distant", "none"],
      radius: [On],
      shadow: [On],
      spacing: ["px", ce],
      text: [On],
      "text-shadow": [On],
      tracking: ["tighter", "tight", "normal", "wide", "wider", "widest"]
    },
    classGroups: {
      // --------------
      // --- Layout ---
      // --------------
      /**
       * Aspect Ratio
       * @see https://tailwindcss.com/docs/aspect-ratio
       */
      aspect: [{
        aspect: ["auto", "square", Rr, V, X, L]
      }],
      /**
       * Container
       * @see https://tailwindcss.com/docs/container
       * @deprecated since Tailwind CSS v4.0.0
       */
      container: ["container"],
      /**
       * Columns
       * @see https://tailwindcss.com/docs/columns
       */
      columns: [{
        columns: [ce, V, X, m]
      }],
      /**
       * Break After
       * @see https://tailwindcss.com/docs/break-after
       */
      "break-after": [{
        "break-after": B()
      }],
      /**
       * Break Before
       * @see https://tailwindcss.com/docs/break-before
       */
      "break-before": [{
        "break-before": B()
      }],
      /**
       * Break Inside
       * @see https://tailwindcss.com/docs/break-inside
       */
      "break-inside": [{
        "break-inside": ["auto", "avoid", "avoid-page", "avoid-column"]
      }],
      /**
       * Box Decoration Break
       * @see https://tailwindcss.com/docs/box-decoration-break
       */
      "box-decoration": [{
        "box-decoration": ["slice", "clone"]
      }],
      /**
       * Box Sizing
       * @see https://tailwindcss.com/docs/box-sizing
       */
      box: [{
        box: ["border", "content"]
      }],
      /**
       * Display
       * @see https://tailwindcss.com/docs/display
       */
      display: ["block", "inline-block", "inline", "flex", "inline-flex", "table", "inline-table", "table-caption", "table-cell", "table-column", "table-column-group", "table-footer-group", "table-header-group", "table-row-group", "table-row", "flow-root", "grid", "inline-grid", "contents", "list-item", "hidden"],
      /**
       * Screen Reader Only
       * @see https://tailwindcss.com/docs/display#screen-reader-only
       */
      sr: ["sr-only", "not-sr-only"],
      /**
       * Floats
       * @see https://tailwindcss.com/docs/float
       */
      float: [{
        float: ["right", "left", "none", "start", "end"]
      }],
      /**
       * Clear
       * @see https://tailwindcss.com/docs/clear
       */
      clear: [{
        clear: ["left", "right", "both", "none", "start", "end"]
      }],
      /**
       * Isolation
       * @see https://tailwindcss.com/docs/isolation
       */
      isolation: ["isolate", "isolation-auto"],
      /**
       * Object Fit
       * @see https://tailwindcss.com/docs/object-fit
       */
      "object-fit": [{
        object: ["contain", "cover", "fill", "none", "scale-down"]
      }],
      /**
       * Object Position
       * @see https://tailwindcss.com/docs/object-position
       */
      "object-position": [{
        object: Y()
      }],
      /**
       * Overflow
       * @see https://tailwindcss.com/docs/overflow
       */
      overflow: [{
        overflow: Q()
      }],
      /**
       * Overflow X
       * @see https://tailwindcss.com/docs/overflow
       */
      "overflow-x": [{
        "overflow-x": Q()
      }],
      /**
       * Overflow Y
       * @see https://tailwindcss.com/docs/overflow
       */
      "overflow-y": [{
        "overflow-y": Q()
      }],
      /**
       * Overscroll Behavior
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */
      overscroll: [{
        overscroll: j()
      }],
      /**
       * Overscroll Behavior X
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */
      "overscroll-x": [{
        "overscroll-x": j()
      }],
      /**
       * Overscroll Behavior Y
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */
      "overscroll-y": [{
        "overscroll-y": j()
      }],
      /**
       * Position
       * @see https://tailwindcss.com/docs/position
       */
      position: ["static", "fixed", "absolute", "relative", "sticky"],
      /**
       * Top / Right / Bottom / Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      inset: [{
        inset: se()
      }],
      /**
       * Right / Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      "inset-x": [{
        "inset-x": se()
      }],
      /**
       * Top / Bottom
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      "inset-y": [{
        "inset-y": se()
      }],
      /**
       * Start
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      start: [{
        start: se()
      }],
      /**
       * End
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      end: [{
        end: se()
      }],
      /**
       * Top
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      top: [{
        top: se()
      }],
      /**
       * Right
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      right: [{
        right: se()
      }],
      /**
       * Bottom
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      bottom: [{
        bottom: se()
      }],
      /**
       * Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      left: [{
        left: se()
      }],
      /**
       * Visibility
       * @see https://tailwindcss.com/docs/visibility
       */
      visibility: ["visible", "invisible", "collapse"],
      /**
       * Z-Index
       * @see https://tailwindcss.com/docs/z-index
       */
      z: [{
        z: [Bn, "auto", X, V]
      }],
      // ------------------------
      // --- Flexbox and Grid ---
      // ------------------------
      /**
       * Flex Basis
       * @see https://tailwindcss.com/docs/flex-basis
       */
      basis: [{
        basis: [Rr, "full", "auto", m, ...U()]
      }],
      /**
       * Flex Direction
       * @see https://tailwindcss.com/docs/flex-direction
       */
      "flex-direction": [{
        flex: ["row", "row-reverse", "col", "col-reverse"]
      }],
      /**
       * Flex Wrap
       * @see https://tailwindcss.com/docs/flex-wrap
       */
      "flex-wrap": [{
        flex: ["nowrap", "wrap", "wrap-reverse"]
      }],
      /**
       * Flex
       * @see https://tailwindcss.com/docs/flex
       */
      flex: [{
        flex: [ce, Rr, "auto", "initial", "none", V]
      }],
      /**
       * Flex Grow
       * @see https://tailwindcss.com/docs/flex-grow
       */
      grow: [{
        grow: ["", ce, X, V]
      }],
      /**
       * Flex Shrink
       * @see https://tailwindcss.com/docs/flex-shrink
       */
      shrink: [{
        shrink: ["", ce, X, V]
      }],
      /**
       * Order
       * @see https://tailwindcss.com/docs/order
       */
      order: [{
        order: [Bn, "first", "last", "none", X, V]
      }],
      /**
       * Grid Template Columns
       * @see https://tailwindcss.com/docs/grid-template-columns
       */
      "grid-cols": [{
        "grid-cols": Ce()
      }],
      /**
       * Grid Column Start / End
       * @see https://tailwindcss.com/docs/grid-column
       */
      "col-start-end": [{
        col: fe()
      }],
      /**
       * Grid Column Start
       * @see https://tailwindcss.com/docs/grid-column
       */
      "col-start": [{
        "col-start": de()
      }],
      /**
       * Grid Column End
       * @see https://tailwindcss.com/docs/grid-column
       */
      "col-end": [{
        "col-end": de()
      }],
      /**
       * Grid Template Rows
       * @see https://tailwindcss.com/docs/grid-template-rows
       */
      "grid-rows": [{
        "grid-rows": Ce()
      }],
      /**
       * Grid Row Start / End
       * @see https://tailwindcss.com/docs/grid-row
       */
      "row-start-end": [{
        row: fe()
      }],
      /**
       * Grid Row Start
       * @see https://tailwindcss.com/docs/grid-row
       */
      "row-start": [{
        "row-start": de()
      }],
      /**
       * Grid Row End
       * @see https://tailwindcss.com/docs/grid-row
       */
      "row-end": [{
        "row-end": de()
      }],
      /**
       * Grid Auto Flow
       * @see https://tailwindcss.com/docs/grid-auto-flow
       */
      "grid-flow": [{
        "grid-flow": ["row", "col", "dense", "row-dense", "col-dense"]
      }],
      /**
       * Grid Auto Columns
       * @see https://tailwindcss.com/docs/grid-auto-columns
       */
      "auto-cols": [{
        "auto-cols": re()
      }],
      /**
       * Grid Auto Rows
       * @see https://tailwindcss.com/docs/grid-auto-rows
       */
      "auto-rows": [{
        "auto-rows": re()
      }],
      /**
       * Gap
       * @see https://tailwindcss.com/docs/gap
       */
      gap: [{
        gap: U()
      }],
      /**
       * Gap X
       * @see https://tailwindcss.com/docs/gap
       */
      "gap-x": [{
        "gap-x": U()
      }],
      /**
       * Gap Y
       * @see https://tailwindcss.com/docs/gap
       */
      "gap-y": [{
        "gap-y": U()
      }],
      /**
       * Justify Content
       * @see https://tailwindcss.com/docs/justify-content
       */
      "justify-content": [{
        justify: [...Te(), "normal"]
      }],
      /**
       * Justify Items
       * @see https://tailwindcss.com/docs/justify-items
       */
      "justify-items": [{
        "justify-items": [...me(), "normal"]
      }],
      /**
       * Justify Self
       * @see https://tailwindcss.com/docs/justify-self
       */
      "justify-self": [{
        "justify-self": ["auto", ...me()]
      }],
      /**
       * Align Content
       * @see https://tailwindcss.com/docs/align-content
       */
      "align-content": [{
        content: ["normal", ...Te()]
      }],
      /**
       * Align Items
       * @see https://tailwindcss.com/docs/align-items
       */
      "align-items": [{
        items: [...me(), {
          baseline: ["", "last"]
        }]
      }],
      /**
       * Align Self
       * @see https://tailwindcss.com/docs/align-self
       */
      "align-self": [{
        self: ["auto", ...me(), {
          baseline: ["", "last"]
        }]
      }],
      /**
       * Place Content
       * @see https://tailwindcss.com/docs/place-content
       */
      "place-content": [{
        "place-content": Te()
      }],
      /**
       * Place Items
       * @see https://tailwindcss.com/docs/place-items
       */
      "place-items": [{
        "place-items": [...me(), "baseline"]
      }],
      /**
       * Place Self
       * @see https://tailwindcss.com/docs/place-self
       */
      "place-self": [{
        "place-self": ["auto", ...me()]
      }],
      // Spacing
      /**
       * Padding
       * @see https://tailwindcss.com/docs/padding
       */
      p: [{
        p: U()
      }],
      /**
       * Padding X
       * @see https://tailwindcss.com/docs/padding
       */
      px: [{
        px: U()
      }],
      /**
       * Padding Y
       * @see https://tailwindcss.com/docs/padding
       */
      py: [{
        py: U()
      }],
      /**
       * Padding Start
       * @see https://tailwindcss.com/docs/padding
       */
      ps: [{
        ps: U()
      }],
      /**
       * Padding End
       * @see https://tailwindcss.com/docs/padding
       */
      pe: [{
        pe: U()
      }],
      /**
       * Padding Top
       * @see https://tailwindcss.com/docs/padding
       */
      pt: [{
        pt: U()
      }],
      /**
       * Padding Right
       * @see https://tailwindcss.com/docs/padding
       */
      pr: [{
        pr: U()
      }],
      /**
       * Padding Bottom
       * @see https://tailwindcss.com/docs/padding
       */
      pb: [{
        pb: U()
      }],
      /**
       * Padding Left
       * @see https://tailwindcss.com/docs/padding
       */
      pl: [{
        pl: U()
      }],
      /**
       * Margin
       * @see https://tailwindcss.com/docs/margin
       */
      m: [{
        m: be()
      }],
      /**
       * Margin X
       * @see https://tailwindcss.com/docs/margin
       */
      mx: [{
        mx: be()
      }],
      /**
       * Margin Y
       * @see https://tailwindcss.com/docs/margin
       */
      my: [{
        my: be()
      }],
      /**
       * Margin Start
       * @see https://tailwindcss.com/docs/margin
       */
      ms: [{
        ms: be()
      }],
      /**
       * Margin End
       * @see https://tailwindcss.com/docs/margin
       */
      me: [{
        me: be()
      }],
      /**
       * Margin Top
       * @see https://tailwindcss.com/docs/margin
       */
      mt: [{
        mt: be()
      }],
      /**
       * Margin Right
       * @see https://tailwindcss.com/docs/margin
       */
      mr: [{
        mr: be()
      }],
      /**
       * Margin Bottom
       * @see https://tailwindcss.com/docs/margin
       */
      mb: [{
        mb: be()
      }],
      /**
       * Margin Left
       * @see https://tailwindcss.com/docs/margin
       */
      ml: [{
        ml: be()
      }],
      /**
       * Space Between X
       * @see https://tailwindcss.com/docs/margin#adding-space-between-children
       */
      "space-x": [{
        "space-x": U()
      }],
      /**
       * Space Between X Reverse
       * @see https://tailwindcss.com/docs/margin#adding-space-between-children
       */
      "space-x-reverse": ["space-x-reverse"],
      /**
       * Space Between Y
       * @see https://tailwindcss.com/docs/margin#adding-space-between-children
       */
      "space-y": [{
        "space-y": U()
      }],
      /**
       * Space Between Y Reverse
       * @see https://tailwindcss.com/docs/margin#adding-space-between-children
       */
      "space-y-reverse": ["space-y-reverse"],
      // --------------
      // --- Sizing ---
      // --------------
      /**
       * Size
       * @see https://tailwindcss.com/docs/width#setting-both-width-and-height
       */
      size: [{
        size: pe()
      }],
      /**
       * Width
       * @see https://tailwindcss.com/docs/width
       */
      w: [{
        w: [m, "screen", ...pe()]
      }],
      /**
       * Min-Width
       * @see https://tailwindcss.com/docs/min-width
       */
      "min-w": [{
        "min-w": [
          m,
          "screen",
          /** Deprecated. @see https://github.com/tailwindlabs/tailwindcss.com/issues/2027#issuecomment-2620152757 */
          "none",
          ...pe()
        ]
      }],
      /**
       * Max-Width
       * @see https://tailwindcss.com/docs/max-width
       */
      "max-w": [{
        "max-w": [
          m,
          "screen",
          "none",
          /** Deprecated since Tailwind CSS v4.0.0. @see https://github.com/tailwindlabs/tailwindcss.com/issues/2027#issuecomment-2620152757 */
          "prose",
          /** Deprecated since Tailwind CSS v4.0.0. @see https://github.com/tailwindlabs/tailwindcss.com/issues/2027#issuecomment-2620152757 */
          {
            screen: [f]
          },
          ...pe()
        ]
      }],
      /**
       * Height
       * @see https://tailwindcss.com/docs/height
       */
      h: [{
        h: ["screen", "lh", ...pe()]
      }],
      /**
       * Min-Height
       * @see https://tailwindcss.com/docs/min-height
       */
      "min-h": [{
        "min-h": ["screen", "lh", "none", ...pe()]
      }],
      /**
       * Max-Height
       * @see https://tailwindcss.com/docs/max-height
       */
      "max-h": [{
        "max-h": ["screen", "lh", ...pe()]
      }],
      // ------------------
      // --- Typography ---
      // ------------------
      /**
       * Font Size
       * @see https://tailwindcss.com/docs/font-size
       */
      "font-size": [{
        text: ["base", r, mi, nr]
      }],
      /**
       * Font Smoothing
       * @see https://tailwindcss.com/docs/font-smoothing
       */
      "font-smoothing": ["antialiased", "subpixel-antialiased"],
      /**
       * Font Style
       * @see https://tailwindcss.com/docs/font-style
       */
      "font-style": ["italic", "not-italic"],
      /**
       * Font Weight
       * @see https://tailwindcss.com/docs/font-weight
       */
      "font-weight": [{
        font: [a, X, ls]
      }],
      /**
       * Font Stretch
       * @see https://tailwindcss.com/docs/font-stretch
       */
      "font-stretch": [{
        "font-stretch": ["ultra-condensed", "extra-condensed", "condensed", "semi-condensed", "normal", "semi-expanded", "expanded", "extra-expanded", "ultra-expanded", us, V]
      }],
      /**
       * Font Family
       * @see https://tailwindcss.com/docs/font-family
       */
      "font-family": [{
        font: [eb, V, i]
      }],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-normal": ["normal-nums"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-ordinal": ["ordinal"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-slashed-zero": ["slashed-zero"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-figure": ["lining-nums", "oldstyle-nums"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-spacing": ["proportional-nums", "tabular-nums"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-fraction": ["diagonal-fractions", "stacked-fractions"],
      /**
       * Letter Spacing
       * @see https://tailwindcss.com/docs/letter-spacing
       */
      tracking: [{
        tracking: [s, X, V]
      }],
      /**
       * Line Clamp
       * @see https://tailwindcss.com/docs/line-clamp
       */
      "line-clamp": [{
        "line-clamp": [ce, "none", X, ls]
      }],
      /**
       * Line Height
       * @see https://tailwindcss.com/docs/line-height
       */
      leading: [{
        leading: [
          /** Deprecated since Tailwind CSS v4.0.0. @see https://github.com/tailwindlabs/tailwindcss.com/issues/2027#issuecomment-2620152757 */
          l,
          ...U()
        ]
      }],
      /**
       * List Style Image
       * @see https://tailwindcss.com/docs/list-style-image
       */
      "list-image": [{
        "list-image": ["none", X, V]
      }],
      /**
       * List Style Position
       * @see https://tailwindcss.com/docs/list-style-position
       */
      "list-style-position": [{
        list: ["inside", "outside"]
      }],
      /**
       * List Style Type
       * @see https://tailwindcss.com/docs/list-style-type
       */
      "list-style-type": [{
        list: ["disc", "decimal", "none", X, V]
      }],
      /**
       * Text Alignment
       * @see https://tailwindcss.com/docs/text-align
       */
      "text-alignment": [{
        text: ["left", "center", "right", "justify", "start", "end"]
      }],
      /**
       * Placeholder Color
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://v3.tailwindcss.com/docs/placeholder-color
       */
      "placeholder-color": [{
        placeholder: F()
      }],
      /**
       * Text Color
       * @see https://tailwindcss.com/docs/text-color
       */
      "text-color": [{
        text: F()
      }],
      /**
       * Text Decoration
       * @see https://tailwindcss.com/docs/text-decoration
       */
      "text-decoration": ["underline", "overline", "line-through", "no-underline"],
      /**
       * Text Decoration Style
       * @see https://tailwindcss.com/docs/text-decoration-style
       */
      "text-decoration-style": [{
        decoration: [...Se(), "wavy"]
      }],
      /**
       * Text Decoration Thickness
       * @see https://tailwindcss.com/docs/text-decoration-thickness
       */
      "text-decoration-thickness": [{
        decoration: [ce, "from-font", "auto", X, nr]
      }],
      /**
       * Text Decoration Color
       * @see https://tailwindcss.com/docs/text-decoration-color
       */
      "text-decoration-color": [{
        decoration: F()
      }],
      /**
       * Text Underline Offset
       * @see https://tailwindcss.com/docs/text-underline-offset
       */
      "underline-offset": [{
        "underline-offset": [ce, "auto", X, V]
      }],
      /**
       * Text Transform
       * @see https://tailwindcss.com/docs/text-transform
       */
      "text-transform": ["uppercase", "lowercase", "capitalize", "normal-case"],
      /**
       * Text Overflow
       * @see https://tailwindcss.com/docs/text-overflow
       */
      "text-overflow": ["truncate", "text-ellipsis", "text-clip"],
      /**
       * Text Wrap
       * @see https://tailwindcss.com/docs/text-wrap
       */
      "text-wrap": [{
        text: ["wrap", "nowrap", "balance", "pretty"]
      }],
      /**
       * Text Indent
       * @see https://tailwindcss.com/docs/text-indent
       */
      indent: [{
        indent: U()
      }],
      /**
       * Vertical Alignment
       * @see https://tailwindcss.com/docs/vertical-align
       */
      "vertical-align": [{
        align: ["baseline", "top", "middle", "bottom", "text-top", "text-bottom", "sub", "super", X, V]
      }],
      /**
       * Whitespace
       * @see https://tailwindcss.com/docs/whitespace
       */
      whitespace: [{
        whitespace: ["normal", "nowrap", "pre", "pre-line", "pre-wrap", "break-spaces"]
      }],
      /**
       * Word Break
       * @see https://tailwindcss.com/docs/word-break
       */
      break: [{
        break: ["normal", "words", "all", "keep"]
      }],
      /**
       * Overflow Wrap
       * @see https://tailwindcss.com/docs/overflow-wrap
       */
      wrap: [{
        wrap: ["break-word", "anywhere", "normal"]
      }],
      /**
       * Hyphens
       * @see https://tailwindcss.com/docs/hyphens
       */
      hyphens: [{
        hyphens: ["none", "manual", "auto"]
      }],
      /**
       * Content
       * @see https://tailwindcss.com/docs/content
       */
      content: [{
        content: ["none", X, V]
      }],
      // -------------------
      // --- Backgrounds ---
      // -------------------
      /**
       * Background Attachment
       * @see https://tailwindcss.com/docs/background-attachment
       */
      "bg-attachment": [{
        bg: ["fixed", "local", "scroll"]
      }],
      /**
       * Background Clip
       * @see https://tailwindcss.com/docs/background-clip
       */
      "bg-clip": [{
        "bg-clip": ["border", "padding", "content", "text"]
      }],
      /**
       * Background Origin
       * @see https://tailwindcss.com/docs/background-origin
       */
      "bg-origin": [{
        "bg-origin": ["border", "padding", "content"]
      }],
      /**
       * Background Position
       * @see https://tailwindcss.com/docs/background-position
       */
      "bg-position": [{
        bg: Me()
      }],
      /**
       * Background Repeat
       * @see https://tailwindcss.com/docs/background-repeat
       */
      "bg-repeat": [{
        bg: xe()
      }],
      /**
       * Background Size
       * @see https://tailwindcss.com/docs/background-size
       */
      "bg-size": [{
        bg: Ie()
      }],
      /**
       * Background Image
       * @see https://tailwindcss.com/docs/background-image
       */
      "bg-image": [{
        bg: ["none", {
          linear: [{
            to: ["t", "tr", "r", "br", "b", "bl", "l", "tl"]
          }, Bn, X, V],
          radial: ["", X, V],
          conic: [Bn, X, V]
        }, nb, Zy]
      }],
      /**
       * Background Color
       * @see https://tailwindcss.com/docs/background-color
       */
      "bg-color": [{
        bg: F()
      }],
      /**
       * Gradient Color Stops From Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-from-pos": [{
        from: yt()
      }],
      /**
       * Gradient Color Stops Via Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-via-pos": [{
        via: yt()
      }],
      /**
       * Gradient Color Stops To Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-to-pos": [{
        to: yt()
      }],
      /**
       * Gradient Color Stops From
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-from": [{
        from: F()
      }],
      /**
       * Gradient Color Stops Via
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-via": [{
        via: F()
      }],
      /**
       * Gradient Color Stops To
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-to": [{
        to: F()
      }],
      // ---------------
      // --- Borders ---
      // ---------------
      /**
       * Border Radius
       * @see https://tailwindcss.com/docs/border-radius
       */
      rounded: [{
        rounded: Oe()
      }],
      /**
       * Border Radius Start
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-s": [{
        "rounded-s": Oe()
      }],
      /**
       * Border Radius End
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-e": [{
        "rounded-e": Oe()
      }],
      /**
       * Border Radius Top
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-t": [{
        "rounded-t": Oe()
      }],
      /**
       * Border Radius Right
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-r": [{
        "rounded-r": Oe()
      }],
      /**
       * Border Radius Bottom
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-b": [{
        "rounded-b": Oe()
      }],
      /**
       * Border Radius Left
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-l": [{
        "rounded-l": Oe()
      }],
      /**
       * Border Radius Start Start
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-ss": [{
        "rounded-ss": Oe()
      }],
      /**
       * Border Radius Start End
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-se": [{
        "rounded-se": Oe()
      }],
      /**
       * Border Radius End End
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-ee": [{
        "rounded-ee": Oe()
      }],
      /**
       * Border Radius End Start
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-es": [{
        "rounded-es": Oe()
      }],
      /**
       * Border Radius Top Left
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-tl": [{
        "rounded-tl": Oe()
      }],
      /**
       * Border Radius Top Right
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-tr": [{
        "rounded-tr": Oe()
      }],
      /**
       * Border Radius Bottom Right
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-br": [{
        "rounded-br": Oe()
      }],
      /**
       * Border Radius Bottom Left
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-bl": [{
        "rounded-bl": Oe()
      }],
      /**
       * Border Width
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w": [{
        border: Be()
      }],
      /**
       * Border Width X
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-x": [{
        "border-x": Be()
      }],
      /**
       * Border Width Y
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-y": [{
        "border-y": Be()
      }],
      /**
       * Border Width Start
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-s": [{
        "border-s": Be()
      }],
      /**
       * Border Width End
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-e": [{
        "border-e": Be()
      }],
      /**
       * Border Width Top
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-t": [{
        "border-t": Be()
      }],
      /**
       * Border Width Right
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-r": [{
        "border-r": Be()
      }],
      /**
       * Border Width Bottom
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-b": [{
        "border-b": Be()
      }],
      /**
       * Border Width Left
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-l": [{
        "border-l": Be()
      }],
      /**
       * Divide Width X
       * @see https://tailwindcss.com/docs/border-width#between-children
       */
      "divide-x": [{
        "divide-x": Be()
      }],
      /**
       * Divide Width X Reverse
       * @see https://tailwindcss.com/docs/border-width#between-children
       */
      "divide-x-reverse": ["divide-x-reverse"],
      /**
       * Divide Width Y
       * @see https://tailwindcss.com/docs/border-width#between-children
       */
      "divide-y": [{
        "divide-y": Be()
      }],
      /**
       * Divide Width Y Reverse
       * @see https://tailwindcss.com/docs/border-width#between-children
       */
      "divide-y-reverse": ["divide-y-reverse"],
      /**
       * Border Style
       * @see https://tailwindcss.com/docs/border-style
       */
      "border-style": [{
        border: [...Se(), "hidden", "none"]
      }],
      /**
       * Divide Style
       * @see https://tailwindcss.com/docs/border-style#setting-the-divider-style
       */
      "divide-style": [{
        divide: [...Se(), "hidden", "none"]
      }],
      /**
       * Border Color
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color": [{
        border: F()
      }],
      /**
       * Border Color X
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-x": [{
        "border-x": F()
      }],
      /**
       * Border Color Y
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-y": [{
        "border-y": F()
      }],
      /**
       * Border Color S
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-s": [{
        "border-s": F()
      }],
      /**
       * Border Color E
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-e": [{
        "border-e": F()
      }],
      /**
       * Border Color Top
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-t": [{
        "border-t": F()
      }],
      /**
       * Border Color Right
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-r": [{
        "border-r": F()
      }],
      /**
       * Border Color Bottom
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-b": [{
        "border-b": F()
      }],
      /**
       * Border Color Left
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-l": [{
        "border-l": F()
      }],
      /**
       * Divide Color
       * @see https://tailwindcss.com/docs/divide-color
       */
      "divide-color": [{
        divide: F()
      }],
      /**
       * Outline Style
       * @see https://tailwindcss.com/docs/outline-style
       */
      "outline-style": [{
        outline: [...Se(), "none", "hidden"]
      }],
      /**
       * Outline Offset
       * @see https://tailwindcss.com/docs/outline-offset
       */
      "outline-offset": [{
        "outline-offset": [ce, X, V]
      }],
      /**
       * Outline Width
       * @see https://tailwindcss.com/docs/outline-width
       */
      "outline-w": [{
        outline: ["", ce, mi, nr]
      }],
      /**
       * Outline Color
       * @see https://tailwindcss.com/docs/outline-color
       */
      "outline-color": [{
        outline: F()
      }],
      // ---------------
      // --- Effects ---
      // ---------------
      /**
       * Box Shadow
       * @see https://tailwindcss.com/docs/box-shadow
       */
      shadow: [{
        shadow: [
          // Deprecated since Tailwind CSS v4.0.0
          "",
          "none",
          w,
          wo,
          vo
        ]
      }],
      /**
       * Box Shadow Color
       * @see https://tailwindcss.com/docs/box-shadow#setting-the-shadow-color
       */
      "shadow-color": [{
        shadow: F()
      }],
      /**
       * Inset Box Shadow
       * @see https://tailwindcss.com/docs/box-shadow#adding-an-inset-shadow
       */
      "inset-shadow": [{
        "inset-shadow": ["none", x, wo, vo]
      }],
      /**
       * Inset Box Shadow Color
       * @see https://tailwindcss.com/docs/box-shadow#setting-the-inset-shadow-color
       */
      "inset-shadow-color": [{
        "inset-shadow": F()
      }],
      /**
       * Ring Width
       * @see https://tailwindcss.com/docs/box-shadow#adding-a-ring
       */
      "ring-w": [{
        ring: Be()
      }],
      /**
       * Ring Width Inset
       * @see https://v3.tailwindcss.com/docs/ring-width#inset-rings
       * @deprecated since Tailwind CSS v4.0.0
       * @see https://github.com/tailwindlabs/tailwindcss/blob/v4.0.0/packages/tailwindcss/src/utilities.ts#L4158
       */
      "ring-w-inset": ["ring-inset"],
      /**
       * Ring Color
       * @see https://tailwindcss.com/docs/box-shadow#setting-the-ring-color
       */
      "ring-color": [{
        ring: F()
      }],
      /**
       * Ring Offset Width
       * @see https://v3.tailwindcss.com/docs/ring-offset-width
       * @deprecated since Tailwind CSS v4.0.0
       * @see https://github.com/tailwindlabs/tailwindcss/blob/v4.0.0/packages/tailwindcss/src/utilities.ts#L4158
       */
      "ring-offset-w": [{
        "ring-offset": [ce, nr]
      }],
      /**
       * Ring Offset Color
       * @see https://v3.tailwindcss.com/docs/ring-offset-color
       * @deprecated since Tailwind CSS v4.0.0
       * @see https://github.com/tailwindlabs/tailwindcss/blob/v4.0.0/packages/tailwindcss/src/utilities.ts#L4158
       */
      "ring-offset-color": [{
        "ring-offset": F()
      }],
      /**
       * Inset Ring Width
       * @see https://tailwindcss.com/docs/box-shadow#adding-an-inset-ring
       */
      "inset-ring-w": [{
        "inset-ring": Be()
      }],
      /**
       * Inset Ring Color
       * @see https://tailwindcss.com/docs/box-shadow#setting-the-inset-ring-color
       */
      "inset-ring-color": [{
        "inset-ring": F()
      }],
      /**
       * Text Shadow
       * @see https://tailwindcss.com/docs/text-shadow
       */
      "text-shadow": [{
        "text-shadow": ["none", T, wo, vo]
      }],
      /**
       * Text Shadow Color
       * @see https://tailwindcss.com/docs/text-shadow#setting-the-shadow-color
       */
      "text-shadow-color": [{
        "text-shadow": F()
      }],
      /**
       * Opacity
       * @see https://tailwindcss.com/docs/opacity
       */
      opacity: [{
        opacity: [ce, X, V]
      }],
      /**
       * Mix Blend Mode
       * @see https://tailwindcss.com/docs/mix-blend-mode
       */
      "mix-blend": [{
        "mix-blend": [...et(), "plus-darker", "plus-lighter"]
      }],
      /**
       * Background Blend Mode
       * @see https://tailwindcss.com/docs/background-blend-mode
       */
      "bg-blend": [{
        "bg-blend": et()
      }],
      /**
       * Mask Clip
       * @see https://tailwindcss.com/docs/mask-clip
       */
      "mask-clip": [{
        "mask-clip": ["border", "padding", "content", "fill", "stroke", "view"]
      }, "mask-no-clip"],
      /**
       * Mask Composite
       * @see https://tailwindcss.com/docs/mask-composite
       */
      "mask-composite": [{
        mask: ["add", "subtract", "intersect", "exclude"]
      }],
      /**
       * Mask Image
       * @see https://tailwindcss.com/docs/mask-image
       */
      "mask-image-linear-pos": [{
        "mask-linear": [ce]
      }],
      "mask-image-linear-from-pos": [{
        "mask-linear-from": ve()
      }],
      "mask-image-linear-to-pos": [{
        "mask-linear-to": ve()
      }],
      "mask-image-linear-from-color": [{
        "mask-linear-from": F()
      }],
      "mask-image-linear-to-color": [{
        "mask-linear-to": F()
      }],
      "mask-image-t-from-pos": [{
        "mask-t-from": ve()
      }],
      "mask-image-t-to-pos": [{
        "mask-t-to": ve()
      }],
      "mask-image-t-from-color": [{
        "mask-t-from": F()
      }],
      "mask-image-t-to-color": [{
        "mask-t-to": F()
      }],
      "mask-image-r-from-pos": [{
        "mask-r-from": ve()
      }],
      "mask-image-r-to-pos": [{
        "mask-r-to": ve()
      }],
      "mask-image-r-from-color": [{
        "mask-r-from": F()
      }],
      "mask-image-r-to-color": [{
        "mask-r-to": F()
      }],
      "mask-image-b-from-pos": [{
        "mask-b-from": ve()
      }],
      "mask-image-b-to-pos": [{
        "mask-b-to": ve()
      }],
      "mask-image-b-from-color": [{
        "mask-b-from": F()
      }],
      "mask-image-b-to-color": [{
        "mask-b-to": F()
      }],
      "mask-image-l-from-pos": [{
        "mask-l-from": ve()
      }],
      "mask-image-l-to-pos": [{
        "mask-l-to": ve()
      }],
      "mask-image-l-from-color": [{
        "mask-l-from": F()
      }],
      "mask-image-l-to-color": [{
        "mask-l-to": F()
      }],
      "mask-image-x-from-pos": [{
        "mask-x-from": ve()
      }],
      "mask-image-x-to-pos": [{
        "mask-x-to": ve()
      }],
      "mask-image-x-from-color": [{
        "mask-x-from": F()
      }],
      "mask-image-x-to-color": [{
        "mask-x-to": F()
      }],
      "mask-image-y-from-pos": [{
        "mask-y-from": ve()
      }],
      "mask-image-y-to-pos": [{
        "mask-y-to": ve()
      }],
      "mask-image-y-from-color": [{
        "mask-y-from": F()
      }],
      "mask-image-y-to-color": [{
        "mask-y-to": F()
      }],
      "mask-image-radial": [{
        "mask-radial": [X, V]
      }],
      "mask-image-radial-from-pos": [{
        "mask-radial-from": ve()
      }],
      "mask-image-radial-to-pos": [{
        "mask-radial-to": ve()
      }],
      "mask-image-radial-from-color": [{
        "mask-radial-from": F()
      }],
      "mask-image-radial-to-color": [{
        "mask-radial-to": F()
      }],
      "mask-image-radial-shape": [{
        "mask-radial": ["circle", "ellipse"]
      }],
      "mask-image-radial-size": [{
        "mask-radial": [{
          closest: ["side", "corner"],
          farthest: ["side", "corner"]
        }]
      }],
      "mask-image-radial-pos": [{
        "mask-radial-at": q()
      }],
      "mask-image-conic-pos": [{
        "mask-conic": [ce]
      }],
      "mask-image-conic-from-pos": [{
        "mask-conic-from": ve()
      }],
      "mask-image-conic-to-pos": [{
        "mask-conic-to": ve()
      }],
      "mask-image-conic-from-color": [{
        "mask-conic-from": F()
      }],
      "mask-image-conic-to-color": [{
        "mask-conic-to": F()
      }],
      /**
       * Mask Mode
       * @see https://tailwindcss.com/docs/mask-mode
       */
      "mask-mode": [{
        mask: ["alpha", "luminance", "match"]
      }],
      /**
       * Mask Origin
       * @see https://tailwindcss.com/docs/mask-origin
       */
      "mask-origin": [{
        "mask-origin": ["border", "padding", "content", "fill", "stroke", "view"]
      }],
      /**
       * Mask Position
       * @see https://tailwindcss.com/docs/mask-position
       */
      "mask-position": [{
        mask: Me()
      }],
      /**
       * Mask Repeat
       * @see https://tailwindcss.com/docs/mask-repeat
       */
      "mask-repeat": [{
        mask: xe()
      }],
      /**
       * Mask Size
       * @see https://tailwindcss.com/docs/mask-size
       */
      "mask-size": [{
        mask: Ie()
      }],
      /**
       * Mask Type
       * @see https://tailwindcss.com/docs/mask-type
       */
      "mask-type": [{
        "mask-type": ["alpha", "luminance"]
      }],
      /**
       * Mask Image
       * @see https://tailwindcss.com/docs/mask-image
       */
      "mask-image": [{
        mask: ["none", X, V]
      }],
      // ---------------
      // --- Filters ---
      // ---------------
      /**
       * Filter
       * @see https://tailwindcss.com/docs/filter
       */
      filter: [{
        filter: [
          // Deprecated since Tailwind CSS v3.0.0
          "",
          "none",
          X,
          V
        ]
      }],
      /**
       * Blur
       * @see https://tailwindcss.com/docs/blur
       */
      blur: [{
        blur: Ye()
      }],
      /**
       * Brightness
       * @see https://tailwindcss.com/docs/brightness
       */
      brightness: [{
        brightness: [ce, X, V]
      }],
      /**
       * Contrast
       * @see https://tailwindcss.com/docs/contrast
       */
      contrast: [{
        contrast: [ce, X, V]
      }],
      /**
       * Drop Shadow
       * @see https://tailwindcss.com/docs/drop-shadow
       */
      "drop-shadow": [{
        "drop-shadow": [
          // Deprecated since Tailwind CSS v4.0.0
          "",
          "none",
          E,
          wo,
          vo
        ]
      }],
      /**
       * Drop Shadow Color
       * @see https://tailwindcss.com/docs/filter-drop-shadow#setting-the-shadow-color
       */
      "drop-shadow-color": [{
        "drop-shadow": F()
      }],
      /**
       * Grayscale
       * @see https://tailwindcss.com/docs/grayscale
       */
      grayscale: [{
        grayscale: ["", ce, X, V]
      }],
      /**
       * Hue Rotate
       * @see https://tailwindcss.com/docs/hue-rotate
       */
      "hue-rotate": [{
        "hue-rotate": [ce, X, V]
      }],
      /**
       * Invert
       * @see https://tailwindcss.com/docs/invert
       */
      invert: [{
        invert: ["", ce, X, V]
      }],
      /**
       * Saturate
       * @see https://tailwindcss.com/docs/saturate
       */
      saturate: [{
        saturate: [ce, X, V]
      }],
      /**
       * Sepia
       * @see https://tailwindcss.com/docs/sepia
       */
      sepia: [{
        sepia: ["", ce, X, V]
      }],
      /**
       * Backdrop Filter
       * @see https://tailwindcss.com/docs/backdrop-filter
       */
      "backdrop-filter": [{
        "backdrop-filter": [
          // Deprecated since Tailwind CSS v3.0.0
          "",
          "none",
          X,
          V
        ]
      }],
      /**
       * Backdrop Blur
       * @see https://tailwindcss.com/docs/backdrop-blur
       */
      "backdrop-blur": [{
        "backdrop-blur": Ye()
      }],
      /**
       * Backdrop Brightness
       * @see https://tailwindcss.com/docs/backdrop-brightness
       */
      "backdrop-brightness": [{
        "backdrop-brightness": [ce, X, V]
      }],
      /**
       * Backdrop Contrast
       * @see https://tailwindcss.com/docs/backdrop-contrast
       */
      "backdrop-contrast": [{
        "backdrop-contrast": [ce, X, V]
      }],
      /**
       * Backdrop Grayscale
       * @see https://tailwindcss.com/docs/backdrop-grayscale
       */
      "backdrop-grayscale": [{
        "backdrop-grayscale": ["", ce, X, V]
      }],
      /**
       * Backdrop Hue Rotate
       * @see https://tailwindcss.com/docs/backdrop-hue-rotate
       */
      "backdrop-hue-rotate": [{
        "backdrop-hue-rotate": [ce, X, V]
      }],
      /**
       * Backdrop Invert
       * @see https://tailwindcss.com/docs/backdrop-invert
       */
      "backdrop-invert": [{
        "backdrop-invert": ["", ce, X, V]
      }],
      /**
       * Backdrop Opacity
       * @see https://tailwindcss.com/docs/backdrop-opacity
       */
      "backdrop-opacity": [{
        "backdrop-opacity": [ce, X, V]
      }],
      /**
       * Backdrop Saturate
       * @see https://tailwindcss.com/docs/backdrop-saturate
       */
      "backdrop-saturate": [{
        "backdrop-saturate": [ce, X, V]
      }],
      /**
       * Backdrop Sepia
       * @see https://tailwindcss.com/docs/backdrop-sepia
       */
      "backdrop-sepia": [{
        "backdrop-sepia": ["", ce, X, V]
      }],
      // --------------
      // --- Tables ---
      // --------------
      /**
       * Border Collapse
       * @see https://tailwindcss.com/docs/border-collapse
       */
      "border-collapse": [{
        border: ["collapse", "separate"]
      }],
      /**
       * Border Spacing
       * @see https://tailwindcss.com/docs/border-spacing
       */
      "border-spacing": [{
        "border-spacing": U()
      }],
      /**
       * Border Spacing X
       * @see https://tailwindcss.com/docs/border-spacing
       */
      "border-spacing-x": [{
        "border-spacing-x": U()
      }],
      /**
       * Border Spacing Y
       * @see https://tailwindcss.com/docs/border-spacing
       */
      "border-spacing-y": [{
        "border-spacing-y": U()
      }],
      /**
       * Table Layout
       * @see https://tailwindcss.com/docs/table-layout
       */
      "table-layout": [{
        table: ["auto", "fixed"]
      }],
      /**
       * Caption Side
       * @see https://tailwindcss.com/docs/caption-side
       */
      caption: [{
        caption: ["top", "bottom"]
      }],
      // ---------------------------------
      // --- Transitions and Animation ---
      // ---------------------------------
      /**
       * Transition Property
       * @see https://tailwindcss.com/docs/transition-property
       */
      transition: [{
        transition: ["", "all", "colors", "opacity", "shadow", "transform", "none", X, V]
      }],
      /**
       * Transition Behavior
       * @see https://tailwindcss.com/docs/transition-behavior
       */
      "transition-behavior": [{
        transition: ["normal", "discrete"]
      }],
      /**
       * Transition Duration
       * @see https://tailwindcss.com/docs/transition-duration
       */
      duration: [{
        duration: [ce, "initial", X, V]
      }],
      /**
       * Transition Timing Function
       * @see https://tailwindcss.com/docs/transition-timing-function
       */
      ease: [{
        ease: ["linear", "initial", I, X, V]
      }],
      /**
       * Transition Delay
       * @see https://tailwindcss.com/docs/transition-delay
       */
      delay: [{
        delay: [ce, X, V]
      }],
      /**
       * Animation
       * @see https://tailwindcss.com/docs/animation
       */
      animate: [{
        animate: ["none", $, X, V]
      }],
      // ------------------
      // --- Transforms ---
      // ------------------
      /**
       * Backface Visibility
       * @see https://tailwindcss.com/docs/backface-visibility
       */
      backface: [{
        backface: ["hidden", "visible"]
      }],
      /**
       * Perspective
       * @see https://tailwindcss.com/docs/perspective
       */
      perspective: [{
        perspective: [k, X, V]
      }],
      /**
       * Perspective Origin
       * @see https://tailwindcss.com/docs/perspective-origin
       */
      "perspective-origin": [{
        "perspective-origin": Y()
      }],
      /**
       * Rotate
       * @see https://tailwindcss.com/docs/rotate
       */
      rotate: [{
        rotate: Ke()
      }],
      /**
       * Rotate X
       * @see https://tailwindcss.com/docs/rotate
       */
      "rotate-x": [{
        "rotate-x": Ke()
      }],
      /**
       * Rotate Y
       * @see https://tailwindcss.com/docs/rotate
       */
      "rotate-y": [{
        "rotate-y": Ke()
      }],
      /**
       * Rotate Z
       * @see https://tailwindcss.com/docs/rotate
       */
      "rotate-z": [{
        "rotate-z": Ke()
      }],
      /**
       * Scale
       * @see https://tailwindcss.com/docs/scale
       */
      scale: [{
        scale: ft()
      }],
      /**
       * Scale X
       * @see https://tailwindcss.com/docs/scale
       */
      "scale-x": [{
        "scale-x": ft()
      }],
      /**
       * Scale Y
       * @see https://tailwindcss.com/docs/scale
       */
      "scale-y": [{
        "scale-y": ft()
      }],
      /**
       * Scale Z
       * @see https://tailwindcss.com/docs/scale
       */
      "scale-z": [{
        "scale-z": ft()
      }],
      /**
       * Scale 3D
       * @see https://tailwindcss.com/docs/scale
       */
      "scale-3d": ["scale-3d"],
      /**
       * Skew
       * @see https://tailwindcss.com/docs/skew
       */
      skew: [{
        skew: De()
      }],
      /**
       * Skew X
       * @see https://tailwindcss.com/docs/skew
       */
      "skew-x": [{
        "skew-x": De()
      }],
      /**
       * Skew Y
       * @see https://tailwindcss.com/docs/skew
       */
      "skew-y": [{
        "skew-y": De()
      }],
      /**
       * Transform
       * @see https://tailwindcss.com/docs/transform
       */
      transform: [{
        transform: [X, V, "", "none", "gpu", "cpu"]
      }],
      /**
       * Transform Origin
       * @see https://tailwindcss.com/docs/transform-origin
       */
      "transform-origin": [{
        origin: Y()
      }],
      /**
       * Transform Style
       * @see https://tailwindcss.com/docs/transform-style
       */
      "transform-style": [{
        transform: ["3d", "flat"]
      }],
      /**
       * Translate
       * @see https://tailwindcss.com/docs/translate
       */
      translate: [{
        translate: st()
      }],
      /**
       * Translate X
       * @see https://tailwindcss.com/docs/translate
       */
      "translate-x": [{
        "translate-x": st()
      }],
      /**
       * Translate Y
       * @see https://tailwindcss.com/docs/translate
       */
      "translate-y": [{
        "translate-y": st()
      }],
      /**
       * Translate Z
       * @see https://tailwindcss.com/docs/translate
       */
      "translate-z": [{
        "translate-z": st()
      }],
      /**
       * Translate None
       * @see https://tailwindcss.com/docs/translate
       */
      "translate-none": ["translate-none"],
      // ---------------------
      // --- Interactivity ---
      // ---------------------
      /**
       * Accent Color
       * @see https://tailwindcss.com/docs/accent-color
       */
      accent: [{
        accent: F()
      }],
      /**
       * Appearance
       * @see https://tailwindcss.com/docs/appearance
       */
      appearance: [{
        appearance: ["none", "auto"]
      }],
      /**
       * Caret Color
       * @see https://tailwindcss.com/docs/just-in-time-mode#caret-color-utilities
       */
      "caret-color": [{
        caret: F()
      }],
      /**
       * Color Scheme
       * @see https://tailwindcss.com/docs/color-scheme
       */
      "color-scheme": [{
        scheme: ["normal", "dark", "light", "light-dark", "only-dark", "only-light"]
      }],
      /**
       * Cursor
       * @see https://tailwindcss.com/docs/cursor
       */
      cursor: [{
        cursor: ["auto", "default", "pointer", "wait", "text", "move", "help", "not-allowed", "none", "context-menu", "progress", "cell", "crosshair", "vertical-text", "alias", "copy", "no-drop", "grab", "grabbing", "all-scroll", "col-resize", "row-resize", "n-resize", "e-resize", "s-resize", "w-resize", "ne-resize", "nw-resize", "se-resize", "sw-resize", "ew-resize", "ns-resize", "nesw-resize", "nwse-resize", "zoom-in", "zoom-out", X, V]
      }],
      /**
       * Field Sizing
       * @see https://tailwindcss.com/docs/field-sizing
       */
      "field-sizing": [{
        "field-sizing": ["fixed", "content"]
      }],
      /**
       * Pointer Events
       * @see https://tailwindcss.com/docs/pointer-events
       */
      "pointer-events": [{
        "pointer-events": ["auto", "none"]
      }],
      /**
       * Resize
       * @see https://tailwindcss.com/docs/resize
       */
      resize: [{
        resize: ["none", "", "y", "x"]
      }],
      /**
       * Scroll Behavior
       * @see https://tailwindcss.com/docs/scroll-behavior
       */
      "scroll-behavior": [{
        scroll: ["auto", "smooth"]
      }],
      /**
       * Scroll Margin
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-m": [{
        "scroll-m": U()
      }],
      /**
       * Scroll Margin X
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mx": [{
        "scroll-mx": U()
      }],
      /**
       * Scroll Margin Y
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-my": [{
        "scroll-my": U()
      }],
      /**
       * Scroll Margin Start
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-ms": [{
        "scroll-ms": U()
      }],
      /**
       * Scroll Margin End
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-me": [{
        "scroll-me": U()
      }],
      /**
       * Scroll Margin Top
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mt": [{
        "scroll-mt": U()
      }],
      /**
       * Scroll Margin Right
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mr": [{
        "scroll-mr": U()
      }],
      /**
       * Scroll Margin Bottom
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mb": [{
        "scroll-mb": U()
      }],
      /**
       * Scroll Margin Left
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-ml": [{
        "scroll-ml": U()
      }],
      /**
       * Scroll Padding
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-p": [{
        "scroll-p": U()
      }],
      /**
       * Scroll Padding X
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-px": [{
        "scroll-px": U()
      }],
      /**
       * Scroll Padding Y
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-py": [{
        "scroll-py": U()
      }],
      /**
       * Scroll Padding Start
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-ps": [{
        "scroll-ps": U()
      }],
      /**
       * Scroll Padding End
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pe": [{
        "scroll-pe": U()
      }],
      /**
       * Scroll Padding Top
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pt": [{
        "scroll-pt": U()
      }],
      /**
       * Scroll Padding Right
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pr": [{
        "scroll-pr": U()
      }],
      /**
       * Scroll Padding Bottom
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pb": [{
        "scroll-pb": U()
      }],
      /**
       * Scroll Padding Left
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pl": [{
        "scroll-pl": U()
      }],
      /**
       * Scroll Snap Align
       * @see https://tailwindcss.com/docs/scroll-snap-align
       */
      "snap-align": [{
        snap: ["start", "end", "center", "align-none"]
      }],
      /**
       * Scroll Snap Stop
       * @see https://tailwindcss.com/docs/scroll-snap-stop
       */
      "snap-stop": [{
        snap: ["normal", "always"]
      }],
      /**
       * Scroll Snap Type
       * @see https://tailwindcss.com/docs/scroll-snap-type
       */
      "snap-type": [{
        snap: ["none", "x", "y", "both"]
      }],
      /**
       * Scroll Snap Type Strictness
       * @see https://tailwindcss.com/docs/scroll-snap-type
       */
      "snap-strictness": [{
        snap: ["mandatory", "proximity"]
      }],
      /**
       * Touch Action
       * @see https://tailwindcss.com/docs/touch-action
       */
      touch: [{
        touch: ["auto", "none", "manipulation"]
      }],
      /**
       * Touch Action X
       * @see https://tailwindcss.com/docs/touch-action
       */
      "touch-x": [{
        "touch-pan": ["x", "left", "right"]
      }],
      /**
       * Touch Action Y
       * @see https://tailwindcss.com/docs/touch-action
       */
      "touch-y": [{
        "touch-pan": ["y", "up", "down"]
      }],
      /**
       * Touch Action Pinch Zoom
       * @see https://tailwindcss.com/docs/touch-action
       */
      "touch-pz": ["touch-pinch-zoom"],
      /**
       * User Select
       * @see https://tailwindcss.com/docs/user-select
       */
      select: [{
        select: ["none", "text", "all", "auto"]
      }],
      /**
       * Will Change
       * @see https://tailwindcss.com/docs/will-change
       */
      "will-change": [{
        "will-change": ["auto", "scroll", "contents", "transform", X, V]
      }],
      // -----------
      // --- SVG ---
      // -----------
      /**
       * Fill
       * @see https://tailwindcss.com/docs/fill
       */
      fill: [{
        fill: ["none", ...F()]
      }],
      /**
       * Stroke Width
       * @see https://tailwindcss.com/docs/stroke-width
       */
      "stroke-w": [{
        stroke: [ce, mi, nr, ls]
      }],
      /**
       * Stroke
       * @see https://tailwindcss.com/docs/stroke
       */
      stroke: [{
        stroke: ["none", ...F()]
      }],
      // ---------------------
      // --- Accessibility ---
      // ---------------------
      /**
       * Forced Color Adjust
       * @see https://tailwindcss.com/docs/forced-color-adjust
       */
      "forced-color-adjust": [{
        "forced-color-adjust": ["auto", "none"]
      }]
    },
    conflictingClassGroups: {
      overflow: ["overflow-x", "overflow-y"],
      overscroll: ["overscroll-x", "overscroll-y"],
      inset: ["inset-x", "inset-y", "start", "end", "top", "right", "bottom", "left"],
      "inset-x": ["right", "left"],
      "inset-y": ["top", "bottom"],
      flex: ["basis", "grow", "shrink"],
      gap: ["gap-x", "gap-y"],
      p: ["px", "py", "ps", "pe", "pt", "pr", "pb", "pl"],
      px: ["pr", "pl"],
      py: ["pt", "pb"],
      m: ["mx", "my", "ms", "me", "mt", "mr", "mb", "ml"],
      mx: ["mr", "ml"],
      my: ["mt", "mb"],
      size: ["w", "h"],
      "font-size": ["leading"],
      "fvn-normal": ["fvn-ordinal", "fvn-slashed-zero", "fvn-figure", "fvn-spacing", "fvn-fraction"],
      "fvn-ordinal": ["fvn-normal"],
      "fvn-slashed-zero": ["fvn-normal"],
      "fvn-figure": ["fvn-normal"],
      "fvn-spacing": ["fvn-normal"],
      "fvn-fraction": ["fvn-normal"],
      "line-clamp": ["display", "overflow"],
      rounded: ["rounded-s", "rounded-e", "rounded-t", "rounded-r", "rounded-b", "rounded-l", "rounded-ss", "rounded-se", "rounded-ee", "rounded-es", "rounded-tl", "rounded-tr", "rounded-br", "rounded-bl"],
      "rounded-s": ["rounded-ss", "rounded-es"],
      "rounded-e": ["rounded-se", "rounded-ee"],
      "rounded-t": ["rounded-tl", "rounded-tr"],
      "rounded-r": ["rounded-tr", "rounded-br"],
      "rounded-b": ["rounded-br", "rounded-bl"],
      "rounded-l": ["rounded-tl", "rounded-bl"],
      "border-spacing": ["border-spacing-x", "border-spacing-y"],
      "border-w": ["border-w-x", "border-w-y", "border-w-s", "border-w-e", "border-w-t", "border-w-r", "border-w-b", "border-w-l"],
      "border-w-x": ["border-w-r", "border-w-l"],
      "border-w-y": ["border-w-t", "border-w-b"],
      "border-color": ["border-color-x", "border-color-y", "border-color-s", "border-color-e", "border-color-t", "border-color-r", "border-color-b", "border-color-l"],
      "border-color-x": ["border-color-r", "border-color-l"],
      "border-color-y": ["border-color-t", "border-color-b"],
      translate: ["translate-x", "translate-y", "translate-none"],
      "translate-none": ["translate", "translate-x", "translate-y", "translate-z"],
      "scroll-m": ["scroll-mx", "scroll-my", "scroll-ms", "scroll-me", "scroll-mt", "scroll-mr", "scroll-mb", "scroll-ml"],
      "scroll-mx": ["scroll-mr", "scroll-ml"],
      "scroll-my": ["scroll-mt", "scroll-mb"],
      "scroll-p": ["scroll-px", "scroll-py", "scroll-ps", "scroll-pe", "scroll-pt", "scroll-pr", "scroll-pb", "scroll-pl"],
      "scroll-px": ["scroll-pr", "scroll-pl"],
      "scroll-py": ["scroll-pt", "scroll-pb"],
      touch: ["touch-x", "touch-y", "touch-pz"],
      "touch-x": ["touch"],
      "touch-y": ["touch"],
      "touch-pz": ["touch"]
    },
    conflictingClassGroupModifiers: {
      "font-size": ["leading"]
    },
    orderSensitiveModifiers: ["*", "**", "after", "backdrop", "before", "details-content", "file", "first-letter", "first-line", "marker", "placeholder", "selection"]
  };
}, ab = /* @__PURE__ */ Uy(ob);
function qn(...n) {
  return ab(Zc(n));
}
const ws = S.forwardRef(({ className: n, ...i }, r) => /* @__PURE__ */ R.jsx(
  "div",
  {
    ref: r,
    className: qn(
      "rounded-lg border bg-card text-card-foreground shadow-sm",
      n
    ),
    ...i
  }
));
ws.displayName = "Card";
const sb = S.forwardRef(({ className: n, ...i }, r) => /* @__PURE__ */ R.jsx(
  "div",
  {
    ref: r,
    className: qn("flex flex-col space-y-1.5 p-6", n),
    ...i
  }
));
sb.displayName = "CardHeader";
const ub = S.forwardRef(({ className: n, ...i }, r) => /* @__PURE__ */ R.jsx(
  "h3",
  {
    ref: r,
    className: qn(
      "text-2xl font-semibold leading-none tracking-tight",
      n
    ),
    ...i
  }
));
ub.displayName = "CardTitle";
const lb = S.forwardRef(({ className: n, ...i }, r) => /* @__PURE__ */ R.jsx(
  "p",
  {
    ref: r,
    className: qn("text-sm text-muted-foreground", n),
    ...i
  }
));
lb.displayName = "CardDescription";
const cb = S.forwardRef(({ className: n, ...i }, r) => /* @__PURE__ */ R.jsx("div", { ref: r, className: qn("p-6 pt-0", n), ...i }));
cb.displayName = "CardContent";
const fb = S.forwardRef(({ className: n, ...i }, r) => /* @__PURE__ */ R.jsx(
  "div",
  {
    ref: r,
    className: qn("flex items-center p-6 pt-0", n),
    ...i
  }
));
fb.displayName = "CardFooter";
function Cc(n, i) {
  if (typeof n == "function")
    return n(i);
  n != null && (n.current = i);
}
function ff(...n) {
  return (i) => {
    let r = !1;
    const a = n.map((s) => {
      const l = Cc(s, i);
      return !r && typeof l == "function" && (r = !0), l;
    });
    if (r)
      return () => {
        for (let s = 0; s < a.length; s++) {
          const l = a[s];
          typeof l == "function" ? l() : Cc(n[s], null);
        }
      };
  };
}
function ur(...n) {
  return S.useCallback(ff(...n), n);
}
// @__NO_SIDE_EFFECTS__
function df(n) {
  const i = /* @__PURE__ */ hb(n), r = S.forwardRef((a, s) => {
    const { children: l, ...f } = a, m = S.Children.toArray(l), g = m.find(mb);
    if (g) {
      const p = g.props.children, w = m.map((x) => x === g ? S.Children.count(p) > 1 ? S.Children.only(null) : S.isValidElement(p) ? p.props.children : null : x);
      return /* @__PURE__ */ R.jsx(i, { ...f, ref: s, children: S.isValidElement(p) ? S.cloneElement(p, void 0, w) : null });
    }
    return /* @__PURE__ */ R.jsx(i, { ...f, ref: s, children: l });
  });
  return r.displayName = `${n}.Slot`, r;
}
var db = /* @__PURE__ */ df("Slot");
// @__NO_SIDE_EFFECTS__
function hb(n) {
  const i = S.forwardRef((r, a) => {
    const { children: s, ...l } = r;
    if (S.isValidElement(s)) {
      const f = vb(s), m = pb(l, s.props);
      return s.type !== S.Fragment && (m.ref = a ? ff(a, f) : f), S.cloneElement(s, m);
    }
    return S.Children.count(s) > 1 ? S.Children.only(null) : null;
  });
  return i.displayName = `${n}.SlotClone`, i;
}
var hf = Symbol("radix.slottable");
// @__NO_SIDE_EFFECTS__
function gb(n) {
  const i = ({ children: r }) => /* @__PURE__ */ R.jsx(R.Fragment, { children: r });
  return i.displayName = `${n}.Slottable`, i.__radixId = hf, i;
}
function mb(n) {
  return S.isValidElement(n) && typeof n.type == "function" && "__radixId" in n.type && n.type.__radixId === hf;
}
function pb(n, i) {
  const r = { ...i };
  for (const a in i) {
    const s = n[a], l = i[a];
    /^on[A-Z]/.test(a) ? s && l ? r[a] = (...m) => {
      const g = l(...m);
      return s(...m), g;
    } : s && (r[a] = s) : a === "style" ? r[a] = { ...s, ...l } : a === "className" && (r[a] = [s, l].filter(Boolean).join(" "));
  }
  return { ...n, ...r };
}
function vb(n) {
  var a, s;
  let i = (a = Object.getOwnPropertyDescriptor(n.props, "ref")) == null ? void 0 : a.get, r = i && "isReactWarning" in i && i.isReactWarning;
  return r ? n.ref : (i = (s = Object.getOwnPropertyDescriptor(n, "ref")) == null ? void 0 : s.get, r = i && "isReactWarning" in i && i.isReactWarning, r ? n.props.ref : n.props.ref || n.ref);
}
const Tc = (n) => typeof n == "boolean" ? `${n}` : n === 0 ? "0" : n, Ec = Zc, wb = (n, i) => (r) => {
  var a;
  if ((i == null ? void 0 : i.variants) == null) return Ec(n, r == null ? void 0 : r.class, r == null ? void 0 : r.className);
  const { variants: s, defaultVariants: l } = i, f = Object.keys(s).map((p) => {
    const w = r == null ? void 0 : r[p], x = l == null ? void 0 : l[p];
    if (w === null) return null;
    const T = Tc(w) || Tc(x);
    return s[p][T];
  }), m = r && Object.entries(r).reduce((p, w) => {
    let [x, T] = w;
    return T === void 0 || (p[x] = T), p;
  }, {}), g = i == null || (a = i.compoundVariants) === null || a === void 0 ? void 0 : a.reduce((p, w) => {
    let { class: x, className: T, ...E } = w;
    return Object.entries(E).every((O) => {
      let [k, L] = O;
      return Array.isArray(L) ? L.includes({
        ...l,
        ...m
      }[k]) : {
        ...l,
        ...m
      }[k] === L;
    }) ? [
      ...p,
      x,
      T
    ] : p;
  }, []);
  return Ec(n, f, g, r == null ? void 0 : r.class, r == null ? void 0 : r.className);
}, yb = wb(
  "inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md text-sm font-medium ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 [&_svg]:pointer-events-none [&_svg]:size-4 [&_svg]:shrink-0",
  {
    variants: {
      variant: {
        default: "bg-primary text-primary-foreground hover:bg-primary/90",
        destructive: "bg-destructive text-destructive-foreground hover:bg-destructive/90",
        outline: "border border-input bg-background hover:bg-accent hover:text-accent-foreground",
        secondary: "bg-secondary text-secondary-foreground hover:bg-secondary/80",
        ghost: "hover:bg-accent hover:text-accent-foreground",
        link: "text-primary underline-offset-4 hover:underline"
      },
      size: {
        default: "h-10 px-4 py-2",
        sm: "h-9 rounded-md px-3",
        lg: "h-11 rounded-md px-8",
        icon: "h-10 w-10"
      }
    },
    defaultVariants: {
      variant: "default",
      size: "default"
    }
  }
), ys = S.forwardRef(
  ({ className: n, variant: i, size: r, asChild: a = !1, ...s }, l) => {
    const f = a ? db : "button";
    return /* @__PURE__ */ R.jsx(
      f,
      {
        className: qn(yb({ variant: i, size: r, className: n })),
        ref: l,
        ...s
      }
    );
  }
);
ys.displayName = "Button";
function Pn(n, i, { checkForDefaultPrevented: r = !0 } = {}) {
  return function(s) {
    if (n == null || n(s), r === !1 || !s.defaultPrevented)
      return i == null ? void 0 : i(s);
  };
}
function gf(n, i = []) {
  let r = [];
  function a(l, f) {
    const m = S.createContext(f), g = r.length;
    r = [...r, f];
    const p = (x) => {
      var I;
      const { scope: T, children: E, ...O } = x, k = ((I = T == null ? void 0 : T[n]) == null ? void 0 : I[g]) || m, L = S.useMemo(() => O, Object.values(O));
      return /* @__PURE__ */ R.jsx(k.Provider, { value: L, children: E });
    };
    p.displayName = l + "Provider";
    function w(x, T) {
      var k;
      const E = ((k = T == null ? void 0 : T[n]) == null ? void 0 : k[g]) || m, O = S.useContext(E);
      if (O) return O;
      if (f !== void 0) return f;
      throw new Error(`\`${x}\` must be used within \`${l}\``);
    }
    return [p, w];
  }
  const s = () => {
    const l = r.map((f) => S.createContext(f));
    return function(m) {
      const g = (m == null ? void 0 : m[n]) || l;
      return S.useMemo(
        () => ({ [`__scope${n}`]: { ...m, [n]: g } }),
        [m, g]
      );
    };
  };
  return s.scopeName = n, [a, bb(s, ...i)];
}
function bb(...n) {
  const i = n[0];
  if (n.length === 1) return i;
  const r = () => {
    const a = n.map((s) => ({
      useScope: s(),
      scopeName: s.scopeName
    }));
    return function(l) {
      const f = a.reduce((m, { useScope: g, scopeName: p }) => {
        const x = g(l)[`__scope${p}`];
        return { ...m, ...x };
      }, {});
      return S.useMemo(() => ({ [`__scope${i.scopeName}`]: f }), [f]);
    };
  };
  return r.scopeName = i.scopeName, r;
}
var xb = [
  "a",
  "button",
  "div",
  "form",
  "h2",
  "h3",
  "img",
  "input",
  "label",
  "li",
  "nav",
  "ol",
  "p",
  "select",
  "span",
  "svg",
  "ul"
], lr = xb.reduce((n, i) => {
  const r = /* @__PURE__ */ df(`Primitive.${i}`), a = S.forwardRef((s, l) => {
    const { asChild: f, ...m } = s, g = f ? r : i;
    return typeof window < "u" && (window[Symbol.for("radix-ui")] = !0), /* @__PURE__ */ R.jsx(g, { ...m, ref: l });
  });
  return a.displayName = `Primitive.${i}`, { ...n, [i]: a };
}, {});
function _b(n, i) {
  n && zc.flushSync(() => n.dispatchEvent(i));
}
function Mo(n) {
  const i = S.useRef(n);
  return S.useEffect(() => {
    i.current = n;
  }), S.useMemo(() => (...r) => {
    var a;
    return (a = i.current) == null ? void 0 : a.call(i, ...r);
  }, []);
}
function Cb(n, i = globalThis == null ? void 0 : globalThis.document) {
  const r = Mo(n);
  S.useEffect(() => {
    const a = (s) => {
      s.key === "Escape" && r(s);
    };
    return i.addEventListener("keydown", a, { capture: !0 }), () => i.removeEventListener("keydown", a, { capture: !0 });
  }, [r, i]);
}
var Tb = "DismissableLayer", bs = "dismissableLayer.update", Eb = "dismissableLayer.pointerDownOutside", Ob = "dismissableLayer.focusOutside", Oc, mf = S.createContext({
  layers: /* @__PURE__ */ new Set(),
  layersWithOutsidePointerEventsDisabled: /* @__PURE__ */ new Set(),
  branches: /* @__PURE__ */ new Set()
}), pf = S.forwardRef(
  (n, i) => {
    const {
      disableOutsidePointerEvents: r = !1,
      onEscapeKeyDown: a,
      onPointerDownOutside: s,
      onFocusOutside: l,
      onInteractOutside: f,
      onDismiss: m,
      ...g
    } = n, p = S.useContext(mf), [w, x] = S.useState(null), T = (w == null ? void 0 : w.ownerDocument) ?? (globalThis == null ? void 0 : globalThis.document), [, E] = S.useState({}), O = ur(i, (j) => x(j)), k = Array.from(p.layers), [L] = [...p.layersWithOutsidePointerEventsDisabled].slice(-1), I = k.indexOf(L), $ = w ? k.indexOf(w) : -1, B = p.layersWithOutsidePointerEventsDisabled.size > 0, q = $ >= I, Y = Rb((j) => {
      const U = j.target, se = [...p.branches].some((Ce) => Ce.contains(U));
      !q || se || (s == null || s(j), f == null || f(j), j.defaultPrevented || m == null || m());
    }, T), Q = Ab((j) => {
      const U = j.target;
      [...p.branches].some((Ce) => Ce.contains(U)) || (l == null || l(j), f == null || f(j), j.defaultPrevented || m == null || m());
    }, T);
    return Cb((j) => {
      $ === p.layers.size - 1 && (a == null || a(j), !j.defaultPrevented && m && (j.preventDefault(), m()));
    }, T), S.useEffect(() => {
      if (w)
        return r && (p.layersWithOutsidePointerEventsDisabled.size === 0 && (Oc = T.body.style.pointerEvents, T.body.style.pointerEvents = "none"), p.layersWithOutsidePointerEventsDisabled.add(w)), p.layers.add(w), Pc(), () => {
          r && p.layersWithOutsidePointerEventsDisabled.size === 1 && (T.body.style.pointerEvents = Oc);
        };
    }, [w, T, r, p]), S.useEffect(() => () => {
      w && (p.layers.delete(w), p.layersWithOutsidePointerEventsDisabled.delete(w), Pc());
    }, [w, p]), S.useEffect(() => {
      const j = () => E({});
      return document.addEventListener(bs, j), () => document.removeEventListener(bs, j);
    }, []), /* @__PURE__ */ R.jsx(
      lr.div,
      {
        ...g,
        ref: O,
        style: {
          pointerEvents: B ? q ? "auto" : "none" : void 0,
          ...n.style
        },
        onFocusCapture: Pn(n.onFocusCapture, Q.onFocusCapture),
        onBlurCapture: Pn(n.onBlurCapture, Q.onBlurCapture),
        onPointerDownCapture: Pn(
          n.onPointerDownCapture,
          Y.onPointerDownCapture
        )
      }
    );
  }
);
pf.displayName = Tb;
var Pb = "DismissableLayerBranch", Sb = S.forwardRef((n, i) => {
  const r = S.useContext(mf), a = S.useRef(null), s = ur(i, a);
  return S.useEffect(() => {
    const l = a.current;
    if (l)
      return r.branches.add(l), () => {
        r.branches.delete(l);
      };
  }, [r.branches]), /* @__PURE__ */ R.jsx(lr.div, { ...n, ref: s });
});
Sb.displayName = Pb;
function Rb(n, i = globalThis == null ? void 0 : globalThis.document) {
  const r = Mo(n), a = S.useRef(!1), s = S.useRef(() => {
  });
  return S.useEffect(() => {
    const l = (m) => {
      if (m.target && !a.current) {
        let g = function() {
          vf(
            Eb,
            r,
            p,
            { discrete: !0 }
          );
        };
        const p = { originalEvent: m };
        m.pointerType === "touch" ? (i.removeEventListener("click", s.current), s.current = g, i.addEventListener("click", s.current, { once: !0 })) : g();
      } else
        i.removeEventListener("click", s.current);
      a.current = !1;
    }, f = window.setTimeout(() => {
      i.addEventListener("pointerdown", l);
    }, 0);
    return () => {
      window.clearTimeout(f), i.removeEventListener("pointerdown", l), i.removeEventListener("click", s.current);
    };
  }, [i, r]), {
    // ensures we check React component tree (not just DOM tree)
    onPointerDownCapture: () => a.current = !0
  };
}
function Ab(n, i = globalThis == null ? void 0 : globalThis.document) {
  const r = Mo(n), a = S.useRef(!1);
  return S.useEffect(() => {
    const s = (l) => {
      l.target && !a.current && vf(Ob, r, { originalEvent: l }, {
        discrete: !1
      });
    };
    return i.addEventListener("focusin", s), () => i.removeEventListener("focusin", s);
  }, [i, r]), {
    onFocusCapture: () => a.current = !0,
    onBlurCapture: () => a.current = !1
  };
}
function Pc() {
  const n = new CustomEvent(bs);
  document.dispatchEvent(n);
}
function vf(n, i, r, { discrete: a }) {
  const s = r.originalEvent.target, l = new CustomEvent(n, { bubbles: !1, cancelable: !0, detail: r });
  i && s.addEventListener(n, i, { once: !0 }), a ? _b(s, l) : s.dispatchEvent(l);
}
var or = globalThis != null && globalThis.document ? S.useLayoutEffect : () => {
}, kb = S[" useId ".trim().toString()] || (() => {
}), Mb = 0;
function Db(n) {
  const [i, r] = S.useState(kb());
  return or(() => {
    r((a) => a ?? String(Mb++));
  }, [n]), i ? `radix-${i}` : "";
}
const Lb = ["top", "right", "bottom", "left"], jn = Math.min, $t = Math.max, Po = Math.round, yo = Math.floor, fn = (n) => ({
  x: n,
  y: n
}), Nb = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
}, Wb = {
  start: "end",
  end: "start"
};
function xs(n, i, r) {
  return $t(n, jn(i, r));
}
function Rn(n, i) {
  return typeof n == "function" ? n(i) : n;
}
function An(n) {
  return n.split("-")[0];
}
function Ir(n) {
  return n.split("-")[1];
}
function Ss(n) {
  return n === "x" ? "y" : "x";
}
function Rs(n) {
  return n === "y" ? "height" : "width";
}
function Sn(n) {
  return ["top", "bottom"].includes(An(n)) ? "y" : "x";
}
function As(n) {
  return Ss(Sn(n));
}
function Ib(n, i, r) {
  r === void 0 && (r = !1);
  const a = Ir(n), s = As(n), l = Rs(s);
  let f = s === "x" ? a === (r ? "end" : "start") ? "right" : "left" : a === "start" ? "bottom" : "top";
  return i.reference[l] > i.floating[l] && (f = So(f)), [f, So(f)];
}
function Fb(n) {
  const i = So(n);
  return [_s(n), i, _s(i)];
}
function _s(n) {
  return n.replace(/start|end/g, (i) => Wb[i]);
}
function $b(n, i, r) {
  const a = ["left", "right"], s = ["right", "left"], l = ["top", "bottom"], f = ["bottom", "top"];
  switch (n) {
    case "top":
    case "bottom":
      return r ? i ? s : a : i ? a : s;
    case "left":
    case "right":
      return i ? l : f;
    default:
      return [];
  }
}
function Ub(n, i, r, a) {
  const s = Ir(n);
  let l = $b(An(n), r === "start", a);
  return s && (l = l.map((f) => f + "-" + s), i && (l = l.concat(l.map(_s)))), l;
}
function So(n) {
  return n.replace(/left|right|bottom|top/g, (i) => Nb[i]);
}
function Hb(n) {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    ...n
  };
}
function wf(n) {
  return typeof n != "number" ? Hb(n) : {
    top: n,
    right: n,
    bottom: n,
    left: n
  };
}
function Ro(n) {
  const {
    x: i,
    y: r,
    width: a,
    height: s
  } = n;
  return {
    width: a,
    height: s,
    top: r,
    left: i,
    right: i + a,
    bottom: r + s,
    x: i,
    y: r
  };
}
function Sc(n, i, r) {
  let {
    reference: a,
    floating: s
  } = n;
  const l = Sn(i), f = As(i), m = Rs(f), g = An(i), p = l === "y", w = a.x + a.width / 2 - s.width / 2, x = a.y + a.height / 2 - s.height / 2, T = a[m] / 2 - s[m] / 2;
  let E;
  switch (g) {
    case "top":
      E = {
        x: w,
        y: a.y - s.height
      };
      break;
    case "bottom":
      E = {
        x: w,
        y: a.y + a.height
      };
      break;
    case "right":
      E = {
        x: a.x + a.width,
        y: x
      };
      break;
    case "left":
      E = {
        x: a.x - s.width,
        y: x
      };
      break;
    default:
      E = {
        x: a.x,
        y: a.y
      };
  }
  switch (Ir(i)) {
    case "start":
      E[f] -= T * (r && p ? -1 : 1);
      break;
    case "end":
      E[f] += T * (r && p ? -1 : 1);
      break;
  }
  return E;
}
const Bb = async (n, i, r) => {
  const {
    placement: a = "bottom",
    strategy: s = "absolute",
    middleware: l = [],
    platform: f
  } = r, m = l.filter(Boolean), g = await (f.isRTL == null ? void 0 : f.isRTL(i));
  let p = await f.getElementRects({
    reference: n,
    floating: i,
    strategy: s
  }), {
    x: w,
    y: x
  } = Sc(p, a, g), T = a, E = {}, O = 0;
  for (let k = 0; k < m.length; k++) {
    const {
      name: L,
      fn: I
    } = m[k], {
      x: $,
      y: B,
      data: q,
      reset: Y
    } = await I({
      x: w,
      y: x,
      initialPlacement: a,
      placement: T,
      strategy: s,
      middlewareData: E,
      rects: p,
      platform: f,
      elements: {
        reference: n,
        floating: i
      }
    });
    w = $ ?? w, x = B ?? x, E = {
      ...E,
      [L]: {
        ...E[L],
        ...q
      }
    }, Y && O <= 50 && (O++, typeof Y == "object" && (Y.placement && (T = Y.placement), Y.rects && (p = Y.rects === !0 ? await f.getElementRects({
      reference: n,
      floating: i,
      strategy: s
    }) : Y.rects), {
      x: w,
      y: x
    } = Sc(p, T, g)), k = -1);
  }
  return {
    x: w,
    y: x,
    placement: T,
    strategy: s,
    middlewareData: E
  };
};
async function wi(n, i) {
  var r;
  i === void 0 && (i = {});
  const {
    x: a,
    y: s,
    platform: l,
    rects: f,
    elements: m,
    strategy: g
  } = n, {
    boundary: p = "clippingAncestors",
    rootBoundary: w = "viewport",
    elementContext: x = "floating",
    altBoundary: T = !1,
    padding: E = 0
  } = Rn(i, n), O = wf(E), L = m[T ? x === "floating" ? "reference" : "floating" : x], I = Ro(await l.getClippingRect({
    element: (r = await (l.isElement == null ? void 0 : l.isElement(L))) == null || r ? L : L.contextElement || await (l.getDocumentElement == null ? void 0 : l.getDocumentElement(m.floating)),
    boundary: p,
    rootBoundary: w,
    strategy: g
  })), $ = x === "floating" ? {
    x: a,
    y: s,
    width: f.floating.width,
    height: f.floating.height
  } : f.reference, B = await (l.getOffsetParent == null ? void 0 : l.getOffsetParent(m.floating)), q = await (l.isElement == null ? void 0 : l.isElement(B)) ? await (l.getScale == null ? void 0 : l.getScale(B)) || {
    x: 1,
    y: 1
  } : {
    x: 1,
    y: 1
  }, Y = Ro(l.convertOffsetParentRelativeRectToViewportRelativeRect ? await l.convertOffsetParentRelativeRectToViewportRelativeRect({
    elements: m,
    rect: $,
    offsetParent: B,
    strategy: g
  }) : $);
  return {
    top: (I.top - Y.top + O.top) / q.y,
    bottom: (Y.bottom - I.bottom + O.bottom) / q.y,
    left: (I.left - Y.left + O.left) / q.x,
    right: (Y.right - I.right + O.right) / q.x
  };
}
const Yb = (n) => ({
  name: "arrow",
  options: n,
  async fn(i) {
    const {
      x: r,
      y: a,
      placement: s,
      rects: l,
      platform: f,
      elements: m,
      middlewareData: g
    } = i, {
      element: p,
      padding: w = 0
    } = Rn(n, i) || {};
    if (p == null)
      return {};
    const x = wf(w), T = {
      x: r,
      y: a
    }, E = As(s), O = Rs(E), k = await f.getDimensions(p), L = E === "y", I = L ? "top" : "left", $ = L ? "bottom" : "right", B = L ? "clientHeight" : "clientWidth", q = l.reference[O] + l.reference[E] - T[E] - l.floating[O], Y = T[E] - l.reference[E], Q = await (f.getOffsetParent == null ? void 0 : f.getOffsetParent(p));
    let j = Q ? Q[B] : 0;
    (!j || !await (f.isElement == null ? void 0 : f.isElement(Q))) && (j = m.floating[B] || l.floating[O]);
    const U = q / 2 - Y / 2, se = j / 2 - k[O] / 2 - 1, Ce = jn(x[I], se), fe = jn(x[$], se), de = Ce, re = j - k[O] - fe, Te = j / 2 - k[O] / 2 + U, me = xs(de, Te, re), be = !g.arrow && Ir(s) != null && Te !== me && l.reference[O] / 2 - (Te < de ? Ce : fe) - k[O] / 2 < 0, pe = be ? Te < de ? Te - de : Te - re : 0;
    return {
      [E]: T[E] + pe,
      data: {
        [E]: me,
        centerOffset: Te - me - pe,
        ...be && {
          alignmentOffset: pe
        }
      },
      reset: be
    };
  }
}), jb = function(n) {
  return n === void 0 && (n = {}), {
    name: "flip",
    options: n,
    async fn(i) {
      var r, a;
      const {
        placement: s,
        middlewareData: l,
        rects: f,
        initialPlacement: m,
        platform: g,
        elements: p
      } = i, {
        mainAxis: w = !0,
        crossAxis: x = !0,
        fallbackPlacements: T,
        fallbackStrategy: E = "bestFit",
        fallbackAxisSideDirection: O = "none",
        flipAlignment: k = !0,
        ...L
      } = Rn(n, i);
      if ((r = l.arrow) != null && r.alignmentOffset)
        return {};
      const I = An(s), $ = Sn(m), B = An(m) === m, q = await (g.isRTL == null ? void 0 : g.isRTL(p.floating)), Y = T || (B || !k ? [So(m)] : Fb(m)), Q = O !== "none";
      !T && Q && Y.push(...Ub(m, k, O, q));
      const j = [m, ...Y], U = await wi(i, L), se = [];
      let Ce = ((a = l.flip) == null ? void 0 : a.overflows) || [];
      if (w && se.push(U[I]), x) {
        const me = Ib(s, f, q);
        se.push(U[me[0]], U[me[1]]);
      }
      if (Ce = [...Ce, {
        placement: s,
        overflows: se
      }], !se.every((me) => me <= 0)) {
        var fe, de;
        const me = (((fe = l.flip) == null ? void 0 : fe.index) || 0) + 1, be = j[me];
        if (be) {
          var re;
          const F = x === "alignment" ? $ !== Sn(be) : !1, Me = ((re = Ce[0]) == null ? void 0 : re.overflows[0]) > 0;
          if (!F || Me)
            return {
              data: {
                index: me,
                overflows: Ce
              },
              reset: {
                placement: be
              }
            };
        }
        let pe = (de = Ce.filter((F) => F.overflows[0] <= 0).sort((F, Me) => F.overflows[1] - Me.overflows[1])[0]) == null ? void 0 : de.placement;
        if (!pe)
          switch (E) {
            case "bestFit": {
              var Te;
              const F = (Te = Ce.filter((Me) => {
                if (Q) {
                  const xe = Sn(Me.placement);
                  return xe === $ || // Create a bias to the `y` side axis due to horizontal
                  // reading directions favoring greater width.
                  xe === "y";
                }
                return !0;
              }).map((Me) => [Me.placement, Me.overflows.filter((xe) => xe > 0).reduce((xe, Ie) => xe + Ie, 0)]).sort((Me, xe) => Me[1] - xe[1])[0]) == null ? void 0 : Te[0];
              F && (pe = F);
              break;
            }
            case "initialPlacement":
              pe = m;
              break;
          }
        if (s !== pe)
          return {
            reset: {
              placement: pe
            }
          };
      }
      return {};
    }
  };
};
function Rc(n, i) {
  return {
    top: n.top - i.height,
    right: n.right - i.width,
    bottom: n.bottom - i.height,
    left: n.left - i.width
  };
}
function Ac(n) {
  return Lb.some((i) => n[i] >= 0);
}
const Gb = function(n) {
  return n === void 0 && (n = {}), {
    name: "hide",
    options: n,
    async fn(i) {
      const {
        rects: r
      } = i, {
        strategy: a = "referenceHidden",
        ...s
      } = Rn(n, i);
      switch (a) {
        case "referenceHidden": {
          const l = await wi(i, {
            ...s,
            elementContext: "reference"
          }), f = Rc(l, r.reference);
          return {
            data: {
              referenceHiddenOffsets: f,
              referenceHidden: Ac(f)
            }
          };
        }
        case "escaped": {
          const l = await wi(i, {
            ...s,
            altBoundary: !0
          }), f = Rc(l, r.floating);
          return {
            data: {
              escapedOffsets: f,
              escaped: Ac(f)
            }
          };
        }
        default:
          return {};
      }
    }
  };
};
async function qb(n, i) {
  const {
    placement: r,
    platform: a,
    elements: s
  } = n, l = await (a.isRTL == null ? void 0 : a.isRTL(s.floating)), f = An(r), m = Ir(r), g = Sn(r) === "y", p = ["left", "top"].includes(f) ? -1 : 1, w = l && g ? -1 : 1, x = Rn(i, n);
  let {
    mainAxis: T,
    crossAxis: E,
    alignmentAxis: O
  } = typeof x == "number" ? {
    mainAxis: x,
    crossAxis: 0,
    alignmentAxis: null
  } : {
    mainAxis: x.mainAxis || 0,
    crossAxis: x.crossAxis || 0,
    alignmentAxis: x.alignmentAxis
  };
  return m && typeof O == "number" && (E = m === "end" ? O * -1 : O), g ? {
    x: E * w,
    y: T * p
  } : {
    x: T * p,
    y: E * w
  };
}
const zb = function(n) {
  return n === void 0 && (n = 0), {
    name: "offset",
    options: n,
    async fn(i) {
      var r, a;
      const {
        x: s,
        y: l,
        placement: f,
        middlewareData: m
      } = i, g = await qb(i, n);
      return f === ((r = m.offset) == null ? void 0 : r.placement) && (a = m.arrow) != null && a.alignmentOffset ? {} : {
        x: s + g.x,
        y: l + g.y,
        data: {
          ...g,
          placement: f
        }
      };
    }
  };
}, Vb = function(n) {
  return n === void 0 && (n = {}), {
    name: "shift",
    options: n,
    async fn(i) {
      const {
        x: r,
        y: a,
        placement: s
      } = i, {
        mainAxis: l = !0,
        crossAxis: f = !1,
        limiter: m = {
          fn: (L) => {
            let {
              x: I,
              y: $
            } = L;
            return {
              x: I,
              y: $
            };
          }
        },
        ...g
      } = Rn(n, i), p = {
        x: r,
        y: a
      }, w = await wi(i, g), x = Sn(An(s)), T = Ss(x);
      let E = p[T], O = p[x];
      if (l) {
        const L = T === "y" ? "top" : "left", I = T === "y" ? "bottom" : "right", $ = E + w[L], B = E - w[I];
        E = xs($, E, B);
      }
      if (f) {
        const L = x === "y" ? "top" : "left", I = x === "y" ? "bottom" : "right", $ = O + w[L], B = O - w[I];
        O = xs($, O, B);
      }
      const k = m.fn({
        ...i,
        [T]: E,
        [x]: O
      });
      return {
        ...k,
        data: {
          x: k.x - r,
          y: k.y - a,
          enabled: {
            [T]: l,
            [x]: f
          }
        }
      };
    }
  };
}, Xb = function(n) {
  return n === void 0 && (n = {}), {
    options: n,
    fn(i) {
      const {
        x: r,
        y: a,
        placement: s,
        rects: l,
        middlewareData: f
      } = i, {
        offset: m = 0,
        mainAxis: g = !0,
        crossAxis: p = !0
      } = Rn(n, i), w = {
        x: r,
        y: a
      }, x = Sn(s), T = Ss(x);
      let E = w[T], O = w[x];
      const k = Rn(m, i), L = typeof k == "number" ? {
        mainAxis: k,
        crossAxis: 0
      } : {
        mainAxis: 0,
        crossAxis: 0,
        ...k
      };
      if (g) {
        const B = T === "y" ? "height" : "width", q = l.reference[T] - l.floating[B] + L.mainAxis, Y = l.reference[T] + l.reference[B] - L.mainAxis;
        E < q ? E = q : E > Y && (E = Y);
      }
      if (p) {
        var I, $;
        const B = T === "y" ? "width" : "height", q = ["top", "left"].includes(An(s)), Y = l.reference[x] - l.floating[B] + (q && ((I = f.offset) == null ? void 0 : I[x]) || 0) + (q ? 0 : L.crossAxis), Q = l.reference[x] + l.reference[B] + (q ? 0 : (($ = f.offset) == null ? void 0 : $[x]) || 0) - (q ? L.crossAxis : 0);
        O < Y ? O = Y : O > Q && (O = Q);
      }
      return {
        [T]: E,
        [x]: O
      };
    }
  };
}, Kb = function(n) {
  return n === void 0 && (n = {}), {
    name: "size",
    options: n,
    async fn(i) {
      var r, a;
      const {
        placement: s,
        rects: l,
        platform: f,
        elements: m
      } = i, {
        apply: g = () => {
        },
        ...p
      } = Rn(n, i), w = await wi(i, p), x = An(s), T = Ir(s), E = Sn(s) === "y", {
        width: O,
        height: k
      } = l.floating;
      let L, I;
      x === "top" || x === "bottom" ? (L = x, I = T === (await (f.isRTL == null ? void 0 : f.isRTL(m.floating)) ? "start" : "end") ? "left" : "right") : (I = x, L = T === "end" ? "top" : "bottom");
      const $ = k - w.top - w.bottom, B = O - w.left - w.right, q = jn(k - w[L], $), Y = jn(O - w[I], B), Q = !i.middlewareData.shift;
      let j = q, U = Y;
      if ((r = i.middlewareData.shift) != null && r.enabled.x && (U = B), (a = i.middlewareData.shift) != null && a.enabled.y && (j = $), Q && !T) {
        const Ce = $t(w.left, 0), fe = $t(w.right, 0), de = $t(w.top, 0), re = $t(w.bottom, 0);
        E ? U = O - 2 * (Ce !== 0 || fe !== 0 ? Ce + fe : $t(w.left, w.right)) : j = k - 2 * (de !== 0 || re !== 0 ? de + re : $t(w.top, w.bottom));
      }
      await g({
        ...i,
        availableWidth: U,
        availableHeight: j
      });
      const se = await f.getDimensions(m.floating);
      return O !== se.width || k !== se.height ? {
        reset: {
          rects: !0
        }
      } : {};
    }
  };
};
function Do() {
  return typeof window < "u";
}
function Fr(n) {
  return yf(n) ? (n.nodeName || "").toLowerCase() : "#document";
}
function Ut(n) {
  var i;
  return (n == null || (i = n.ownerDocument) == null ? void 0 : i.defaultView) || window;
}
function hn(n) {
  var i;
  return (i = (yf(n) ? n.ownerDocument : n.document) || window.document) == null ? void 0 : i.documentElement;
}
function yf(n) {
  return Do() ? n instanceof Node || n instanceof Ut(n).Node : !1;
}
function rn(n) {
  return Do() ? n instanceof Element || n instanceof Ut(n).Element : !1;
}
function dn(n) {
  return Do() ? n instanceof HTMLElement || n instanceof Ut(n).HTMLElement : !1;
}
function kc(n) {
  return !Do() || typeof ShadowRoot > "u" ? !1 : n instanceof ShadowRoot || n instanceof Ut(n).ShadowRoot;
}
function Ti(n) {
  const {
    overflow: i,
    overflowX: r,
    overflowY: a,
    display: s
  } = on(n);
  return /auto|scroll|overlay|hidden|clip/.test(i + a + r) && !["inline", "contents"].includes(s);
}
function Qb(n) {
  return ["table", "td", "th"].includes(Fr(n));
}
function Lo(n) {
  return [":popover-open", ":modal"].some((i) => {
    try {
      return n.matches(i);
    } catch {
      return !1;
    }
  });
}
function ks(n) {
  const i = Ms(), r = rn(n) ? on(n) : n;
  return ["transform", "translate", "scale", "rotate", "perspective"].some((a) => r[a] ? r[a] !== "none" : !1) || (r.containerType ? r.containerType !== "normal" : !1) || !i && (r.backdropFilter ? r.backdropFilter !== "none" : !1) || !i && (r.filter ? r.filter !== "none" : !1) || ["transform", "translate", "scale", "rotate", "perspective", "filter"].some((a) => (r.willChange || "").includes(a)) || ["paint", "layout", "strict", "content"].some((a) => (r.contain || "").includes(a));
}
function Jb(n) {
  let i = Gn(n);
  for (; dn(i) && !Dr(i); ) {
    if (ks(i))
      return i;
    if (Lo(i))
      return null;
    i = Gn(i);
  }
  return null;
}
function Ms() {
  return typeof CSS > "u" || !CSS.supports ? !1 : CSS.supports("-webkit-backdrop-filter", "none");
}
function Dr(n) {
  return ["html", "body", "#document"].includes(Fr(n));
}
function on(n) {
  return Ut(n).getComputedStyle(n);
}
function No(n) {
  return rn(n) ? {
    scrollLeft: n.scrollLeft,
    scrollTop: n.scrollTop
  } : {
    scrollLeft: n.scrollX,
    scrollTop: n.scrollY
  };
}
function Gn(n) {
  if (Fr(n) === "html")
    return n;
  const i = (
    // Step into the shadow DOM of the parent of a slotted node.
    n.assignedSlot || // DOM Element detected.
    n.parentNode || // ShadowRoot detected.
    kc(n) && n.host || // Fallback.
    hn(n)
  );
  return kc(i) ? i.host : i;
}
function bf(n) {
  const i = Gn(n);
  return Dr(i) ? n.ownerDocument ? n.ownerDocument.body : n.body : dn(i) && Ti(i) ? i : bf(i);
}
function yi(n, i, r) {
  var a;
  i === void 0 && (i = []), r === void 0 && (r = !0);
  const s = bf(n), l = s === ((a = n.ownerDocument) == null ? void 0 : a.body), f = Ut(s);
  if (l) {
    const m = Cs(f);
    return i.concat(f, f.visualViewport || [], Ti(s) ? s : [], m && r ? yi(m) : []);
  }
  return i.concat(s, yi(s, [], r));
}
function Cs(n) {
  return n.parent && Object.getPrototypeOf(n.parent) ? n.frameElement : null;
}
function xf(n) {
  const i = on(n);
  let r = parseFloat(i.width) || 0, a = parseFloat(i.height) || 0;
  const s = dn(n), l = s ? n.offsetWidth : r, f = s ? n.offsetHeight : a, m = Po(r) !== l || Po(a) !== f;
  return m && (r = l, a = f), {
    width: r,
    height: a,
    $: m
  };
}
function Ds(n) {
  return rn(n) ? n : n.contextElement;
}
function kr(n) {
  const i = Ds(n);
  if (!dn(i))
    return fn(1);
  const r = i.getBoundingClientRect(), {
    width: a,
    height: s,
    $: l
  } = xf(i);
  let f = (l ? Po(r.width) : r.width) / a, m = (l ? Po(r.height) : r.height) / s;
  return (!f || !Number.isFinite(f)) && (f = 1), (!m || !Number.isFinite(m)) && (m = 1), {
    x: f,
    y: m
  };
}
const Zb = /* @__PURE__ */ fn(0);
function _f(n) {
  const i = Ut(n);
  return !Ms() || !i.visualViewport ? Zb : {
    x: i.visualViewport.offsetLeft,
    y: i.visualViewport.offsetTop
  };
}
function ex(n, i, r) {
  return i === void 0 && (i = !1), !r || i && r !== Ut(n) ? !1 : i;
}
function ar(n, i, r, a) {
  i === void 0 && (i = !1), r === void 0 && (r = !1);
  const s = n.getBoundingClientRect(), l = Ds(n);
  let f = fn(1);
  i && (a ? rn(a) && (f = kr(a)) : f = kr(n));
  const m = ex(l, r, a) ? _f(l) : fn(0);
  let g = (s.left + m.x) / f.x, p = (s.top + m.y) / f.y, w = s.width / f.x, x = s.height / f.y;
  if (l) {
    const T = Ut(l), E = a && rn(a) ? Ut(a) : a;
    let O = T, k = Cs(O);
    for (; k && a && E !== O; ) {
      const L = kr(k), I = k.getBoundingClientRect(), $ = on(k), B = I.left + (k.clientLeft + parseFloat($.paddingLeft)) * L.x, q = I.top + (k.clientTop + parseFloat($.paddingTop)) * L.y;
      g *= L.x, p *= L.y, w *= L.x, x *= L.y, g += B, p += q, O = Ut(k), k = Cs(O);
    }
  }
  return Ro({
    width: w,
    height: x,
    x: g,
    y: p
  });
}
function Ls(n, i) {
  const r = No(n).scrollLeft;
  return i ? i.left + r : ar(hn(n)).left + r;
}
function Cf(n, i, r) {
  r === void 0 && (r = !1);
  const a = n.getBoundingClientRect(), s = a.left + i.scrollLeft - (r ? 0 : (
    // RTL <body> scrollbar.
    Ls(n, a)
  )), l = a.top + i.scrollTop;
  return {
    x: s,
    y: l
  };
}
function tx(n) {
  let {
    elements: i,
    rect: r,
    offsetParent: a,
    strategy: s
  } = n;
  const l = s === "fixed", f = hn(a), m = i ? Lo(i.floating) : !1;
  if (a === f || m && l)
    return r;
  let g = {
    scrollLeft: 0,
    scrollTop: 0
  }, p = fn(1);
  const w = fn(0), x = dn(a);
  if ((x || !x && !l) && ((Fr(a) !== "body" || Ti(f)) && (g = No(a)), dn(a))) {
    const E = ar(a);
    p = kr(a), w.x = E.x + a.clientLeft, w.y = E.y + a.clientTop;
  }
  const T = f && !x && !l ? Cf(f, g, !0) : fn(0);
  return {
    width: r.width * p.x,
    height: r.height * p.y,
    x: r.x * p.x - g.scrollLeft * p.x + w.x + T.x,
    y: r.y * p.y - g.scrollTop * p.y + w.y + T.y
  };
}
function nx(n) {
  return Array.from(n.getClientRects());
}
function rx(n) {
  const i = hn(n), r = No(n), a = n.ownerDocument.body, s = $t(i.scrollWidth, i.clientWidth, a.scrollWidth, a.clientWidth), l = $t(i.scrollHeight, i.clientHeight, a.scrollHeight, a.clientHeight);
  let f = -r.scrollLeft + Ls(n);
  const m = -r.scrollTop;
  return on(a).direction === "rtl" && (f += $t(i.clientWidth, a.clientWidth) - s), {
    width: s,
    height: l,
    x: f,
    y: m
  };
}
function ix(n, i) {
  const r = Ut(n), a = hn(n), s = r.visualViewport;
  let l = a.clientWidth, f = a.clientHeight, m = 0, g = 0;
  if (s) {
    l = s.width, f = s.height;
    const p = Ms();
    (!p || p && i === "fixed") && (m = s.offsetLeft, g = s.offsetTop);
  }
  return {
    width: l,
    height: f,
    x: m,
    y: g
  };
}
function ox(n, i) {
  const r = ar(n, !0, i === "fixed"), a = r.top + n.clientTop, s = r.left + n.clientLeft, l = dn(n) ? kr(n) : fn(1), f = n.clientWidth * l.x, m = n.clientHeight * l.y, g = s * l.x, p = a * l.y;
  return {
    width: f,
    height: m,
    x: g,
    y: p
  };
}
function Mc(n, i, r) {
  let a;
  if (i === "viewport")
    a = ix(n, r);
  else if (i === "document")
    a = rx(hn(n));
  else if (rn(i))
    a = ox(i, r);
  else {
    const s = _f(n);
    a = {
      x: i.x - s.x,
      y: i.y - s.y,
      width: i.width,
      height: i.height
    };
  }
  return Ro(a);
}
function Tf(n, i) {
  const r = Gn(n);
  return r === i || !rn(r) || Dr(r) ? !1 : on(r).position === "fixed" || Tf(r, i);
}
function ax(n, i) {
  const r = i.get(n);
  if (r)
    return r;
  let a = yi(n, [], !1).filter((m) => rn(m) && Fr(m) !== "body"), s = null;
  const l = on(n).position === "fixed";
  let f = l ? Gn(n) : n;
  for (; rn(f) && !Dr(f); ) {
    const m = on(f), g = ks(f);
    !g && m.position === "fixed" && (s = null), (l ? !g && !s : !g && m.position === "static" && !!s && ["absolute", "fixed"].includes(s.position) || Ti(f) && !g && Tf(n, f)) ? a = a.filter((w) => w !== f) : s = m, f = Gn(f);
  }
  return i.set(n, a), a;
}
function sx(n) {
  let {
    element: i,
    boundary: r,
    rootBoundary: a,
    strategy: s
  } = n;
  const f = [...r === "clippingAncestors" ? Lo(i) ? [] : ax(i, this._c) : [].concat(r), a], m = f[0], g = f.reduce((p, w) => {
    const x = Mc(i, w, s);
    return p.top = $t(x.top, p.top), p.right = jn(x.right, p.right), p.bottom = jn(x.bottom, p.bottom), p.left = $t(x.left, p.left), p;
  }, Mc(i, m, s));
  return {
    width: g.right - g.left,
    height: g.bottom - g.top,
    x: g.left,
    y: g.top
  };
}
function ux(n) {
  const {
    width: i,
    height: r
  } = xf(n);
  return {
    width: i,
    height: r
  };
}
function lx(n, i, r) {
  const a = dn(i), s = hn(i), l = r === "fixed", f = ar(n, !0, l, i);
  let m = {
    scrollLeft: 0,
    scrollTop: 0
  };
  const g = fn(0);
  function p() {
    g.x = Ls(s);
  }
  if (a || !a && !l)
    if ((Fr(i) !== "body" || Ti(s)) && (m = No(i)), a) {
      const E = ar(i, !0, l, i);
      g.x = E.x + i.clientLeft, g.y = E.y + i.clientTop;
    } else s && p();
  l && !a && s && p();
  const w = s && !a && !l ? Cf(s, m) : fn(0), x = f.left + m.scrollLeft - g.x - w.x, T = f.top + m.scrollTop - g.y - w.y;
  return {
    x,
    y: T,
    width: f.width,
    height: f.height
  };
}
function cs(n) {
  return on(n).position === "static";
}
function Dc(n, i) {
  if (!dn(n) || on(n).position === "fixed")
    return null;
  if (i)
    return i(n);
  let r = n.offsetParent;
  return hn(n) === r && (r = r.ownerDocument.body), r;
}
function Ef(n, i) {
  const r = Ut(n);
  if (Lo(n))
    return r;
  if (!dn(n)) {
    let s = Gn(n);
    for (; s && !Dr(s); ) {
      if (rn(s) && !cs(s))
        return s;
      s = Gn(s);
    }
    return r;
  }
  let a = Dc(n, i);
  for (; a && Qb(a) && cs(a); )
    a = Dc(a, i);
  return a && Dr(a) && cs(a) && !ks(a) ? r : a || Jb(n) || r;
}
const cx = async function(n) {
  const i = this.getOffsetParent || Ef, r = this.getDimensions, a = await r(n.floating);
  return {
    reference: lx(n.reference, await i(n.floating), n.strategy),
    floating: {
      x: 0,
      y: 0,
      width: a.width,
      height: a.height
    }
  };
};
function fx(n) {
  return on(n).direction === "rtl";
}
const dx = {
  convertOffsetParentRelativeRectToViewportRelativeRect: tx,
  getDocumentElement: hn,
  getClippingRect: sx,
  getOffsetParent: Ef,
  getElementRects: cx,
  getClientRects: nx,
  getDimensions: ux,
  getScale: kr,
  isElement: rn,
  isRTL: fx
};
function Of(n, i) {
  return n.x === i.x && n.y === i.y && n.width === i.width && n.height === i.height;
}
function hx(n, i) {
  let r = null, a;
  const s = hn(n);
  function l() {
    var m;
    clearTimeout(a), (m = r) == null || m.disconnect(), r = null;
  }
  function f(m, g) {
    m === void 0 && (m = !1), g === void 0 && (g = 1), l();
    const p = n.getBoundingClientRect(), {
      left: w,
      top: x,
      width: T,
      height: E
    } = p;
    if (m || i(), !T || !E)
      return;
    const O = yo(x), k = yo(s.clientWidth - (w + T)), L = yo(s.clientHeight - (x + E)), I = yo(w), B = {
      rootMargin: -O + "px " + -k + "px " + -L + "px " + -I + "px",
      threshold: $t(0, jn(1, g)) || 1
    };
    let q = !0;
    function Y(Q) {
      const j = Q[0].intersectionRatio;
      if (j !== g) {
        if (!q)
          return f();
        j ? f(!1, j) : a = setTimeout(() => {
          f(!1, 1e-7);
        }, 1e3);
      }
      j === 1 && !Of(p, n.getBoundingClientRect()) && f(), q = !1;
    }
    try {
      r = new IntersectionObserver(Y, {
        ...B,
        // Handle <iframe>s
        root: s.ownerDocument
      });
    } catch {
      r = new IntersectionObserver(Y, B);
    }
    r.observe(n);
  }
  return f(!0), l;
}
function gx(n, i, r, a) {
  a === void 0 && (a = {});
  const {
    ancestorScroll: s = !0,
    ancestorResize: l = !0,
    elementResize: f = typeof ResizeObserver == "function",
    layoutShift: m = typeof IntersectionObserver == "function",
    animationFrame: g = !1
  } = a, p = Ds(n), w = s || l ? [...p ? yi(p) : [], ...yi(i)] : [];
  w.forEach((I) => {
    s && I.addEventListener("scroll", r, {
      passive: !0
    }), l && I.addEventListener("resize", r);
  });
  const x = p && m ? hx(p, r) : null;
  let T = -1, E = null;
  f && (E = new ResizeObserver((I) => {
    let [$] = I;
    $ && $.target === p && E && (E.unobserve(i), cancelAnimationFrame(T), T = requestAnimationFrame(() => {
      var B;
      (B = E) == null || B.observe(i);
    })), r();
  }), p && !g && E.observe(p), E.observe(i));
  let O, k = g ? ar(n) : null;
  g && L();
  function L() {
    const I = ar(n);
    k && !Of(k, I) && r(), k = I, O = requestAnimationFrame(L);
  }
  return r(), () => {
    var I;
    w.forEach(($) => {
      s && $.removeEventListener("scroll", r), l && $.removeEventListener("resize", r);
    }), x == null || x(), (I = E) == null || I.disconnect(), E = null, g && cancelAnimationFrame(O);
  };
}
const mx = zb, px = Vb, vx = jb, wx = Kb, yx = Gb, Lc = Yb, bx = Xb, xx = (n, i, r) => {
  const a = /* @__PURE__ */ new Map(), s = {
    platform: dx,
    ...r
  }, l = {
    ...s.platform,
    _c: a
  };
  return Bb(n, i, {
    ...s,
    platform: l
  });
};
var _o = typeof document < "u" ? a0 : xo;
function Ao(n, i) {
  if (n === i)
    return !0;
  if (typeof n != typeof i)
    return !1;
  if (typeof n == "function" && n.toString() === i.toString())
    return !0;
  let r, a, s;
  if (n && i && typeof n == "object") {
    if (Array.isArray(n)) {
      if (r = n.length, r !== i.length) return !1;
      for (a = r; a-- !== 0; )
        if (!Ao(n[a], i[a]))
          return !1;
      return !0;
    }
    if (s = Object.keys(n), r = s.length, r !== Object.keys(i).length)
      return !1;
    for (a = r; a-- !== 0; )
      if (!{}.hasOwnProperty.call(i, s[a]))
        return !1;
    for (a = r; a-- !== 0; ) {
      const l = s[a];
      if (!(l === "_owner" && n.$$typeof) && !Ao(n[l], i[l]))
        return !1;
    }
    return !0;
  }
  return n !== n && i !== i;
}
function Pf(n) {
  return typeof window > "u" ? 1 : (n.ownerDocument.defaultView || window).devicePixelRatio || 1;
}
function Nc(n, i) {
  const r = Pf(n);
  return Math.round(i * r) / r;
}
function fs(n) {
  const i = S.useRef(n);
  return _o(() => {
    i.current = n;
  }), i;
}
function _x(n) {
  n === void 0 && (n = {});
  const {
    placement: i = "bottom",
    strategy: r = "absolute",
    middleware: a = [],
    platform: s,
    elements: {
      reference: l,
      floating: f
    } = {},
    transform: m = !0,
    whileElementsMounted: g,
    open: p
  } = n, [w, x] = S.useState({
    x: 0,
    y: 0,
    strategy: r,
    placement: i,
    middlewareData: {},
    isPositioned: !1
  }), [T, E] = S.useState(a);
  Ao(T, a) || E(a);
  const [O, k] = S.useState(null), [L, I] = S.useState(null), $ = S.useCallback((F) => {
    F !== Q.current && (Q.current = F, k(F));
  }, []), B = S.useCallback((F) => {
    F !== j.current && (j.current = F, I(F));
  }, []), q = l || O, Y = f || L, Q = S.useRef(null), j = S.useRef(null), U = S.useRef(w), se = g != null, Ce = fs(g), fe = fs(s), de = fs(p), re = S.useCallback(() => {
    if (!Q.current || !j.current)
      return;
    const F = {
      placement: i,
      strategy: r,
      middleware: T
    };
    fe.current && (F.platform = fe.current), xx(Q.current, j.current, F).then((Me) => {
      const xe = {
        ...Me,
        // The floating element's position may be recomputed while it's closed
        // but still mounted (such as when transitioning out). To ensure
        // `isPositioned` will be `false` initially on the next open, avoid
        // setting it to `true` when `open === false` (must be specified).
        isPositioned: de.current !== !1
      };
      Te.current && !Ao(U.current, xe) && (U.current = xe, zc.flushSync(() => {
        x(xe);
      }));
    });
  }, [T, i, r, fe, de]);
  _o(() => {
    p === !1 && U.current.isPositioned && (U.current.isPositioned = !1, x((F) => ({
      ...F,
      isPositioned: !1
    })));
  }, [p]);
  const Te = S.useRef(!1);
  _o(() => (Te.current = !0, () => {
    Te.current = !1;
  }), []), _o(() => {
    if (q && (Q.current = q), Y && (j.current = Y), q && Y) {
      if (Ce.current)
        return Ce.current(q, Y, re);
      re();
    }
  }, [q, Y, re, Ce, se]);
  const me = S.useMemo(() => ({
    reference: Q,
    floating: j,
    setReference: $,
    setFloating: B
  }), [$, B]), be = S.useMemo(() => ({
    reference: q,
    floating: Y
  }), [q, Y]), pe = S.useMemo(() => {
    const F = {
      position: r,
      left: 0,
      top: 0
    };
    if (!be.floating)
      return F;
    const Me = Nc(be.floating, w.x), xe = Nc(be.floating, w.y);
    return m ? {
      ...F,
      transform: "translate(" + Me + "px, " + xe + "px)",
      ...Pf(be.floating) >= 1.5 && {
        willChange: "transform"
      }
    } : {
      position: r,
      left: Me,
      top: xe
    };
  }, [r, m, be.floating, w.x, w.y]);
  return S.useMemo(() => ({
    ...w,
    update: re,
    refs: me,
    elements: be,
    floatingStyles: pe
  }), [w, re, me, be, pe]);
}
const Cx = (n) => {
  function i(r) {
    return {}.hasOwnProperty.call(r, "current");
  }
  return {
    name: "arrow",
    options: n,
    fn(r) {
      const {
        element: a,
        padding: s
      } = typeof n == "function" ? n(r) : n;
      return a && i(a) ? a.current != null ? Lc({
        element: a.current,
        padding: s
      }).fn(r) : {} : a ? Lc({
        element: a,
        padding: s
      }).fn(r) : {};
    }
  };
}, Tx = (n, i) => ({
  ...mx(n),
  options: [n, i]
}), Ex = (n, i) => ({
  ...px(n),
  options: [n, i]
}), Ox = (n, i) => ({
  ...bx(n),
  options: [n, i]
}), Px = (n, i) => ({
  ...vx(n),
  options: [n, i]
}), Sx = (n, i) => ({
  ...wx(n),
  options: [n, i]
}), Rx = (n, i) => ({
  ...yx(n),
  options: [n, i]
}), Ax = (n, i) => ({
  ...Cx(n),
  options: [n, i]
});
var kx = "Arrow", Sf = S.forwardRef((n, i) => {
  const { children: r, width: a = 10, height: s = 5, ...l } = n;
  return /* @__PURE__ */ R.jsx(
    lr.svg,
    {
      ...l,
      ref: i,
      width: a,
      height: s,
      viewBox: "0 0 30 10",
      preserveAspectRatio: "none",
      children: n.asChild ? r : /* @__PURE__ */ R.jsx("polygon", { points: "0,0 30,0 15,10" })
    }
  );
});
Sf.displayName = kx;
var Mx = Sf;
function Dx(n) {
  const [i, r] = S.useState(void 0);
  return or(() => {
    if (n) {
      r({ width: n.offsetWidth, height: n.offsetHeight });
      const a = new ResizeObserver((s) => {
        if (!Array.isArray(s) || !s.length)
          return;
        const l = s[0];
        let f, m;
        if ("borderBoxSize" in l) {
          const g = l.borderBoxSize, p = Array.isArray(g) ? g[0] : g;
          f = p.inlineSize, m = p.blockSize;
        } else
          f = n.offsetWidth, m = n.offsetHeight;
        r({ width: f, height: m });
      });
      return a.observe(n, { box: "border-box" }), () => a.unobserve(n);
    } else
      r(void 0);
  }, [n]), i;
}
var Ns = "Popper", [Rf, Af] = gf(Ns), [Lx, kf] = Rf(Ns), Mf = (n) => {
  const { __scopePopper: i, children: r } = n, [a, s] = S.useState(null);
  return /* @__PURE__ */ R.jsx(Lx, { scope: i, anchor: a, onAnchorChange: s, children: r });
};
Mf.displayName = Ns;
var Df = "PopperAnchor", Lf = S.forwardRef(
  (n, i) => {
    const { __scopePopper: r, virtualRef: a, ...s } = n, l = kf(Df, r), f = S.useRef(null), m = ur(i, f);
    return S.useEffect(() => {
      l.onAnchorChange((a == null ? void 0 : a.current) || f.current);
    }), a ? null : /* @__PURE__ */ R.jsx(lr.div, { ...s, ref: m });
  }
);
Lf.displayName = Df;
var Ws = "PopperContent", [Nx, Wx] = Rf(Ws), Nf = S.forwardRef(
  (n, i) => {
    var ve, Ye, Ke, ft, De, st;
    const {
      __scopePopper: r,
      side: a = "bottom",
      sideOffset: s = 0,
      align: l = "center",
      alignOffset: f = 0,
      arrowPadding: m = 0,
      avoidCollisions: g = !0,
      collisionBoundary: p = [],
      collisionPadding: w = 0,
      sticky: x = "partial",
      hideWhenDetached: T = !1,
      updatePositionStrategy: E = "optimized",
      onPlaced: O,
      ...k
    } = n, L = kf(Ws, r), [I, $] = S.useState(null), B = ur(i, (Bt) => $(Bt)), [q, Y] = S.useState(null), Q = Dx(q), j = (Q == null ? void 0 : Q.width) ?? 0, U = (Q == null ? void 0 : Q.height) ?? 0, se = a + (l !== "center" ? "-" + l : ""), Ce = typeof w == "number" ? w : { top: 0, right: 0, bottom: 0, left: 0, ...w }, fe = Array.isArray(p) ? p : [p], de = fe.length > 0, re = {
      padding: Ce,
      boundary: fe.filter(Fx),
      // with `strategy: 'fixed'`, this is the only way to get it to respect boundaries
      altBoundary: de
    }, { refs: Te, floatingStyles: me, placement: be, isPositioned: pe, middlewareData: F } = _x({
      // default to `fixed` strategy so users don't have to pick and we also avoid focus scroll issues
      strategy: "fixed",
      placement: se,
      whileElementsMounted: (...Bt) => gx(...Bt, {
        animationFrame: E === "always"
      }),
      elements: {
        reference: L.anchor
      },
      middleware: [
        Tx({ mainAxis: s + U, alignmentAxis: f }),
        g && Ex({
          mainAxis: !0,
          crossAxis: !1,
          limiter: x === "partial" ? Ox() : void 0,
          ...re
        }),
        g && Px({ ...re }),
        Sx({
          ...re,
          apply: ({ elements: Bt, rects: Qe, availableWidth: dt, availableHeight: Ct }) => {
            const { width: ut, height: gn } = Qe.reference, kt = Bt.floating.style;
            kt.setProperty("--radix-popper-available-width", `${dt}px`), kt.setProperty("--radix-popper-available-height", `${Ct}px`), kt.setProperty("--radix-popper-anchor-width", `${ut}px`), kt.setProperty("--radix-popper-anchor-height", `${gn}px`);
          }
        }),
        q && Ax({ element: q, padding: m }),
        $x({ arrowWidth: j, arrowHeight: U }),
        T && Rx({ strategy: "referenceHidden", ...re })
      ]
    }), [Me, xe] = Ff(be), Ie = Mo(O);
    or(() => {
      pe && (Ie == null || Ie());
    }, [pe, Ie]);
    const yt = (ve = F.arrow) == null ? void 0 : ve.x, Oe = (Ye = F.arrow) == null ? void 0 : Ye.y, Be = ((Ke = F.arrow) == null ? void 0 : Ke.centerOffset) !== 0, [Se, et] = S.useState();
    return or(() => {
      I && et(window.getComputedStyle(I).zIndex);
    }, [I]), /* @__PURE__ */ R.jsx(
      "div",
      {
        ref: Te.setFloating,
        "data-radix-popper-content-wrapper": "",
        style: {
          ...me,
          transform: pe ? me.transform : "translate(0, -200%)",
          // keep off the page when measuring
          minWidth: "max-content",
          zIndex: Se,
          "--radix-popper-transform-origin": [
            (ft = F.transformOrigin) == null ? void 0 : ft.x,
            (De = F.transformOrigin) == null ? void 0 : De.y
          ].join(" "),
          // hide the content if using the hide middleware and should be hidden
          // set visibility to hidden and disable pointer events so the UI behaves
          // as if the PopperContent isn't there at all
          ...((st = F.hide) == null ? void 0 : st.referenceHidden) && {
            visibility: "hidden",
            pointerEvents: "none"
          }
        },
        dir: n.dir,
        children: /* @__PURE__ */ R.jsx(
          Nx,
          {
            scope: r,
            placedSide: Me,
            onArrowChange: Y,
            arrowX: yt,
            arrowY: Oe,
            shouldHideArrow: Be,
            children: /* @__PURE__ */ R.jsx(
              lr.div,
              {
                "data-side": Me,
                "data-align": xe,
                ...k,
                ref: B,
                style: {
                  ...k.style,
                  // if the PopperContent hasn't been placed yet (not all measurements done)
                  // we prevent animations so that users's animation don't kick in too early referring wrong sides
                  animation: pe ? void 0 : "none"
                }
              }
            )
          }
        )
      }
    );
  }
);
Nf.displayName = Ws;
var Wf = "PopperArrow", Ix = {
  top: "bottom",
  right: "left",
  bottom: "top",
  left: "right"
}, If = S.forwardRef(function(i, r) {
  const { __scopePopper: a, ...s } = i, l = Wx(Wf, a), f = Ix[l.placedSide];
  return (
    // we have to use an extra wrapper because `ResizeObserver` (used by `useSize`)
    // doesn't report size as we'd expect on SVG elements.
    // it reports their bounding box which is effectively the largest path inside the SVG.
    /* @__PURE__ */ R.jsx(
      "span",
      {
        ref: l.onArrowChange,
        style: {
          position: "absolute",
          left: l.arrowX,
          top: l.arrowY,
          [f]: 0,
          transformOrigin: {
            top: "",
            right: "0 0",
            bottom: "center 0",
            left: "100% 0"
          }[l.placedSide],
          transform: {
            top: "translateY(100%)",
            right: "translateY(50%) rotate(90deg) translateX(-50%)",
            bottom: "rotate(180deg)",
            left: "translateY(50%) rotate(-90deg) translateX(50%)"
          }[l.placedSide],
          visibility: l.shouldHideArrow ? "hidden" : void 0
        },
        children: /* @__PURE__ */ R.jsx(
          Mx,
          {
            ...s,
            ref: r,
            style: {
              ...s.style,
              // ensures the element can be measured correctly (mostly for if SVG)
              display: "block"
            }
          }
        )
      }
    )
  );
});
If.displayName = Wf;
function Fx(n) {
  return n !== null;
}
var $x = (n) => ({
  name: "transformOrigin",
  options: n,
  fn(i) {
    var L, I, $;
    const { placement: r, rects: a, middlewareData: s } = i, f = ((L = s.arrow) == null ? void 0 : L.centerOffset) !== 0, m = f ? 0 : n.arrowWidth, g = f ? 0 : n.arrowHeight, [p, w] = Ff(r), x = { start: "0%", center: "50%", end: "100%" }[w], T = (((I = s.arrow) == null ? void 0 : I.x) ?? 0) + m / 2, E = ((($ = s.arrow) == null ? void 0 : $.y) ?? 0) + g / 2;
    let O = "", k = "";
    return p === "bottom" ? (O = f ? x : `${T}px`, k = `${-g}px`) : p === "top" ? (O = f ? x : `${T}px`, k = `${a.floating.height + g}px`) : p === "right" ? (O = `${-g}px`, k = f ? x : `${E}px`) : p === "left" && (O = `${a.floating.width + g}px`, k = f ? x : `${E}px`), { data: { x: O, y: k } };
  }
});
function Ff(n) {
  const [i, r = "center"] = n.split("-");
  return [i, r];
}
var Ux = Mf, Hx = Lf, Bx = Nf, Yx = If;
function jx(n, i) {
  return S.useReducer((r, a) => i[r][a] ?? r, n);
}
var $f = (n) => {
  const { present: i, children: r } = n, a = Gx(i), s = typeof r == "function" ? r({ present: a.isPresent }) : S.Children.only(r), l = ur(a.ref, qx(s));
  return typeof r == "function" || a.isPresent ? S.cloneElement(s, { ref: l }) : null;
};
$f.displayName = "Presence";
function Gx(n) {
  const [i, r] = S.useState(), a = S.useRef(null), s = S.useRef(n), l = S.useRef("none"), f = n ? "mounted" : "unmounted", [m, g] = jx(f, {
    mounted: {
      UNMOUNT: "unmounted",
      ANIMATION_OUT: "unmountSuspended"
    },
    unmountSuspended: {
      MOUNT: "mounted",
      ANIMATION_END: "unmounted"
    },
    unmounted: {
      MOUNT: "mounted"
    }
  });
  return S.useEffect(() => {
    const p = bo(a.current);
    l.current = m === "mounted" ? p : "none";
  }, [m]), or(() => {
    const p = a.current, w = s.current;
    if (w !== n) {
      const T = l.current, E = bo(p);
      n ? g("MOUNT") : E === "none" || (p == null ? void 0 : p.display) === "none" ? g("UNMOUNT") : g(w && T !== E ? "ANIMATION_OUT" : "UNMOUNT"), s.current = n;
    }
  }, [n, g]), or(() => {
    if (i) {
      let p;
      const w = i.ownerDocument.defaultView ?? window, x = (E) => {
        const k = bo(a.current).includes(E.animationName);
        if (E.target === i && k && (g("ANIMATION_END"), !s.current)) {
          const L = i.style.animationFillMode;
          i.style.animationFillMode = "forwards", p = w.setTimeout(() => {
            i.style.animationFillMode === "forwards" && (i.style.animationFillMode = L);
          });
        }
      }, T = (E) => {
        E.target === i && (l.current = bo(a.current));
      };
      return i.addEventListener("animationstart", T), i.addEventListener("animationcancel", x), i.addEventListener("animationend", x), () => {
        w.clearTimeout(p), i.removeEventListener("animationstart", T), i.removeEventListener("animationcancel", x), i.removeEventListener("animationend", x);
      };
    } else
      g("ANIMATION_END");
  }, [i, g]), {
    isPresent: ["mounted", "unmountSuspended"].includes(m),
    ref: S.useCallback((p) => {
      a.current = p ? getComputedStyle(p) : null, r(p);
    }, [])
  };
}
function bo(n) {
  return (n == null ? void 0 : n.animationName) || "none";
}
function qx(n) {
  var a, s;
  let i = (a = Object.getOwnPropertyDescriptor(n.props, "ref")) == null ? void 0 : a.get, r = i && "isReactWarning" in i && i.isReactWarning;
  return r ? n.ref : (i = (s = Object.getOwnPropertyDescriptor(n, "ref")) == null ? void 0 : s.get, r = i && "isReactWarning" in i && i.isReactWarning, r ? n.props.ref : n.props.ref || n.ref);
}
var zx = S[" useInsertionEffect ".trim().toString()] || or;
function Vx({
  prop: n,
  defaultProp: i,
  onChange: r = () => {
  },
  caller: a
}) {
  const [s, l, f] = Xx({
    defaultProp: i,
    onChange: r
  }), m = n !== void 0, g = m ? n : s;
  {
    const w = S.useRef(n !== void 0);
    S.useEffect(() => {
      const x = w.current;
      x !== m && console.warn(
        `${a} is changing from ${x ? "controlled" : "uncontrolled"} to ${m ? "controlled" : "uncontrolled"}. Components should not switch from controlled to uncontrolled (or vice versa). Decide between using a controlled or uncontrolled value for the lifetime of the component.`
      ), w.current = m;
    }, [m, a]);
  }
  const p = S.useCallback(
    (w) => {
      var x;
      if (m) {
        const T = Kx(w) ? w(n) : w;
        T !== n && ((x = f.current) == null || x.call(f, T));
      } else
        l(w);
    },
    [m, n, l, f]
  );
  return [g, p];
}
function Xx({
  defaultProp: n,
  onChange: i
}) {
  const [r, a] = S.useState(n), s = S.useRef(r), l = S.useRef(i);
  return zx(() => {
    l.current = i;
  }, [i]), S.useEffect(() => {
    var f;
    s.current !== r && ((f = l.current) == null || f.call(l, r), s.current = r);
  }, [r, s]), [r, a, l];
}
function Kx(n) {
  return typeof n == "function";
}
var Qx = Object.freeze({
  // See: https://github.com/twbs/bootstrap/blob/main/scss/mixins/_visually-hidden.scss
  position: "absolute",
  border: 0,
  width: 1,
  height: 1,
  padding: 0,
  margin: -1,
  overflow: "hidden",
  clip: "rect(0, 0, 0, 0)",
  whiteSpace: "nowrap",
  wordWrap: "normal"
}), Jx = "VisuallyHidden", Uf = S.forwardRef(
  (n, i) => /* @__PURE__ */ R.jsx(
    lr.span,
    {
      ...n,
      ref: i,
      style: { ...Qx, ...n.style }
    }
  )
);
Uf.displayName = Jx;
var Zx = Uf, [Wo, B_] = gf("Tooltip", [
  Af
]), Io = Af(), Hf = "TooltipProvider", e1 = 700, Ts = "tooltip.open", [t1, Is] = Wo(Hf), Bf = (n) => {
  const {
    __scopeTooltip: i,
    delayDuration: r = e1,
    skipDelayDuration: a = 300,
    disableHoverableContent: s = !1,
    children: l
  } = n, f = S.useRef(!0), m = S.useRef(!1), g = S.useRef(0);
  return S.useEffect(() => {
    const p = g.current;
    return () => window.clearTimeout(p);
  }, []), /* @__PURE__ */ R.jsx(
    t1,
    {
      scope: i,
      isOpenDelayedRef: f,
      delayDuration: r,
      onOpen: S.useCallback(() => {
        window.clearTimeout(g.current), f.current = !1;
      }, []),
      onClose: S.useCallback(() => {
        window.clearTimeout(g.current), g.current = window.setTimeout(
          () => f.current = !0,
          a
        );
      }, [a]),
      isPointerInTransitRef: m,
      onPointerInTransitChange: S.useCallback((p) => {
        m.current = p;
      }, []),
      disableHoverableContent: s,
      children: l
    }
  );
};
Bf.displayName = Hf;
var bi = "Tooltip", [n1, Fo] = Wo(bi), Yf = (n) => {
  const {
    __scopeTooltip: i,
    children: r,
    open: a,
    defaultOpen: s,
    onOpenChange: l,
    disableHoverableContent: f,
    delayDuration: m
  } = n, g = Is(bi, n.__scopeTooltip), p = Io(i), [w, x] = S.useState(null), T = Db(), E = S.useRef(0), O = f ?? g.disableHoverableContent, k = m ?? g.delayDuration, L = S.useRef(!1), [I, $] = Vx({
    prop: a,
    defaultProp: s ?? !1,
    onChange: (j) => {
      j ? (g.onOpen(), document.dispatchEvent(new CustomEvent(Ts))) : g.onClose(), l == null || l(j);
    },
    caller: bi
  }), B = S.useMemo(() => I ? L.current ? "delayed-open" : "instant-open" : "closed", [I]), q = S.useCallback(() => {
    window.clearTimeout(E.current), E.current = 0, L.current = !1, $(!0);
  }, [$]), Y = S.useCallback(() => {
    window.clearTimeout(E.current), E.current = 0, $(!1);
  }, [$]), Q = S.useCallback(() => {
    window.clearTimeout(E.current), E.current = window.setTimeout(() => {
      L.current = !0, $(!0), E.current = 0;
    }, k);
  }, [k, $]);
  return S.useEffect(() => () => {
    E.current && (window.clearTimeout(E.current), E.current = 0);
  }, []), /* @__PURE__ */ R.jsx(Ux, { ...p, children: /* @__PURE__ */ R.jsx(
    n1,
    {
      scope: i,
      contentId: T,
      open: I,
      stateAttribute: B,
      trigger: w,
      onTriggerChange: x,
      onTriggerEnter: S.useCallback(() => {
        g.isOpenDelayedRef.current ? Q() : q();
      }, [g.isOpenDelayedRef, Q, q]),
      onTriggerLeave: S.useCallback(() => {
        O ? Y() : (window.clearTimeout(E.current), E.current = 0);
      }, [Y, O]),
      onOpen: q,
      onClose: Y,
      disableHoverableContent: O,
      children: r
    }
  ) });
};
Yf.displayName = bi;
var Es = "TooltipTrigger", jf = S.forwardRef(
  (n, i) => {
    const { __scopeTooltip: r, ...a } = n, s = Fo(Es, r), l = Is(Es, r), f = Io(r), m = S.useRef(null), g = ur(i, m, s.onTriggerChange), p = S.useRef(!1), w = S.useRef(!1), x = S.useCallback(() => p.current = !1, []);
    return S.useEffect(() => () => document.removeEventListener("pointerup", x), [x]), /* @__PURE__ */ R.jsx(Hx, { asChild: !0, ...f, children: /* @__PURE__ */ R.jsx(
      lr.button,
      {
        "aria-describedby": s.open ? s.contentId : void 0,
        "data-state": s.stateAttribute,
        ...a,
        ref: g,
        onPointerMove: Pn(n.onPointerMove, (T) => {
          T.pointerType !== "touch" && !w.current && !l.isPointerInTransitRef.current && (s.onTriggerEnter(), w.current = !0);
        }),
        onPointerLeave: Pn(n.onPointerLeave, () => {
          s.onTriggerLeave(), w.current = !1;
        }),
        onPointerDown: Pn(n.onPointerDown, () => {
          s.open && s.onClose(), p.current = !0, document.addEventListener("pointerup", x, { once: !0 });
        }),
        onFocus: Pn(n.onFocus, () => {
          p.current || s.onOpen();
        }),
        onBlur: Pn(n.onBlur, s.onClose),
        onClick: Pn(n.onClick, s.onClose)
      }
    ) });
  }
);
jf.displayName = Es;
var r1 = "TooltipPortal", [Y_, i1] = Wo(r1, {
  forceMount: void 0
}), Lr = "TooltipContent", Gf = S.forwardRef(
  (n, i) => {
    const r = i1(Lr, n.__scopeTooltip), { forceMount: a = r.forceMount, side: s = "top", ...l } = n, f = Fo(Lr, n.__scopeTooltip);
    return /* @__PURE__ */ R.jsx($f, { present: a || f.open, children: f.disableHoverableContent ? /* @__PURE__ */ R.jsx(qf, { side: s, ...l, ref: i }) : /* @__PURE__ */ R.jsx(o1, { side: s, ...l, ref: i }) });
  }
), o1 = S.forwardRef((n, i) => {
  const r = Fo(Lr, n.__scopeTooltip), a = Is(Lr, n.__scopeTooltip), s = S.useRef(null), l = ur(i, s), [f, m] = S.useState(null), { trigger: g, onClose: p } = r, w = s.current, { onPointerInTransitChange: x } = a, T = S.useCallback(() => {
    m(null), x(!1);
  }, [x]), E = S.useCallback(
    (O, k) => {
      const L = O.currentTarget, I = { x: O.clientX, y: O.clientY }, $ = c1(I, L.getBoundingClientRect()), B = f1(I, $), q = d1(k.getBoundingClientRect()), Y = g1([...B, ...q]);
      m(Y), x(!0);
    },
    [x]
  );
  return S.useEffect(() => () => T(), [T]), S.useEffect(() => {
    if (g && w) {
      const O = (L) => E(L, w), k = (L) => E(L, g);
      return g.addEventListener("pointerleave", O), w.addEventListener("pointerleave", k), () => {
        g.removeEventListener("pointerleave", O), w.removeEventListener("pointerleave", k);
      };
    }
  }, [g, w, E, T]), S.useEffect(() => {
    if (f) {
      const O = (k) => {
        const L = k.target, I = { x: k.clientX, y: k.clientY }, $ = (g == null ? void 0 : g.contains(L)) || (w == null ? void 0 : w.contains(L)), B = !h1(I, f);
        $ ? T() : B && (T(), p());
      };
      return document.addEventListener("pointermove", O), () => document.removeEventListener("pointermove", O);
    }
  }, [g, w, f, p, T]), /* @__PURE__ */ R.jsx(qf, { ...n, ref: l });
}), [a1, s1] = Wo(bi, { isInside: !1 }), u1 = /* @__PURE__ */ gb("TooltipContent"), qf = S.forwardRef(
  (n, i) => {
    const {
      __scopeTooltip: r,
      children: a,
      "aria-label": s,
      onEscapeKeyDown: l,
      onPointerDownOutside: f,
      ...m
    } = n, g = Fo(Lr, r), p = Io(r), { onClose: w } = g;
    return S.useEffect(() => (document.addEventListener(Ts, w), () => document.removeEventListener(Ts, w)), [w]), S.useEffect(() => {
      if (g.trigger) {
        const x = (T) => {
          const E = T.target;
          E != null && E.contains(g.trigger) && w();
        };
        return window.addEventListener("scroll", x, { capture: !0 }), () => window.removeEventListener("scroll", x, { capture: !0 });
      }
    }, [g.trigger, w]), /* @__PURE__ */ R.jsx(
      pf,
      {
        asChild: !0,
        disableOutsidePointerEvents: !1,
        onEscapeKeyDown: l,
        onPointerDownOutside: f,
        onFocusOutside: (x) => x.preventDefault(),
        onDismiss: w,
        children: /* @__PURE__ */ R.jsxs(
          Bx,
          {
            "data-state": g.stateAttribute,
            ...p,
            ...m,
            ref: i,
            style: {
              ...m.style,
              "--radix-tooltip-content-transform-origin": "var(--radix-popper-transform-origin)",
              "--radix-tooltip-content-available-width": "var(--radix-popper-available-width)",
              "--radix-tooltip-content-available-height": "var(--radix-popper-available-height)",
              "--radix-tooltip-trigger-width": "var(--radix-popper-anchor-width)",
              "--radix-tooltip-trigger-height": "var(--radix-popper-anchor-height)"
            },
            children: [
              /* @__PURE__ */ R.jsx(u1, { children: a }),
              /* @__PURE__ */ R.jsx(a1, { scope: r, isInside: !0, children: /* @__PURE__ */ R.jsx(Zx, { id: g.contentId, role: "tooltip", children: s || a }) })
            ]
          }
        )
      }
    );
  }
);
Gf.displayName = Lr;
var zf = "TooltipArrow", l1 = S.forwardRef(
  (n, i) => {
    const { __scopeTooltip: r, ...a } = n, s = Io(r);
    return s1(
      zf,
      r
    ).isInside ? null : /* @__PURE__ */ R.jsx(Yx, { ...s, ...a, ref: i });
  }
);
l1.displayName = zf;
function c1(n, i) {
  const r = Math.abs(i.top - n.y), a = Math.abs(i.bottom - n.y), s = Math.abs(i.right - n.x), l = Math.abs(i.left - n.x);
  switch (Math.min(r, a, s, l)) {
    case l:
      return "left";
    case s:
      return "right";
    case r:
      return "top";
    case a:
      return "bottom";
    default:
      throw new Error("unreachable");
  }
}
function f1(n, i, r = 5) {
  const a = [];
  switch (i) {
    case "top":
      a.push(
        { x: n.x - r, y: n.y + r },
        { x: n.x + r, y: n.y + r }
      );
      break;
    case "bottom":
      a.push(
        { x: n.x - r, y: n.y - r },
        { x: n.x + r, y: n.y - r }
      );
      break;
    case "left":
      a.push(
        { x: n.x + r, y: n.y - r },
        { x: n.x + r, y: n.y + r }
      );
      break;
    case "right":
      a.push(
        { x: n.x - r, y: n.y - r },
        { x: n.x - r, y: n.y + r }
      );
      break;
  }
  return a;
}
function d1(n) {
  const { top: i, right: r, bottom: a, left: s } = n;
  return [
    { x: s, y: i },
    { x: r, y: i },
    { x: r, y: a },
    { x: s, y: a }
  ];
}
function h1(n, i) {
  const { x: r, y: a } = n;
  let s = !1;
  for (let l = 0, f = i.length - 1; l < i.length; f = l++) {
    const m = i[l], g = i[f], p = m.x, w = m.y, x = g.x, T = g.y;
    w > a != T > a && r < (x - p) * (a - w) / (T - w) + p && (s = !s);
  }
  return s;
}
function g1(n) {
  const i = n.slice();
  return i.sort((r, a) => r.x < a.x ? -1 : r.x > a.x ? 1 : r.y < a.y ? -1 : r.y > a.y ? 1 : 0), m1(i);
}
function m1(n) {
  if (n.length <= 1) return n.slice();
  const i = [];
  for (let a = 0; a < n.length; a++) {
    const s = n[a];
    for (; i.length >= 2; ) {
      const l = i[i.length - 1], f = i[i.length - 2];
      if ((l.x - f.x) * (s.y - f.y) >= (l.y - f.y) * (s.x - f.x)) i.pop();
      else break;
    }
    i.push(s);
  }
  i.pop();
  const r = [];
  for (let a = n.length - 1; a >= 0; a--) {
    const s = n[a];
    for (; r.length >= 2; ) {
      const l = r[r.length - 1], f = r[r.length - 2];
      if ((l.x - f.x) * (s.y - f.y) >= (l.y - f.y) * (s.x - f.x)) r.pop();
      else break;
    }
    r.push(s);
  }
  return r.pop(), i.length === 1 && r.length === 1 && i[0].x === r[0].x && i[0].y === r[0].y ? i : i.concat(r);
}
var p1 = Bf, v1 = Yf, w1 = jf, Vf = Gf;
const y1 = p1, b1 = v1, x1 = w1, Xf = S.forwardRef(({ className: n, sideOffset: i = 4, ...r }, a) => /* @__PURE__ */ R.jsx(
  Vf,
  {
    ref: a,
    sideOffset: i,
    className: qn(
      "z-50 overflow-hidden rounded-md border bg-popover px-3 py-1.5 text-sm text-popover-foreground shadow-md animate-in fade-in-0 zoom-in-95 data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=closed]:zoom-out-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2",
      n
    ),
    ...r
  }
));
Xf.displayName = Vf.displayName;
const Wc = ({
  date: n,
  day: i,
  count: r,
  blockSize: a = 14,
  blockRadius: s = 2,
  isHighlighted: l,
  onClick: f,
  onMouseEnter: m,
  onMouseLeave: g,
  color: p,
  shouldFade: w
}) => /* @__PURE__ */ R.jsx(y1, { children: /* @__PURE__ */ R.jsxs(b1, { open: l, children: [
  /* @__PURE__ */ R.jsx(x1, { onClick: f, onMouseEnter: m, onMouseLeave: g, children: /* @__PURE__ */ R.jsx(
    "div",
    {
      className: "transition-all duration-200",
      style: {
        width: a,
        height: a,
        borderRadius: s,
        backgroundColor: p,
        opacity: w ? 0.3 : 1,
        transform: l ? "scale(1.1)" : "scale(1)",
        // Apply border when cell is selected (clicked)
        border: l && !m ? "2px solid black" : "none"
      }
    }
  ) }),
  /* @__PURE__ */ R.jsx(Xf, { side: "top", className: "z-[100]", children: /* @__PURE__ */ R.jsxs("div", { className: "text-sm", children: [
    /* @__PURE__ */ R.jsx("div", { children: Mr(i, "MMMM d, yyyy") }),
    /* @__PURE__ */ R.jsxs("div", { children: [
      r,
      " contribution",
      r !== 1 ? "s" : ""
    ] })
  ] }) })
] }) }), _1 = (n, i) => n === 0 ? i.noContributions : n <= 2 ? i.low : n <= 4 ? i.moderate : n <= 6 ? i.high : i.veryHigh, C1 = (n) => n === 0 ? "noContributions" : n <= 2 ? "low" : n <= 4 ? "moderate" : n <= 6 ? "high" : "veryHigh", Ic = (n) => {
  const i = /* @__PURE__ */ new Date();
  return n ? {
    startDate: new Date(n, 0, 1),
    endDate: new Date(n, 11, 31)
  } : {
    startDate: by(i, 1),
    endDate: i
  };
}, T1 = (n, i) => w0({ start: n, end: i }), Kf = (n) => v0({
  start: n,
  end: Vc(n, 6)
}), E1 = (n, i) => {
  var a;
  const r = Mr(i, "yyyy-MM-dd");
  return ((a = n.find((s) => s.date === r)) == null ? void 0 : a.count) || 0;
}, O1 = (n) => n.reduce((i, r) => i + r.count, 0), P1 = (n) => {
  if (n.length === 0) return [];
  const i = [];
  for (let r = 0; r < n.length; r++) {
    const a = n[r], s = Kf(a);
    for (let l = 0; l < s.length; l++) {
      const f = s[l];
      if (f.getDate() === 1) {
        const m = Mr(f, "MMM");
        i.some((p) => p.label === m) || i.push({
          label: m,
          index: r
        });
      }
    }
  }
  return i.sort((r, a) => r.index - a.index);
}, S1 = (n) => {
  if (!n) return "No contributions found";
  const i = new Date(n), r = i.getDate(), a = Mr(i, "MMM"), s = i.getFullYear();
  let l = "th";
  return r % 10 === 1 && r !== 11 ? l = "st" : r % 10 === 2 && r !== 12 ? l = "nd" : r % 10 === 3 && r !== 13 && (l = "rd"), `${a} ${r}${l}, ${s}`;
}, R1 = (n) => {
  let i = null;
  for (let r = n.length - 1; r >= 0; r--)
    if (n[r].count > 0) {
      i = n[r].date;
      break;
    }
  return S1(i);
}, Fc = {
  background: "#0d1117",
  text: "#e6edf3",
  border: "#30363d",
  dayBackground: "rgba(255, 255, 255, 0.05)",
  muted: "#8b949e",
  accent: "#161b22"
}, $c = {
  background: "#ffffff",
  text: "#24292f",
  border: "#d0d7de",
  dayBackground: "rgba(0, 0, 0, 0.05)",
  muted: "#57606a",
  accent: "#f6f8fa"
}, Fs = (n) => n === "dark" || n === "system" && typeof window < "u" && window.matchMedia && window.matchMedia("(prefers-color-scheme: dark)").matches ? Fc : $c, A1 = ({
  formattedDate: n,
  contributionCount: i,
  details: r,
  isLoading: a,
  fontSize: s = 14,
  colorScheme: l = "light"
}) => {
  const f = Fs(l);
  return /* @__PURE__ */ R.jsxs(
    "div",
    {
      className: "p-4 rounded-md space-y-2",
      style: {
        backgroundColor: f.accent,
        fontSize: `${s}px`
      },
      children: [
        /* @__PURE__ */ R.jsx("h3", { className: "font-medium text-lg", style: { color: f.text }, children: n }),
        a ? /* @__PURE__ */ R.jsxs("div", { className: "animate-pulse space-y-2 mt-2", children: [
          /* @__PURE__ */ R.jsx("div", { className: "h-4 rounded w-3/4", style: { backgroundColor: f.dayBackground } }),
          /* @__PURE__ */ R.jsx("div", { className: "h-4 rounded w-1/2", style: { backgroundColor: f.dayBackground } })
        ] }) : i === 0 ? /* @__PURE__ */ R.jsx("p", { style: { color: f.muted }, children: "No activity on this day" }) : /* @__PURE__ */ R.jsxs("div", { className: "space-y-2 mt-2", children: [
          /* @__PURE__ */ R.jsxs("p", { className: "font-medium", style: { color: f.text }, children: [
            i,
            " total contribution",
            i !== 1 ? "s" : ""
          ] }),
          /* @__PURE__ */ R.jsxs("div", { className: "grid grid-cols-2 gap-2 text-sm", children: [
            /* @__PURE__ */ R.jsxs("div", { className: "flex items-center gap-2", children: [
              /* @__PURE__ */ R.jsx(Ty, { className: "h-4 w-4", style: { color: f.text } }),
              /* @__PURE__ */ R.jsxs("span", { style: { color: f.text }, children: [
                (r == null ? void 0 : r.commits) || 0,
                " commits"
              ] })
            ] }),
            /* @__PURE__ */ R.jsxs("div", { className: "flex items-center gap-2", children: [
              /* @__PURE__ */ R.jsx(Oy, { className: "h-4 w-4", style: { color: f.text } }),
              /* @__PURE__ */ R.jsxs("span", { style: { color: f.text }, children: [
                (r == null ? void 0 : r.pullRequests) || 0,
                " pull requests"
              ] })
            ] }),
            /* @__PURE__ */ R.jsxs("div", { className: "flex items-center gap-2", children: [
              /* @__PURE__ */ R.jsx(Ey, { className: "h-4 w-4", style: { color: f.text } }),
              /* @__PURE__ */ R.jsxs("span", { style: { color: f.text }, children: [
                (r == null ? void 0 : r.mergeRequests) || 0,
                " merge requests"
              ] })
            ] }),
            /* @__PURE__ */ R.jsxs("div", { className: "flex items-center gap-2", children: [
              /* @__PURE__ */ R.jsx(Cy, { className: "h-4 w-4", style: { color: f.text } }),
              /* @__PURE__ */ R.jsxs("span", { style: { color: f.text }, children: [
                (r == null ? void 0 : r.branchesContributed) || 0,
                " branches"
              ] })
            ] })
          ] })
        ] })
      ]
    }
  );
}, k1 = ({
  theme: n,
  colorScheme: i = "light",
  onLevelClick: r,
  selectedLevel: a,
  blockSize: s = 14,
  blockRadius: l = 2,
  fontSize: f = 13
}) => {
  const m = Fs(i), g = [
    "noContributions",
    "low",
    "moderate",
    "high",
    "veryHigh"
  ];
  return /* @__PURE__ */ R.jsxs(
    "div",
    {
      className: "flex items-center justify-end space-x-2 text-sm",
      style: { fontSize: `${f}px` },
      children: [
        /* @__PURE__ */ R.jsx("span", { style: { color: m.muted }, children: "Less" }),
        /* @__PURE__ */ R.jsx("div", { className: "flex space-x-1", children: g.map((p) => /* @__PURE__ */ R.jsx(
          "div",
          {
            className: "cursor-pointer transition-all duration-200",
            style: {
              width: s,
              height: s,
              borderRadius: l,
              backgroundColor: n[p],
              transform: a === p ? "scale(1.1)" : "scale(1)",
              opacity: a && a !== p ? 0.3 : 1,
              boxShadow: a === p ? "0 0 0 2px rgba(0,0,0,0.1)" : "none"
            },
            onClick: () => r(p)
          },
          p
        )) }),
        /* @__PURE__ */ R.jsx("span", { style: { color: m.muted }, children: "More" })
      ]
    }
  );
};
function an(n) {
  const i = Object.prototype.toString.call(n);
  return n instanceof Date || typeof n == "object" && i === "[object Date]" ? new n.constructor(+n) : typeof n == "number" || i === "[object Number]" || typeof n == "string" || i === "[object String]" ? new Date(n) : /* @__PURE__ */ new Date(NaN);
}
function sr(n, i) {
  return n instanceof Date ? new n.constructor(i) : new Date(i);
}
const Qf = 6048e5, M1 = 864e5;
let D1 = {};
function $o() {
  return D1;
}
function xi(n, i) {
  var m, g, p, w;
  const r = $o(), a = (i == null ? void 0 : i.weekStartsOn) ?? ((g = (m = i == null ? void 0 : i.locale) == null ? void 0 : m.options) == null ? void 0 : g.weekStartsOn) ?? r.weekStartsOn ?? ((w = (p = r.locale) == null ? void 0 : p.options) == null ? void 0 : w.weekStartsOn) ?? 0, s = an(n), l = s.getDay(), f = (l < a ? 7 : 0) + l - a;
  return s.setDate(s.getDate() - f), s.setHours(0, 0, 0, 0), s;
}
function ko(n) {
  return xi(n, { weekStartsOn: 1 });
}
function Jf(n) {
  const i = an(n), r = i.getFullYear(), a = sr(n, 0);
  a.setFullYear(r + 1, 0, 4), a.setHours(0, 0, 0, 0);
  const s = ko(a), l = sr(n, 0);
  l.setFullYear(r, 0, 4), l.setHours(0, 0, 0, 0);
  const f = ko(l);
  return i.getTime() >= s.getTime() ? r + 1 : i.getTime() >= f.getTime() ? r : r - 1;
}
function Uc(n) {
  const i = an(n);
  return i.setHours(0, 0, 0, 0), i;
}
function Hc(n) {
  const i = an(n), r = new Date(
    Date.UTC(
      i.getFullYear(),
      i.getMonth(),
      i.getDate(),
      i.getHours(),
      i.getMinutes(),
      i.getSeconds(),
      i.getMilliseconds()
    )
  );
  return r.setUTCFullYear(i.getFullYear()), +n - +r;
}
function L1(n, i) {
  const r = Uc(n), a = Uc(i), s = +r - Hc(r), l = +a - Hc(a);
  return Math.round((s - l) / M1);
}
function N1(n) {
  const i = Jf(n), r = sr(n, 0);
  return r.setFullYear(i, 0, 4), r.setHours(0, 0, 0, 0), ko(r);
}
function W1(n) {
  return n instanceof Date || typeof n == "object" && Object.prototype.toString.call(n) === "[object Date]";
}
function I1(n) {
  if (!W1(n) && typeof n != "number")
    return !1;
  const i = an(n);
  return !isNaN(Number(i));
}
function F1(n) {
  const i = an(n), r = sr(n, 0);
  return r.setFullYear(i.getFullYear(), 0, 1), r.setHours(0, 0, 0, 0), r;
}
const $1 = {
  lessThanXSeconds: {
    one: "less than a second",
    other: "less than {{count}} seconds"
  },
  xSeconds: {
    one: "1 second",
    other: "{{count}} seconds"
  },
  halfAMinute: "half a minute",
  lessThanXMinutes: {
    one: "less than a minute",
    other: "less than {{count}} minutes"
  },
  xMinutes: {
    one: "1 minute",
    other: "{{count}} minutes"
  },
  aboutXHours: {
    one: "about 1 hour",
    other: "about {{count}} hours"
  },
  xHours: {
    one: "1 hour",
    other: "{{count}} hours"
  },
  xDays: {
    one: "1 day",
    other: "{{count}} days"
  },
  aboutXWeeks: {
    one: "about 1 week",
    other: "about {{count}} weeks"
  },
  xWeeks: {
    one: "1 week",
    other: "{{count}} weeks"
  },
  aboutXMonths: {
    one: "about 1 month",
    other: "about {{count}} months"
  },
  xMonths: {
    one: "1 month",
    other: "{{count}} months"
  },
  aboutXYears: {
    one: "about 1 year",
    other: "about {{count}} years"
  },
  xYears: {
    one: "1 year",
    other: "{{count}} years"
  },
  overXYears: {
    one: "over 1 year",
    other: "over {{count}} years"
  },
  almostXYears: {
    one: "almost 1 year",
    other: "almost {{count}} years"
  }
}, U1 = (n, i, r) => {
  let a;
  const s = $1[n];
  return typeof s == "string" ? a = s : i === 1 ? a = s.one : a = s.other.replace("{{count}}", i.toString()), r != null && r.addSuffix ? r.comparison && r.comparison > 0 ? "in " + a : a + " ago" : a;
};
function ds(n) {
  return (i = {}) => {
    const r = i.width ? String(i.width) : n.defaultWidth;
    return n.formats[r] || n.formats[n.defaultWidth];
  };
}
const H1 = {
  full: "EEEE, MMMM do, y",
  long: "MMMM do, y",
  medium: "MMM d, y",
  short: "MM/dd/yyyy"
}, B1 = {
  full: "h:mm:ss a zzzz",
  long: "h:mm:ss a z",
  medium: "h:mm:ss a",
  short: "h:mm a"
}, Y1 = {
  full: "{{date}} 'at' {{time}}",
  long: "{{date}} 'at' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, j1 = {
  date: ds({
    formats: H1,
    defaultWidth: "full"
  }),
  time: ds({
    formats: B1,
    defaultWidth: "full"
  }),
  dateTime: ds({
    formats: Y1,
    defaultWidth: "full"
  })
}, G1 = {
  lastWeek: "'last' eeee 'at' p",
  yesterday: "'yesterday at' p",
  today: "'today at' p",
  tomorrow: "'tomorrow at' p",
  nextWeek: "eeee 'at' p",
  other: "P"
}, q1 = (n, i, r, a) => G1[n];
function pi(n) {
  return (i, r) => {
    const a = r != null && r.context ? String(r.context) : "standalone";
    let s;
    if (a === "formatting" && n.formattingValues) {
      const f = n.defaultFormattingWidth || n.defaultWidth, m = r != null && r.width ? String(r.width) : f;
      s = n.formattingValues[m] || n.formattingValues[f];
    } else {
      const f = n.defaultWidth, m = r != null && r.width ? String(r.width) : n.defaultWidth;
      s = n.values[m] || n.values[f];
    }
    const l = n.argumentCallback ? n.argumentCallback(i) : i;
    return s[l];
  };
}
const z1 = {
  narrow: ["B", "A"],
  abbreviated: ["BC", "AD"],
  wide: ["Before Christ", "Anno Domini"]
}, V1 = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["Q1", "Q2", "Q3", "Q4"],
  wide: ["1st quarter", "2nd quarter", "3rd quarter", "4th quarter"]
}, X1 = {
  narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
  abbreviated: [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec"
  ],
  wide: [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December"
  ]
}, K1 = {
  narrow: ["S", "M", "T", "W", "T", "F", "S"],
  short: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"],
  abbreviated: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
  wide: [
    "Sunday",
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday"
  ]
}, Q1 = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  }
}, J1 = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  }
}, Z1 = (n, i) => {
  const r = Number(n), a = r % 100;
  if (a > 20 || a < 10)
    switch (a % 10) {
      case 1:
        return r + "st";
      case 2:
        return r + "nd";
      case 3:
        return r + "rd";
    }
  return r + "th";
}, e_ = {
  ordinalNumber: Z1,
  era: pi({
    values: z1,
    defaultWidth: "wide"
  }),
  quarter: pi({
    values: V1,
    defaultWidth: "wide",
    argumentCallback: (n) => n - 1
  }),
  month: pi({
    values: X1,
    defaultWidth: "wide"
  }),
  day: pi({
    values: K1,
    defaultWidth: "wide"
  }),
  dayPeriod: pi({
    values: Q1,
    defaultWidth: "wide",
    formattingValues: J1,
    defaultFormattingWidth: "wide"
  })
};
function vi(n) {
  return (i, r = {}) => {
    const a = r.width, s = a && n.matchPatterns[a] || n.matchPatterns[n.defaultMatchWidth], l = i.match(s);
    if (!l)
      return null;
    const f = l[0], m = a && n.parsePatterns[a] || n.parsePatterns[n.defaultParseWidth], g = Array.isArray(m) ? n_(m, (x) => x.test(f)) : (
      // eslint-disable-next-line @typescript-eslint/no-explicit-any -- I challange you to fix the type
      t_(m, (x) => x.test(f))
    );
    let p;
    p = n.valueCallback ? n.valueCallback(g) : g, p = r.valueCallback ? (
      // eslint-disable-next-line @typescript-eslint/no-explicit-any -- I challange you to fix the type
      r.valueCallback(p)
    ) : p;
    const w = i.slice(f.length);
    return { value: p, rest: w };
  };
}
function t_(n, i) {
  for (const r in n)
    if (Object.prototype.hasOwnProperty.call(n, r) && i(n[r]))
      return r;
}
function n_(n, i) {
  for (let r = 0; r < n.length; r++)
    if (i(n[r]))
      return r;
}
function r_(n) {
  return (i, r = {}) => {
    const a = i.match(n.matchPattern);
    if (!a) return null;
    const s = a[0], l = i.match(n.parsePattern);
    if (!l) return null;
    let f = n.valueCallback ? n.valueCallback(l[0]) : l[0];
    f = r.valueCallback ? r.valueCallback(f) : f;
    const m = i.slice(s.length);
    return { value: f, rest: m };
  };
}
const i_ = /^(\d+)(th|st|nd|rd)?/i, o_ = /\d+/i, a_ = {
  narrow: /^(b|a)/i,
  abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
  wide: /^(before christ|before common era|anno domini|common era)/i
}, s_ = {
  any: [/^b/i, /^(a|c)/i]
}, u_ = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234](th|st|nd|rd)? quarter/i
}, l_ = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, c_ = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
  wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
}, f_ = {
  narrow: [
    /^j/i,
    /^f/i,
    /^m/i,
    /^a/i,
    /^m/i,
    /^j/i,
    /^j/i,
    /^a/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ],
  any: [
    /^ja/i,
    /^f/i,
    /^mar/i,
    /^ap/i,
    /^may/i,
    /^jun/i,
    /^jul/i,
    /^au/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ]
}, d_ = {
  narrow: /^[smtwf]/i,
  short: /^(su|mo|tu|we|th|fr|sa)/i,
  abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
  wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
}, h_ = {
  narrow: [/^s/i, /^m/i, /^t/i, /^w/i, /^t/i, /^f/i, /^s/i],
  any: [/^su/i, /^m/i, /^tu/i, /^w/i, /^th/i, /^f/i, /^sa/i]
}, g_ = {
  narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
  any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
}, m_ = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^mi/i,
    noon: /^no/i,
    morning: /morning/i,
    afternoon: /afternoon/i,
    evening: /evening/i,
    night: /night/i
  }
}, p_ = {
  ordinalNumber: r_({
    matchPattern: i_,
    parsePattern: o_,
    valueCallback: (n) => parseInt(n, 10)
  }),
  era: vi({
    matchPatterns: a_,
    defaultMatchWidth: "wide",
    parsePatterns: s_,
    defaultParseWidth: "any"
  }),
  quarter: vi({
    matchPatterns: u_,
    defaultMatchWidth: "wide",
    parsePatterns: l_,
    defaultParseWidth: "any",
    valueCallback: (n) => n + 1
  }),
  month: vi({
    matchPatterns: c_,
    defaultMatchWidth: "wide",
    parsePatterns: f_,
    defaultParseWidth: "any"
  }),
  day: vi({
    matchPatterns: d_,
    defaultMatchWidth: "wide",
    parsePatterns: h_,
    defaultParseWidth: "any"
  }),
  dayPeriod: vi({
    matchPatterns: g_,
    defaultMatchWidth: "any",
    parsePatterns: m_,
    defaultParseWidth: "any"
  })
}, v_ = {
  code: "en-US",
  formatDistance: U1,
  formatLong: j1,
  formatRelative: q1,
  localize: e_,
  match: p_,
  options: {
    weekStartsOn: 0,
    firstWeekContainsDate: 1
  }
};
function w_(n) {
  const i = an(n);
  return L1(i, F1(i)) + 1;
}
function y_(n) {
  const i = an(n), r = +ko(i) - +N1(i);
  return Math.round(r / Qf) + 1;
}
function Zf(n, i) {
  var w, x, T, E;
  const r = an(n), a = r.getFullYear(), s = $o(), l = (i == null ? void 0 : i.firstWeekContainsDate) ?? ((x = (w = i == null ? void 0 : i.locale) == null ? void 0 : w.options) == null ? void 0 : x.firstWeekContainsDate) ?? s.firstWeekContainsDate ?? ((E = (T = s.locale) == null ? void 0 : T.options) == null ? void 0 : E.firstWeekContainsDate) ?? 1, f = sr(n, 0);
  f.setFullYear(a + 1, 0, l), f.setHours(0, 0, 0, 0);
  const m = xi(f, i), g = sr(n, 0);
  g.setFullYear(a, 0, l), g.setHours(0, 0, 0, 0);
  const p = xi(g, i);
  return r.getTime() >= m.getTime() ? a + 1 : r.getTime() >= p.getTime() ? a : a - 1;
}
function b_(n, i) {
  var m, g, p, w;
  const r = $o(), a = (i == null ? void 0 : i.firstWeekContainsDate) ?? ((g = (m = i == null ? void 0 : i.locale) == null ? void 0 : m.options) == null ? void 0 : g.firstWeekContainsDate) ?? r.firstWeekContainsDate ?? ((w = (p = r.locale) == null ? void 0 : p.options) == null ? void 0 : w.firstWeekContainsDate) ?? 1, s = Zf(n, i), l = sr(n, 0);
  return l.setFullYear(s, 0, a), l.setHours(0, 0, 0, 0), xi(l, i);
}
function x_(n, i) {
  const r = an(n), a = +xi(r, i) - +b_(r, i);
  return Math.round(a / Qf) + 1;
}
function We(n, i) {
  const r = n < 0 ? "-" : "", a = Math.abs(n).toString().padStart(i, "0");
  return r + a;
}
const Yn = {
  // Year
  y(n, i) {
    const r = n.getFullYear(), a = r > 0 ? r : 1 - r;
    return We(i === "yy" ? a % 100 : a, i.length);
  },
  // Month
  M(n, i) {
    const r = n.getMonth();
    return i === "M" ? String(r + 1) : We(r + 1, 2);
  },
  // Day of the month
  d(n, i) {
    return We(n.getDate(), i.length);
  },
  // AM or PM
  a(n, i) {
    const r = n.getHours() / 12 >= 1 ? "pm" : "am";
    switch (i) {
      case "a":
      case "aa":
        return r.toUpperCase();
      case "aaa":
        return r;
      case "aaaaa":
        return r[0];
      case "aaaa":
      default:
        return r === "am" ? "a.m." : "p.m.";
    }
  },
  // Hour [1-12]
  h(n, i) {
    return We(n.getHours() % 12 || 12, i.length);
  },
  // Hour [0-23]
  H(n, i) {
    return We(n.getHours(), i.length);
  },
  // Minute
  m(n, i) {
    return We(n.getMinutes(), i.length);
  },
  // Second
  s(n, i) {
    return We(n.getSeconds(), i.length);
  },
  // Fraction of second
  S(n, i) {
    const r = i.length, a = n.getMilliseconds(), s = Math.trunc(
      a * Math.pow(10, r - 3)
    );
    return We(s, i.length);
  }
}, Ar = {
  midnight: "midnight",
  noon: "noon",
  morning: "morning",
  afternoon: "afternoon",
  evening: "evening",
  night: "night"
}, Bc = {
  // Era
  G: function(n, i, r) {
    const a = n.getFullYear() > 0 ? 1 : 0;
    switch (i) {
      case "G":
      case "GG":
      case "GGG":
        return r.era(a, { width: "abbreviated" });
      case "GGGGG":
        return r.era(a, { width: "narrow" });
      case "GGGG":
      default:
        return r.era(a, { width: "wide" });
    }
  },
  // Year
  y: function(n, i, r) {
    if (i === "yo") {
      const a = n.getFullYear(), s = a > 0 ? a : 1 - a;
      return r.ordinalNumber(s, { unit: "year" });
    }
    return Yn.y(n, i);
  },
  // Local week-numbering year
  Y: function(n, i, r, a) {
    const s = Zf(n, a), l = s > 0 ? s : 1 - s;
    if (i === "YY") {
      const f = l % 100;
      return We(f, 2);
    }
    return i === "Yo" ? r.ordinalNumber(l, { unit: "year" }) : We(l, i.length);
  },
  // ISO week-numbering year
  R: function(n, i) {
    const r = Jf(n);
    return We(r, i.length);
  },
  // Extended year. This is a single number designating the year of this calendar system.
  // The main difference between `y` and `u` localizers are B.C. years:
  // | Year | `y` | `u` |
  // |------|-----|-----|
  // | AC 1 |   1 |   1 |
  // | BC 1 |   1 |   0 |
  // | BC 2 |   2 |  -1 |
  // Also `yy` always returns the last two digits of a year,
  // while `uu` pads single digit years to 2 characters and returns other years unchanged.
  u: function(n, i) {
    const r = n.getFullYear();
    return We(r, i.length);
  },
  // Quarter
  Q: function(n, i, r) {
    const a = Math.ceil((n.getMonth() + 1) / 3);
    switch (i) {
      case "Q":
        return String(a);
      case "QQ":
        return We(a, 2);
      case "Qo":
        return r.ordinalNumber(a, { unit: "quarter" });
      case "QQQ":
        return r.quarter(a, {
          width: "abbreviated",
          context: "formatting"
        });
      case "QQQQQ":
        return r.quarter(a, {
          width: "narrow",
          context: "formatting"
        });
      case "QQQQ":
      default:
        return r.quarter(a, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone quarter
  q: function(n, i, r) {
    const a = Math.ceil((n.getMonth() + 1) / 3);
    switch (i) {
      case "q":
        return String(a);
      case "qq":
        return We(a, 2);
      case "qo":
        return r.ordinalNumber(a, { unit: "quarter" });
      case "qqq":
        return r.quarter(a, {
          width: "abbreviated",
          context: "standalone"
        });
      case "qqqqq":
        return r.quarter(a, {
          width: "narrow",
          context: "standalone"
        });
      case "qqqq":
      default:
        return r.quarter(a, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // Month
  M: function(n, i, r) {
    const a = n.getMonth();
    switch (i) {
      case "M":
      case "MM":
        return Yn.M(n, i);
      case "Mo":
        return r.ordinalNumber(a + 1, { unit: "month" });
      case "MMM":
        return r.month(a, {
          width: "abbreviated",
          context: "formatting"
        });
      case "MMMMM":
        return r.month(a, {
          width: "narrow",
          context: "formatting"
        });
      case "MMMM":
      default:
        return r.month(a, { width: "wide", context: "formatting" });
    }
  },
  // Stand-alone month
  L: function(n, i, r) {
    const a = n.getMonth();
    switch (i) {
      case "L":
        return String(a + 1);
      case "LL":
        return We(a + 1, 2);
      case "Lo":
        return r.ordinalNumber(a + 1, { unit: "month" });
      case "LLL":
        return r.month(a, {
          width: "abbreviated",
          context: "standalone"
        });
      case "LLLLL":
        return r.month(a, {
          width: "narrow",
          context: "standalone"
        });
      case "LLLL":
      default:
        return r.month(a, { width: "wide", context: "standalone" });
    }
  },
  // Local week of year
  w: function(n, i, r, a) {
    const s = x_(n, a);
    return i === "wo" ? r.ordinalNumber(s, { unit: "week" }) : We(s, i.length);
  },
  // ISO week of year
  I: function(n, i, r) {
    const a = y_(n);
    return i === "Io" ? r.ordinalNumber(a, { unit: "week" }) : We(a, i.length);
  },
  // Day of the month
  d: function(n, i, r) {
    return i === "do" ? r.ordinalNumber(n.getDate(), { unit: "date" }) : Yn.d(n, i);
  },
  // Day of year
  D: function(n, i, r) {
    const a = w_(n);
    return i === "Do" ? r.ordinalNumber(a, { unit: "dayOfYear" }) : We(a, i.length);
  },
  // Day of week
  E: function(n, i, r) {
    const a = n.getDay();
    switch (i) {
      case "E":
      case "EE":
      case "EEE":
        return r.day(a, {
          width: "abbreviated",
          context: "formatting"
        });
      case "EEEEE":
        return r.day(a, {
          width: "narrow",
          context: "formatting"
        });
      case "EEEEEE":
        return r.day(a, {
          width: "short",
          context: "formatting"
        });
      case "EEEE":
      default:
        return r.day(a, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Local day of week
  e: function(n, i, r, a) {
    const s = n.getDay(), l = (s - a.weekStartsOn + 8) % 7 || 7;
    switch (i) {
      case "e":
        return String(l);
      case "ee":
        return We(l, 2);
      case "eo":
        return r.ordinalNumber(l, { unit: "day" });
      case "eee":
        return r.day(s, {
          width: "abbreviated",
          context: "formatting"
        });
      case "eeeee":
        return r.day(s, {
          width: "narrow",
          context: "formatting"
        });
      case "eeeeee":
        return r.day(s, {
          width: "short",
          context: "formatting"
        });
      case "eeee":
      default:
        return r.day(s, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone local day of week
  c: function(n, i, r, a) {
    const s = n.getDay(), l = (s - a.weekStartsOn + 8) % 7 || 7;
    switch (i) {
      case "c":
        return String(l);
      case "cc":
        return We(l, i.length);
      case "co":
        return r.ordinalNumber(l, { unit: "day" });
      case "ccc":
        return r.day(s, {
          width: "abbreviated",
          context: "standalone"
        });
      case "ccccc":
        return r.day(s, {
          width: "narrow",
          context: "standalone"
        });
      case "cccccc":
        return r.day(s, {
          width: "short",
          context: "standalone"
        });
      case "cccc":
      default:
        return r.day(s, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // ISO day of week
  i: function(n, i, r) {
    const a = n.getDay(), s = a === 0 ? 7 : a;
    switch (i) {
      case "i":
        return String(s);
      case "ii":
        return We(s, i.length);
      case "io":
        return r.ordinalNumber(s, { unit: "day" });
      case "iii":
        return r.day(a, {
          width: "abbreviated",
          context: "formatting"
        });
      case "iiiii":
        return r.day(a, {
          width: "narrow",
          context: "formatting"
        });
      case "iiiiii":
        return r.day(a, {
          width: "short",
          context: "formatting"
        });
      case "iiii":
      default:
        return r.day(a, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // AM or PM
  a: function(n, i, r) {
    const s = n.getHours() / 12 >= 1 ? "pm" : "am";
    switch (i) {
      case "a":
      case "aa":
        return r.dayPeriod(s, {
          width: "abbreviated",
          context: "formatting"
        });
      case "aaa":
        return r.dayPeriod(s, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "aaaaa":
        return r.dayPeriod(s, {
          width: "narrow",
          context: "formatting"
        });
      case "aaaa":
      default:
        return r.dayPeriod(s, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // AM, PM, midnight, noon
  b: function(n, i, r) {
    const a = n.getHours();
    let s;
    switch (a === 12 ? s = Ar.noon : a === 0 ? s = Ar.midnight : s = a / 12 >= 1 ? "pm" : "am", i) {
      case "b":
      case "bb":
        return r.dayPeriod(s, {
          width: "abbreviated",
          context: "formatting"
        });
      case "bbb":
        return r.dayPeriod(s, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "bbbbb":
        return r.dayPeriod(s, {
          width: "narrow",
          context: "formatting"
        });
      case "bbbb":
      default:
        return r.dayPeriod(s, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // in the morning, in the afternoon, in the evening, at night
  B: function(n, i, r) {
    const a = n.getHours();
    let s;
    switch (a >= 17 ? s = Ar.evening : a >= 12 ? s = Ar.afternoon : a >= 4 ? s = Ar.morning : s = Ar.night, i) {
      case "B":
      case "BB":
      case "BBB":
        return r.dayPeriod(s, {
          width: "abbreviated",
          context: "formatting"
        });
      case "BBBBB":
        return r.dayPeriod(s, {
          width: "narrow",
          context: "formatting"
        });
      case "BBBB":
      default:
        return r.dayPeriod(s, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Hour [1-12]
  h: function(n, i, r) {
    if (i === "ho") {
      let a = n.getHours() % 12;
      return a === 0 && (a = 12), r.ordinalNumber(a, { unit: "hour" });
    }
    return Yn.h(n, i);
  },
  // Hour [0-23]
  H: function(n, i, r) {
    return i === "Ho" ? r.ordinalNumber(n.getHours(), { unit: "hour" }) : Yn.H(n, i);
  },
  // Hour [0-11]
  K: function(n, i, r) {
    const a = n.getHours() % 12;
    return i === "Ko" ? r.ordinalNumber(a, { unit: "hour" }) : We(a, i.length);
  },
  // Hour [1-24]
  k: function(n, i, r) {
    let a = n.getHours();
    return a === 0 && (a = 24), i === "ko" ? r.ordinalNumber(a, { unit: "hour" }) : We(a, i.length);
  },
  // Minute
  m: function(n, i, r) {
    return i === "mo" ? r.ordinalNumber(n.getMinutes(), { unit: "minute" }) : Yn.m(n, i);
  },
  // Second
  s: function(n, i, r) {
    return i === "so" ? r.ordinalNumber(n.getSeconds(), { unit: "second" }) : Yn.s(n, i);
  },
  // Fraction of second
  S: function(n, i) {
    return Yn.S(n, i);
  },
  // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
  X: function(n, i, r) {
    const a = n.getTimezoneOffset();
    if (a === 0)
      return "Z";
    switch (i) {
      case "X":
        return jc(a);
      case "XXXX":
      case "XX":
        return ir(a);
      case "XXXXX":
      case "XXX":
      default:
        return ir(a, ":");
    }
  },
  // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
  x: function(n, i, r) {
    const a = n.getTimezoneOffset();
    switch (i) {
      case "x":
        return jc(a);
      case "xxxx":
      case "xx":
        return ir(a);
      case "xxxxx":
      case "xxx":
      default:
        return ir(a, ":");
    }
  },
  // Timezone (GMT)
  O: function(n, i, r) {
    const a = n.getTimezoneOffset();
    switch (i) {
      case "O":
      case "OO":
      case "OOO":
        return "GMT" + Yc(a, ":");
      case "OOOO":
      default:
        return "GMT" + ir(a, ":");
    }
  },
  // Timezone (specific non-location)
  z: function(n, i, r) {
    const a = n.getTimezoneOffset();
    switch (i) {
      case "z":
      case "zz":
      case "zzz":
        return "GMT" + Yc(a, ":");
      case "zzzz":
      default:
        return "GMT" + ir(a, ":");
    }
  },
  // Seconds timestamp
  t: function(n, i, r) {
    const a = Math.trunc(n.getTime() / 1e3);
    return We(a, i.length);
  },
  // Milliseconds timestamp
  T: function(n, i, r) {
    const a = n.getTime();
    return We(a, i.length);
  }
};
function Yc(n, i = "") {
  const r = n > 0 ? "-" : "+", a = Math.abs(n), s = Math.trunc(a / 60), l = a % 60;
  return l === 0 ? r + String(s) : r + String(s) + i + We(l, 2);
}
function jc(n, i) {
  return n % 60 === 0 ? (n > 0 ? "-" : "+") + We(Math.abs(n) / 60, 2) : ir(n, i);
}
function ir(n, i = "") {
  const r = n > 0 ? "-" : "+", a = Math.abs(n), s = We(Math.trunc(a / 60), 2), l = We(a % 60, 2);
  return r + s + i + l;
}
const Gc = (n, i) => {
  switch (n) {
    case "P":
      return i.date({ width: "short" });
    case "PP":
      return i.date({ width: "medium" });
    case "PPP":
      return i.date({ width: "long" });
    case "PPPP":
    default:
      return i.date({ width: "full" });
  }
}, ed = (n, i) => {
  switch (n) {
    case "p":
      return i.time({ width: "short" });
    case "pp":
      return i.time({ width: "medium" });
    case "ppp":
      return i.time({ width: "long" });
    case "pppp":
    default:
      return i.time({ width: "full" });
  }
}, __ = (n, i) => {
  const r = n.match(/(P+)(p+)?/) || [], a = r[1], s = r[2];
  if (!s)
    return Gc(n, i);
  let l;
  switch (a) {
    case "P":
      l = i.dateTime({ width: "short" });
      break;
    case "PP":
      l = i.dateTime({ width: "medium" });
      break;
    case "PPP":
      l = i.dateTime({ width: "long" });
      break;
    case "PPPP":
    default:
      l = i.dateTime({ width: "full" });
      break;
  }
  return l.replace("{{date}}", Gc(a, i)).replace("{{time}}", ed(s, i));
}, C_ = {
  p: ed,
  P: __
}, T_ = /^D+$/, E_ = /^Y+$/, O_ = ["D", "DD", "YY", "YYYY"];
function P_(n) {
  return T_.test(n);
}
function S_(n) {
  return E_.test(n);
}
function R_(n, i, r) {
  const a = A_(n, i, r);
  if (console.warn(a), O_.includes(n)) throw new RangeError(a);
}
function A_(n, i, r) {
  const a = n[0] === "Y" ? "years" : "days of the month";
  return `Use \`${n.toLowerCase()}\` instead of \`${n}\` (in \`${i}\`) for formatting ${a} to the input \`${r}\`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md`;
}
const k_ = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g, M_ = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g, D_ = /^'([^]*?)'?$/, L_ = /''/g, N_ = /[a-zA-Z]/;
function hs(n, i, r) {
  var w, x, T, E;
  const a = $o(), s = a.locale ?? v_, l = a.firstWeekContainsDate ?? ((x = (w = a.locale) == null ? void 0 : w.options) == null ? void 0 : x.firstWeekContainsDate) ?? 1, f = a.weekStartsOn ?? ((E = (T = a.locale) == null ? void 0 : T.options) == null ? void 0 : E.weekStartsOn) ?? 0, m = an(n);
  if (!I1(m))
    throw new RangeError("Invalid time value");
  let g = i.match(M_).map((O) => {
    const k = O[0];
    if (k === "p" || k === "P") {
      const L = C_[k];
      return L(O, s.formatLong);
    }
    return O;
  }).join("").match(k_).map((O) => {
    if (O === "''")
      return { isToken: !1, value: "'" };
    const k = O[0];
    if (k === "'")
      return { isToken: !1, value: W_(O) };
    if (Bc[k])
      return { isToken: !0, value: O };
    if (k.match(N_))
      throw new RangeError(
        "Format string contains an unescaped latin alphabet character `" + k + "`"
      );
    return { isToken: !1, value: O };
  });
  s.localize.preprocessor && (g = s.localize.preprocessor(m, g));
  const p = {
    firstWeekContainsDate: l,
    weekStartsOn: f,
    locale: s
  };
  return g.map((O) => {
    if (!O.isToken) return O.value;
    const k = O.value;
    (S_(k) || P_(k)) && R_(k, i, String(n));
    const L = Bc[k[0]];
    return L(m, k, s.localize, p);
  }).join("");
}
function W_(n) {
  const i = n.match(D_);
  return i ? i[1].replace(L_, "'") : n;
}
const I_ = async (n, i, r, a) => {
  var m, g, p, w, x;
  const s = hs(r, "yyyy-MM-dd'T'00:00:00'Z'"), l = hs(a, "yyyy-MM-dd'T'23:59:59'Z'"), f = `
    query ($username: String!, $from: DateTime!, $to: DateTime!) {
      user(login: $username) {
        contributionsCollection(from: $from, to: $to) {
          contributionCalendar {
            totalContributions
            weeks {
              contributionDays {
                contributionCount
                date
              }
            }
          }
        }
      }
    }
  `;
  try {
    if (!n)
      return console.error("Missing GitHub username"), [];
    const T = {
      "Content-Type": "application/json"
    };
    i && (T.Authorization = `Bearer ${i}`);
    const E = await fetch("https://api.github.com/graphql", {
      method: "POST",
      headers: T,
      body: JSON.stringify({
        query: f,
        variables: {
          username: n,
          from: s,
          to: l
        }
      })
    });
    if (!E.ok)
      throw new Error(`HTTP error! status: ${E.status}`);
    const O = await E.json();
    if (O.errors)
      throw console.error("GitHub API Errors:", O.errors), new Error(((m = O.errors[0]) == null ? void 0 : m.message) || "GitHub API Error");
    if (!((x = (w = (p = (g = O.data) == null ? void 0 : g.user) == null ? void 0 : p.contributionsCollection) == null ? void 0 : w.contributionCalendar) != null && x.weeks))
      return console.error("Invalid response structure:", O), [];
    const k = [];
    return O.data.user.contributionsCollection.contributionCalendar.weeks.forEach(
      (L) => {
        L.contributionDays.forEach((I) => {
          k.push({
            date: hs(new Date(I.date), "yyyy-MM-dd"),
            count: I.contributionCount
          });
        });
      }
    ), k;
  } catch (T) {
    throw console.error("Error fetching GitHub contributions:", T), new Error(
      `Failed to fetch GitHub contributions: ${T instanceof Error ? T.message : "Unknown error"}`
    );
  }
}, F_ = async (n, i, r) => {
  try {
    if (!n)
      return console.error("Missing GitHub username"), {
        commits: 0,
        pullRequests: 0,
        mergeRequests: 0,
        pushes: 0,
        branchesContributed: 0
      };
    const a = parseInt(r.split("-")[2]) % 10;
    return {
      commits: a || 0,
      pullRequests: Math.max(0, Math.floor(a / 3)),
      mergeRequests: Math.max(0, Math.floor(a / 4)),
      pushes: Math.max(0, a - 1),
      branchesContributed: Math.max(0, Math.floor(a / 2))
    };
  } catch (a) {
    return console.error("Error fetching contribution details:", a), {
      commits: 0,
      pullRequests: 0,
      mergeRequests: 0,
      pushes: 0,
      branchesContributed: 0
    };
  }
}, $_ = {
  classic: {
    noContributions: "#ebedf0",
    low: "#9be9a8",
    moderate: "#40c463",
    high: "#30a14e",
    veryHigh: "#216e39"
  },
  aurora: {
    noContributions: "#ebedf0",
    low: "#88c0d0",
    moderate: "#81a1c1",
    high: "#5e81ac",
    veryHigh: "#4c566a"
  },
  velvet: {
    noContributions: "#ebedf0",
    low: "#ff9ecd",
    moderate: "#ff69b4",
    high: "#da1884",
    veryHigh: "#851050"
  },
  solar: {
    noContributions: "#ebedf0",
    low: "#ffd700",
    moderate: "#ffa500",
    high: "#ff4500",
    veryHigh: "#8b0000"
  },
  prism: {
    noContributions: "#ebedf0",
    low: "#ff9aa2",
    moderate: "#c7ceea",
    high: "#b5ead7",
    veryHigh: "#85dcb8"
  },
  galaxy: {
    noContributions: "#ebedf0",
    low: "#8e8cd8",
    moderate: "#6b4f89",
    high: "#483475",
    veryHigh: "#2b1955"
  },
  pastel: {
    noContributions: "#ebedf0",
    low: "#ffd6e0",
    moderate: "#ffb3c6",
    high: "#ff8fab",
    veryHigh: "#ff6b8b"
  },
  monotone: {
    noContributions: "#ebedf0",
    low: "#c6c6c6",
    moderate: "#929292",
    high: "#636363",
    veryHigh: "#2f2f2f"
  },
  halloween: {
    noContributions: "#ebedf0",
    low: "#ffee4a",
    moderate: "#ffc501",
    high: "#fe9600",
    veryHigh: "#03001c"
  },
  winter: {
    noContributions: "#ebedf0",
    low: "#b6e3ff",
    moderate: "#54aeff",
    high: "#0969da",
    veryHigh: "#0a3069"
  },
  nature: {
    noContributions: "#ebedf0",
    low: "#d8e8b0",
    moderate: "#95c077",
    high: "#4f772d",
    veryHigh: "#31572c"
  }
}, U_ = {
  classic: {
    noContributions: "#161b22",
    low: "#0e4429",
    moderate: "#006d32",
    high: "#26a641",
    veryHigh: "#39d353"
  },
  aurora: {
    noContributions: "#161b22",
    low: "#133d55",
    moderate: "#1c5a80",
    high: "#2188c6",
    veryHigh: "#4dabf5"
  },
  velvet: {
    noContributions: "#161b22",
    low: "#4b1736",
    moderate: "#6e1e51",
    high: "#a82577",
    veryHigh: "#f25cb5"
  },
  solar: {
    noContributions: "#161b22",
    low: "#452c01",
    moderate: "#6f4206",
    high: "#a86406",
    veryHigh: "#ffa21f"
  },
  prism: {
    noContributions: "#161b22",
    low: "#153042",
    moderate: "#1e4973",
    high: "#2471b5",
    veryHigh: "#5295e3"
  },
  galaxy: {
    noContributions: "#161b22",
    low: "#1d1d46",
    moderate: "#2c2a6e",
    high: "#413aa3",
    veryHigh: "#695de3"
  },
  pastel: {
    noContributions: "#161b22",
    low: "#461536",
    moderate: "#692155",
    high: "#a13282",
    veryHigh: "#e564c3"
  },
  monotone: {
    noContributions: "#161b22",
    low: "#222222",
    moderate: "#444444",
    high: "#666666",
    veryHigh: "#888888"
  },
  halloween: {
    noContributions: "#161b22",
    low: "#341b00",
    moderate: "#662c00",
    high: "#873800",
    veryHigh: "#c65000"
  },
  winter: {
    noContributions: "#161b22",
    low: "#0a1c40",
    moderate: "#0f295c",
    high: "#183e8a",
    veryHigh: "#275bd6"
  },
  nature: {
    noContributions: "#161b22",
    low: "#1e3c16",
    moderate: "#2c5a21",
    high: "#3b7a2c",
    veryHigh: "#57ad41"
  }
}, qc = "classic", j_ = ({
  // Data props
  username: n,
  token: i,
  data: r,
  transformData: a,
  fetchData: s,
  // Appearance props
  blockMargin: l = 2,
  blockRadius: f = 2,
  blockSize: m = 12,
  fontSize: g = 14,
  // Theme props
  theme: p = qc,
  customTheme: w,
  themes: x,
  colorScheme: T = "light",
  // Visibility props
  hideColorLegend: E = !1,
  hideMonthLabels: O = !1,
  hideWeekdayLabels: k = !1,
  hideTotalCount: L = !1,
  // Event and render props
  loading: I,
  renderLoading: $,
  onDayClick: B,
  renderDay: q,
  renderDetails: Y,
  // Years
  years: Q = [
    (/* @__PURE__ */ new Date()).getFullYear(),
    (/* @__PURE__ */ new Date()).getFullYear() - 1,
    (/* @__PURE__ */ new Date()).getFullYear() - 2,
    (/* @__PURE__ */ new Date()).getFullYear() - 3
  ],
  year: j,
  onYearChange: U
}) => {
  const [se, Ce] = cn(
    r || []
  ), [fe, de] = cn(I || !r), [re, Te] = cn(Ic(j)), [me, be] = cn(
    j ? j.toString() : "lastYear"
  ), [pe, F] = cn(p), [Me, xe] = cn(null), [Ie, yt] = cn(null), [Oe, Be] = cn(null), [Se, et] = cn(null), [ve, Ye] = cn({ type: null, message: "" }), Ke = T === "dark" ? { ...U_, ...x } : { ...$_, ...x }, ft = w || Ke[pe] || Ke[qc], De = Fs(T);
  xo(() => {
    if (r) {
      Ce(r), de(!1);
      return;
    }
    de(!0), Ye({ type: null, message: "" }), yt(null), Be(null), xe(null), et(null), (async () => {
      var Re, Fe, Qt, ht, tt;
      try {
        let Tt;
        if (s)
          Tt = await s(n, j);
        else
          try {
            console.log("Attempting to fetch data for username:", n), Tt = await I_(
              n,
              i || "",
              // Use token if provided, otherwise empty string
              re.startDate,
              re.endDate
            );
          } catch (Mt) {
            console.error("Error fetching GitHub data:", Mt);
            const lt = Mt;
            console.log(
              "GitHub API Error Status:",
              (Re = lt.response) == null ? void 0 : Re.status
            ), console.log(
              "GitHub API Error Message:",
              (Fe = lt.response) == null ? void 0 : Fe.message
            );
            try {
              console.log("Checking if username exists:", n);
              const Et = await fetch(
                `https://api.github.com/users/${n}`
              );
              if (console.log("Username check response status:", Et.status), !Et.ok) {
                console.log("Username does not exist"), Ye({
                  type: "invalid_username",
                  message: `GitHub user "${n}" does not exist. Please check the username and try again.`
                });
                return;
              }
            } catch (Et) {
              console.error("Error checking username:", Et), Ye({
                type: "api_error",
                message: "Unable to verify GitHub username. Please check your internet connection and try again."
              });
              return;
            }
            console.log("Username exists but error fetching contributions"), ((Qt = lt.response) == null ? void 0 : Qt.status) === 401 || ((ht = lt.response) == null ? void 0 : ht.status) === 403 ? (console.log("Token/access error detected"), Ye({
              type: "invalid_token",
              message: `Unable to access contribution data for "${n}". This could be because:
                  • The token is invalid or expired
                  • The token doesn't have access to this user's data
                  • The user's contribution data is private`
            })) : ((tt = lt.response) == null ? void 0 : tt.status) === 429 ? (console.log("Rate limit error detected"), Ye({
              type: "api_error",
              message: "GitHub API rate limit exceeded. Please try again later."
            })) : (console.log("Generic API error"), Ye({
              type: "api_error",
              message: "Failed to fetch contribution data. Please try again later."
            }));
            return;
          }
        a && (Tt = a(Tt)), Ce(Tt);
      } catch (Tt) {
        console.error("Error fetching contributions:", Tt), Ye({
          type: "api_error",
          message: "An unexpected error occurred. Please try again later."
        });
      } finally {
        de(!1);
      }
    })();
  }, [r, s, re, a, n, i, j]), xo(() => {
    Se && Se.isLoading && (async () => {
      try {
        const Re = await F_(
          n,
          i || "",
          Se.date
        );
        et(
          (Fe) => Fe ? {
            ...Fe,
            details: Re,
            isLoading: !1
          } : null
        );
      } catch (Re) {
        console.error("Error fetching contribution details:", Re), et(
          (Fe) => Fe ? {
            ...Fe,
            details: {
              commits: Math.floor(Math.random() * 5),
              pullRequests: Math.floor(Math.random() * 2),
              mergeRequests: Math.floor(Math.random() * 2),
              pushes: Math.floor(Math.random() * 3),
              branchesContributed: Math.floor(Math.random() * 2)
            },
            isLoading: !1
          } : null
        );
      }
    })();
  }, [Se, n, i]);
  const st = (J, Re) => {
    Te({ startDate: J, endDate: Re }), U && J.getFullYear() === Re.getFullYear() && U(J.getFullYear());
  }, Bt = (J) => {
    yt(Ie === J ? null : J), Be(null), xe(null), et(null);
  }, Qe = os(
    as.throttle((J) => {
      Oe || xe(J);
    }, 100),
    [Oe]
  ), dt = os(
    as.throttle(() => {
      Oe || xe(null);
    }, 100),
    [Oe]
  ), Ct = os(
    as.debounce((J, Re, Fe) => {
      Oe === J ? (Be(null), xe(null), et(null)) : (Be(J), xe(J), B ? B({ date: J, count: Fe }) : et({
        date: J,
        formattedDate: Mr(Re, "MMMM d, yyyy"),
        contributionCount: Fe,
        details: null,
        isLoading: !0
      })), yt(null);
    }, 200),
    [B, Oe]
  );
  if (xo(() => () => {
    Qe.cancel(), dt.cancel(), Ct.cancel();
  }, [Qe, dt, Ct]), ve.type)
    return console.log("Rendering error state:", ve), /* @__PURE__ */ R.jsx(
      ws,
      {
        className: "p-6 animate-fadeIn max-w-full overflow-hidden",
        style: {
          backgroundColor: De.background,
          borderColor: De.border
        },
        children: /* @__PURE__ */ R.jsxs("div", { className: "space-y-6", children: [
          /* @__PURE__ */ R.jsx("div", { className: "flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4", children: /* @__PURE__ */ R.jsxs("div", { className: "flex items-center space-x-2", children: [
            /* @__PURE__ */ R.jsx(wc, { className: "w-5 h-5", style: { color: De.text } }),
            /* @__PURE__ */ R.jsx(
              "h2",
              {
                className: "text-lg font-semibold hidden sm:inline",
                style: { color: De.text },
                children: "Contribution Calendar"
              }
            )
          ] }) }),
          /* @__PURE__ */ R.jsxs("div", { className: "flex flex-col items-center justify-center py-8 space-y-4", children: [
            /* @__PURE__ */ R.jsxs("div", { className: "text-red-500 text-xl font-semibold", children: [
              ve.type === "invalid_username" && "User Not Found",
              ve.type === "invalid_token" && "Access Denied",
              ve.type === "api_error" && "Error"
            ] }),
            /* @__PURE__ */ R.jsxs("div", { className: "text-center space-y-2", children: [
              /* @__PURE__ */ R.jsx("p", { className: "text-gray-600 dark:text-gray-400 whitespace-pre-line", children: ve.message }),
              ve.type === "invalid_username" && /* @__PURE__ */ R.jsx("p", { className: "text-sm text-gray-500 dark:text-gray-500", children: "Make sure the GitHub username is correct and the account is public." }),
              ve.type === "invalid_token" && /* @__PURE__ */ R.jsxs("div", { className: "text-sm text-gray-500 dark:text-gray-500 space-y-2", children: [
                /* @__PURE__ */ R.jsx("p", { children: "To fix this, you can:" }),
                /* @__PURE__ */ R.jsxs("ol", { className: "list-decimal list-inside space-y-1", children: [
                  /* @__PURE__ */ R.jsx("li", { children: "Create a new token in your GitHub settings under Developer Settings > Personal Access Tokens" }),
                  /* @__PURE__ */ R.jsx("li", { children: "Make sure the token has the necessary permissions (repo, read:user)" }),
                  /* @__PURE__ */ R.jsx("li", { children: "Check if the token is still valid and not expired" })
                ] })
              ] })
            ] })
          ] })
        ] })
      }
    );
  if (fe) {
    if ($) {
      const J = $();
      return Os.isValidElement(J) ? J : /* @__PURE__ */ R.jsx("div", { children: "Loading..." });
    }
    return /* @__PURE__ */ R.jsx("div", { children: "Loading..." });
  }
  const ut = T1(re.startDate, re.endDate), gn = P1(ut), kt = O1(se);
  return /* @__PURE__ */ R.jsx(
    ws,
    {
      className: "p-6 animate-fadeIn max-w-full overflow-hidden",
      style: { backgroundColor: De.background, borderColor: De.border },
      children: /* @__PURE__ */ R.jsxs("div", { className: "space-y-6", children: [
        /* @__PURE__ */ R.jsxs("div", { className: "flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4", children: [
          /* @__PURE__ */ R.jsxs("div", { className: "flex items-center space-x-2", children: [
            /* @__PURE__ */ R.jsx(wc, { className: "w-5 h-5", style: { color: De.text } }),
            /* @__PURE__ */ R.jsx(
              "h2",
              {
                className: "text-lg font-semibold hidden sm:inline",
                style: { color: De.text },
                children: "Contribution Calendar"
              }
            )
          ] }),
          /* @__PURE__ */ R.jsxs("div", { className: "flex flex-wrap gap-2", children: [
            /* @__PURE__ */ R.jsx(
              ys,
              {
                variant: me === "lastYear" ? "default" : "outline",
                size: "sm",
                onClick: () => {
                  const J = Ic();
                  st(J.startDate, J.endDate), be("lastYear");
                },
                children: "Last Year"
              }
            ),
            Q.map((J) => /* @__PURE__ */ R.jsx(
              ys,
              {
                variant: me === J.toString() ? "default" : "outline",
                size: "sm",
                onClick: () => {
                  st(
                    new Date(J, 0, 1),
                    new Date(J, 11, 31)
                  ), be(J.toString());
                },
                children: J
              },
              J
            ))
          ] }),
          /* @__PURE__ */ R.jsx("div", { children: /* @__PURE__ */ R.jsx(
            "select",
            {
              value: pe,
              onChange: (J) => F(J.target.value),
              className: "border rounded p-1",
              style: {
                borderColor: De.border,
                color: De.text,
                backgroundColor: De.background
              },
              children: Object.keys(Ke).map((J) => /* @__PURE__ */ R.jsx("option", { value: J, children: J.charAt(0).toUpperCase() + J.slice(1) }, J))
            }
          ) })
        ] }),
        !L && /* @__PURE__ */ R.jsxs(
          "div",
          {
            className: "text-center text-lg font-semibold",
            style: { color: De.text },
            children: [
              kt,
              " contributions in ",
              me
            ]
          }
        ),
        /* @__PURE__ */ R.jsx("div", { className: "space-y-2", children: /* @__PURE__ */ R.jsxs("div", { className: "flex", children: [
          !k && /* @__PURE__ */ R.jsxs("div", { className: "w-10 flex-shrink-0", children: [
            /* @__PURE__ */ R.jsx("div", { className: "h-5" }),
            " ",
            /* @__PURE__ */ R.jsx(
              "div",
              {
                className: "grid grid-rows-7 text-xs",
                style: {
                  color: De.muted,
                  gap: l
                },
                children: ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"].map(
                  (J) => /* @__PURE__ */ R.jsx(
                    "div",
                    {
                      style: {
                        height: `${m}px`,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center"
                      },
                      children: J
                    },
                    J
                  )
                )
              }
            )
          ] }),
          /* @__PURE__ */ R.jsx("div", { className: "flex-1 overflow-x-auto", children: /* @__PURE__ */ R.jsxs("div", { className: "min-w-[900px]", children: [
            !O && /* @__PURE__ */ R.jsx("div", { className: "h-5 relative", children: gn.map((J, Re) => /* @__PURE__ */ R.jsx(
              "div",
              {
                className: "absolute text-xs",
                style: {
                  left: `${J.index / ut.length * 100}%`,
                  color: De.muted
                },
                children: J.label
              },
              Re
            )) }),
            /* @__PURE__ */ R.jsx("div", { className: "relative contribution-grid", children: /* @__PURE__ */ R.jsx(
              "div",
              {
                className: "grid grid-flow-col",
                style: { gap: l },
                children: ut.map((J, Re) => /* @__PURE__ */ R.jsx(
                  "div",
                  {
                    className: "grid grid-rows-7",
                    style: { gap: l },
                    children: Kf(J).map((Fe, Qt) => {
                      const ht = Mr(Fe, "yyyy-MM-dd"), tt = E1(
                        se,
                        Fe
                      ), Tt = C1(tt), Mt = Ie === Tt, lt = Oe === ht, Et = !!(Ie && !Mt || Oe && !lt), mn = _1(
                        tt,
                        ft
                      );
                      return q ? q(
                        { date: ht, count: tt },
                        /* @__PURE__ */ R.jsx(
                          Wc,
                          {
                            date: ht,
                            day: Fe,
                            count: tt,
                            blockSize: m,
                            blockRadius: f,
                            isHighlighted: lt || Me === ht,
                            onClick: () => Ct(
                              ht,
                              Fe,
                              tt
                            ),
                            onMouseEnter: () => Qe(ht),
                            onMouseLeave: dt,
                            color: mn,
                            shouldFade: Et
                          }
                        )
                      ) : /* @__PURE__ */ R.jsx(
                        Wc,
                        {
                          date: ht,
                          day: Fe,
                          count: tt,
                          blockSize: m,
                          blockRadius: f,
                          isHighlighted: lt || Me === ht,
                          onClick: () => Ct(
                            ht,
                            Fe,
                            tt
                          ),
                          onMouseEnter: () => Qe(ht),
                          onMouseLeave: dt,
                          color: mn,
                          shouldFade: Et
                        },
                        `${Re}-${Qt}`
                      );
                    })
                  },
                  Re
                ))
              }
            ) })
          ] }) })
        ] }) }),
        Se && !Y && /* @__PURE__ */ R.jsx(
          A1,
          {
            date: Se.date,
            formattedDate: Se.formattedDate,
            contributionCount: Se.contributionCount,
            details: Se.details,
            isLoading: Se.isLoading,
            fontSize: g,
            colorScheme: T
          }
        ),
        Se && Y && Se.details && Y(Se.details, Se.date),
        /* @__PURE__ */ R.jsxs("div", { className: "flex flex-col md:flex-row justify-between items-center", children: [
          /* @__PURE__ */ R.jsxs(
            "div",
            {
              className: "text-center text-sm",
              style: { color: De.muted, fontSize: `${g}px` },
              children: [
                "Last contributed on: ",
                R1(se)
              ]
            }
          ),
          !E && /* @__PURE__ */ R.jsx(
            k1,
            {
              theme: ft,
              colorScheme: T,
              onLevelClick: Bt,
              selectedLevel: Ie,
              blockSize: m,
              blockRadius: f,
              fontSize: g
            }
          )
        ] })
      ] })
    }
  );
};
export {
  j_ as default
};
